
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("bSXAs", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");
// eslint-disable-next-line import/no-namespace
var $8dd462732d984c7b$exports = {};
$parcel$export($8dd462732d984c7b$exports, "expandWithNestedExpand", () => (parcelRequire("4r9Pq")).expandWithNestedExpand);
$parcel$export($8dd462732d984c7b$exports, "expandWithNestedExpandLocalId", () => (parcelRequire("4r9Pq")).expandWithNestedExpandLocalId);
$parcel$export($8dd462732d984c7b$exports, "expandToJSON", () => (parcelRequire("4r9Pq")).toJSON);
$parcel$export($8dd462732d984c7b$exports, "confluenceJiraIssue", () => (parcelRequire("fsHCc")).confluenceJiraIssue);
$parcel$export($8dd462732d984c7b$exports, "confluenceUnsupportedBlock", () => (parcelRequire("aZa28")).confluenceUnsupportedBlock);
$parcel$export($8dd462732d984c7b$exports, "confluenceUnsupportedInline", () => (parcelRequire("fnSCn")).confluenceUnsupportedInline);
$parcel$export($8dd462732d984c7b$exports, "doc", () => (parcelRequire("jRrsu")).doc);
$parcel$export($8dd462732d984c7b$exports, "blockquote", () => (parcelRequire("iIGXo")).blockquote);
$parcel$export($8dd462732d984c7b$exports, "extendedBlockquote", () => (parcelRequire("iIGXo")).extendedBlockquote);
$parcel$export($8dd462732d984c7b$exports, "extendedBlockquoteWithLocalId", () => (parcelRequire("iIGXo")).extendedBlockquoteWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "bulletList", () => (parcelRequire("ghpxT")).bulletList);
$parcel$export($8dd462732d984c7b$exports, "bulletListSelector", () => (parcelRequire("ghpxT")).bulletListSelector);
$parcel$export($8dd462732d984c7b$exports, "bulletListWithLocalId", () => (parcelRequire("ghpxT")).bulletListWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "codeBlock", () => (parcelRequire("4HD7y")).codeBlock);
$parcel$export($8dd462732d984c7b$exports, "codeBlockWithLocalId", () => (parcelRequire("4HD7y")).codeBlockWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "codeBlockToJSON", () => (parcelRequire("4HD7y")).toJSON);
$parcel$export($8dd462732d984c7b$exports, "hardBreak", () => (parcelRequire("aFNbc")).hardBreak);
$parcel$export($8dd462732d984c7b$exports, "heading", () => (parcelRequire("j0UBv")).heading);
$parcel$export($8dd462732d984c7b$exports, "rule", () => (parcelRequire("bLhD4")).rule);
$parcel$export($8dd462732d984c7b$exports, "ruleWithLocalId", () => (parcelRequire("bLhD4")).ruleWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "orderedList", () => (parcelRequire("fGuiW")).orderedList);
$parcel$export($8dd462732d984c7b$exports, "orderedListSelector", () => (parcelRequire("fGuiW")).orderedListSelector);
$parcel$export($8dd462732d984c7b$exports, "orderedListWithLocalId", () => (parcelRequire("fGuiW")).orderedListWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "orderedListWithOrder", () => (parcelRequire("fGuiW")).orderedListWithOrder);
$parcel$export($8dd462732d984c7b$exports, "orderedListWithOrderAndLocalId", () => (parcelRequire("fGuiW")).orderedListWithOrderAndLocalId);
$parcel$export($8dd462732d984c7b$exports, "paragraph", () => (parcelRequire("eK2Ov")).paragraph);
$parcel$export($8dd462732d984c7b$exports, "emoji", () => (parcelRequire("bIZRt")).emoji);
$parcel$export($8dd462732d984c7b$exports, "emojiWithLocalId", () => (parcelRequire("bIZRt")).emojiWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "image", () => (parcelRequire("dupND")).image);
$parcel$export($8dd462732d984c7b$exports, "mention", () => (parcelRequire("CmplZ")).mention);
$parcel$export($8dd462732d984c7b$exports, "mentionToJSON", () => (parcelRequire("CmplZ")).toJSON);
$parcel$export($8dd462732d984c7b$exports, "listItem", () => (parcelRequire("jl5Qf")).listItem);
$parcel$export($8dd462732d984c7b$exports, "listItemWithFlexibleFirstChildStage0", () => (parcelRequire("jl5Qf")).listItemWithFlexibleFirstChildStage0);
$parcel$export($8dd462732d984c7b$exports, "listItemWithLocalId", () => (parcelRequire("jl5Qf")).listItemWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "extendedPanel", () => (parcelRequire("dGKc1")).extendedPanel);
$parcel$export($8dd462732d984c7b$exports, "extendedPanelWithLocalId", () => (parcelRequire("dGKc1")).extendedPanelWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "PanelType", () => (parcelRequire("dGKc1")).PanelType);
$parcel$export($8dd462732d984c7b$exports, "text", () => (parcelRequire("bSuKu")).text);
$parcel$export($8dd462732d984c7b$exports, "unknownBlock", () => (parcelRequire("h3652")).default);
$parcel$export($8dd462732d984c7b$exports, "caption", () => (parcelRequire("kRG5M")).caption);
$parcel$export($8dd462732d984c7b$exports, "captionWithLocalId", () => (parcelRequire("kRG5M")).captionWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "media", () => (parcelRequire("kZ3vg")).media);
$parcel$export($8dd462732d984c7b$exports, "copyPrivateMediaAttributes", () => (parcelRequire("kZ3vg")).copyPrivateAttributes);
$parcel$export($8dd462732d984c7b$exports, "mediaToJSON", () => (parcelRequire("kZ3vg")).toJSON);
$parcel$export($8dd462732d984c7b$exports, "mediaGroup", () => (parcelRequire("6xrFZ")).mediaGroup);
$parcel$export($8dd462732d984c7b$exports, "mediaInline", () => (parcelRequire("bTc4a")).mediaInline);
$parcel$export($8dd462732d984c7b$exports, "mediaSingle", () => (parcelRequire("jblCI")).mediaSingle);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleSpec", () => (parcelRequire("jblCI")).mediaSingleSpec);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleWithCaption", () => (parcelRequire("jblCI")).mediaSingleWithCaption);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleWithWidthType", () => (parcelRequire("jblCI")).mediaSingleWithWidthType);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleFull", () => (parcelRequire("jblCI")).mediaSingleFull);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleFullWithLocalId", () => (parcelRequire("jblCI")).mediaSingleFullWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "mediaSingleToJSON", () => (parcelRequire("jblCI")).toJSON);
$parcel$export($8dd462732d984c7b$exports, "table", () => (parcelRequire("63Ztt")).table);
$parcel$export($8dd462732d984c7b$exports, "tableWithNestedTable", () => (parcelRequire("63Ztt")).tableWithNestedTable);
$parcel$export($8dd462732d984c7b$exports, "tableRowWithNestedTable", () => (parcelRequire("63Ztt")).tableRowWithNestedTable);
$parcel$export($8dd462732d984c7b$exports, "tableCellWithNestedTable", () => (parcelRequire("63Ztt")).tableCellWithNestedTable);
$parcel$export($8dd462732d984c7b$exports, "tableHeaderWithNestedTable", () => (parcelRequire("63Ztt")).tableHeaderWithNestedTable);
$parcel$export($8dd462732d984c7b$exports, "tableRowWithLocalId", () => (parcelRequire("63Ztt")).tableRowWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableCellWithLocalId", () => (parcelRequire("63Ztt")).tableCellWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableHeaderWithLocalId", () => (parcelRequire("63Ztt")).tableHeaderWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("63Ztt")).tableRowWithNestedTableWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("63Ztt")).tableCellWithNestedTableWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("63Ztt")).tableHeaderWithNestedTableWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "tableStage0", () => (parcelRequire("63Ztt")).tableStage0);
$parcel$export($8dd462732d984c7b$exports, "tableWithCustomWidth", () => (parcelRequire("63Ztt")).tableWithCustomWidth);
$parcel$export($8dd462732d984c7b$exports, "tableToJSON", () => (parcelRequire("63Ztt")).tableToJSON);
$parcel$export($8dd462732d984c7b$exports, "tableCell", () => (parcelRequire("63Ztt")).tableCell);
$parcel$export($8dd462732d984c7b$exports, "toJSONTableCell", () => (parcelRequire("63Ztt")).toJSONTableCell);
$parcel$export($8dd462732d984c7b$exports, "tableHeader", () => (parcelRequire("63Ztt")).tableHeader);
$parcel$export($8dd462732d984c7b$exports, "toJSONTableHeader", () => (parcelRequire("63Ztt")).toJSONTableHeader);
$parcel$export($8dd462732d984c7b$exports, "tableRow", () => (parcelRequire("63Ztt")).tableRow);
$parcel$export($8dd462732d984c7b$exports, "tableBackgroundColorPalette", () => (parcelRequire("63Ztt")).tableBackgroundColorPalette);
$parcel$export($8dd462732d984c7b$exports, "tableBackgroundBorderColor", () => (parcelRequire("63Ztt")).tableBackgroundBorderColor);
$parcel$export($8dd462732d984c7b$exports, "tableBackgroundColorNames", () => (parcelRequire("63Ztt")).tableBackgroundColorNames);
$parcel$export($8dd462732d984c7b$exports, "getCellAttrs", () => (parcelRequire("63Ztt")).getCellAttrs);
$parcel$export($8dd462732d984c7b$exports, "getCellDomAttrs", () => (parcelRequire("63Ztt")).getCellDomAttrs);
$parcel$export($8dd462732d984c7b$exports, "tablePrefixSelector", () => (parcelRequire("63Ztt")).tablePrefixSelector);
$parcel$export($8dd462732d984c7b$exports, "tableCellSelector", () => (parcelRequire("63Ztt")).tableCellSelector);
$parcel$export($8dd462732d984c7b$exports, "tableHeaderSelector", () => (parcelRequire("63Ztt")).tableHeaderSelector);
$parcel$export($8dd462732d984c7b$exports, "tableCellContentWrapperSelector", () => (parcelRequire("63Ztt")).tableCellContentWrapperSelector);
$parcel$export($8dd462732d984c7b$exports, "tableCellContentDomSelector", () => (parcelRequire("63Ztt")).tableCellContentDomSelector);
$parcel$export($8dd462732d984c7b$exports, "decisionList", () => (parcelRequire("gClzS")).decisionList);
$parcel$export($8dd462732d984c7b$exports, "decisionListSelector", () => (parcelRequire("gClzS")).decisionListSelector);
$parcel$export($8dd462732d984c7b$exports, "decisionItem", () => (parcelRequire("bpTLT")).decisionItem);
$parcel$export($8dd462732d984c7b$exports, "taskList", () => (parcelRequire("cXZ4C")).taskList);
$parcel$export($8dd462732d984c7b$exports, "taskListSelector", () => (parcelRequire("cXZ4C")).taskListSelector);
$parcel$export($8dd462732d984c7b$exports, "taskListWithFlexibleFirstChildStage0", () => (parcelRequire("cXZ4C")).taskListWithFlexibleFirstChildStage0);
$parcel$export($8dd462732d984c7b$exports, "taskItem", () => (parcelRequire("5elS6")).taskItem);
$parcel$export($8dd462732d984c7b$exports, "blockTaskItem", () => (parcelRequire("5elS6")).blockTaskItem);
$parcel$export($8dd462732d984c7b$exports, "date", () => (parcelRequire("cAWza")).date);
$parcel$export($8dd462732d984c7b$exports, "dateWithLocalId", () => (parcelRequire("cAWza")).dateWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "placeholder", () => (parcelRequire("jEypY")).placeholder);
$parcel$export($8dd462732d984c7b$exports, "placeholderWithLocalId", () => (parcelRequire("jEypY")).placeholderWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "layoutSection", () => (parcelRequire("hVXQj")).layoutSection);
$parcel$export($8dd462732d984c7b$exports, "layoutSectionWithLocalId", () => (parcelRequire("hVXQj")).layoutSectionWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "layoutSectionWithSingleColumn", () => (parcelRequire("hVXQj")).layoutSectionWithSingleColumn);
$parcel$export($8dd462732d984c7b$exports, "layoutSectionWithSingleColumnLocalId", () => (parcelRequire("hVXQj")).layoutSectionWithSingleColumnLocalId);
$parcel$export($8dd462732d984c7b$exports, "layoutColumn", () => (parcelRequire("lifsC")).layoutColumn);
$parcel$export($8dd462732d984c7b$exports, "layoutColumnWithLocalId", () => (parcelRequire("lifsC")).layoutColumnWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "inlineCard", () => (parcelRequire("aqHdD")).inlineCard);
$parcel$export($8dd462732d984c7b$exports, "inlineCardWithLocalId", () => (parcelRequire("aqHdD")).inlineCardWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "blockCard", () => (parcelRequire("aGTRk")).blockCard);
$parcel$export($8dd462732d984c7b$exports, "blockCardWithLocalId", () => (parcelRequire("aGTRk")).blockCardWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "unsupportedBlock", () => (parcelRequire("iSXnW")).unsupportedBlock);
$parcel$export($8dd462732d984c7b$exports, "unsupportedInline", () => (parcelRequire("cre7m")).unsupportedInline);
$parcel$export($8dd462732d984c7b$exports, "status", () => (parcelRequire("f4dR3")).status);
$parcel$export($8dd462732d984c7b$exports, "nestedExpand", () => (parcelRequire("iw2ID")).nestedExpand);
$parcel$export($8dd462732d984c7b$exports, "nestedExpandWithLocalId", () => (parcelRequire("iw2ID")).nestedExpandWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "embedCard", () => (parcelRequire("cfHGv")).embedCard);
$parcel$export($8dd462732d984c7b$exports, "embedCardWithLocalId", () => (parcelRequire("cfHGv")).embedCardWithLocalId);
$parcel$export($8dd462732d984c7b$exports, "extension", () => (parcelRequire("2xxP6")).extension);
$parcel$export($8dd462732d984c7b$exports, "inlineExtension", () => (parcelRequire("u6ZFj")).inlineExtension);
$parcel$export($8dd462732d984c7b$exports, "bodiedExtension", () => (parcelRequire("4sfnB")).bodiedExtension);
$parcel$export($8dd462732d984c7b$exports, "extensionFrame", () => (parcelRequire("aotp7")).extensionFrame);
$parcel$export($8dd462732d984c7b$exports, "multiBodiedExtension", () => (parcelRequire("aotp7")).multiBodiedExtension);
$parcel$export($8dd462732d984c7b$exports, "syncBlock", () => (parcelRequire("8WAFY")).syncBlock);
$parcel$export($8dd462732d984c7b$exports, "bodiedSyncBlock", () => (parcelRequire("3EiOU")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4r9Pq = parcelRequire("4r9Pq");


var $fsHCc = parcelRequire("fsHCc");


var $aZa28 = parcelRequire("aZa28");


var $fnSCn = parcelRequire("fnSCn");


var $jRrsu = parcelRequire("jRrsu");


var $iIGXo = parcelRequire("iIGXo");


var $ghpxT = parcelRequire("ghpxT");


var $4HD7y = parcelRequire("4HD7y");


var $aFNbc = parcelRequire("aFNbc");


var $j0UBv = parcelRequire("j0UBv");


var $bLhD4 = parcelRequire("bLhD4");


var $fGuiW = parcelRequire("fGuiW");


var $eK2Ov = parcelRequire("eK2Ov");


var $bIZRt = parcelRequire("bIZRt");


var $dupND = parcelRequire("dupND");


var $CmplZ = parcelRequire("CmplZ");


var $jl5Qf = parcelRequire("jl5Qf");


var $dGKc1 = parcelRequire("dGKc1");


var $bSuKu = parcelRequire("bSuKu");


var $h3652 = parcelRequire("h3652");


var $kRG5M = parcelRequire("kRG5M");


var $kZ3vg = parcelRequire("kZ3vg");


var $6xrFZ = parcelRequire("6xrFZ");


var $bTc4a = parcelRequire("bTc4a");


var $jblCI = parcelRequire("jblCI");


var $63Ztt = parcelRequire("63Ztt");


var $gClzS = parcelRequire("gClzS");


var $bpTLT = parcelRequire("bpTLT");


var $cXZ4C = parcelRequire("cXZ4C");


var $5elS6 = parcelRequire("5elS6");


var $cAWza = parcelRequire("cAWza");


var $jEypY = parcelRequire("jEypY");


var $hVXQj = parcelRequire("hVXQj");


var $lifsC = parcelRequire("lifsC");


var $aqHdD = parcelRequire("aqHdD");


var $aGTRk = parcelRequire("aGTRk");


var $iSXnW = parcelRequire("iSXnW");


var $cre7m = parcelRequire("cre7m");


var $f4dR3 = parcelRequire("f4dR3");


var $iw2ID = parcelRequire("iw2ID");


var $cfHGv = parcelRequire("cfHGv");


var $2xxP6 = parcelRequire("2xxP6");


var $u6ZFj = parcelRequire("u6ZFj");


var $4sfnB = parcelRequire("4sfnB");


var $aotp7 = parcelRequire("aotp7");


var $8WAFY = parcelRequire("8WAFY");


var $3EiOU = parcelRequire("3EiOU");



// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0dbcfc79b71921e3$var$typedNodes = $8dd462732d984c7b$exports;
const $0dbcfc79b71921e3$export$b1f729c6af6f2a6e = new Set(Object.keys($0dbcfc79b71921e3$var$typedNodes).filter((key)=>$0dbcfc79b71921e3$var$typedNodes[key] && $0dbcfc79b71921e3$var$typedNodes[key].group === 'inline'));


var $81OAa = parcelRequire("81OAa");




var $iyDxB = parcelRequire("iyDxB");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");

const $b807d28bb87bffcf$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $b807d28bb87bffcf$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $b807d28bb87bffcf$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $b807d28bb87bffcf$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$b807d28bb87bffcf$export$62d5811a2955c1d8.indexOf(a.type.name) - $b807d28bb87bffcf$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $b807d28bb87bffcf$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $b807d28bb87bffcf$export$fb80336a7e408cb3 = (doc, schema = (0, $iyDxB.defaultSchema), adfStage = 'final')=>{
    const node = $b807d28bb87bffcf$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $b807d28bb87bffcf$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $b807d28bb87bffcf$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $0dbcfc79b71921e3$export$b1f729c6af6f2a6e).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $b807d28bb87bffcf$export$fafd4f799ee68da0 = (content, schema = (0, $iyDxB.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$b807d28bb87bffcf$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b807d28bb87bffcf$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b807d28bb87bffcf$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b807d28bb87bffcf$var$ANCHOR_LINK = /^#/;
const $b807d28bb87bffcf$var$flattenUnknownBlockTree = (node, schema = (0, $iyDxB.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($b807d28bb87bffcf$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$b807d28bb87bffcf$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $b807d28bb87bffcf$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $81OAa.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $b807d28bb87bffcf$var$flattenUnknownBlockTree(node)
    };
};
const $b807d28bb87bffcf$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $b807d28bb87bffcf$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $b807d28bb87bffcf$export$81b20b6c83a56bd = (originalNode, schema = (0, $iyDxB.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $b807d28bb87bffcf$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $81OAa.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $81OAa.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $81OAa.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $81OAa.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $81OAa.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $81OAa.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $b807d28bb87bffcf$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $b807d28bb87bffcf$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $b807d28bb87bffcf$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $b807d28bb87bffcf$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $b807d28bb87bffcf$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $dGKc1.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $fO7hX.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $fO7hX.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $fO7hX.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $fO7hX.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $fO7hX.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $fO7hX.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $b807d28bb87bffcf$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (attrs && attrs.resourceId && (0, $iu6m9.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $fO7hX.generateUuid)()
                },
                marks: marks
            };
            else return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (attrs && attrs.resourceId && Array.isArray(content) && content.length > 0 && (0, $iu6m9.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $fO7hX.generateUuid)()
                },
                marks: marks,
                content: content
            };
            else return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
    }
    return $b807d28bb87bffcf$export$b9908ef75cad1e0e(node);
};
const $b807d28bb87bffcf$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$b807d28bb87bffcf$var$RELATIVE_LINK.test(linkHref) && !$b807d28bb87bffcf$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $81OAa.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($b807d28bb87bffcf$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $b807d28bb87bffcf$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $b807d28bb87bffcf$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};
module.exports["ADFStages"] = $b807d28bb87bffcf$export$3b94ef2190b2d585;
module.exports["getMarksByOrder"] = $b807d28bb87bffcf$export$99a33ed044c278ae;
module.exports["isSameMark"] = $b807d28bb87bffcf$export$b1304404bdc42b7a;
module.exports["getValidDocument"] = $b807d28bb87bffcf$export$fb80336a7e408cb3;
module.exports["getValidNode"] = $b807d28bb87bffcf$export$81b20b6c83a56bd;

});

parcelRegister("6aq5c", function(module, exports) {

var $jqXx5 = parcelRequire("jqXx5");


var $d925B = parcelRequire("d925B");


var $juTiU = parcelRequire("juTiU");

const $a505c57fde83bb0c$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $a505c57fde83bb0c$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $a505c57fde83bb0c$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $a505c57fde83bb0c$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $a505c57fde83bb0c$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $a505c57fde83bb0c$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $a505c57fde83bb0c$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $a505c57fde83bb0c$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $a505c57fde83bb0c$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $a505c57fde83bb0c$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $a505c57fde83bb0c$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $a505c57fde83bb0c$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $a505c57fde83bb0c$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $a505c57fde83bb0c$export$87b732fa69cdf16e(child) : validate(child, $a505c57fde83bb0c$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $a505c57fde83bb0c$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $a505c57fde83bb0c$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $a505c57fde83bb0c$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $juTiU.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $a505c57fde83bb0c$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $jqXx5.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $a505c57fde83bb0c$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
function $a505c57fde83bb0c$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}
module.exports["validateADFEntity"] = $a505c57fde83bb0c$export$884cfad20dece33e;

});

parcelRegister("jqXx5", function(module, exports) {

var $dZ8uq = parcelRequire("dZ8uq");

var $58b4146701b9e110$exports = {};
$parcel$export($58b4146701b9e110$exports, "alignment", () => (parcelRequire("4rpi6")).alignment);
$parcel$export($58b4146701b9e110$exports, "annotation", () => (parcelRequire("4rpi6")).annotation);
$parcel$export($58b4146701b9e110$exports, "backgroundColor", () => (parcelRequire("4rpi6")).backgroundColor);
$parcel$export($58b4146701b9e110$exports, "blockCard", () => (parcelRequire("4rpi6")).blockCard);
$parcel$export($58b4146701b9e110$exports, "block_content", () => (parcelRequire("4rpi6")).block_content);
$parcel$export($58b4146701b9e110$exports, "blockRootOnly", () => (parcelRequire("4rpi6")).blockRootOnly);
$parcel$export($58b4146701b9e110$exports, "blockquote", () => (parcelRequire("4rpi6")).blockquote);
$parcel$export($58b4146701b9e110$exports, "blockTaskItem", () => (parcelRequire("4rpi6")).blockTaskItem);
$parcel$export($58b4146701b9e110$exports, "bodiedExtension", () => (parcelRequire("4rpi6")).bodiedExtension);
$parcel$export($58b4146701b9e110$exports, "bodiedExtension_with_marks", () => (parcelRequire("4rpi6")).bodiedExtension_with_marks);
$parcel$export($58b4146701b9e110$exports, "border", () => (parcelRequire("4rpi6")).border);
$parcel$export($58b4146701b9e110$exports, "breakout", () => (parcelRequire("4rpi6")).breakout);
$parcel$export($58b4146701b9e110$exports, "bulletList", () => (parcelRequire("4rpi6")).bulletList);
$parcel$export($58b4146701b9e110$exports, "caption", () => (parcelRequire("4rpi6")).caption);
$parcel$export($58b4146701b9e110$exports, "code", () => (parcelRequire("4rpi6")).code);
$parcel$export($58b4146701b9e110$exports, "codeBlock", () => (parcelRequire("4rpi6")).codeBlock);
$parcel$export($58b4146701b9e110$exports, "codeBlock_root_only", () => (parcelRequire("4rpi6")).codeBlock_root_only);
$parcel$export($58b4146701b9e110$exports, "text_with_no_marks", () => (parcelRequire("4rpi6")).text_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "confluenceInlineComment", () => (parcelRequire("4rpi6")).confluenceInlineComment);
$parcel$export($58b4146701b9e110$exports, "dataConsumer", () => (parcelRequire("4rpi6")).dataConsumer);
$parcel$export($58b4146701b9e110$exports, "date", () => (parcelRequire("4rpi6")).date);
$parcel$export($58b4146701b9e110$exports, "decisionItem", () => (parcelRequire("4rpi6")).decisionItem);
$parcel$export($58b4146701b9e110$exports, "decisionList", () => (parcelRequire("4rpi6")).decisionList);
$parcel$export($58b4146701b9e110$exports, "doc", () => (parcelRequire("4rpi6")).doc);
$parcel$export($58b4146701b9e110$exports, "em", () => (parcelRequire("4rpi6")).em);
$parcel$export($58b4146701b9e110$exports, "embedCard", () => (parcelRequire("4rpi6")).embedCard);
$parcel$export($58b4146701b9e110$exports, "emoji", () => (parcelRequire("4rpi6")).emoji);
$parcel$export($58b4146701b9e110$exports, "expand", () => (parcelRequire("4rpi6")).expand);
$parcel$export($58b4146701b9e110$exports, "expand_root_only", () => (parcelRequire("4rpi6")).expand_root_only);
$parcel$export($58b4146701b9e110$exports, "extension", () => (parcelRequire("4rpi6")).extension);
$parcel$export($58b4146701b9e110$exports, "extensionFrame", () => (parcelRequire("4rpi6")).extensionFrame);
$parcel$export($58b4146701b9e110$exports, "extension_with_marks", () => (parcelRequire("4rpi6")).extension_with_marks);
$parcel$export($58b4146701b9e110$exports, "fontSize", () => (parcelRequire("4rpi6")).fontSize);
$parcel$export($58b4146701b9e110$exports, "fragment", () => (parcelRequire("4rpi6")).fragment);
$parcel$export($58b4146701b9e110$exports, "hardBreak", () => (parcelRequire("4rpi6")).hardBreak);
$parcel$export($58b4146701b9e110$exports, "heading", () => (parcelRequire("4rpi6")).heading);
$parcel$export($58b4146701b9e110$exports, "heading_with_alignment", () => (parcelRequire("4rpi6")).heading_with_alignment);
$parcel$export($58b4146701b9e110$exports, "heading_with_indentation", () => (parcelRequire("4rpi6")).heading_with_indentation);
$parcel$export($58b4146701b9e110$exports, "heading_with_no_marks", () => (parcelRequire("4rpi6")).heading_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "indentation", () => (parcelRequire("4rpi6")).indentation);
$parcel$export($58b4146701b9e110$exports, "inlineCard", () => (parcelRequire("4rpi6")).inlineCard);
$parcel$export($58b4146701b9e110$exports, "inlineExtension", () => (parcelRequire("4rpi6")).inlineExtension);
$parcel$export($58b4146701b9e110$exports, "inlineExtension_with_marks", () => (parcelRequire("4rpi6")).inlineExtension_with_marks);
$parcel$export($58b4146701b9e110$exports, "inline_content", () => (parcelRequire("4rpi6")).inline_content);
$parcel$export($58b4146701b9e110$exports, "layoutColumn", () => (parcelRequire("4rpi6")).layoutColumn);
$parcel$export($58b4146701b9e110$exports, "layoutSection", () => (parcelRequire("4rpi6")).layoutSection);
$parcel$export($58b4146701b9e110$exports, "layoutSection_full", () => (parcelRequire("4rpi6")).layoutSection_full);
$parcel$export($58b4146701b9e110$exports, "layoutSection_with_single_column", () => (parcelRequire("4rpi6")).layoutSection_with_single_column);
$parcel$export($58b4146701b9e110$exports, "link", () => (parcelRequire("4rpi6")).link);
$parcel$export($58b4146701b9e110$exports, "listItem", () => (parcelRequire("4rpi6")).listItem);
$parcel$export($58b4146701b9e110$exports, "listItem_with_flexible_first_child", () => (parcelRequire("4rpi6")).listItem_with_flexible_first_child);
$parcel$export($58b4146701b9e110$exports, "media", () => (parcelRequire("4rpi6")).media);
$parcel$export($58b4146701b9e110$exports, "mediaGroup", () => (parcelRequire("4rpi6")).mediaGroup);
$parcel$export($58b4146701b9e110$exports, "mediaInline", () => (parcelRequire("4rpi6")).mediaInline);
$parcel$export($58b4146701b9e110$exports, "mediaSingle", () => (parcelRequire("4rpi6")).mediaSingle);
$parcel$export($58b4146701b9e110$exports, "mediaSingle_caption", () => (parcelRequire("4rpi6")).mediaSingle_caption);
$parcel$export($58b4146701b9e110$exports, "mediaSingle_full", () => (parcelRequire("4rpi6")).mediaSingle_full);
$parcel$export($58b4146701b9e110$exports, "mention", () => (parcelRequire("4rpi6")).mention);
$parcel$export($58b4146701b9e110$exports, "multiBodiedExtension", () => (parcelRequire("4rpi6")).multiBodiedExtension);
$parcel$export($58b4146701b9e110$exports, "nestedExpand", () => (parcelRequire("4rpi6")).nestedExpand);
$parcel$export($58b4146701b9e110$exports, "nestedExpand_content", () => (parcelRequire("4rpi6")).nestedExpand_content);
$parcel$export($58b4146701b9e110$exports, "nestedExpand_with_no_marks", () => (parcelRequire("4rpi6")).nestedExpand_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "non_nestable_block_content", () => (parcelRequire("4rpi6")).non_nestable_block_content);
$parcel$export($58b4146701b9e110$exports, "orderedList", () => (parcelRequire("4rpi6")).orderedList);
$parcel$export($58b4146701b9e110$exports, "panel", () => (parcelRequire("4rpi6")).panel);
$parcel$export($58b4146701b9e110$exports, "paragraph", () => (parcelRequire("4rpi6")).paragraph);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_alignment", () => (parcelRequire("4rpi6")).paragraph_with_alignment);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_font_size", () => (parcelRequire("4rpi6")).paragraph_with_font_size);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_font_size_and_alignment", () => (parcelRequire("4rpi6")).paragraph_with_font_size_and_alignment);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_font_size_and_indentation", () => (parcelRequire("4rpi6")).paragraph_with_font_size_and_indentation);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_indentation", () => (parcelRequire("4rpi6")).paragraph_with_indentation);
$parcel$export($58b4146701b9e110$exports, "paragraph_with_no_marks", () => (parcelRequire("4rpi6")).paragraph_with_no_marks);
$parcel$export($58b4146701b9e110$exports, "placeholder", () => (parcelRequire("4rpi6")).placeholder);
$parcel$export($58b4146701b9e110$exports, "rule", () => (parcelRequire("4rpi6")).rule);
$parcel$export($58b4146701b9e110$exports, "status", () => (parcelRequire("4rpi6")).status);
$parcel$export($58b4146701b9e110$exports, "strike", () => (parcelRequire("4rpi6")).strike);
$parcel$export($58b4146701b9e110$exports, "strong", () => (parcelRequire("4rpi6")).strong);
$parcel$export($58b4146701b9e110$exports, "subsup", () => (parcelRequire("4rpi6")).subsup);
$parcel$export($58b4146701b9e110$exports, "table", () => (parcelRequire("4rpi6")).table);
$parcel$export($58b4146701b9e110$exports, "tableCell", () => (parcelRequire("4rpi6")).tableCell);
$parcel$export($58b4146701b9e110$exports, "tableHeader", () => (parcelRequire("4rpi6")).tableHeader);
$parcel$export($58b4146701b9e110$exports, "tableRow", () => (parcelRequire("4rpi6")).tableRow);
$parcel$export($58b4146701b9e110$exports, "taskItem", () => (parcelRequire("4rpi6")).taskItem);
$parcel$export($58b4146701b9e110$exports, "taskList", () => (parcelRequire("4rpi6")).taskList);
$parcel$export($58b4146701b9e110$exports, "taskList_with_flexible_first_child", () => (parcelRequire("4rpi6")).taskList_with_flexible_first_child);
$parcel$export($58b4146701b9e110$exports, "text", () => (parcelRequire("4rpi6")).text);
$parcel$export($58b4146701b9e110$exports, "textColor", () => (parcelRequire("4rpi6")).textColor);
$parcel$export($58b4146701b9e110$exports, "text_code_inline", () => (parcelRequire("4rpi6")).text_code_inline);
$parcel$export($58b4146701b9e110$exports, "text_formatted", () => (parcelRequire("4rpi6")).text_formatted);
$parcel$export($58b4146701b9e110$exports, "text_link_inline", () => (parcelRequire("4rpi6")).text_link_inline);
$parcel$export($58b4146701b9e110$exports, "underline", () => (parcelRequire("4rpi6")).underline);
$parcel$export($58b4146701b9e110$exports, "syncBlock", () => (parcelRequire("4rpi6")).syncBlock);
$parcel$export($58b4146701b9e110$exports, "bodiedSyncBlock", () => (parcelRequire("4rpi6")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4rpi6 = parcelRequire("4rpi6");



const $b212eb2b08ba23cd$export$4e62c701997796c1 = (x)=>x != null;
const $b212eb2b08ba23cd$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $b212eb2b08ba23cd$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $b212eb2b08ba23cd$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $b212eb2b08ba23cd$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $b212eb2b08ba23cd$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $b212eb2b08ba23cd$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $b212eb2b08ba23cd$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];


function $f843a69f28c03b39$export$7d2123bc001cdbf8(validatorSpecs, entity) {
    // Filter out content type + irrelevant nodes
    const potentialAllowedContent = Object.entries(validatorSpecs).filter((item)=>{
        const [node, value] = item;
        if ($f843a69f28c03b39$var$isValidatorSpec(value)) return node === entity.type;
        const [nodeName, spec] = [
            value[0],
            value[1]
        ];
        if (typeof spec === 'string' || typeof spec !== 'object') return false;
        return nodeName === entity.type;
    });
    // Keep types such as `mediaSingle_full` which contain additional spec information
    const contentArray = potentialAllowedContent.map((allowedContent)=>{
        if ($f843a69f28c03b39$var$isValidatorSpec(allowedContent)) return undefined;
        const value = allowedContent[1];
        return !$f843a69f28c03b39$var$isValidatorSpec(value) ? [
            [
                value[0],
                value[1]
            ]
        ] : undefined;
    });
    return contentArray.filter((x)=>!!x);
}
function $f843a69f28c03b39$var$isValidatorSpec(spec) {
    return spec.props !== undefined || spec.required !== undefined || spec.maxItems !== undefined || spec.minItems !== undefined;
}



var $81OAa = parcelRequire("81OAa");

const $7553da36add03409$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $81OAa.isSafeUrl)
};


// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5a24607d60a15c5e$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5a24607d60a15c5e$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Checks if a spec is a variant spec.
 * A variant spec is an array where the first element is a string (base spec name)
 * and the second element is a ValidatorSpec object { props: { ... } }
 *
 * @param spec - The spec to check
 * @returns true if the spec is a variant spec, false otherwise
 */ const $5a24607d60a15c5e$var$isVariant = (spec)=>typeof spec === 'object' && !!spec && 0 in spec && 1 in spec && typeof spec[0] === 'string' && typeof spec[1] === 'object';
function $5a24607d60a15c5e$export$a49afc9edc88765c(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($58b4146701b9e110$exports).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let spec = {
            ...$58b4146701b9e110$exports[k]
        };
        if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true) && $5a24607d60a15c5e$var$isVariant(spec) && // Only apply to variants which are explicitly marked for override in `variantSpecOverrides`
        Object.values($5a24607d60a15c5e$var$variantSpecOverrides).includes(k)) // This allows the variant spec to also have the content normalization applied to it
        // When the spec is a variant it will be in the form of ['base_spec_name', { props: { ... } }]
        // So the actual validator spec of the variant will be the second item in the array
        // We also need to shallow clone this to ensure we don't mutate the original spec
        spec = {
            ...spec[1]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $b212eb2b08ba23cd$export$844ec244b1367d54)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $58b4146701b9e110$exports[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $b212eb2b08ba23cd$export$844ec244b1367d54)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($58b4146701b9e110$exports[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $58b4146701b9e110$exports[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($58b4146701b9e110$exports[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $58b4146701b9e110$exports[subItem] : (0, $b212eb2b08ba23cd$export$844ec244b1367d54)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $5a24607d60a15c5e$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5a24607d60a15c5e$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $5a24607d60a15c5e$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $5a24607d60a15c5e$export$66c739158ef99a42(spec, value) {
    if (!(0, $b212eb2b08ba23cd$export$4e62c701997796c1)(value)) return !!spec.optional;
    if ($5a24607d60a15c5e$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $5a24607d60a15c5e$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $5a24607d60a15c5e$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $b212eb2b08ba23cd$export$f9ce7b637dfbe238)(value);
        case 'number':
            return (0, $b212eb2b08ba23cd$export$7e4aa119212bc614)(value) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $b212eb2b08ba23cd$export$a287f47fed4544b8)(value) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $b212eb2b08ba23cd$export$4e62c701997796c1)((0, $7553da36add03409$export$d1b377ca77ac267d)[rule]) && (0, $7553da36add03409$export$d1b377ca77ac267d)[rule](value);
            return (0, $b212eb2b08ba23cd$export$844ec244b1367d54)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $b212eb2b08ba23cd$export$53b83ca8eaab0383)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$5a24607d60a15c5e$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$5a24607d60a15c5e$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $b212eb2b08ba23cd$export$844ec244b1367d54)(value) && spec.values.indexOf(value) > -1;
    }
}
const $5a24607d60a15c5e$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $5a24607d60a15c5e$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $5a24607d60a15c5e$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $5a24607d60a15c5e$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $5a24607d60a15c5e$var$getUnsupportedOptions(parentSpec));
};
const $5a24607d60a15c5e$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $5a24607d60a15c5e$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $5a24607d60a15c5e$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
/**
 * Map of base spec names to a preferred variant spec that should be used in their place during validation.
 *
 * WARNING: The variant spec must be a strict superset of the base spec, i.e. any content valid
 * under the base spec must also be valid under the variant
 */ const $5a24607d60a15c5e$var$variantSpecOverrides = {
    listItem: 'listItem_with_flexible_first_child',
    taskList: 'taskList_with_flexible_first_child'
};
/**
 * Replaces base validator specs with their designated variant overrides
 */ const $5a24607d60a15c5e$var$applyVariantSpecOverrides = (validatorSpecs)=>{
    Object.entries($5a24607d60a15c5e$var$variantSpecOverrides).forEach(([base, variant])=>{
        const baseSpec = validatorSpecs[base];
        const variantOverride = validatorSpecs[variant];
        if (baseSpec?.props && variantOverride?.props && typeof baseSpec.props === 'object' && typeof variantOverride.props === 'object') // Merge variant overrides INTO the base spec
        baseSpec.props = {
            ...baseSpec.props,
            ...variantOverride.props
        };
    });
};
function $5a24607d60a15c5e$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $5a24607d60a15c5e$export$a49afc9edc88765c(nodes, marks);
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true)) $5a24607d60a15c5e$var$applyVariantSpecOverrides(validatorSpecs);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        if (!allowed) for (const allowed of (0, $f843a69f28c03b39$export$7d2123bc001cdbf8)(validatorSpecs, entity)){
            const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
            if (validationResult.valid) return {
                entity: validationResult.entity,
                valid: validationResult.valid
            };
        }
        // If `allowed` was provided or we haven't passed yet, return the initial result
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $5a24607d60a15c5e$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $5a24607d60a15c5e$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $5a24607d60a15c5e$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $5a24607d60a15c5e$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $b212eb2b08ba23cd$export$4e62c701997796c1)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$5a24607d60a15c5e$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $b212eb2b08ba23cd$export$4e62c701997796c1)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $b212eb2b08ba23cd$export$7b85fd78dd236198)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $5a24607d60a15c5e$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $5a24607d60a15c5e$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $5a24607d60a15c5e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $5a24607d60a15c5e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $5a24607d60a15c5e$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $5a24607d60a15c5e$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $5a24607d60a15c5e$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $5a24607d60a15c5e$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $b212eb2b08ba23cd$export$4e62c701997796c1)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $b212eb2b08ba23cd$export$784d13d8ee351f07)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $5a24607d60a15c5e$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $b212eb2b08ba23cd$export$4e62c701997796c1)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $5a24607d60a15c5e$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $b212eb2b08ba23cd$export$7b85fd78dd236198)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $b212eb2b08ba23cd$export$7b85fd78dd236198)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $5a24607d60a15c5e$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $5a24607d60a15c5e$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}
module.exports["validator"] = $5a24607d60a15c5e$export$956325f45c5d174a;

});

parcelRegister("4rpi6", function(module, exports) {
const $281e0d22c9e4e7a0$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'paragraph_with_font_size_and_alignment',
    'paragraph_with_font_size_and_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $281e0d22c9e4e7a0$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $281e0d22c9e4e7a0$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $281e0d22c9e4e7a0$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $281e0d22c9e4e7a0$export$16018c61064a18df = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ]
            ],
            minItems: 1
        }
    }
};
const $281e0d22c9e4e7a0$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $281e0d22c9e4e7a0$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$e92c7e4302dd4371 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        },
        attrs: {
            props: {
                resourceId: {
                    type: 'string'
                },
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_font_size_and_alignment',
                    'paragraph_with_font_size_and_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel',
                    'rule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_flexible_first_child'
                ]
            ],
            minItems: 1
        }
    }
};
const $281e0d22c9e4e7a0$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $281e0d22c9e4e7a0$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $281e0d22c9e4e7a0$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $281e0d22c9e4e7a0$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $281e0d22c9e4e7a0$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_font_size_and_alignment',
                    'paragraph_with_font_size_and_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $281e0d22c9e4e7a0$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $281e0d22c9e4e7a0$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $281e0d22c9e4e7a0$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$85e3c3ca0c6fb93 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fontSize'
            ]
        },
        attrs: {
            props: {
                fontSize: {
                    type: 'enum',
                    values: [
                        'small'
                    ]
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $281e0d22c9e4e7a0$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $281e0d22c9e4e7a0$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $281e0d22c9e4e7a0$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $281e0d22c9e4e7a0$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $281e0d22c9e4e7a0$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $281e0d22c9e4e7a0$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $281e0d22c9e4e7a0$export$d80b696b842918ee = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_font_size',
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'taskList_with_flexible_first_child',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $281e0d22c9e4e7a0$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $281e0d22c9e4e7a0$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $281e0d22c9e4e7a0$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $281e0d22c9e4e7a0$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_font_size',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $281e0d22c9e4e7a0$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'paragraph_with_font_size',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $281e0d22c9e4e7a0$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_flexible_first_child'
                ]
            ],
            minItems: 1
        }
    }
};
const $281e0d22c9e4e7a0$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $281e0d22c9e4e7a0$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $281e0d22c9e4e7a0$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$f745a1f9fa5e1ca8 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'fontSize'
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$20cf96f162e24b93 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'fontSize',
                        'alignment'
                    ]
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$8f4b0a3fbc7cdc91 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'fontSize',
                        'indentation'
                    ]
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $281e0d22c9e4e7a0$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$faab0ca9701d7048 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        },
        attrs: {
            props: {
                resourceId: {
                    type: 'string'
                },
                localId: {
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_font_size_and_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $281e0d22c9e4e7a0$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_font_size_and_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $281e0d22c9e4e7a0$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $281e0d22c9e4e7a0$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $281e0d22c9e4e7a0$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'taskItem',
                    'blockTaskItem'
                ],
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $281e0d22c9e4e7a0$export$32c25bbc91b30817 = [
    'taskList',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'taskItem',
                        'taskList',
                        'blockTaskItem'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $281e0d22c9e4e7a0$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $281e0d22c9e4e7a0$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $281e0d22c9e4e7a0$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};
module.exports["alignment"] = $281e0d22c9e4e7a0$export$8e53000a4ec837;
module.exports["annotation"] = $281e0d22c9e4e7a0$export$8512c9afa7b24c3b;
module.exports["backgroundColor"] = $281e0d22c9e4e7a0$export$8c5a050822fd698c;
module.exports["block_content"] = $281e0d22c9e4e7a0$export$a31afb40076fa18b;
module.exports["blockCard"] = $281e0d22c9e4e7a0$export$c4c2f833baaebdb8;
module.exports["blockquote"] = $281e0d22c9e4e7a0$export$67dc04e652a298ca;
module.exports["blockRootOnly"] = $281e0d22c9e4e7a0$export$ebb5393736e9ba23;
module.exports["blockTaskItem"] = $281e0d22c9e4e7a0$export$16018c61064a18df;
module.exports["bodiedExtension"] = $281e0d22c9e4e7a0$export$27903d543b563e39;
module.exports["bodiedExtension_with_marks"] = $281e0d22c9e4e7a0$export$ee052cc5b2356e83;
module.exports["bodiedSyncBlock"] = $281e0d22c9e4e7a0$export$e92c7e4302dd4371;
module.exports["border"] = $281e0d22c9e4e7a0$export$1edee58a52776cd9;
module.exports["breakout"] = $281e0d22c9e4e7a0$export$89015c65f1c75e3f;
module.exports["bulletList"] = $281e0d22c9e4e7a0$export$a140c94e5ea26bee;
module.exports["caption"] = $281e0d22c9e4e7a0$export$8e3c2dfdc4f0453d;
module.exports["code"] = $281e0d22c9e4e7a0$export$6565f9f03506010b;
module.exports["codeBlock"] = $281e0d22c9e4e7a0$export$7bb0d5c671655cc4;
module.exports["codeBlock_root_only"] = $281e0d22c9e4e7a0$export$38d90d1aac6883a3;
module.exports["confluenceInlineComment"] = $281e0d22c9e4e7a0$export$f3b72f8fc4684ecd;
module.exports["dataConsumer"] = $281e0d22c9e4e7a0$export$3024f02c495408d6;
module.exports["date"] = $281e0d22c9e4e7a0$export$324d90190a8b822a;
module.exports["decisionItem"] = $281e0d22c9e4e7a0$export$6959e16eeff859b4;
module.exports["decisionList"] = $281e0d22c9e4e7a0$export$62d45a65fb43d95e;
module.exports["doc"] = $281e0d22c9e4e7a0$export$2a111da947c407d2;
module.exports["em"] = $281e0d22c9e4e7a0$export$c63c6f932822f543;
module.exports["embedCard"] = $281e0d22c9e4e7a0$export$be4283d9a1cb1ff6;
module.exports["emoji"] = $281e0d22c9e4e7a0$export$a19185d1233fc4b2;
module.exports["expand"] = $281e0d22c9e4e7a0$export$9f77e0932fb78f72;
module.exports["expand_root_only"] = $281e0d22c9e4e7a0$export$b2817c6954dd6d2c;
module.exports["extension"] = $281e0d22c9e4e7a0$export$1b45514b112dd749;
module.exports["extension_with_marks"] = $281e0d22c9e4e7a0$export$15be7c145cec614a;
module.exports["extensionFrame"] = $281e0d22c9e4e7a0$export$4fdcae991fd743e7;
module.exports["fontSize"] = $281e0d22c9e4e7a0$export$85e3c3ca0c6fb93;
module.exports["fragment"] = $281e0d22c9e4e7a0$export$f00aeb236b6f05af;
module.exports["hardBreak"] = $281e0d22c9e4e7a0$export$371da9dd35aba193;
module.exports["heading"] = $281e0d22c9e4e7a0$export$46e4a324ac90507f;
module.exports["heading_with_alignment"] = $281e0d22c9e4e7a0$export$c17edf9af655deaf;
module.exports["heading_with_indentation"] = $281e0d22c9e4e7a0$export$1902f9737466a0dc;
module.exports["heading_with_no_marks"] = $281e0d22c9e4e7a0$export$7b491e75f1be9278;
module.exports["indentation"] = $281e0d22c9e4e7a0$export$480c699bd4ec0d86;
module.exports["inline_content"] = $281e0d22c9e4e7a0$export$e23e6162adaa368d;
module.exports["inlineCard"] = $281e0d22c9e4e7a0$export$cbf8224b64e0d942;
module.exports["inlineExtension"] = $281e0d22c9e4e7a0$export$16b353b2649bd8d9;
module.exports["inlineExtension_with_marks"] = $281e0d22c9e4e7a0$export$e37f10815f36843d;
module.exports["layoutColumn"] = $281e0d22c9e4e7a0$export$ab76e7c03cd6f650;
module.exports["layoutSection"] = $281e0d22c9e4e7a0$export$b3b6a70a7fa4a5be;
module.exports["layoutSection_full"] = $281e0d22c9e4e7a0$export$941b63fbd931e449;
module.exports["layoutSection_with_single_column"] = $281e0d22c9e4e7a0$export$e0e9834198e8601d;
module.exports["link"] = $281e0d22c9e4e7a0$export$9c30223ca0a664fb;
module.exports["listItem"] = $281e0d22c9e4e7a0$export$76c7e83ecc9cdf05;
module.exports["listItem_with_flexible_first_child"] = $281e0d22c9e4e7a0$export$d80b696b842918ee;
module.exports["media"] = $281e0d22c9e4e7a0$export$987d49ffe1b0900f;
module.exports["mediaGroup"] = $281e0d22c9e4e7a0$export$2855e964765eac9;
module.exports["mediaInline"] = $281e0d22c9e4e7a0$export$38bab695e3f720f1;
module.exports["mediaSingle"] = $281e0d22c9e4e7a0$export$969fe3781ca15058;
module.exports["mediaSingle_caption"] = $281e0d22c9e4e7a0$export$68b0ead306f9670f;
module.exports["mediaSingle_full"] = $281e0d22c9e4e7a0$export$f7fd577406abd5f8;
module.exports["mention"] = $281e0d22c9e4e7a0$export$db83999c14438df4;
module.exports["multiBodiedExtension"] = $281e0d22c9e4e7a0$export$c3c04d555a8b9013;
module.exports["nestedExpand"] = $281e0d22c9e4e7a0$export$63cadbf5f4296627;
module.exports["nestedExpand_content"] = $281e0d22c9e4e7a0$export$9584f52f3ebd5d7e;
module.exports["nestedExpand_with_no_marks"] = $281e0d22c9e4e7a0$export$b756fc994eb0bc4f;
module.exports["non_nestable_block_content"] = $281e0d22c9e4e7a0$export$ed866000601e7fa5;
module.exports["orderedList"] = $281e0d22c9e4e7a0$export$a5dc81035676e7a;
module.exports["panel"] = $281e0d22c9e4e7a0$export$21f42ab9b6679f44;
module.exports["paragraph"] = $281e0d22c9e4e7a0$export$9c206ddddb32a9b;
module.exports["paragraph_with_alignment"] = $281e0d22c9e4e7a0$export$9ca11c06877e5c64;
module.exports["paragraph_with_font_size"] = $281e0d22c9e4e7a0$export$f745a1f9fa5e1ca8;
module.exports["paragraph_with_font_size_and_alignment"] = $281e0d22c9e4e7a0$export$20cf96f162e24b93;
module.exports["paragraph_with_font_size_and_indentation"] = $281e0d22c9e4e7a0$export$8f4b0a3fbc7cdc91;
module.exports["paragraph_with_indentation"] = $281e0d22c9e4e7a0$export$a3bd66932996fb7d;
module.exports["paragraph_with_no_marks"] = $281e0d22c9e4e7a0$export$f06f75eb1e56b0c5;
module.exports["placeholder"] = $281e0d22c9e4e7a0$export$c7187bbd1a7a9244;
module.exports["rule"] = $281e0d22c9e4e7a0$export$fbeb3a3956e8a3c7;
module.exports["status"] = $281e0d22c9e4e7a0$export$471f7ae5c4103ae1;
module.exports["strike"] = $281e0d22c9e4e7a0$export$4899a95d70ec5056;
module.exports["strong"] = $281e0d22c9e4e7a0$export$59ae2c325a998f89;
module.exports["subsup"] = $281e0d22c9e4e7a0$export$b3401ee80eb31041;
module.exports["syncBlock"] = $281e0d22c9e4e7a0$export$faab0ca9701d7048;
module.exports["table"] = $281e0d22c9e4e7a0$export$9852986a3ec5f6a0;
module.exports["tableCell"] = $281e0d22c9e4e7a0$export$e1e720e5f4603e6a;
module.exports["tableHeader"] = $281e0d22c9e4e7a0$export$48884d2a5190dc73;
module.exports["tableRow"] = $281e0d22c9e4e7a0$export$ce666bf02318c957;
module.exports["taskItem"] = $281e0d22c9e4e7a0$export$6d8b0ef52e2e6390;
module.exports["taskList"] = $281e0d22c9e4e7a0$export$375b6afcc5f4d291;
module.exports["taskList_with_flexible_first_child"] = $281e0d22c9e4e7a0$export$32c25bbc91b30817;
module.exports["text"] = $281e0d22c9e4e7a0$export$6f093cfa640b7166;
module.exports["text_code_inline"] = $281e0d22c9e4e7a0$export$5008c13f04d544f6;
module.exports["text_formatted"] = $281e0d22c9e4e7a0$export$d24a7becb4e0da7c;
module.exports["text_link_inline"] = $281e0d22c9e4e7a0$export$2a9d18d5b3064e6c;
module.exports["text_with_no_marks"] = $281e0d22c9e4e7a0$export$437a3d96346717e0;
module.exports["textColor"] = $281e0d22c9e4e7a0$export$32f78bffcd82ff28;
module.exports["underline"] = $281e0d22c9e4e7a0$export$425327af25286e5e;

});

parcelRegister("juTiU", function(module, exports) {

var $d925B = parcelRequire("d925B");

const $e291ba685b2f2282$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $e291ba685b2f2282$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e291ba685b2f2282$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $e291ba685b2f2282$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $e291ba685b2f2282$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$e291ba685b2f2282$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $e291ba685b2f2282$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $e291ba685b2f2282$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $e291ba685b2f2282$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $e291ba685b2f2282$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $d925B.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $e291ba685b2f2282$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$e291ba685b2f2282$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $e291ba685b2f2282$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $e291ba685b2f2282$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $e291ba685b2f2282$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $e291ba685b2f2282$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $d925B.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $e291ba685b2f2282$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $e291ba685b2f2282$var$trackUnsupportedContentTooltipActionFor((0, $d925B.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};
module.exports["findAndTrackUnsupportedContentNodes"] = $e291ba685b2f2282$export$d343369b8f25914;
module.exports["fireUnsupportedEvent"] = $e291ba685b2f2282$export$e1051b410945e4d4;
module.exports["trackUnsupportedContentTooltipDisplayedFor"] = $e291ba685b2f2282$export$3a34598135e7219b;

});

parcelRegister("67O0h", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $iyDxB = parcelRequire("iyDxB");


var $4FxUL = parcelRequire("4FxUL");

var $6mbqi = parcelRequire("6mbqi");


var $4BBKV = parcelRequire("4BBKV");

var $kckFS = parcelRequire("kckFS");

var $iq4lN = parcelRequire("iq4lN");

var $bWRlG = parcelRequire("bWRlG");




var $1DWH0 = parcelRequire("1DWH0");

const $0d5221b11c687d15$export$9ac3d19711324187 = (0, $1DWH0.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});



var $iu6m9 = parcelRequire("iu6m9");


var $9K4OG = parcelRequire("9K4OG");


var $d7ZU3 = parcelRequire("d7ZU3");


var $2T4ch = parcelRequire("2T4ch");


var $jz9wK = parcelRequire("jz9wK");


var $8pwxt = parcelRequire("8pwxt");





var $hTKp4 = parcelRequire("hTKp4");


var $cQJcI = parcelRequire("cQJcI");

var $bBdDv = parcelRequire("bBdDv");




const $af6ef71a6f2fded7$export$3325eba9424d3c32 = (options = {})=>{
    const { stabilityWaitTime: stabilityWaitTime = 200, maxStabilityWaitTime: maxStabilityWaitTime = 10000 } = options;
    const stabilityTimeoutRef = (0, $42omo.useRef)(null);
    const resizeObserverRef = (0, $42omo.useRef)(null);
    const lastStableTimeRef = (0, $42omo.useRef)(0);
    const onStableCallbackRef = (0, $42omo.useRef)(null);
    const cleanup = (0, $42omo.useCallback)(()=>{
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        onStableCallbackRef.current = null;
        lastStableTimeRef.current = 0;
    }, []);
    const scheduleStabilityCheck = (0, $42omo.useCallback)(()=>{
        // Clear any existing stability timeout.
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        // Check if we've exceeded the maximum stability wait time.
        const now = Date.now();
        if (lastStableTimeRef.current === 0) lastStableTimeRef.current = now;
        else if (now - lastStableTimeRef.current > maxStabilityWaitTime) {
            // We've waited too long for stability, call the callback now.
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
            return;
        }
        // Set a timeout to call the callback after the stability wait time.
        stabilityTimeoutRef.current = setTimeout(()=>{
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
        }, stabilityWaitTime);
    }, [
        stabilityWaitTime,
        maxStabilityWaitTime,
        cleanup
    ]);
    const waitForStability = (0, $42omo.useCallback)((container, onStable)=>{
        // Clean up any existing observer
        cleanup();
        // Store the callback
        onStableCallbackRef.current = onStable;
        // Check if ResizeObserver is available
        if (typeof ResizeObserver === 'undefined') {
            // Fallback: just call the callback after the stability wait time
            stabilityTimeoutRef.current = setTimeout(()=>{
                if (onStableCallbackRef.current) {
                    onStableCallbackRef.current();
                    cleanup();
                }
            }, stabilityWaitTime);
            return;
        }
        // Create a ResizeObserver to monitor the container for size changes.
        resizeObserverRef.current = new ResizeObserver(()=>{
            // Container size changed, reset stability timer.
            scheduleStabilityCheck();
        });
        resizeObserverRef.current.observe(container);
        // Start the initial stability check
        scheduleStabilityCheck();
    }, [
        stabilityWaitTime,
        scheduleStabilityCheck,
        cleanup
    ]);
    return {
        waitForStability: waitForStability,
        cleanup: cleanup
    };
};


const $d95cfbbdf326d486$export$81bdbc2b3f1c95ef = (containerRef, adfDoc)=>{
    const { waitForStability: waitForStability, cleanup: cleanupStability } = (0, $af6ef71a6f2fded7$export$3325eba9424d3c32)({
        stabilityWaitTime: 750,
        maxStabilityWaitTime: 10000
    });
    (0, $42omo.useEffect)(()=>{
        // Only run in browser environment.
        if (typeof window === 'undefined' || !containerRef?.current) return;
        // Parse hash fragment for block ID (format: #block-{localId}).
        const hash = window.location.hash;
        const defaultPrefixWithHash = `#${(0, $cQJcI.DEFAULT_BLOCK_LINK_HASH_PREFIX)}`;
        const blockId = hash && hash.startsWith(defaultPrefixWithHash) ? hash.slice(defaultPrefixWithHash.length) : null;
        if (!blockId) return;
        let retryCount = 0;
        const maxRetries = 40;
        const retryInterval = 250;
        let intervalId = null;
        let hasScrolled = false;
        let cancelExpandAndScroll = null;
        const scrollToElement = ()=>{
            // Step 1: Search the ADF document for the node with the given blockId.
            // This works even if the node is hidden inside a collapsed expand.
            if (!adfDoc || !containerRef?.current) return false;
            const nodeWithExpandParents = (0, $bBdDv.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) // Node not found in ADF document.
            return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Step 2: If the node has expand parents, we need to expand them first.
            if (expandParentLocalIds.length > 0) {
                // Find the expand elements in the DOM using their localIds.
                // Note: We need to expand from outermost to innermost.
                let allExpandsFound = true;
                let anyExpandsCollapsed = false;
                for (const expandLocalId of expandParentLocalIds){
                    const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                    if (!expandContainer) {
                        // Expand not found in DOM yet (shouldn't happen but handle it).
                        allExpandsFound = false;
                        break;
                    }
                    // Check if this expand is collapsed.
                    if ((0, $bBdDv.isExpandCollapsed)(expandContainer)) {
                        anyExpandsCollapsed = true;
                        // Expand it.
                        (0, $bBdDv.expandElement)(expandContainer);
                        // After expanding, we need to retry to handle nested expands.
                        // The DOM needs time to update.
                        return false; // Will retry after interval.
                    }
                }
                if (!allExpandsFound) // Retry later when expands are in DOM.
                return false;
                // All parent expands are now open (or we just expanded one and need to wait).
                if (anyExpandsCollapsed) // Just expanded something, wait for DOM update.
                return false;
            }
            // Step 3: Now the target element should be visible in the DOM, find it and scroll.
            const element = (0, $bBdDv.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) // Element still not in DOM, retry.
            return false;
            // Element found and all parent expands are open! Use the utility to scroll.
            // (This will handle any final edge cases and do the actual scrolling).
            // Capture cleanup function to cancel pending timeouts.
            cancelExpandAndScroll = (0, $bBdDv.expandAllParentsThenScroll)(element);
            return true;
        };
        const performScroll = ()=>{
            if (hasScrolled) return;
            // Try to scroll to element.
            if (scrollToElement()) {
                hasScrolled = true;
                cleanup();
            }
        };
        const attemptScroll = ()=>{
            retryCount++;
            // Try to find the element first.
            if (!adfDoc || !containerRef?.current) return false;
            const nodeWithExpandParents = (0, $bBdDv.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Check if all expands are expanded and element exists.
            let allReady = true;
            if (expandParentLocalIds.length > 0) for (const expandLocalId of expandParentLocalIds){
                const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                if (!expandContainer) {
                    allReady = false;
                    break;
                }
                if ((0, $bBdDv.isExpandCollapsed)(expandContainer)) {
                    (0, $bBdDv.expandElement)(expandContainer);
                    allReady = false;
                    break;
                }
            }
            const element = (0, $bBdDv.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) allReady = false;
            // If everything is ready, start monitoring for stability.
            if (allReady) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                waitForStability(containerRef.current, performScroll);
                return true;
            }
            // Stop retrying if we've exceeded max retries.
            if (retryCount >= maxRetries) {
                cleanup();
                return false;
            }
            return false;
        };
        const cleanup = ()=>{
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
            cleanupStability();
            // Cancel any pending expand and scroll operations.
            if (cancelExpandAndScroll) {
                cancelExpandAndScroll();
                cancelExpandAndScroll = null;
            }
        };
        // Try to scroll immediately.
        if (attemptScroll()) return cleanup;
        if ((0, $hTKp4.getDocument)()?.readyState === 'complete') // Document is already ready, try a few more times with delays.
        // This handles cases where elements are added after document ready.
        intervalId = setInterval(()=>{
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry.
        intervalId = setInterval(()=>{
            if ((0, $hTKp4.getDocument)()?.readyState === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) cleanup();
            else retryCount++;
        }, retryInterval);
        // Cleanup function.
        return cleanup;
    // Intentionally not including adfDoc in the dependency array to avoid unnecessary re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        containerRef,
        waitForStability,
        cleanupStability
    ]);
};



var $lWghV = parcelRequire("lWghV");

var $NPJKR = parcelRequire("NPJKR");


var $dh538 = parcelRequire("dh538");


var $k7eoe = parcelRequire("k7eoe");


var $ffCOo = parcelRequire("ffCOo");


var $d925B = parcelRequire("d925B");


var $9ciHB = parcelRequire("9ciHB");


var $cUcZ5 = parcelRequire("cUcZ5");


var $aUnCJ = parcelRequire("aUnCJ");

var $lf9Ji = parcelRequire("lf9Ji");


var $6uN0A = parcelRequire("6uN0A");


var $59U23 = parcelRequire("59U23");


var $l998X = parcelRequire("l998X");





var $grxv4 = parcelRequire("grxv4");

var $3rvSa = parcelRequire("3rvSa");




const $bd8a5c6aad625abd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $42omo.useState)();
    const mediaProvider = (0, $6mbqi.useProviderLayout)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $42omo.useMemo)(()=>mediaClientConfig ? (0, $grxv4.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $42omo.useLayoutEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};



var $iNqGB = parcelRequire("iNqGB");


var $bBvs5 = parcelRequire("bBvs5");


var $b7FrM = parcelRequire("b7FrM");


var $lspPP = parcelRequire("lspPP");


var $bZfVt = parcelRequire("bZfVt");


var $9KIOh = parcelRequire("9KIOh");


var $d7o2V = parcelRequire("d7o2V");


var $fZRom = parcelRequire("fZRom");




parcelRequire("42omo");


var $fJNzZ = parcelRequire("fJNzZ");





var $1zvWv = parcelRequire("1zvWv");


var $1oCLl = parcelRequire("1oCLl");

function $a8c331734550a1c3$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const shouldSkipScript = {
        table: (0, $dh538.fg)('platform-ssr-table-resize')
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $a8c331734550a1c3$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $a8c331734550a1c3$export$92859d13f30c883e(id, shouldSkipScript) {
    const flags = {
        platform_editor_fix_media_in_renderer: (0, $dh538.fg)('platform_editor_fix_media_in_renderer'),
        platform_editor_fix_wide_media_in_renderer: (0, $dh538.fg)('platform_editor_fix_wide_media_in_renderer'),
        platform_editor_renderer_extension_width_fix: (0, $1oCLl.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)
    };
    return `(function(window){
if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }
${$a8c331734550a1c3$export$47813c4121c8b4b3};
(${$a8c331734550a1c3$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${JSON.stringify(shouldSkipScript)}, ${JSON.stringify(flags)});
})(window);
`;
}
const $a8c331734550a1c3$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $fJNzZ.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $fJNzZ.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $fJNzZ.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $fJNzZ.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $fJNzZ.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $fJNzZ.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $1zvWv.FullPagePadding).toString()};
`;
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a8c331734550a1c3$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript, flags) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const nodeType = node.dataset.nodeType;
                const widthType = node.dataset.widthType;
                const isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                isMediaSingleWithPixelWidth && flags['platform_editor_fix_media_in_renderer'] || isExtension && flags['platform_editor_renderer_extension_width_fix']) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target, flags);
        });
    });
    const applyMediaBreakout = (card, flags)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override width
        if (flags['platform_editor_fix_wide_media_in_renderer'] && isPixelBasedResizing) return;
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && (!isPixelBasedResizing || flags['platform_editor_fix_wide_media_in_renderer'])) card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $a8c331734550a1c3$export$2a0b3eeee3f2ea40 = (0, $fJNzZ.breakoutConsts).calcLineLength((0, $fJNzZ.breakoutConsts));



var $jTudT = parcelRequire("jTudT");


var $ozLJl = parcelRequire("ozLJl");

function $d3e1cf2918b1cf26$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $ozLJl.mediaViewerPopupClass))) return true;
    if (element.classList.contains((0, $jTudT.fileCardImageViewSelector))) return true;
    return false;
}



var $1Qaul = parcelRequire("1Qaul");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






const $af8e00728130c250$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $9K4OG.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, #00000000)"}, ${backgroundColor} )`
        }
    });
const $af8e00728130c250$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $af8e00728130c250$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: styles
    }, children);
};
class $af8e00728130c250$export$79ad592494094f07 extends (0, $42omo.Component) {
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, #FFFFFF)", children: children } = this.props;
        return /*#__PURE__*/ (0, $9K4OG.jsx)($af8e00728130c250$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
    constructor(props){
        super(props);
    }
}



var $iZq0X = parcelRequire("iZq0X");

/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled










var $jVL42 = parcelRequire("jVL42");


var $aFUXX = parcelRequire("aFUXX");


var $fhm10 = parcelRequire("fhm10");


var $3HdsG = parcelRequire("3HdsG");


var $5MaNT = parcelRequire("5MaNT");

var $7bDsi = parcelRequire("7bDsi");

var $4mSjx = parcelRequire("4mSjx");

var $gnMzP = parcelRequire("gnMzP");

var $cV5SN = parcelRequire("cV5SN");

var $1zav4 = parcelRequire("1zav4");

var $7iisy = parcelRequire("7iisy");


var $ghpxT = parcelRequire("ghpxT");

var $fGuiW = parcelRequire("fGuiW");


var $frt7o = parcelRequire("frt7o");

var $fp8V7 = parcelRequire("fp8V7");








var $2jkq1 = parcelRequire("2jkq1");


var $1j8OE = parcelRequire("1j8OE");


var $j2w4t = parcelRequire("j2w4t");


var $ilPbq = parcelRequire("ilPbq");







const $ec7cc60cabf60b92$export$8e2864079bc476bd = (appearance, contentMode)=>{
    if ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) {
        if (contentMode === 'compact') return 0, $aFUXX.akEditorFullPageDenseFontSize;
    }
    return appearance && appearance !== 'comment' ? (0, $aFUXX.akEditorFullPageDefaultFontSize) : 14;
};



var $fhsiz = parcelRequire("fhsiz");

var $98HrB = parcelRequire("98HrB");





var $e6n00 = parcelRequire("e6n00");

function $913a570f210a4bc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $913a570f210a4bc3$var$wrappedMediaBreakoutPoint = 410;
const $913a570f210a4bc3$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $913a570f210a4bc3$var$tableShadowWidth = 32;
const $913a570f210a4bc3$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $913a570f210a4bc3$var$tableRowHeight = 44;
const $913a570f210a4bc3$var$isBackgroundClipBrowserFixNeeded = ()=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
const $913a570f210a4bc3$var$baseFontStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    font: (0, $ilPbq.default)('editor.font.body')
});
const $913a570f210a4bc3$var$smallTextStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-renderer-editor-font-small-text': (0, $ilPbq.default)('editor.font.body.small')
});
const $913a570f210a4bc3$var$fontSizeStyles = {
    name: "1o6mf5h",
    styles: ".fabric-editor-font-size{&[data-font-size='small']{font:var(--ak-renderer-editor-font-small-text);}}"
};
const $913a570f210a4bc3$var$originalBaseFontLineHeight = {
    name: "1dw7ik1",
    styles: "line-height:1.5rem"
};
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $913a570f210a4bc3$var$baseStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    color: "var(--ds-text, #292A2E)",
    '--ak-editor--full-width-layout-width': `${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px`,
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    [`& span.akActionMark`]: {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: "var(--ds-link, #1868DB)",
            textDecoration: 'underline'
        },
        '&:active': {
            color: "var(--ds-link-pressed, #1558BC)"
        }
    },
    '& span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #6B6E76)"
    }
});
const $913a570f210a4bc3$var$headingAnchorStylesDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: 'translate(-8px, 0px)',
                    transition: 'opacity 0.2s ease 0s, transform 0.2s ease 0s'
                }
            },
            '&:hover': {
                [`.${0, $3HdsG.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $913a570f210a4bc3$var$headingAnchorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $3HdsG.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    // Line-height for heading anchor based on heading level (via data-level attribute on .renderer-heading-wrapper)
    '& .renderer-heading-wrapper[data-level="1"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $913a570f210a4bc3$var$akEditorBreakpointForSmallDevice = '1266px';
const $913a570f210a4bc3$var$responsiveBreakoutWidth = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - ${(0, $aFUXX.akEditorGutterPadding)}px * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$913a570f210a4bc3$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $913a570f210a4bc3$var$responsiveBreakoutWidthFullWidth = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$913a570f210a4bc3$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $913a570f210a4bc3$var$responsiveBreakoutWidthWithReducedPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$913a570f210a4bc3$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $aFUXX.akEditorCalculatedWideLayoutWidth)}px`
    },
    [`@media (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`
    }
});
const $913a570f210a4bc3$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererFullPageStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $1zvWv.FullPagePadding)}px`
});
const $913a570f210a4bc3$var$rendererFullPageStylesWithReducedPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    '--ak-renderer--full-page-gutter': `${(0, $1zvWv.FullPagePadding)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 var(--ak-renderer--full-page-gutter)`,
    [`@media (max-width: ${0, $aFUXX.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-renderer--full-page-gutter': `${(0, $aFUXX.akEditorGutterPaddingReduced)}px`
    }
});
const $913a570f210a4bc3$var$oldRendererFullWidthStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $913a570f210a4bc3$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $913a570f210a4bc3$var$oldRendererMaxWidthStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $913a570f210a4bc3$var$rendererMaxWidthStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $aFUXX.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $913a570f210a4bc3$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
const $913a570f210a4bc3$var$rovoTelepointerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`#${$913a570f210a4bc3$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '24px',
        backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            width: '31.5px',
            height: '15.5px',
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
            'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
        },
        '&::before': {
            content: '"Rovo"',
            position: 'absolute',
            fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            color: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-text, #292A2E)",
            top: 1,
            left: 1,
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            zIndex: 1,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            padding: '0.5px 2.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});
const $913a570f210a4bc3$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $913a570f210a4bc3$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $913a570f210a4bc3$var$headingsSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 20px)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    }
});
/**
 * When the copy-link a11y fix is enabled, the heading copy-link button is a sibling of the heading
 * text within `.renderer-heading-wrapper`. To ensure the button sits immediately after the last
 * rendered character (including when the heading wraps), the heading itself needs to participate in
 * inline layout.
 *
 * Since inline elements don't support vertical margins in normal flow, we migrate the UGC heading
 * `marginTop` values (from `headingsSharedStyles`) onto the wrapper.
 */ const $913a570f210a4bc3$var$headingWrapperInlineFlowStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Ensure heading and copy-link button participate in inline flow so the button sits after the final wrapped line of text.
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        display: 'inline'
    },
    [`& .renderer-heading-wrapper > .${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
        display: 'inline',
        verticalAlign: 'baseline'
    },
    '& .renderer-heading-wrapper[data-level="1"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em'
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em'
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.25em'
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em'
    }
});
const $913a570f210a4bc3$var$headingWithAlignmentStylesDuplicateAnchor = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $913a570f210a4bc3$var$headingWithAlignmentStyles = {
    name: "1abdc8p",
    styles: ".fabric-editor-block-mark[data-align=\"center\"] > .renderer-heading-wrapper{justify-content:center;}.fabric-editor-block-mark[data-align=\"end\"] > .renderer-heading-wrapper{justify-content:flex-end;}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $913a570f210a4bc3$var$ruleSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $aFUXX.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $913a570f210a4bc3$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $aFUXX.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $913a570f210a4bc3$var$paragraphStylesUGCScaledMargin = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $aFUXX.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $913a570f210a4bc3$var$paragraphSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $aFUXX.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $aFUXX.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $913a570f210a4bc3$var$paragraphSharedStyleScaledMargin = /*#__PURE__*/ (0, $9K4OG.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $aFUXX.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $aFUXX.scaledBlockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $913a570f210a4bc3$var$listsSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $4mSjx.listItemCounterPadding)}px)`
    },
    [`${0, $fGuiW.orderedListSelector}, ${0, $ghpxT.bulletListSelector}`]: {
        /*
    Ensures list item content adheres to the list's margin instead
    of filling the entire block row. This is important to allow
    clicking interactive elements which are floated next to a list.
    	For some history and context on this block, see PRs related to tickets.:
    @see ED-6551 - original issue.
    @see ED-7015 - follow up issue.
    @see ED-7447 - flow-root change.
    	used to have display: 'table' in tag template style but not supported in object styles
    removed display: 'table' as 'flow-root' is supported in latest browsers
    	@see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $913a570f210a4bc3$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
/**
 * Hides list markers for "wrapper items" - list items that only contain nested lists with no other content.
 * These wrapper items have no meaningful content themselves, only nested lists below.
 * Applied when platform_editor_flexible_list_schema experiment is enabled.
 */ const $913a570f210a4bc3$var$listItemHiddenMarkerStyles = {
    name: "haapvm",
    styles: "li:has(> ul:only-child), li:has(> ol:only-child){list-style-type:none;margin-top:0;margin-bottom:0;}li:has(> ul:only-child) > ul, li:has(> ol:only-child) > ol{margin-top:0;}div[data-task-local-id]:has([data-component=\"content\"]:empty):has(+ div[data-node-type=\"actionList\"]){display:none;}"
};
const $913a570f210a4bc3$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $913a570f210a4bc3$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $aFUXX.blockNodesVerticalMargin)
        }
    }
});
const $913a570f210a4bc3$var$blockMarksSharedStylesDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $913a570f210a4bc3$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        },
        '.renderer-heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                'h1, h2, h3, h4, h5, h6': {
                    marginTop: 0
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #0515240F)"})`,
        color: "var(--ds-text, #292A2E)",
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $913a570f210a4bc3$var$extensionStyle = {
    name: "188isfx",
    styles: ".ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *){font-size:var(--ak-renderer-base-font-size);}"
};
const $913a570f210a4bc3$var$oldExtensionAsInlineStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        // use !important here because the current width has !important applied to it and it's not working when used in React style prop
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        marginTop: 0
    },
    [`.${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jVL42.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
const $913a570f210a4bc3$var$extensionAsInlineStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        width: 'auto',
        marginTop: 0
    },
    [`.${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jVL42.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
// Removes the blockNodesVerticalMargin styling for inline extensions, i.e. borderless excerpt-include
const $913a570f210a4bc3$var$inlineExtensionRendererMarginFix = {
    name: "vgr91k",
    styles: ".ak-renderer-document .inline-extension-renderer .ak-renderer-extension{margin-top:0;}"
};
const $913a570f210a4bc3$var$shadowSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $aFUXX.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $fp8V7.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $fp8V7.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $913a570f210a4bc3$var$dateSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $7bDsi.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $913a570f210a4bc3$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $913a570f210a4bc3$var$backgroundColorStyles = {
    name: "yf96ao",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $913a570f210a4bc3$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $913a570f210a4bc3$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $7iisy.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $aFUXX.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $7iisy.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $aFUXX.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $aFUXX.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $aFUXX.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $aFUXX.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-150, 12px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $913a570f210a4bc3$var$headingPanelStyles = {
    name: "e0for6",
    styles: ".ak-editor-panel__content{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $913a570f210a4bc3$var$smartCardStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $913a570f210a4bc3$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $913a570f210a4bc3$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $913a570f210a4bc3$var$smartCardStylesAvatarListZeroMarginTop = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginTop: 0
        }
    }
});
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
const $913a570f210a4bc3$var$headerSmartCardStyles = {
    name: "qwtpmh",
    styles: "[data-inline-card=\"true\"]{[data-inlinecard-button-overlay=\"icon-wrapper-line-height\"] span{line-height:0;}}"
};
// Flex wrapper for centering without transform (platform_editor_flex_based_centering).
// flex: 1 1 0% + minWidth: 0 so the wrapper takes full width when it's a flex item (full-width nodes otherwise render narrow).
// flexShrink: 0 on child so the node keeps size.
const $913a570f210a4bc3$var$centerWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        flex: '1 1 0%',
        minWidth: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flexShrink: 0
        }
    }
});
const $913a570f210a4bc3$var$baseOtherStylesDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + .${0, $gnMzP.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.image-align-start,
		.${0, $gnMzP.richMediaClassName}.image-center,
		.${0, $gnMzP.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $jVL42.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $jVL42.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $aFUXX.blockNodesVerticalMargin)}`
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $jVL42.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* platform_editor_flex_based_centering: embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $fp8V7.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $913a570f210a4bc3$var$extensionCenterAlignLegacyStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        }
    }
});
const $913a570f210a4bc3$var$baseOtherStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + .${0, $gnMzP.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $gnMzP.richMediaClassName}.image-align-start,
		.${0, $gnMzP.richMediaClassName}.image-center,
		.${0, $gnMzP.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $jVL42.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $jVL42.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $aFUXX.blockNodesVerticalMargin)}`
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $jVL42.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* platform_editor_flex_based_centering: embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jVL42.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $fp8V7.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $913a570f210a4bc3$var$alignedHeadingAnchorStyleDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $913a570f210a4bc3$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        '.renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                position: 'relative'
            }
        }
    },
    // Center alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="center"] > .renderer-heading-wrapper': {
        justifyContent: 'center'
    },
    // Right/end alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="end"] > .renderer-heading-wrapper': {
        justifyContent: 'flex-end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3HdsG.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $913a570f210a4bc3$var$firstWrappedMediaStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
    [`.${0, $gnMzP.richMediaClassName}[class*="image-wrap-"]:has(+ .${0, $gnMzP.richMediaClassName}[class*="image-wrap-"])`]: {
        marginRight: 0,
        marginLeft: 0
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $913a570f210a4bc3$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $gnMzP.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $gnMzP.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-right, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$913a570f210a4bc3$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            marginTop: "var(--ds-space-150, 12px)",
            marginRight: 0,
            marginBottom: "var(--ds-space-150, 12px)",
            marginLeft: 0
        }
    }
});
// was shared between editor-core and renderer
const $913a570f210a4bc3$var$tableSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E7F9FF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFECEB)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #CFE1FD)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #C6EDFB)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #BAF3DB)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #F5E989)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFD5D2)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #EED7FC)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #8C8F97)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #669DF1)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #6CC3E0)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #4BCE97)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FCA700)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #C97CF4)"} !important`
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        marginTop: 0,
        marginRight: 'auto',
        marginBottom: "var(--ds-space-200, 16px)",
        marginLeft: 'auto',
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $aFUXX.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: "var(--ds-space-100, 8px)",
        marginBottom: 0,
        marginLeft: 0
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $1zav4.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
                    [`&:not(.${0, $aFUXX.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #0B120E24)"}`
                    },
                    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, #0515240F)"
                    }
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $1zav4.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $913a570f210a4bc3$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
    }
});
const $913a570f210a4bc3$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $913a570f210a4bc3$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $913a570f210a4bc3$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $1zav4.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $1zav4.tableMarginTop)}px)`,
            zIndex: `${(0, $aFUXX.akEditorStickyHeaderZIndex)}`,
            width: `${$913a570f210a4bc3$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $fp8V7.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $fp8V7.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $1zav4.tableMarginTop)}px)`
        }
    }
});
const $913a570f210a4bc3$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$913a570f210a4bc3$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $913a570f210a4bc3$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $1zav4.tableCellPadding)}px`,
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${"var(--ds-border-focused, #4688EC)"}`
                        }
                    }
                },
                [`> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $jVL42.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`,
                borderRight: `${"var(--ds-border-width, 1px)"} solid
								${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
                width: `${(0, $aFUXX.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${"var(--ds-text-subtlest, #6B6E76)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $jVL42.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
const $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3HdsG.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '> .renderer-heading-wrapper': {
                        // Reserve space for the sortable-column icon so the heading+anchor wrapper never overlaps it.
                        // Use padding (instead of margin on the heading) so we don't create a gap between the heading
                        // text and the copy-link anchor button
                        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                        paddingRight: '30px'
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $913a570f210a4bc3$var$stickyHeaderStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $aFUXX.akEditorStickyHeaderZIndex)}`,
        borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $aFUXX.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -0.5px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			inset -1px 0px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $913a570f210a4bc3$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $aFUXX.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}
		> .${(0, $j2w4t.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $aFUXX.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $aFUXX.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $aFUXX.blockNodesVerticalMargin)
        }
    }
});
const $913a570f210a4bc3$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $913a570f210a4bc3$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $913a570f210a4bc3$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $aFUXX.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $aFUXX.akEditorLineHeight)}em !important`
        }
    }
});
const $913a570f210a4bc3$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $913a570f210a4bc3$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $913a570f210a4bc3$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$913a570f210a4bc3$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $913a570f210a4bc3$var$rendererAnnotationStylesOld = /*#__PURE__*/ (0, $9K4OG.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    }
});
const $913a570f210a4bc3$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    },
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'][data-has-focus='true'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
});
const $913a570f210a4bc3$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        paddingRight: 0,
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: 0,
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP = `max(0px,calc((var(--ak-renderer-base-font-size) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px)* (4/3)))`;
const $913a570f210a4bc3$var$TASKLIST_CONTAINER_DENSE_MARGIN = `max(calc(10px + (var(--ak-renderer-base-font-size) - ${(0, $aFUXX.akEditorFullPageDenseFontSize)}px) *( 2 / 3)))`;
const $913a570f210a4bc3$var$scaledDenseEmojiStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`,
        minHeight: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`,
        minWidth: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`,
        maxHeight: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
        maxWidth: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.denseEmojiHeightH1)}px`,
        width: `${(0, $fhsiz.denseEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.denseEmojiHeightH2)}px`,
        width: `${(0, $fhsiz.denseEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.denseEmojiHeightH3)}px`,
        width: `${(0, $fhsiz.denseEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.denseEmojiHeightH4)}px`,
        width: `${(0, $fhsiz.denseEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`,
        width: `${(0, $fhsiz.defaultDenseEmojiHeight)}px`
    }
});
const $913a570f210a4bc3$var$scaledEmojiStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        minHeight: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        minWidth: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        maxHeight: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        maxWidth: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.scaledEmojiHeightH1)}px`,
        width: `${(0, $fhsiz.scaledEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.scaledEmojiHeightH2)}px`,
        width: `${(0, $fhsiz.scaledEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.scaledEmojiHeightH3)}px`,
        width: `${(0, $fhsiz.scaledEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.scaledEmojiHeightH4)}px`,
        width: `${(0, $fhsiz.scaledEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $fhsiz.defaultEmojiHeight)}px`,
        width: `${(0, $fhsiz.defaultEmojiHeight)}px`
    }
});
const $913a570f210a4bc3$var$denseStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // Scale emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    [`.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `calc(${(0, $fhsiz.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $aFUXX.akEditorFullPageDefaultFontSize)})`,
        width: `calc(${(0, $fhsiz.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $aFUXX.akEditorFullPageDefaultFontSize)})`,
        maxHeight: `calc(${(0, $fhsiz.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $aFUXX.akEditorFullPageDefaultFontSize)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    // Scale panel icon
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT} .ak-editor-panel .ak-editor-panel__icon`]: {
        height: "var(--ds-space-250, 20px)",
        width: "var(--ds-space-250, 20px)"
    },
    // Condense spacing across lists, tasks and decisions
    [`.${(0, $jVL42.RendererCssClassName).DOCUMENT}`]: {
        // Adjacent list items
        'li + li': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        },
        // Nested lists directly under an li (unordered and ordered)
        'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        },
        // Task lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id]': {
            // Task lists: container top margin
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$TASKLIST_CONTAINER_DENSE_MARGIN
        },
        // Task lists: sibling items and nested lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] > * + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $913a570f210a4bc3$var$RENDERER_LIST_DENSE_GAP
        }
    }
});
const $913a570f210a4bc3$var$syncBlockStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}, .${(0, $e6n00.BodiedSyncBlockSharedCssClassName).renderer}, .${(0, $e6n00.SyncBlockSharedCssClassName).error}, .${(0, $e6n00.SyncBlockSharedCssClassName).loading}`]: {
        borderRadius: "var(--ds-radius-small, 3px)",
        marginTop: "var(--ds-space-075, 6px)",
        paddingBlock: "var(--ds-space-150, 12px)",
        overflow: 'visible'
    },
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).renderer}`]: {
        // First child node in syncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-renderer-document > :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).renderer}`]: {
        // First child node in bodiedSyncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '> :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).error}`]: {
        backgroundColor: "var(--ds-background-disabled, #17171708)"
    },
    [`.${(0, $e6n00.SyncBlockSharedCssClassName).loading}`]: {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $913a570f210a4bc3$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, contentMode: contentMode, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId } = props;
    const isAdvancedLayoutsOn = (0, $iu6m9.editorExperiment)('advanced_layouts', true);
    const isPreviewPanelResponsivenessOn = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    const isCompactModeSupported = (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp');
    const isCompactModeEnabled = contentMode === 'compact' && isCompactModeSupported;
    const baseFontSize = (0, $ec7cc60cabf60b92$export$8e2864079bc476bd)(appearance, contentMode);
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        role: "none",
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${baseFontSize}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $ilPbq.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $ilPbq.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $ilPbq.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $ilPbq.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $ilPbq.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $ilPbq.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $ilPbq.default)('editor.font.body')}`
        },
        css: [
            (0, $1oCLl.expValEquals)('confluence_ttvc_inline_extensions', 'isEnabled', true) ? $913a570f210a4bc3$var$baseFontStyle : $913a570f210a4bc3$var$originalBaseFontLineHeight,
            $913a570f210a4bc3$var$baseStyles,
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && $913a570f210a4bc3$var$smallTextStyle,
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && $913a570f210a4bc3$var$fontSizeStyles,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$headingAnchorStyles : $913a570f210a4bc3$var$headingAnchorStylesDuplicateAnchor,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$hideHeadingCopyLinkWrapperStyles : $913a570f210a4bc3$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$rendererFullPageStyles,
            appearance === 'full-width' && ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $913a570f210a4bc3$var$rendererFullWidthStyles : $913a570f210a4bc3$var$oldRendererFullWidthStyles),
            (appearance === 'full-width' || appearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && !(0, $2jkq1.isTableResizingEnabled)(appearance) && $913a570f210a4bc3$var$rendererFullWidthStylesForTableResizing,
            appearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $913a570f210a4bc3$var$rendererMaxWidthStyles : $913a570f210a4bc3$var$oldRendererMaxWidthStyles),
            $913a570f210a4bc3$var$rovoTelepointerStyles,
            $913a570f210a4bc3$var$whitespaceSharedStyles,
            $913a570f210a4bc3$var$blockquoteSharedStyles,
            $913a570f210a4bc3$var$headingsSharedStyles,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $913a570f210a4bc3$var$headingWrapperInlineFlowStyles,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$headingWithAlignmentStyles : $913a570f210a4bc3$var$headingWithAlignmentStylesDuplicateAnchor,
            $913a570f210a4bc3$var$ruleSharedStyles,
            contentMode === 'compact' && isCompactModeSupported && $913a570f210a4bc3$var$extensionStyle,
            (0, $dh538.fg)('platform_editor_typography_ugc') ? isCompactModeSupported ? $913a570f210a4bc3$var$paragraphStylesUGCScaledMargin : $913a570f210a4bc3$var$paragraphSharedStylesWithEditorUGC : isCompactModeSupported ? $913a570f210a4bc3$var$paragraphSharedStyleScaledMargin : $913a570f210a4bc3$var$paragraphSharedStyles,
            $913a570f210a4bc3$var$listsSharedStyles,
            browser.gecko && $913a570f210a4bc3$var$listsSharedStylesForGekko,
            (0, $1oCLl.expValEquals)('platform_editor_flexible_list_schema', 'isEnabled', true) && $913a570f210a4bc3$var$listItemHiddenMarkerStyles,
            $913a570f210a4bc3$var$indentationSharedStyles,
            (0, $dh538.fg)('platform_editor__renderer_indentation_text_margin') && $913a570f210a4bc3$var$indentationSharedStylesWithMarginFix,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$blockMarksSharedStyles : $913a570f210a4bc3$var$blockMarksSharedStylesDuplicateAnchor,
            $913a570f210a4bc3$var$codeMarkSharedStyles,
            $913a570f210a4bc3$var$shadowSharedStyle,
            $913a570f210a4bc3$var$dateSharedStyle,
            $913a570f210a4bc3$var$textColorStyles,
            $913a570f210a4bc3$var$backgroundColorStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $913a570f210a4bc3$export$a365082c2a191514,
            $913a570f210a4bc3$var$tasksAndDecisionsStyles,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $913a570f210a4bc3$var$headingPanelStyles,
            $913a570f210a4bc3$var$smartCardStyles,
            $913a570f210a4bc3$var$smartCardStylesAvatarFix,
            (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true) && $913a570f210a4bc3$var$headerSmartCardStyles,
            $913a570f210a4bc3$var$smartCardStylesAvatarMarginFix,
            $913a570f210a4bc3$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') && ((0, $1oCLl.expValEquals)('confluence_fe_renderer_inline_node_mark_color_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$rendererAnnotationStyles : $913a570f210a4bc3$var$rendererAnnotationStylesOld),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') && $913a570f210a4bc3$var$rendererAnnotationStylesCommentHeightFix,
            (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$baseOtherStyles : $913a570f210a4bc3$var$baseOtherStylesDuplicateAnchor,
            !(0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) && $913a570f210a4bc3$var$extensionCenterAlignLegacyStyles,
            // this should be placed after baseOtherStyles
            (0, $1oCLl.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true) && ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $913a570f210a4bc3$var$extensionAsInlineStyle : $913a570f210a4bc3$var$oldExtensionAsInlineStyle),
            $913a570f210a4bc3$var$inlineExtensionRendererMarginFix,
            allowNestedHeaderLinks && ((0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$alignedHeadingAnchorStyle : $913a570f210a4bc3$var$alignedHeadingAnchorStyleDuplicateAnchor),
            $913a570f210a4bc3$var$mediaSingleSharedStyle,
            // merge firstWrappedMediaStyles with mediaSingleSharedStyle when clean up platform_editor_fix_media_in_renderer
            (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $913a570f210a4bc3$var$firstWrappedMediaStyles,
            $913a570f210a4bc3$var$tableSharedStyle,
            $913a570f210a4bc3$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $dh538.fg)('platform_editor_bordered_panel_nested_in_table') && $913a570f210a4bc3$var$tableRendererNestedPanelStyles,
            $913a570f210a4bc3$var$isBackgroundClipBrowserFixNeeded() && $913a570f210a4bc3$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $913a570f210a4bc3$var$firstNodeWithNotMarginTopWithNestedDnD : $913a570f210a4bc3$var$firstNodeWithNotMarginTop,
            $913a570f210a4bc3$var$rendererTableStyles,
            (0, $2jkq1.isStickyScrollbarEnabled)(appearance) && $913a570f210a4bc3$var$stickyScrollbarStyles,
            $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $913a570f210a4bc3$var$rendererTableSortableColumnStyles,
            allowColumnSorting && allowNestedHeaderLinks && ((0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks : $913a570f210a4bc3$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor),
            $913a570f210a4bc3$var$rendererTableColumnStyles,
            $913a570f210a4bc3$var$stickyHeaderStyles,
            $913a570f210a4bc3$var$codeBlockAndLayoutStyles,
            $913a570f210a4bc3$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $913a570f210a4bc3$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $913a570f210a4bc3$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $913a570f210a4bc3$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $913a570f210a4bc3$var$gridRenderForCodeBlockStyles,
            browser.safari && $913a570f210a4bc3$var$codeBlockInListSafariFixStyles,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $913a570f210a4bc3$var$responsiveBreakoutWidthWithReducedPadding,
            (appearance === 'full-width' || appearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && $913a570f210a4bc3$var$responsiveBreakoutWidthFullWidth,
            (0, $1oCLl.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? isCompactModeEnabled ? $913a570f210a4bc3$var$scaledDenseEmojiStyles : $913a570f210a4bc3$var$scaledEmojiStyles : isCompactModeEnabled ? $913a570f210a4bc3$var$denseStyles : undefined,
            (0, $iu6m9.editorExperiment)('platform_synced_block', true) && $913a570f210a4bc3$var$syncBlockStyles,
            $913a570f210a4bc3$var$centerWrapperStyles
        ],
        "data-testid": testId
    }, children);
};



const $72f5f4ba20544324$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !(child?.type === 'hardBreak' || child?.type === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};





function $6d2060ea59e4ee09$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $42omo.useRef)(props);
    const prevFactory = (0, $42omo.useRef)(null);
    return (0, $42omo.useMemo)(()=>{
        // check if the serializer is already created
        let shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            const propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}



var $eauJy = parcelRequire("eauJy");


var $dZ8uq = parcelRequire("dZ8uq");







var $e2wMq = parcelRequire("e2wMq");

var $3824I = parcelRequire("3824I");




const $ac23999863c9cf10$export$208d2421b73f3f86 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    const editorWidth = renderer.scrollWidth;
    return {
        action: (0, $3824I.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $lWghV.getBreakpointKey)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $lWghV.getBreakpointKey)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            mode: (0, $e2wMq.MODE).RENDERER
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};
const $ac23999863c9cf10$export$34e5b28c67455a81 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableHeight: table.scrollHeight,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    /** NOTE: Renderer is not scrollable, so this height represents the height of the content */ const rendererClientHeight = renderer.clientHeight;
    const viewportHeight = window.innerHeight;
    if (!viewportHeight) return undefined;
    return {
        action: (0, $3824I.TABLE_ACTION).TABLE_RENDERER_HEIGHT_INFO,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            viewportHeight: viewportHeight,
            rendererHeight: rendererClientHeight,
            maxTableHeight: maxTableHeight,
            maxTableToViewportHeightRatio: maxTableHeight / viewportHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};


function $19370cae7f055953$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19370cae7f055953$export$47b2879ca9bbf67a = 2000;
const $19370cae7f055953$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
const $19370cae7f055953$var$TABLE_INFO_TIMEOUT = 10000;
const $19370cae7f055953$var$RENDER_EVENT_SAMPLE_RATE = 0.2;
const $19370cae7f055953$var$packageName = "platform-pkg";
const $19370cae7f055953$var$packageVersion = "0.0.0-use.local";
const $19370cae7f055953$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $19370cae7f055953$var$handleMouseTripleClickInTables = (event)=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    if (browser.ios || browser.android) return;
    const badBrowser = browser.chrome || browser.safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $19370cae7f055953$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $19370cae7f055953$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $b7FrM.findInTree)(targetElement, rendererWrapper, (0, $d3e1cf2918b1cf26$export$3dee5e4542c672d9));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $19370cae7f055953$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $42omo.useRef)(undefined);
    const providerFactory = (0, $42omo.useMemo)(()=>props.dataProviders || new (0, $4FxUL.default)(), [
        props.dataProviders
    ]);
    const { nestedRendererType: nestedRendererType } = (0, $bBvs5.useRendererContext)();
    const createRendererContext = (0, $42omo.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $9ciHB.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }, []);
    const fireAnalyticsEventOld = (0, $42omo.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $k7eoe.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $42omo.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $k7eoe.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $iu6m9.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $42omo.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $72f5f4ba20544324$export$c94cfc0c675062a1)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext,
                nestedRendererType: nestedRendererType
            },
            appearance: props.appearance,
            contentMode: props.contentMode,
            onSetLinkTarget: props.onSetLinkTarget,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionHeight: props.getExtensionHeight,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption,
            shouldDisplayExtensionAsInline: props.shouldDisplayExtensionAsInline
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent,
        nestedRendererType
    ]);
    const serializer = (0, $6d2060ea59e4ee09$export$80ffe7e3c6bf25c3)((serializerProps)=>props.createSerializer?.(serializerProps) ?? new (0, $aUnCJ.default)(serializerProps), deriveSerializerProps, props);
    const localRef = (0, $42omo.useRef)(null);
    const editorRef = props.innerRef || localRef;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $42omo.useMemo)(()=>(0, $jz9wK.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $42omo.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $2T4ch.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $42omo.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $d925B.ACTION).VIEWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    mode: (0, $59U23.MODE).RENDERER
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $42omo.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $iyDxB.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $42omo.useEffect)(()=>{
        let rafID;
        let heightWidthAnalyticsSetTimeoutID;
        let heightWidthAnalyticsRicID;
        let heightWidthAnalyticsRafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $d925B.ACTION).STARTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $2T4ch.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $NPJKR.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $lWghV.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $19370cae7f055953$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $19370cae7f055953$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) {
                        const event = {
                            action: (0, $d925B.ACTION).RENDERED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                            attributes: {
                                platform: (0, $59U23.PLATFORM).WEB,
                                duration: duration,
                                // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                                ttfb: (0, $8pwxt.getResponseEndTime)(),
                                nodes: (0, $1Qaul.countNodes)(props.document),
                                nestedRendererType: (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? nestedRendererType : undefined,
                                severity: severity
                            },
                            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                        };
                        fireAnalyticsEvent(event);
                        if ((0, $1oCLl.expValEquals)('platform_editor_sample_renderer_rendered_event', 'isEnabled', true) && Math.random() < $19370cae7f055953$var$RENDER_EVENT_SAMPLE_RATE) fireAnalyticsEvent({
                            ...event,
                            action: (0, $d925B.ACTION).RENDERED_SAMPLED
                        });
                    }
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            // send statistics about the heights/widths of the tables on the page for alerting
            heightWidthAnalyticsSetTimeoutID = setTimeout(()=>{
                const requestIdleCallbackFn = ()=>{
                    const renderer = props.innerRef?.current?.querySelector('.ak-renderer-document');
                    if (renderer) {
                        const payload = (0, $ac23999863c9cf10$export$208d2421b73f3f86)(renderer);
                        if (payload) fireAnalyticsEvent(payload);
                        if ((0, $dh538.fg)('platform_editor_table_height_analytics_event')) {
                            const payloadHeight = (0, $ac23999863c9cf10$export$34e5b28c67455a81)(renderer);
                            if (payloadHeight) fireAnalyticsEvent(payloadHeight);
                        }
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') heightWidthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                heightWidthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $19370cae7f055953$var$TABLE_INFO_TIMEOUT);
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (heightWidthAnalyticsSetTimeoutID) window.clearTimeout(heightWidthAnalyticsSetTimeoutID);
            if (heightWidthAnalyticsRafID) window.cancelAnimationFrame(heightWidthAnalyticsRafID);
            if (heightWidthAnalyticsRicID) window.cancelIdleCallback(heightWidthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $42omo.useMemo)(()=>({
            ...createRendererContext(props.featureFlags, props.isTopLevelRenderer),
            timeZone: props.timeZone
        }), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.timeZone
    ]);
    (0, $d95cfbbdf326d486$export$81bdbc2b3f1c95ef)(editorRef, props.document);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $lf9Ji.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $72f5f4ba20544324$export$c94cfc0c675062a1)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, props.validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bBvs5.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9KIOh.ActiveHeaderIdProvider), {
            value: (0, $iNqGB.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6uN0A.default).Provider, {
            // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bZfVt.Provider), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6mbqi.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $iNqGB.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$19370cae7f055953$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a8c331734550a1c3$export$cfc1361be0de4203), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $af8e00728130c250$export$79ad592494094f07), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $iNqGB.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$19370cae7f055953$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iq4lN.default), null));
    }
};
const $19370cae7f055953$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($19370cae7f055953$export$c49fe2316038f3c2);
const $19370cae7f055953$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($19370cae7f055953$var$RendererFunctionalComponentMemoized, props);
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eauJy.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($19370cae7f055953$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $19370cae7f055953$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $d7o2V.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $bBvs5.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $42omo.useContext)((0, $iZq0X.ValidationContext)) || {};
    const validationOverrides = (0, $42omo.useMemo)(()=>({
            allowNestedTables: allowNestedTables
        }), [
        allowNestedTables
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RendererFunctionalComponentWithPortalContext, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: props.isTopLevelRenderer ?? isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: validationOverrides
    });
}
const $19370cae7f055953$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $ffCOo.FabricEditorAnalyticsContext), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        data: {
            appearance: (0, $lWghV.getAnalyticsAppearance)(props.appearance),
            packageName: $19370cae7f055953$var$packageName,
            packageVersion: $19370cae7f055953$var$packageVersion,
            componentName: 'renderer',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $0d5221b11c687d15$export$9ac3d19711324187), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fZRom.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kckFS.IntlErrorBoundary), null, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $19370cae7f055953$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, contentMode: contentMode, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $1zvWv.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    (0, $42omo.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation, _index)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $1zvWv.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $1zvWv.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ if (mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && mutation.addedNodes[0]?.id === (0, $1zvWv.TELEPOINTER_ID) || mutation.removedNodes.length === 1 && mutation.removedNodes[0]?.id === (0, $1zvWv.TELEPOINTER_ID)) && (0, $dh538.fg)('platform_editor_ai_adf_prompts_in_all_products')) {
                        const lastChild = renderer.lastChild;
                        if (lastChild) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ const contentElements = lastChild.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            const lastElement = contentElements[contentElements.length - 1];
                            const oldTelepointer = renderer.querySelector(`#${(0, $1zvWv.TELEPOINTER_ID)}`);
                            if (lastElement) {
                                oldTelepointer?.remove();
                                lastElement?.appendChild(createTelepointer());
                            } else {
                                oldTelepointer?.remove();
                                lastChild?.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4BBKV.BaseTheme), {
        baseFontSize: (0, $ec7cc60cabf60b92$export$8e2864079bc476bd)(appearance, contentMode)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bd8a5c6aad625abd$export$77218b6ff680865f), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $913a570f210a4bc3$export$8f0929e72efe521f), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer && (0, $dh538.fg)('platform-ssr-table-resize')) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $19370cae7f055953$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || ((0, $dZ8uq.expValEqualsNoExposure)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && appearance === 'max') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles && (0, $dh538.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $19370cae7f055953$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $19370cae7f055953$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $19370cae7f055953$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($19370cae7f055953$var$RootRendererContext);
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const rendererRef = (0, $42omo.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $42omo.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true)) return(// eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children));
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $19370cae7f055953$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const innerRef = props.innerRef || localRef;
    // @see https://hello.jira.atlassian.cloud/browse/EDITOR-3389
    if (props.appearance === 'max' && !(0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) props.appearance = 'full-width';
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d7o2V.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($19370cae7f055953$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $19370cae7f055953$export$2e2bcd8739ae039 = $19370cae7f055953$var$RendererWithAnnotationSelection;
module.exports["RendererWithAnalytics"] = $19370cae7f055953$export$af81ffb59b6ef0dd;
module.exports["default"] = $19370cae7f055953$export$2e2bcd8739ae039;

});

parcelRegister("4FxUL", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a192a3f63d3335de$var$isUndefined(x) {
    return x === undefined;
}
class $a192a3f63d3335de$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $a192a3f63d3335de$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$a192a3f63d3335de$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}
module.exports["default"] = $a192a3f63d3335de$export$2e2bcd8739ae039;

});

parcelRegister("6mbqi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4FxUL = parcelRequire("4FxUL");

const $78deebab959b7b48$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(new (0, $4FxUL.default)());
const $78deebab959b7b48$export$617c134b25cc4265 = $78deebab959b7b48$var$ProviderFactoryContext.Provider;
const $78deebab959b7b48$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($78deebab959b7b48$var$ProviderFactoryContext);
const $78deebab959b7b48$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerFactory = $78deebab959b7b48$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $78deebab959b7b48$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerFactory = $78deebab959b7b48$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
module.exports["ProviderFactoryProvider"] = $78deebab959b7b48$export$617c134b25cc4265;
module.exports["useProvider"] = $78deebab959b7b48$export$693cdb10cec23617;
module.exports["useProviderLayout"] = $78deebab959b7b48$export$6fde1d0d81db98e1;

});

parcelRegister("bWRlG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $2XqLN = parcelRequire("2XqLN");


var $2P8Ax = parcelRequire("2P8Ax");


var $4JDbp = parcelRequire("4JDbp");


var $eTj7Y = parcelRequire("eTj7Y");

function $3aa0833fdfae2152$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3aa0833fdfae2152$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $3aa0833fdfae2152$var$SCROLLBAR_WIDTH = 30;
function $3aa0833fdfae2152$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $3aa0833fdfae2152$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $3aa0833fdfae2152$export$1eb095b00b926404(width)
    };
}
const $3aa0833fdfae2152$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($3aa0833fdfae2152$export$31a4966bffb9ac98());
const $3aa0833fdfae2152$var$Provider = $3aa0833fdfae2152$export$27e39f636459b9f.Provider;
const $3aa0833fdfae2152$export$5d8538aa831b6ebb = $3aa0833fdfae2152$export$27e39f636459b9f.Consumer;
const $3aa0833fdfae2152$export$df154c49e93b2ac2 = (0, $2XqLN.default)(()=>{
    return (0, $eTj7Y.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $3aa0833fdfae2152$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $42omo.useContext)($3aa0833fdfae2152$export$27e39f636459b9f);
    const [width, setWidth] = (0, $42omo.useState)($3aa0833fdfae2152$export$df154c49e93b2ac2);
    const widthRef = (0, $42omo.useRef)(width);
    const isMountedRef = (0, $42omo.useRef)(true);
    const providerValue = (0, $42omo.useMemo)(()=>$3aa0833fdfae2152$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $42omo.useMemo)(()=>{
        return (0, $2P8Ax.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $3aa0833fdfae2152$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $3aa0833fdfae2152$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4JDbp.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $9K4OG.jsx)($3aa0833fdfae2152$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};
module.exports["getBreakpoint"] = $3aa0833fdfae2152$export$1eb095b00b926404;
module.exports["createWidthContext"] = $3aa0833fdfae2152$export$31a4966bffb9ac98;
module.exports["WidthContext"] = $3aa0833fdfae2152$export$27e39f636459b9f;
module.exports["WidthConsumer"] = $3aa0833fdfae2152$export$5d8538aa831b6ebb;
module.exports["WidthProvider"] = $3aa0833fdfae2152$export$7921e18173e8c666;

});

parcelRegister("kckFS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $30lHU = parcelRequire("30lHU");

const $f91595f582fbd74b$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $f91595f582fbd74b$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $f91595f582fbd74b$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, _errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($f91595f582fbd74b$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30lHU.default), {
            locale: "en"
        }, this.props.children);
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}
module.exports["IntlErrorBoundary"] = $f91595f582fbd74b$export$7df0749115d18d19;

});

parcelRegister("iq4lN", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $cs1vW = parcelRequire("cs1vW");


var $aFUXX = parcelRequire("aFUXX");


var $ci7Ox = parcelRequire("ci7Ox");


var $3gadb = parcelRequire("3gadb");


var $d925B = parcelRequire("d925B");


var $iCOwP = parcelRequire("iCOwP");


var $juTiU = parcelRequire("juTiU");


var $1QdLR = parcelRequire("1QdLR");

const $879359e6a013f2d4$var$blockNodeStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    background: "var(--ds-background-disabled, #17171708)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $879359e6a013f2d4$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $1QdLR.getUnsupportedContent)((0, $iCOwP.unsupportedContentMessages).unsupportedBlockContent, (0, $iCOwP.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $iCOwP.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $42omo.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $42omo.useCallback)(()=>dispatchAnalyticsEvent && (0, $juTiU.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $879359e6a013f2d4$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
        label: "?"
    })))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $879359e6a013f2d4$var$_default_1 = (0, $cs1vW.default)($879359e6a013f2d4$var$UnsupportedBlockNode);
var $879359e6a013f2d4$export$2e2bcd8739ae039 = $879359e6a013f2d4$var$_default_1;
module.exports["default"] = $879359e6a013f2d4$export$2e2bcd8739ae039;

});

parcelRegister("d7ZU3", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * @deprecated
 * This file is deprecated and will be removed in the next major release.
 * Please use `getBrowserInfo` function to get the browser info on demand.
 * Static `browser` info is no longer supported.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e9b48e5e619880d3$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieEdge = /(?:Edge|Edg)\/(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.windows = // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigator.userAgentData?.platform === 'Windows' || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /Windows|Win\d+/i.test(navigator.userAgent);
    const ie = $e9b48e5e619880d3$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.ios = // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.safari_version = parseInt(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $e9b48e5e619880d3$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
const $e9b48e5e619880d3$var$getFirstMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
};
const $e9b48e5e619880d3$var$getSecondMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[2] || '';
};
// Helper functions to safely access browser properties
const $e9b48e5e619880d3$var$getSafeUserAgent = ()=>{
    if (typeof window === 'undefined') return undefined;
    // Fallback to navigator.userAgent with proper null checking
    return window.navigator?.userAgent;
};
const $e9b48e5e619880d3$var$getSafePlatform = ()=>{
    if (typeof window === 'undefined') return undefined;
    return window.navigator?.platform;
};
const $e9b48e5e619880d3$var$hasIntersectionObserver = ()=>{
    return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
const $e9b48e5e619880d3$var$hasResizeObserver = ()=>{
    return typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
};
const $e9b48e5e619880d3$export$6c724a6ffa2dc3e1 = (0, $2XqLN.default)(()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    const userAgent = $e9b48e5e619880d3$var$getSafeUserAgent();
    const platform = $e9b48e5e619880d3$var$getSafePlatform();
    if (userAgent) {
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const ieEdge = /\sedg\//i.test(userAgent);
        // eslint-disable-next-line require-unicode-regexp
        const ieEdge2 = /edg([ea]|ios)/i.test(userAgent);
        // eslint-disable-next-line require-unicode-regexp
        const internetExplorer = /msie|trident/i.test(userAgent);
        // Ideally we should use userAgent instead of platform, but we have lots of keymap tests failure when we change it
        // So leave it as is for now.
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.mac = platform && /Mac/.test(platform);
        // Previously relied on navigator.userAgentData?.platform and userAgent, now used only userAgent
        result.windows = // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        /Windows|Win\d+/i.test(userAgent);
        // used userAgent rather than relying on documentMode
        const ie = ieEdge || ieEdge2 || internetExplorer;
        result.ie = ie;
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        result.ie_version = ieEdge ? parseInt($e9b48e5e619880d3$var$getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, userAgent), 10) : ieEdge2 ? parseInt($e9b48e5e619880d3$var$getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, userAgent), 10) : parseInt($e9b48e5e619880d3$var$getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, userAgent), 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.gecko = !ie && /gecko\/\d/i.test(userAgent);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.gecko_version = parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.chrome = !ie && /Chrome\//.test(userAgent);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.chrome_version = parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        result.android = /Android \d/.test(userAgent);
        result.ios = // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        !ie && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
        // Previously relied on navigator.vendor, now used userAgent
        result.safari = !result.chrome && !result.ie && !result.gecko && !result.android && !userAgent.includes('CriOS') && !userAgent.includes('FxiOS') && // eslint-disable-next-line require-unicode-regexp
        /safari|applewebkit/i.test(userAgent);
        result.safari_version = parseInt(// eslint-disable-next-line require-unicode-regexp
        (userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
        // Previously we relied on documentElement.style.WebkitAppearance, now changed to userAgent
        // eslint-disable-next-line require-unicode-regexp
        result.webkit = /(apple)?webkit/i.test(userAgent);
        result.supportsIntersectionObserver = $e9b48e5e619880d3$var$hasIntersectionObserver();
        result.supportsResizeObserver = $e9b48e5e619880d3$var$hasResizeObserver();
    }
    return result;
});
module.exports["browser"] = $e9b48e5e619880d3$export$3f2684e5d7cb1006;
module.exports["getBrowserInfo"] = $e9b48e5e619880d3$export$6c724a6ffa2dc3e1;

});

parcelRegister("2T4ch", function(module, exports) {

var $aAn37 = parcelRequire("aAn37");

const $0c7596c6c4d45ef6$var$measureMap = new Map();
function $0c7596c6c4d45ef6$export$b62aa2130c86b59b(measureName) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $0c7596c6c4d45ef6$var$measureMap.set(measureName, performance.now());
}
function $0c7596c6c4d45ef6$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $0c7596c6c4d45ef6$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $0c7596c6c4d45ef6$export$6f766653554dac02(measureName);
    }
}
function $0c7596c6c4d45ef6$export$6f766653554dac02(measureName) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    $0c7596c6c4d45ef6$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $0c7596c6c4d45ef6$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return false;
    return $0c7596c6c4d45ef6$var$measureMap.get(measureName) !== undefined;
}
module.exports["startMeasure"] = $0c7596c6c4d45ef6$export$b62aa2130c86b59b;
module.exports["stopMeasure"] = $0c7596c6c4d45ef6$export$37c25be427bec097;
module.exports["clearMeasure"] = $0c7596c6c4d45ef6$export$6f766653554dac02;
module.exports["isMeasuring"] = $0c7596c6c4d45ef6$export$b0a51f9f0047ea32;

});

parcelRegister("aAn37", function(module, exports) {
let $5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs;
function $5fe8bf23ec0d3d67$export$b5717a625dd4a3eb() {
    if ($5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs === undefined) $5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $5fe8bf23ec0d3d67$var$hasRequiredPerformanceAPIs;
}
function $5fe8bf23ec0d3d67$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $5fe8bf23ec0d3d67$export$4370ec0f52022f66() {
    return $5fe8bf23ec0d3d67$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}
module.exports["isPerformanceAPIAvailable"] = $5fe8bf23ec0d3d67$export$b5717a625dd4a3eb;
module.exports["isPerformanceObserverAvailable"] = $5fe8bf23ec0d3d67$export$48995af1e77d8643;

});

parcelRegister("jz9wK", function(module, exports) {

var $aAn37 = parcelRequire("aAn37");

const $ecd76f47871a107c$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $ecd76f47871a107c$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $ecd76f47871a107c$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}
module.exports["getDistortedDurationMonitor"] = $ecd76f47871a107c$export$70f7d127254a90c;
module.exports["measureRender"] = $ecd76f47871a107c$export$267ed650a5d21ae6;

});

parcelRegister("8pwxt", function(module, exports) {

var $aAn37 = parcelRequire("aAn37");

function $7ee14385cde98d2c$export$92d097a1155bbe27() {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}
function $7ee14385cde98d2c$export$c982229f6c12dcf() {
    if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd - nav.requestStart;
    return;
}
module.exports["getResponseEndTime"] = $7ee14385cde98d2c$export$92d097a1155bbe27;
module.exports["getRequestToResponseTime"] = $7ee14385cde98d2c$export$c982229f6c12dcf;

});

parcelRegister("cQJcI", function(module, exports) {
const $514594b472e6880e$export$18a71eb9fe4307bc = 'block-';
const $514594b472e6880e$export$d7e471f6502a69e2 = (hash, prefix = $514594b472e6880e$export$18a71eb9fe4307bc)=>{
    if (!hash || !prefix) return false;
    // Match either UUID format (8-4-4-4-12) or short hex ID format (exactly 12 hex chars without dashes).
    const uuidRegex = new RegExp(`^#?${prefix}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$`, 'iu');
    const shortIdRegex = new RegExp(`^#?${prefix}[0-9a-f]{12}$`, 'iu');
    return uuidRegex.test(hash) || shortIdRegex.test(hash);
};
const $514594b472e6880e$export$c95c8d5e0fd74b32 = (hash, prefix = $514594b472e6880e$export$18a71eb9fe4307bc)=>{
    if (!$514594b472e6880e$export$d7e471f6502a69e2(hash, prefix)) return null;
    // Remove leading # if present, then remove the prefix.
    const normalized = hash.startsWith('#') ? hash.slice(1) : hash;
    return normalized.slice(prefix.length);
};
const $514594b472e6880e$export$7d28ccc9eddf2197 = (blockId, prefix = $514594b472e6880e$export$18a71eb9fe4307bc)=>{
    return `${prefix}${blockId}`;
};
module.exports["DEFAULT_BLOCK_LINK_HASH_PREFIX"] = $514594b472e6880e$export$18a71eb9fe4307bc;
module.exports["extractBlockIdFromLinkHash"] = $514594b472e6880e$export$c95c8d5e0fd74b32;
module.exports["createBlockLinkHashValue"] = $514594b472e6880e$export$7d28ccc9eddf2197;

});

parcelRegister("bBdDv", function(module, exports) {
/**
 * Shared utilities for scrolling to block elements with expand node support.
 * Used by both Confluence's useScrollOnUrlChange and platform renderer's useScrollToBlock.
 */ const $d796894128b2da9f$export$7f8747c9df4cadcb = {
    /** Minimal delay for DOM/React updates after expanding (no animation in expand component). */ DOM_UPDATE_DELAY: 50,
    /** Delay when expand operation fails and needs retry. */ RETRY_DELAY: 100,
    /** Maximum number of retry attempts before giving up and scrolling anyway. */ MAX_ATTEMPTS: 5,
    /** Maximum depth of nested expands to search (prevents infinite loops). */ MAX_EXPAND_DEPTH: 2
};
function $d796894128b2da9f$export$e070f925e0e65bbc(adfDoc, targetLocalId) {
    let result;
    /**
   * Recursive helper to traverse the ADF document and track expand ancestors.
   * We use recursion to properly maintain the expand ancestor stack.
   */ const traverse = (node, expandAncestors)=>{
        // If we already found the target, stop traversing
        if (result) return false;
        // Check if this is the target node by localId
        if (node?.attrs?.localId === targetLocalId) {
            result = {
                expandParentLocalIds: [
                    ...expandAncestors
                ] // Copy the array
            };
            return false; // Stop traversing
        }
        // Check if this node is an expand or nestedExpand
        const isExpand = node?.type === 'expand' || node?.type === 'nestedExpand';
        const newExpandAncestors = isExpand && node?.attrs?.localId ? [
            ...expandAncestors,
            node.attrs.localId
        ] : expandAncestors;
        // Traverse children if they exist
        if (node?.content && Array.isArray(node.content)) for (const child of node.content){
            if (result || !child) break;
            traverse(child, newExpandAncestors);
        }
        return !result; // Continue if we haven't found it yet
    };
    // Start traversal from the root
    traverse(adfDoc, []);
    return result;
}
const $d796894128b2da9f$export$4fc3b03d60a46096 = (element, maxDepth = $d796894128b2da9f$export$7f8747c9df4cadcb.MAX_EXPAND_DEPTH)=>{
    const expands = [];
    let currentElement = element;
    let depth = 0;
    while(currentElement && depth < maxDepth){
        // Look for expand container - handles both "expand" and "nestedExpand" types
        const expandContainer = currentElement.closest('[data-node-type="expand"], [data-node-type="nestedExpand"]');
        if (!expandContainer || expands.includes(expandContainer)) break;
        expands.push(expandContainer);
        currentElement = expandContainer.parentElement;
        depth++;
    }
    // Return in reverse order so we expand from outermost to innermost
    return expands.reverse();
};
const $d796894128b2da9f$export$785b8bfd794fa7b6 = (expandContainer)=>{
    // Check for aria-expanded attribute on the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded]');
    if (toggleButton && toggleButton instanceof HTMLElement) return toggleButton.getAttribute('aria-expanded') === 'false';
    // Fallback: check if content div is hidden using the actual class name
    const contentDiv = expandContainer.querySelector('.ak-editor-expand__content');
    if (contentDiv && contentDiv instanceof HTMLElement) {
        const computedStyle = window.getComputedStyle(contentDiv);
        return computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || contentDiv.hidden;
    }
    return false;
};
const $d796894128b2da9f$export$280ec17414a50cdd = (expandContainer)=>{
    // Find and click the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded="false"]');
    if (toggleButton && toggleButton instanceof HTMLElement) {
        toggleButton.click();
        return true;
    }
    return false;
};
const $d796894128b2da9f$export$9d8f3695c9ce7da0 = (element, attempt = 0)=>{
    const { MAX_EXPAND_DEPTH: MAX_EXPAND_DEPTH, MAX_ATTEMPTS: MAX_ATTEMPTS, DOM_UPDATE_DELAY: DOM_UPDATE_DELAY, RETRY_DELAY: RETRY_DELAY } = $d796894128b2da9f$export$7f8747c9df4cadcb;
    // Store timeout ID and nested cleanup function so they can be cancelled.
    let timeoutId = null;
    let nestedCleanup = null;
    // Cleanup function that cancels pending timeout and any nested operations.
    const cleanup = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        if (nestedCleanup) {
            nestedCleanup();
            nestedCleanup = null;
        }
    };
    // Guard against element being disconnected from DOM or exceeding max attempts.
    if (attempt >= MAX_ATTEMPTS || !element.isConnected) {
        // Max attempts reached or element disconnected, scroll anyway.
        if (element.isConnected) element.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
        return cleanup;
    }
    try {
        // Step 1: Find all parent expands (outermost to innermost).
        const parentExpands = $d796894128b2da9f$export$4fc3b03d60a46096(element, MAX_EXPAND_DEPTH);
        // Step 2: Find any collapsed expands (filter out disconnected elements).
        const collapsedExpands = parentExpands.filter((expandContainer)=>expandContainer.isConnected && $d796894128b2da9f$export$785b8bfd794fa7b6(expandContainer));
        if (collapsedExpands.length === 0) {
            // All expands are open (or there are no expands), scroll to element.
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            return cleanup;
        }
        // Step 3: Expand ONLY the outermost collapsed expand first.
        // This is critical for nested expands - we must expand parent before child.
        const outermostCollapsed = collapsedExpands[0];
        try {
            const expanded = $d796894128b2da9f$export$280ec17414a50cdd(outermostCollapsed);
            if (expanded) // Successfully expanded, wait briefly for DOM update then recurse to handle any nested expands.
            // Note: There's no animation, but we need a minimal delay for DOM/React updates.
            timeoutId = setTimeout(()=>{
                try {
                    // Verify element is still connected before proceeding.
                    if (!element.isConnected) return;
                    // Recurse to handle any nested collapsed expands or retry if still collapsed.
                    nestedCleanup = $d796894128b2da9f$export$9d8f3695c9ce7da0(element, attempt + 1);
                } catch  {
                    // Fallback to simple scroll on error.
                    if (element.isConnected) element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            }, DOM_UPDATE_DELAY);
            else // Failed to expand, retry with longer delay.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $d796894128b2da9f$export$9d8f3695c9ce7da0(element, attempt + 1);
            }, RETRY_DELAY);
        } catch  {
            // Retry on error.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $d796894128b2da9f$export$9d8f3695c9ce7da0(element, attempt + 1);
            }, RETRY_DELAY);
        }
    } catch  {
        // Fallback to simple scroll on error.
        if (element.isConnected) element.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
    return cleanup;
};
const $d796894128b2da9f$export$94a68fcf7c5634d2 = (localId, container)=>{
    // Check if the element with data-local-id exists
    let element = container.querySelector(`[data-local-id="${localId}"]`);
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector(`[data-decision-list-local-id="${localId}"]`);
    if (element) return element;
    element = container.querySelector(`[data-task-list-local-id="${localId}"]`);
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector(`[data-table-local-id="${localId}"]`);
    if (element) return element;
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector(`[localid="${localId}"]`);
    if (element) return element;
    return null;
};
module.exports["findNodeWithExpandParents"] = $d796894128b2da9f$export$e070f925e0e65bbc;
module.exports["isExpandCollapsed"] = $d796894128b2da9f$export$785b8bfd794fa7b6;
module.exports["expandElement"] = $d796894128b2da9f$export$280ec17414a50cdd;
module.exports["expandAllParentsThenScroll"] = $d796894128b2da9f$export$9d8f3695c9ce7da0;
module.exports["getLocalIdSelector"] = $d796894128b2da9f$export$94a68fcf7c5634d2;

});

parcelRegister("lWghV", function(module, exports) {

var $7i8J9 = parcelRequire("7i8J9");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");

const $b76cb162368f342e$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        case 'max':
            return (0, $7i8J9.EDITOR_APPEARANCE_CONTEXT).MAX;
    }
};
const $b76cb162368f342e$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$b76cb162368f342e$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $b76cb162368f342e$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $b76cb162368f342e$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $ks2lK.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $7XFGZ.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $8m4tT.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $b76cb162368f342e$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $b76cb162368f342e$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
const $b76cb162368f342e$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
const $b76cb162368f342e$var$TABLE_BREAKPOINT_KEYS = Object.keys($b76cb162368f342e$var$EDITOR_BREAKPOINT_WIDTH);
const $b76cb162368f342e$export$afdcbbd112676ca8 = (width)=>{
    return $b76cb162368f342e$var$TABLE_BREAKPOINT_KEYS.find((key)=>width <= $b76cb162368f342e$var$EDITOR_BREAKPOINT_WIDTH[key]) || 'L';
};
module.exports["getAnalyticsAppearance"] = $b76cb162368f342e$export$be87849653b93e6b;
module.exports["getAnalyticsEditorAppearance"] = $b76cb162368f342e$export$31ae53e002edded0;
module.exports["getAnalyticsEventSeverity"] = $b76cb162368f342e$export$f8edd689e8b20f3a;
module.exports["findInsertLocation"] = $b76cb162368f342e$export$d770b562ead089d8;
module.exports["analyticsEventKey"] = $b76cb162368f342e$export$288273ee3e3b6132;
module.exports["getBreakpointKey"] = $b76cb162368f342e$export$afdcbbd112676ca8;

});

parcelRegister("7XFGZ", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json




var $bMyNT = parcelRequire("bMyNT");

class $52ce063c47c095ed$export$ca751a6394ad160e {
    map(mapping) {
        return new $52ce063c47c095ed$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $bMyNT.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $ks2lK.Selection).fromJSON(doc, data);
        }
        return (0, $ks2lK.Selection).near($headCell, 1);
    }
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
}



var $LmqWp = parcelRequire("LmqWp");


var $3gZJH = parcelRequire("3gZJH");


var $jl382 = parcelRequire("jl382");







function $ae78fe5cf073a8d4$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $LmqWp.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $ks2lK.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}





class $72b1aa04a2aec42d$export$831cc7e2a83afa94 extends (0, $ks2lK.Selection) {
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $3gZJH.pointsAtCell)($anchorCell) && (0, $3gZJH.pointsAtCell)($headCell) && (0, $bMyNT.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $72b1aa04a2aec42d$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $72b1aa04a2aec42d$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $72b1aa04a2aec42d$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $ks2lK.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $LmqWp.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $jl382.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $jl382.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            const rowNode = table.child(row).copy((0, $5SAOw.Fragment).from(rowContent));
            rows.push(rowNode);
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $5SAOw.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $5SAOw.Slice).empty : content);
        }
        const sel = (0, $ks2lK.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $LmqWp.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $LmqWp.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $72b1aa04a2aec42d$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $LmqWp.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $72b1aa04a2aec42d$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell, reverse = false) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $LmqWp.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return reverse ? new $72b1aa04a2aec42d$export$831cc7e2a83afa94($calculatedHeadCell, $calculatedAnchorCell) : new $72b1aa04a2aec42d$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $72b1aa04a2aec42d$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $72b1aa04a2aec42d$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $52ce063c47c095ed$export$ca751a6394ad160e)(this.$anchorCell.pos, this.$headCell.pos);
    }
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $ae78fe5cf073a8d4$export$a60a444208fd5099)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        // :: (ResolvedPos, ?ResolvedPos)
        // A table selection is identified by its anchor and head cells. The
        // positions given to this constructor should point _before_ two
        // cells in the same table. They may be the same, to select a single
        // cell.
        this.$anchorCell = void 0;
        this.$headCell = void 0;
        this.visible = void 0;
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
}
(0, $ks2lK.Selection).jsonID('cell', $72b1aa04a2aec42d$export$831cc7e2a83afa94);
module.exports["CellSelection"] = $72b1aa04a2aec42d$export$831cc7e2a83afa94;

});

parcelRegister("bMyNT", function(module, exports) {
function $153dcb01ebe77604$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $153dcb01ebe77604$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}
module.exports["isInTable"] = $153dcb01ebe77604$export$217a88ad224d1b11;
module.exports["inSameTable"] = $153dcb01ebe77604$export$debd62b44eb7e281;

});

parcelRegister("LmqWp", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $37be4ede18960ae5$var$readFromCache, $37be4ede18960ae5$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $37be4ede18960ae5$var$readFromCache = (key)=>cache.get(key);
    $37be4ede18960ae5$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $37be4ede18960ae5$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $37be4ede18960ae5$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $37be4ede18960ae5$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = void 0;
        this.top = void 0;
        this.right = void 0;
        this.bottom = void 0;
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $37be4ede18960ae5$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $37be4ede18960ae5$export$c60fae4049791eae = 140;
class $37be4ede18960ae5$export$493da463fed0a57a {
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $37be4ede18960ae5$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $37be4ede18960ae5$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $37be4ede18960ae5$var$readFromCache(table) || $37be4ede18960ae5$var$addToCache(table, $37be4ede18960ae5$var$computeMap(table));
    }
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        // The width of the table
        this.width = void 0;
        // The table's height
        this.height = void 0;
        this.map = void 0;
        this.problems = void 0;
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
}
// Compute a table map.
function $37be4ede18960ae5$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $37be4ede18960ae5$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $37be4ede18960ae5$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($37be4ede18960ae5$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $37be4ede18960ae5$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $37be4ede18960ae5$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $37be4ede18960ae5$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $37be4ede18960ae5$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $37be4ede18960ae5$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}
module.exports["Rect"] = $37be4ede18960ae5$export$c79fc6492f3af13d;
module.exports["TableProblemTypes"] = $37be4ede18960ae5$export$d8cd393a71edca79;
module.exports["TableMap"] = $37be4ede18960ae5$export$493da463fed0a57a;

});

parcelRegister("3gZJH", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $LmqWp = parcelRequire("LmqWp");

function $462b8962de02df31$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $462b8962de02df31$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $462b8962de02df31$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $462b8962de02df31$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $LmqWp.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}
module.exports["pointsAtCell"] = $462b8962de02df31$export$3c89e45c7dff9619;
module.exports["cellNear"] = $462b8962de02df31$export$7a283ef453dbae9e;
module.exports["cellAround"] = $462b8962de02df31$export$1f482d92c57578ce;
module.exports["nextCell"] = $462b8962de02df31$export$172699367bb25225;

});

parcelRegister("jl382", function(module, exports) {
function $cbe2c55ec9e68dec$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $cbe2c55ec9e68dec$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $cbe2c55ec9e68dec$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $cbe2c55ec9e68dec$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}
module.exports["removeColSpan"] = $cbe2c55ec9e68dec$export$b24d9c3cc95412e0;
module.exports["assertColspan"] = $cbe2c55ec9e68dec$export$6fccdf7cee1b5201;
module.exports["addColSpan"] = $cbe2c55ec9e68dec$export$147ee78a1321ac36;

});

parcelRegister("NPJKR", function(module, exports) {
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $10cc70c3cd038eda$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260
module.exports["shouldForceTracking"] = $10cc70c3cd038eda$export$5b59d3e9e22dbdc6;

});

parcelRegister("9ciHB", function(module, exports) {

var $5nZsM = parcelRequire("5nZsM");


var $kB2tR = parcelRequire("kB2tR");

const $afdd01693dbe3419$var$EMPTY = {};
function $afdd01693dbe3419$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $afdd01693dbe3419$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $afdd01693dbe3419$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $afdd01693dbe3419$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($afdd01693dbe3419$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(e[0]), e[1], options?.objectFlagKeys) && $afdd01693dbe3419$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($afdd01693dbe3419$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $afdd01693dbe3419$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}
module.exports["normalizeFeatureFlags"] = $afdd01693dbe3419$export$f1485fc4974593c0;
module.exports["getEnabledFeatureFlagKeys"] = $afdd01693dbe3419$export$6d018dd0f6cbebcb;

});

parcelRegister("kB2tR", function(module, exports) {

var $2Ed9T = parcelRequire("2Ed9T");

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $efe92ff277fe7159$var$kebabCase = $2Ed9T(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $efe92ff277fe7159$var$kebabCase;

});

parcelRegister("aUnCJ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5SAOw = parcelRequire("5SAOw");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");

parcelRequire("hlcQd");
var $8jc2v = parcelRequire("8jc2v");
var $hlcQd = parcelRequire("hlcQd");




parcelRequire("42omo");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

var $95b75d6dcf8c3302$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});





const $1ab33d55077bc7e8$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($1ab33d55077bc7e8$var$isReactElement(childNode) && childNode.props.children) result = $1ab33d55077bc7e8$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $1ab33d55077bc7e8$var$isReactElement(child) {
    return !!child.type;
}
const $1ab33d55077bc7e8$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $1ab33d55077bc7e8$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};



const $6bc9d398fb95b20f$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).START;
    return false;
};



var $jZG1P = parcelRequire("jZG1P");

function $5f4b8fc731c93068$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}








function $53c7ce50256f5198$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            })
        }, `${segment.text}_${startPos}_${idx}`);
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}



var $jSHzw = parcelRequire("jSHzw");


var $3h7Ko = parcelRequire("3h7Ko");

// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $5f8afa0614c300d4$var$markStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
});
const $5f8afa0614c300d4$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const markRef = (0, $42omo.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $jZG1P.dataAttributes)(draftPosition),
        css: $5f8afa0614c300d4$var$markStyles,
        ref: markRef
    }, children);
};
const $5f8afa0614c300d4$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).START) return 0;
    if (annotationPosition === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).END) return fragmentCount - 1;
    if (annotationPosition === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $5f8afa0614c300d4$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $5f8afa0614c300d4$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)($5f8afa0614c300d4$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: index
        }, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $5f8afa0614c300d4$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $6bc9d398fb95b20f$export$b1baddbd5f289877)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $1ab33d55077bc7e8$export$a9795c84b22a1f06)(children);
    if (!textString) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $95b75d6dcf8c3302$export$c1bd4813440b4505).AROUND_TEXT) {
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $9K4OG.jsx)($5f8afa0614c300d4$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $1ab33d55077bc7e8$export$1059bfc467f4f55d)(nextDraftPosition, textPosition, textString);
    const texts = (0, $1ab33d55077bc7e8$export$2878cc467c8be8fe)(textString, offsets);
    if (!texts) {
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $5f8afa0614c300d4$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, components);
};


const $3ab91fd4d23d289e$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5f8afa0614c300d4$export$69a4e0ac39aaf9b7), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        children: children
    });
};
var $3ab91fd4d23d289e$export$2e2bcd8739ae039 = $3ab91fd4d23d289e$var$TextWrapper;



var $iNqGB = parcelRequire("iNqGB");


var $caYZ2 = parcelRequire("caYZ2");


var $bSXAs = parcelRequire("bSXAs");


var $8m4tT = parcelRequire("8m4tT");


var $dh538 = parcelRequire("dh538");


var $b7FrM = parcelRequire("b7FrM");


var $7nUdN = parcelRequire("7nUdN");
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $GH4gU = parcelRequire("GH4gU");


var $hMQQ9 = parcelRequire("hMQQ9");


var $g5cj9 = parcelRequire("g5cj9");


var $jyYl7 = parcelRequire("jyYl7");


var $cHFH7 = parcelRequire("cHFH7");


var $2KFEz = parcelRequire("2KFEz");


var $6wVZ8 = parcelRequire("6wVZ8");


var $4XjCW = parcelRequire("4XjCW");


var $6ObvC = parcelRequire("6ObvC");


var $hJ84o = parcelRequire("hJ84o");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");





var $anbEX = parcelRequire("anbEX");

const $82b4ce436e9fddb4$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $anbEX.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $82b4ce436e9fddb4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)($82b4ce436e9fddb4$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}





parcelRequire("42omo");

function $a3a9aa36f44a86d5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}



var $9DaqG = parcelRequire("9DaqG");


var $gwCgB = parcelRequire("gwCgB");


var $118BP = parcelRequire("118BP");


var $a6ktG = parcelRequire("a6ktG");





var $5UG0R = parcelRequire("5UG0R");


var $kzW3z = parcelRequire("kzW3z");







class $9e616c67c8d349d1$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}


const $75a8f360c7129c0b$export$c00d967a0f56fdb7 = {
    code: (0, $GH4gU.default),
    em: (0, $hMQQ9.default),
    link: (0, $g5cj9.default),
    strike: (0, $jyYl7.default),
    strong: (0, $cHFH7.default),
    subsup: (0, $2KFEz.default),
    textColor: (0, $6wVZ8.default),
    backgroundColor: (0, $4XjCW.default),
    underline: (0, $6ObvC.default),
    annotation: (0, $7nUdN.default),
    border: (0, $5UG0R.default),
    fontSize: (0, $kzW3z.default),
    // Stage0
    confluenceInlineComment: (0, $9e616c67c8d349d1$export$2e2bcd8739ae039),
    breakout: (0, $hJ84o.default),
    alignment: (0, $82b4ce436e9fddb4$export$2e2bcd8739ae039),
    indentation: (0, $a3a9aa36f44a86d5$export$2e2bcd8739ae039),
    unsupportedMark: (0, $9DaqG.default),
    unsupportedNodeAttribute: (0, $gwCgB.default),
    dataConsumer: (0, $118BP.default),
    fragment: (0, $a6ktG.default)
};
const $75a8f360c7129c0b$export$d4334b129116aad7 = (mark)=>{
    return $75a8f360c7129c0b$export$c00d967a0f56fdb7[mark.type.name];
};





const $816aa5ff776b1fd8$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $816aa5ff776b1fd8$var$isExpandNode = (node)=>node.type.name === 'expand';
const $816aa5ff776b1fd8$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $816aa5ff776b1fd8$export$d7bc71cca336a3b = (path)=>path.some((item)=>$816aa5ff776b1fd8$var$isLayoutNode(item) && $816aa5ff776b1fd8$var$hasBreakOutMark(item));
const $816aa5ff776b1fd8$export$3e763fd7277c58c5 = (path)=>path.some((item)=>$816aa5ff776b1fd8$var$isExpandNode(item) && $816aa5ff776b1fd8$var$hasBreakOutMark(item));
const $816aa5ff776b1fd8$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $816aa5ff776b1fd8$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $816aa5ff776b1fd8$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};
const $816aa5ff776b1fd8$export$a8df1f99c673fa27 = (path, nodeTypeNames)=>{
    for (const node of path){
        if (nodeTypeNames.includes(node.type.name)) return node.type.name;
    }
    return undefined;
};





var $aUnCJ = parcelRequire("aUnCJ");

const $96ace269c0bdcf98$export$eeb66772b38d7581 = (content)=>{
    const standaloneMarks = [];
    // keep track of the previous node's state
    let prev = {
        selfSpaceOnTheRight: true
    };
    let prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(let i = 0; i < content.length; i++){
        const node = content[i];
        const nodeMarks = (0, $aUnCJ.default).getMarks(node);
        const isBackgroundColor = nodeMarks.some((m)=>m.type.name === 'backgroundColor');
        let selfSpaceOnTheLeft = false;
        let selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    const mark = (0, $aUnCJ.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            const mark = (0, $aUnCJ.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
            if (mark) standaloneMarks.push(mark);
        }
    }
    return standaloneMarks;
};


function $8ae98293eca6c2e6$export$3a88c97d9b0d8d1c({ nodes: nodes, onMark: onMark, parentPos: parentPos, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline }) {
    if (!nodes || nodes.length === 0 || nodes[0].isInline) return;
    function isInlineBodiedExtension(node) {
        return Boolean(node?.type.name === 'bodiedExtension' && shouldDisplayExtensionAsInline({
            type: node.type.name,
            extensionKey: node.attrs?.extensionKey,
            extensionType: node.attrs?.extensionType,
            parameters: node.attrs?.parameters,
            content: node.content,
            localId: node.attrs?.localId
        }));
    }
    try {
        let prevPos = parentPos;
        let pos = parentPos;
        let prevTextBlockType;
        for (const [index, node] of nodes.entries()){
            const prevNode = nodes[index - 1];
            // textblock + inlinedBodiedExtension
            if (prevNode?.isTextblock && isInlineBodiedExtension(node)) onMark({
                pos: prevPos
            });
            else if (isInlineBodiedExtension(prevNode) && node.isTextblock && (!prevTextBlockType || node.type === prevTextBlockType)) onMark({
                pos: pos
            });
            if (!isInlineBodiedExtension(node)) prevTextBlockType = node.isTextblock ? node.type : undefined;
            prevPos = pos;
            pos += node.nodeSize;
        }
    } catch  {}
}


function $4b5cdd4f3b34cbcf$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $5SAOw.MarkType) && prev && prev.type instanceof (0, $5SAOw.MarkType) && Array.isArray(prev.content) && (0, $bSXAs.isSameMark)(prev, markOrNode)) prev.content = $4b5cdd4f3b34cbcf$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039 {
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node, path);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'inlineCard':
                return this.getInlineCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'nestedExpand':
                if ((0, $dh538.fg)('hot-121622_lazy_load_expand_content')) return this.getExpandProps(node, path);
                return this.getProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $8jc2v.DocWithSelectAllTrap) : (0, $8jc2v.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, this.getChildNodes(fragment).map((node, index)=>{
            if ((0, $hlcQd.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        this.standaloneBackgroundColorMarks.push(...(0, $96ace269c0bdcf98$export$eeb66772b38d7581)(content));
        return $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, _index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $hlcQd.isTextNode)(mark)) {
            const serializeContent = (childMark, _index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            const isStandalone = this.standaloneBackgroundColorMarks.some((m)=>mark.eq(m));
            return this.renderMark((0, $75a8f360c7129c0b$export$d4334b129116aad7)(mark), {
                ...this.getMarkProps(mark, parentMark.path),
                isStandalone: isStandalone
            }, markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $3ab91fd4d23d289e$export$2e2bcd8739ae039), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                children: mark.text
            }, textKey);
        }
        const segments = (0, $5f4b8fc731c93068$export$93301b6f1ff0b0c3)(mark.text, this.textHighlighter);
        return (0, $53c7ce50256f5198$export$8a20fd0614851c5f)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $l998X.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $l998X.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $816aa5ff776b1fd8$export$42ddc573eb5a7b43)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $816aa5ff776b1fd8$export$9f1e9347b0411934)(path, node.type.schema);
        const isInsideOfTable = (0, $816aa5ff776b1fd8$export$244bf4b32387ef62)(path, node.type.schema);
        const isStickySafeCenteringEnabled = (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const isInsideBreakoutExpand = !isStickySafeCenteringEnabled && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_11', 'isEnabled', true) && (0, $816aa5ff776b1fd8$export$3e763fd7277c58c5)(path);
        const stickyHeaders = isStickySafeCenteringEnabled ? !isInsideOfTable ? this.stickyHeaders : undefined : !isInsideOfTable && !(0, $816aa5ff776b1fd8$export$d7bc71cca336a3b)(path) && !isInsideBreakoutExpand ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $caYZ2.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            // eslint-disable-next-line @atlaskit/platform/valid-gate-name
            isPresentational: (0, $dh538.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
            disableTableOverflowShadow: this.disableTableOverflowShadow,
            allowFixedColumnWidthOption: this.allowFixedColumnWidthOption
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $816aa5ff776b1fd8$export$42ddc573eb5a7b43)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        // Only check path for bodiedSyncBlock; syncBlock uses RendererContext
        const nestedUnder = (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? (0, $816aa5ff776b1fd8$export$a8df1f99c673fa27)(path, [
            'bodiedSyncBlock'
        ]) : undefined;
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            enableSyncMediaCard: this.media?.enableSyncMediaCard,
            mediaViewerExtensions: this.media?.mediaViewerExtensions,
            nestedUnder: nestedUnder
        };
    }
    getExtensionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes,
            nodeHeight: this.getExtensionHeight?.(node),
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        };
    }
    getEmojiProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $816aa5ff776b1fd8$export$42ddc573eb5a7b43)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getInlineCardProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            asInline: this.inlinePositions.has(startPos) ? 'on' : undefined,
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            rendererContentMode: this.contentMode,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $iNqGB.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, _path = []) {
        let loadBodyContent = false;
        if ((0, $dh538.fg)('hot-121622_lazy_load_expand_content')) {
            const annotations = (0, $8m4tT.findChildrenByMark)(node, node.type.schema.marks.annotation, true);
            // Force rendering children if there are inline comments to support comments navigation
            // which relies on the HTML node to be present.
            loadBodyContent = annotations.some((annotation)=>{
                return annotation.node.marks.some((mark)=>mark.attrs.annotationType === 'inlineComment');
            });
        }
        if (!(0, $iNqGB.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return {
            ...this.getProps(node),
            loadBodyContent: loadBodyContent
        };
        const nestedHeaderIds = (0, $8m4tT.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds,
            loadBodyContent: loadBodyContent
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $b7FrM.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    getChildNodes(fragment) {
        let children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        children = (0, $hlcQd.mergeTextNodes)(children);
        if (!!this.shouldDisplayExtensionAsInline && (0, $1oCLl.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true)) (0, $8ae98293eca6c2e6$export$3a88c97d9b0d8d1c)({
            nodes: children,
            onMark: ({ pos: pos })=>{
                this.inlinePositions.add(pos);
            },
            parentPos: this.startPos,
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        });
        return children;
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $bSXAs.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $4b5cdd4f3b34cbcf$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    constructor(init){
        this.providers = void 0;
        this.eventHandlers = void 0;
        this.extensionHandlers = void 0;
        this.portal = void 0;
        this.rendererContext = void 0;
        this.appearance = void 0;
        this.contentMode = void 0;
        this.disableHeadingIDs = void 0;
        this.disableActions = void 0;
        this.headingIds = [];
        /**
     * The reason we have this extra array here is because we need to generate the same unique
     * heading id for 2 different nodes: headers and expands (check the implementation of
     * `getUniqueHeadingId` for more info).
     *
     * We will eventually need to refactor the current approach to generate unique ids
     * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
     */ this.expandHeadingIds = [];
        this.allowHeadingAnchorLinks = void 0;
        this.allowColumnSorting = void 0;
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.fireAnalyticsEvent = void 0;
        this.shouldOpenMediaViewer = void 0;
        this.allowAltTextOnImages = void 0;
        this.stickyHeaders = void 0;
        this.allowMediaLinking = void 0;
        this.initStartPos = void 0;
        this.startPos = void 0;
        this.surroundTextNodesWithTextWrapper = false;
        this.media = void 0;
        this.emojiResourceConfig = void 0;
        this.smartLinks = void 0;
        this.extensionViewportSizes = void 0;
        this.getExtensionHeight = void 0;
        this.allowAnnotations = false;
        this.allowSelectAllTrap = void 0;
        this.nodeComponents = void 0;
        this.allowWindowedCodeBlock = void 0;
        this.isInsideOfInlineExtension = void 0;
        this.textHighlighter = void 0;
        this.allowTableAlignment = void 0;
        this.allowTableResizing = void 0;
        this.allowFixedColumnWidthOption = void 0;
        this.isPresentational = void 0;
        this.disableTableOverflowShadow = void 0;
        this.standaloneBackgroundColorMarks = [];
        this.onSetLinkTarget = void 0;
        this.shouldDisplayExtensionAsInline = void 0;
        this.inlinePositions = new Set();
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem' && (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && parentInfo?.parentIsIncompleteTask === true && (0, $1oCLl.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true);
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $hlcQd.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $75a8f360c7129c0b$export$d4334b129116aad7)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $7nUdN.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $7nUdN.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $GH4gU.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            // Add deepLinkTarget for link marks
            const linkSpecificProps = mark.type.name === 'link' ? {
                onSetLinkTarget: this.onSetLinkTarget
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                ...linkSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.getExtensionHeight = init.getExtensionHeight;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.allowFixedColumnWidthOption = init.allowFixedColumnWidthOption;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
        this.onSetLinkTarget = init.onSetLinkTarget;
        this.shouldDisplayExtensionAsInline = init.shouldDisplayExtensionAsInline;
    }
}
module.exports["default"] = $4b5cdd4f3b34cbcf$export$2e2bcd8739ae039;

});

parcelRegister("hlcQd", function(module, exports) {
$parcel$export(module.exports, "Doc", () => (parcelRequire("8jc2v")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("8jc2v")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $4wH3g = parcelRequire("4wH3g");


var $iq4lN = parcelRequire("iq4lN");

var $gndLe = parcelRequire("gndLe");


var $dh538 = parcelRequire("dh538");


var $8FDtv = parcelRequire("8FDtv");


var $bHs3B = parcelRequire("bHs3B");


var $1acNj = parcelRequire("1acNj");


var $l5RsK = parcelRequire("l5RsK");


var $4aPtv = parcelRequire("4aPtv");


var $8jc2v = parcelRequire("8jc2v");


var $k8515 = parcelRequire("k8515");


var $8dFG8 = parcelRequire("8dFG8");


var $9IIii = parcelRequire("9IIii");


var $AXP6M = parcelRequire("AXP6M");


var $iPgHB = parcelRequire("iPgHB");


var $gaxtd = parcelRequire("gaxtd");


var $2y2LK = parcelRequire("2y2LK");


var $e3xiQ = parcelRequire("e3xiQ");


var $iKbB3 = parcelRequire("iKbB3");


var $4AYMa = parcelRequire("4AYMa");


var $12YDi = parcelRequire("12YDi");


var $40qpT = parcelRequire("40qpT");


var $2jkq1 = parcelRequire("2jkq1");


var $iKFPk = parcelRequire("iKFPk");


var $a78Ri = parcelRequire("a78Ri");


var $cCNNZ = parcelRequire("cCNNZ");


const $bcf3851500a04fac$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "lyuNf",
    name: "WindowedCodeBlock",
    loader: ()=>(parcelRequire("96XCF")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7voiQ",
    name: "CodeBlock",
    loader: ()=>(parcelRequire("d5ZV5")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "QxM0Q",
    name: "TaskList",
    loader: ()=>(parcelRequire("jblE9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "mFjlc",
    name: "TaskItem",
    loader: ()=>(parcelRequire("2ve85")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Es_G2",
    name: "DecisionList",
    loader: ()=>(parcelRequire("8DVsQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "tXkFq",
    name: "DecisionItem",
    loader: ()=>(parcelRequire("gbCDG")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "UW2mx",
    name: "Date",
    loader: ()=>(parcelRequire("ezNcf")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "YWl55",
    name: "Status",
    loader: ()=>(parcelRequire("kQgmx")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "vg-Rq",
    name: "Emoji",
    _vcPlaceholderIgnored: true,
    loader: ()=>(parcelRequire("fqjOA")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Hm6N8",
    name: "Panel",
    _addVCPlaceholderWrapper: "span",
    loader: ()=>(parcelRequire("jSXwK")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Ecfpn",
    name: "EmbedCard",
    loader: ()=>(parcelRequire("68cQw")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "0vDZ-",
    name: "InlineCard",
    loader: ()=>(parcelRequire("dVRt3")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "cNtW6",
    name: "BlockCard",
    loader: ()=>(parcelRequire("bUOE6")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "nouWf",
    name: "Media",
    _vcPlaceholderIgnored: true,
    loader: ()=>(parcelRequire("3yJXT")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "l7RKL",
    name: "MediaGroup",
    loader: ()=>(parcelRequire("gtfGk")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "IVdRD",
    name: "MediaInline",
    loader: ()=>(parcelRequire("9wbn0")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Eb7Gh",
    name: "MediaSingle",
    _delayHydration: true,
    loader: ()=>(parcelRequire("dm5Dj")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "w10Xv",
    name: "Mention",
    loader: ()=>(parcelRequire("a8O6D")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "UPgdC",
    name: "Expand",
    loader: ()=>(parcelRequire("4Y3We")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "f1NYX",
    name: "SyncBlockLoader",
    loader: ()=>(parcelRequire("64LyH")).then((mod)=>mod.default),
    loading: ()=>null
});

const $bcf3851500a04fac$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "uj9UW",
    name: "BodiedSyncBlock",
    loader: ()=>(parcelRequire("dvtp1")).then((mod)=>mod.default),
    loading: ()=>null
});
const $bcf3851500a04fac$export$3931063f6a5f290e = {
    blockquote: (0, $8FDtv.default),
    bulletList: (0, $4aPtv.default),
    blockCard: $bcf3851500a04fac$export$d18ccd25c0d2c6b0,
    caption: (0, $e3xiQ.default),
    date: $bcf3851500a04fac$export$6341f9a885713487,
    decisionItem: $bcf3851500a04fac$export$b6f73a2b0b0de599,
    decisionList: $bcf3851500a04fac$export$b458dfa720128865,
    doc: (0, $8jc2v.default),
    emoji: $bcf3851500a04fac$export$56cc48506ff790a,
    extension: (0, $k8515.default),
    bodiedExtension: (0, $bHs3B.default),
    multiBodiedExtension: (0, $1acNj.default),
    extensionFrame: (0, $l5RsK.default),
    hardBreak: (0, $8dFG8.default),
    heading: (0, $9IIii.default),
    inlineCard: $bcf3851500a04fac$export$aff6291803939b05,
    inlineExtension: (0, $AXP6M.default),
    layoutSection: (0, $iPgHB.default),
    layoutColumn: (0, $gaxtd.default),
    listItem: (0, $2y2LK.default),
    media: $bcf3851500a04fac$export$7fc53215244aec38,
    mediaGroup: $bcf3851500a04fac$export$d7858be3df00d59,
    mediaInline: $bcf3851500a04fac$export$462ea7c2a1c4cb1f,
    mediaSingle: $bcf3851500a04fac$export$888d74bc001c3a5d,
    mention: $bcf3851500a04fac$export$e891316fea657d90,
    orderedList: (0, $iKbB3.default),
    panel: $bcf3851500a04fac$export$2ddb90ad54e5f587,
    paragraph: (0, $4AYMa.default),
    placeholder: (0, $12YDi.default),
    rule: (0, $40qpT.default),
    status: $bcf3851500a04fac$export$96e9906d6d93a972,
    taskItem: $bcf3851500a04fac$export$27c4189b8be1bf93,
    taskList: $bcf3851500a04fac$export$771a55a10b0a40ae,
    table: (0, $2jkq1.default),
    tableCell: (0, $iKFPk.TableCell),
    tableHeader: (0, $iKFPk.TableHeader),
    tableRow: (0, $a78Ri.default),
    unknownBlock: (0, $cCNNZ.default),
    unsupportedBlock: (0, $iq4lN.default),
    unsupportedInline: (0, $gndLe.default),
    expand: $bcf3851500a04fac$export$49bd1dfb0ad29c40,
    syncBlock: $bcf3851500a04fac$var$SyncBlockLoader,
    bodiedSyncBlock: $bcf3851500a04fac$var$BodiedSyncBlock,
    nestedExpand: $bcf3851500a04fac$export$49bd1dfb0ad29c40,
    embedCard: $bcf3851500a04fac$export$6789d7ecdc77631b,
    blockTaskItem: $bcf3851500a04fac$export$27c4189b8be1bf93
};
const $bcf3851500a04fac$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $8jc2v.DocWithSelectAllTrap;
    if (!(0, $dh538.fg)('jfp-magma-ssr-iv-editor-codeblock')) {
        if (node.type.name === 'codeBlock') {
            if (flags?.allowWindowedCodeBlock === true) return $bcf3851500a04fac$export$a22ee8f907eecb5f;
            return $bcf3851500a04fac$export$6c415d1fdae3dfdb;
        }
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$bcf3851500a04fac$export$3931063f6a5f290e,
        ...nodeComponents
    };
    if ((0, $dh538.fg)('jfp-magma-ssr-iv-editor-codeblock')) {
        if (node.type.name === 'codeBlock') {
            if (flags?.allowWindowedCodeBlock === true) return nodes.windowedCodeBlock ?? $bcf3851500a04fac$export$a22ee8f907eecb5f;
            return nodes.codeBlock ?? $bcf3851500a04fac$export$6c415d1fdae3dfdb;
        }
    }
    nodes['multiBodiedExtension'] = (0, $1acNj.default);
    return nodes[node.type.name];
};
const $bcf3851500a04fac$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$bcf3851500a04fac$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $bcf3851500a04fac$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $bcf3851500a04fac$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $bcf3851500a04fac$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $bcf3851500a04fac$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $bcf3851500a04fac$var$whitespaceRegex = /^\s*$/;
const $bcf3851500a04fac$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $bcf3851500a04fac$var$isEmojiBlock(node.content);
};
const $bcf3851500a04fac$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($bcf3851500a04fac$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};
module.exports["InlineCard"] = $bcf3851500a04fac$export$aff6291803939b05;
module.exports["nodeToReact"] = $bcf3851500a04fac$export$3931063f6a5f290e;
module.exports["toReact"] = $bcf3851500a04fac$export$d4334b129116aad7;
module.exports["mergeTextNodes"] = $bcf3851500a04fac$export$8045509d14b5046f;
module.exports["isTextWrapper"] = $bcf3851500a04fac$export$d4ebd3557ee7fac1;
module.exports["isTextNode"] = $bcf3851500a04fac$export$ccbedd67ef6e9417;

});

parcelRegister("gndLe", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $cs1vW = parcelRequire("cs1vW");


var $aFUXX = parcelRequire("aFUXX");


var $ci7Ox = parcelRequire("ci7Ox");


var $3gadb = parcelRequire("3gadb");


var $d925B = parcelRequire("d925B");


var $iCOwP = parcelRequire("iCOwP");


var $juTiU = parcelRequire("juTiU");


var $1QdLR = parcelRequire("1QdLR");

const $21cc51f6839cd966$var$inlineNodeStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #17171708)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $21cc51f6839cd966$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $1QdLR.getUnsupportedContent)((0, $iCOwP.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $iCOwP.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $42omo.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $42omo.useCallback)(()=>dispatchAnalyticsEvent && (0, $juTiU.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $d925B.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $21cc51f6839cd966$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
        label: "?"
    }))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $21cc51f6839cd966$var$_default_1 = (0, $cs1vW.default)($21cc51f6839cd966$var$UnsupportedInlineNode);
var $21cc51f6839cd966$export$2e2bcd8739ae039 = $21cc51f6839cd966$var$_default_1;
module.exports["default"] = $21cc51f6839cd966$export$2e2bcd8739ae039;

});

parcelRegister("5VmpF", function(module, exports) {
$parcel$export(module.exports, "default", () => $52efeb67c19e95a1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $heH5c = parcelRequire("heH5c");


var $dYBVS = parcelRequire("dYBVS");


var $2diEG = parcelRequire("2diEG");

function $52efeb67c19e95a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $52efeb67c19e95a1$var$inlineExtensionStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
const $52efeb67c19e95a1$var$plainTextMacroStyle = {
    name: "1b7osz4",
    styles: "display:inline;vertical-align:baseline;[data-macro-body]{display:inline;}"
};
function $52efeb67c19e95a1$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $2XqLN.default)((0, $heH5c.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((_name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        const isPlainTextMacro = Boolean(node?.parameters?.macroParams?.__bodyContent);
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $2diEG.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $9K4OG.jsx)($52efeb67c19e95a1$export$f41ccc3bd3324832, {
                    isPlainTextMacro: isPlainTextMacro
                }, /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch  {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            node: node,
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dYBVS.WithProviders), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $52efeb67c19e95a1$export$f41ccc3bd3324832 = ({ children: children, isPlainTextMacro: isPlainTextMacro, ssrPlaceholder: ssrPlaceholder, ssrPlaceholderReplace: ssrPlaceholderReplace })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `inline-extension-renderer ${isPlainTextMacro ? 'plain-text-macro' : ''}`,
        css: [
            $52efeb67c19e95a1$var$inlineExtensionStyle,
            isPlainTextMacro && $52efeb67c19e95a1$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};
module.exports["InlineNodeRendererWrapper"] = $52efeb67c19e95a1$export$f41ccc3bd3324832;

});

parcelRegister("heH5c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $4wH3g = parcelRequire("4wH3g");


var $dh538 = parcelRequire("dh538");


var $3jQ9y = parcelRequire("3jQ9y");


var $5pF33 = parcelRequire("5pF33");

/* UnknownMacroPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");







const $6061b910d878542d$var$neutralBorder = "var(--ds-background-neutral, #0515240F)";
const $6061b910d878542d$var$unknownMacroContainerStyles = null; // Match LCM header exactly: lcmHeaderStyles from LegacyContentHeader/index.tsx
const $6061b910d878542d$var$unknownMacroHeaderStyles = null; // Match LCM content area: white surface, text color inherits
const $6061b910d878542d$var$unknownMacroBodyStyles = null;
const $6061b910d878542d$var$unknownMacroPreStyles = null;
function $6061b910d878542d$export$414b5225f50e455b({ extensionNode: extensionNode }) {
    const intl = (0, $1cfRh.default)();
    const macroTitle = extensionNode.parameters?.macroMetadata?.title || extensionNode.extensionKey;
    const bodyContent = extensionNode.parameters?.macroParams?.__bodyContent?.value;
    const macroParams = extensionNode.parameters?.macroParams ?? {};
    const formatParam = (key, param)=>{
        const value = String(param?.value ?? '').trim();
        return `${key} = ${value}`;
    }; // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const visibleParams = Object.entries(macroParams).filter(([key])=>!key.startsWith('_')).map(([key, param])=>formatParam(key, param)).join(' | ');
    const headerText = visibleParams ? `${intl.formatMessage((0, $5pF33.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    })} | ${visibleParams}` : intl.formatMessage((0, $5pF33.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    });
    return /*#__PURE__*/ $42omo.createElement("section", {
        "aria-label": intl.formatMessage((0, $5pF33.messages).unknownMacroPlaceholderAriaLabel),
        className: (0, $gMc0m.default)([
            "_19it1tra _2rko12b0 _1reo15vq _18m915vq _bfhkhp5a"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_2rko14xi _11c8wadc _n7zlbjo2 _bfhki8nm _ca0qu2gc _u5f3pxbi _n3td1b66 _19bvpxbi _kqswh2mm _154i1n1a"
        ])
    }, headerText), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkvuon _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
        ])
    }, /*#__PURE__*/ $42omo.createElement("pre", {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey _o5721jtm _1nmz1hna _6z24egat"
        ])
    }, bodyContent)));
}


function $05c1a9b049285eb2$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
function $05c1a9b049285eb2$export$573ee875a39e7e73(extensionProvider, extensionType, extensionKey) {
    const [extKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    return extensionProvider.getExtension(extensionType, extKey);
}
async function $05c1a9b049285eb2$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $05c1a9b049285eb2$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $05c1a9b049285eb2$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $3jQ9y.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider?.getPreloadedExtension?.(extensionType, extKey);
    if (manifest) return $05c1a9b049285eb2$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$05c1a9b049285eb2$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $05c1a9b049285eb2$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $05c1a9b049285eb2$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $05c1a9b049285eb2$var$isUnknownConfluenceMacroWithBody(extensionNode) {
    return extensionNode !== null && extensionNode.type === 'extension' && extensionNode.extensionType === 'com.atlassian.confluence.macro.core' && !!extensionNode.parameters?.macroParams?.__bodyContent?.value;
}
function $05c1a9b049285eb2$var$ExtensionLoading(props) {
    const intl = (0, $1cfRh.default)();
    const extensionNode = props.node;
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $05c1a9b049285eb2$var$isUnknownConfluenceMacroWithBody(extensionNode) && (0, $dh538.fg)('tinymce_display_unknown_macro_body_content')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6061b910d878542d$export$414b5225f50e455b), {
            extensionNode: extensionNode
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, intl.formatMessage((0, $5pF33.messages).extensionLoadingError));
    } else return null;
}
function $05c1a9b049285eb2$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "w8Pzf",
        name: "getNodeRenderer",
        _maybeSyncLoader: true,
        loader: ()=>{
            const maybePromise = $05c1a9b049285eb2$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
            if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $3jQ9y.resolveImport)(node.render()));
            else {
                const preloaded = maybePromise?.renderSync?.();
                // Only product implemented preloading will return sync result
                // However the out-of-box won't handle this. Confluence uses a custom implementation
                return preloaded ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $3jQ9y.resolveImportSync)(preloaded) : (0, $3jQ9y.resolveImport)(maybePromise.render());
            }
        },
        // react-loadable passes all props from <NodeRenderer> to the loading component at runtime,
        // but its TypeScript types only expect LoadingComponentProps. We cast here because
        // ExtensionLoading accepts additional props (node, showUnknownMacroPlaceholder) that
        // react-loadable will pass through but doesn't know about in its type definitions.
        loading: $05c1a9b049285eb2$var$ExtensionLoading
    });
}
module.exports["getExtensionModuleNode"] = $05c1a9b049285eb2$export$82dd45c2db936caf;
module.exports["getExtensionModuleNodePrivateProps"] = $05c1a9b049285eb2$export$426f8efd8690d8aa;
module.exports["getNodeRenderer"] = $05c1a9b049285eb2$export$67a7d49db68d30a0;

});

parcelRegister("3jQ9y", function(module, exports) {
const $e45bd9e65e516a2b$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $e45bd9e65e516a2b$export$862c0e8acc7585d7 = 'com.atlassian.confluence.macro.core';
const $e45bd9e65e516a2b$export$b343a94058bea058 = 'native-embed';
const $e45bd9e65e516a2b$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $e45bd9e65e516a2b$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $e45bd9e65e516a2b$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $e45bd9e65e516a2b$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $e45bd9e65e516a2b$export$33863d887d6f4bfd(action, manifest);
}
const $e45bd9e65e516a2b$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
const $e45bd9e65e516a2b$export$d69c9b451c47653b = async (importPromise)=>{
    return $e45bd9e65e516a2b$export$dca2026e63034304(await importPromise);
};
function $e45bd9e65e516a2b$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $e45bd9e65e516a2b$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}
module.exports["NATIVE_EMBED_EXTENSION_TYPE"] = $e45bd9e65e516a2b$export$862c0e8acc7585d7;
module.exports["NATIVE_EMBED_EXTENSION_KEY"] = $e45bd9e65e516a2b$export$b343a94058bea058;
module.exports["getExtensionKeyAndNodeKey"] = $e45bd9e65e516a2b$export$8a49818572e1d105;
module.exports["buildAction"] = $e45bd9e65e516a2b$export$bb33bcdd9a10a608;
module.exports["resolveImportSync"] = $e45bd9e65e516a2b$export$dca2026e63034304;
module.exports["resolveImport"] = $e45bd9e65e516a2b$export$d69c9b451c47653b;

});

parcelRegister("5pF33", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $888908f21431656e$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    edit: {
        id: "fabric.editor.edit",
        defaultMessage: "Edit"
    },
    deleteElementTitle: {
        id: "fabric.editor.extension.deleteElementTitle",
        defaultMessage: "Delete element"
    },
    unnamedSource: {
        id: "fabric.editor.extension.sourceNoTitledName",
        defaultMessage: "this element"
    },
    confirmDeleteLinkedModalOKButton: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalOKButton",
        defaultMessage: "Delete"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    confirmModalCheckboxLabel: {
        id: "fabric.editor.floatingToolbar.confirmModalCheckboxLabel",
        defaultMessage: "Also delete connected elements"
    },
    saveIndicator: {
        id: "fabric.editor.extensions.config-panel.save-indicator",
        defaultMessage: "All changes are always autosaved"
    },
    panelLoadingError: {
        id: "fabric.editor.extensions.config-panel.loading-error.non-final",
        defaultMessage: "We ran into a bit of trouble. Refresh to try again."
    },
    extensionLoadingError: {
        id: "fabric.editor.extension.loading-error",
        defaultMessage: "Error loading the extension!"
    },
    unknownMacroPlaceholderAriaLabel: {
        id: "fabric.editor.extension.unknownMacroPlaceholderAriaLabel",
        defaultMessage: "Unknown macro placeholder"
    },
    unknownMacroHeader: {
        id: "fabric.editor.extension.unknownMacroHeader",
        defaultMessage: "Unknown macro: ''{macroTitle}''"
    }
});
const $888908f21431656e$export$163c7b0716312254 = (0, $h82at.defineMessages)({
    configFailedToLoad: {
        id: "fabric.editor.configFailedToLoad",
        defaultMessage: "Failed to load"
    },
    submit: {
        id: "fabric.editor.configPanel.submit",
        defaultMessage: "Submit"
    },
    cancel: {
        id: "fabric.editor.configPanel.cancel",
        defaultMessage: "Cancel"
    },
    close: {
        id: "fabric.editor.configPanel.close",
        defaultMessage: "Close"
    },
    required: {
        id: "fabric.editor.configPanel.required",
        defaultMessage: "Required field"
    },
    invalid: {
        id: "fabric.editor.configPanel.invalid",
        defaultMessage: "Invalid field"
    },
    isMultipleAndRadio: {
        id: "fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio",
        defaultMessage: "Can not combine isMultiple with style: radio"
    },
    addField: {
        id: "fabric.editor.configPanel.formType.addField",
        defaultMessage: "Add field"
    },
    removeField: {
        id: "fabric.editor.configPanel.formType.removeField",
        defaultMessage: "Remove field"
    },
    createOption: {
        id: "fabric.editor.configPanel.customSelect.createOption",
        defaultMessage: "Create"
    },
    documentation: {
        id: "fabric.editor.configPanel.documentation",
        defaultMessage: "Documentation"
    },
    help: {
        id: "fabric.editor.configPanel.help",
        defaultMessage: "Need help?"
    },
    custom: {
        id: "fabric.editor.configPanel.dateRange.option.custom",
        defaultMessage: "Custom"
    },
    from: {
        id: "fabric.editor.configPanel.dateRange.custom.from",
        defaultMessage: "From"
    },
    to: {
        id: "fabric.editor.configPanel.dateRange.custom.to",
        defaultMessage: "To"
    },
    expand: {
        id: "fabric.editor.configPanel.dateRange.grouping.expand",
        defaultMessage: "Expand"
    },
    collapse: {
        id: "fabric.editor.configPanel.dateRange.grouping.collapse",
        defaultMessage: "Collapse"
    },
    errorBoundaryTitle: {
        id: "fabric.editor.configPanel.errorBoundary.title",
        defaultMessage: "Something went wrong."
    },
    errorBoundaryNote: {
        id: "fabric.editor.configPanel.errorBoundary.note",
        defaultMessage: "We've let the team know. You can still edit and publish this page, or check the error console for more information."
    }
});
module.exports["messages"] = $888908f21431656e$export$defe85febe8b728c;
module.exports["configPanelMessages"] = $888908f21431656e$export$163c7b0716312254;

});

parcelRegister("dYBVS", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $42omo = parcelRequire("42omo");

class $45c1f6450eda5090$export$d498ee8be33e096f extends (0, $42omo.PureComponent) {
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProviderIfMounted);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
    constructor(props){
        super(props);
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            _providers[name] = providerPromise;
        });
        this.state = {
            providers: _providers
        };
    }
}
$45c1f6450eda5090$export$d498ee8be33e096f.displayName = 'WithProviders';
module.exports["WithProviders"] = $45c1f6450eda5090$export$d498ee8be33e096f;

});

parcelRegister("2diEG", function(module, exports) {
function $b48cc40544bb1d44$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}
module.exports["getExtensionRenderer"] = $b48cc40544bb1d44$export$9214452ef07eda7;

});

parcelRegister("frt7o", function(module, exports) {
$parcel$export(module.exports, "default", () => $df5484c93cd47d97$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fp8V7 = parcelRequire("fp8V7");

const $df5484c93cd47d97$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $df5484c93cd47d97$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $fp8V7.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                !this.props?.disableTableOverflowShadow && showRightShadow && $df5484c93cd47d97$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                !this.props?.disableTableOverflowShadow && showLeftShadow && $df5484c93cd47d97$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $fp8V7.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            /**
       * The widths have already been calculated to determine
       * showRightShadow and showLeftShadow. If either is true,
       * then the content is scrollable and we need to set the
       * tabIndex to 0 to allow the user to scroll the content
       * for a11y purposes.
       */ const hasOverflowScroll = showRightShadow || showLeftShadow;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                handleRef: this.handleContainer,
                tabIndex: hasOverflowScroll ? 0 : undefined,
                shadowClassNames: classNames,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.overflowContainer = void 0;
            this.container = void 0;
            this.shadowObserver = void 0;
            this.overflowContainerWidth = 0;
            this.scrollable = void 0;
            this.diff = void 0;
            this.state = {
                showLeftShadow: false,
                showRightShadow: false
            };
            this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            };
            this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            };
            this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            };
            this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            };
            this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    if ($df5484c93cd47d97$var$isElementNode(scrollableElement)) width += scrollableElement.scrollWidth;
                }
                return width;
            };
            this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}
// Helper function to check if the passed node is of Element class
function $df5484c93cd47d97$var$isElementNode(node) {
    return node.nodeType === 1;
}
module.exports["shadowClassNames"] = $df5484c93cd47d97$export$4735dd2b0fa88aa5;

});

parcelRegister("fJNzZ", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $61p3e = parcelRequire("61p3e");


var $4BBKV = parcelRequire("4BBKV");


var $bWRlG = parcelRequire("bWRlG");


var $4vlwG = parcelRequire("4vlwG");

const $d5ea6d1627235160$export$2626b4a7243208a1 = [
    'expand',
    'layoutSection',
    'codeBlock',
    'syncBlock',
    'bodiedSyncBlock'
];
const $d5ea6d1627235160$export$c2c078d93ed82790 = (schema)=>{
    const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection, syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock } = schema.nodes;
    return new Set([
        expand,
        codeBlock,
        layoutSection,
        syncBlock,
        bodiedSyncBlock
    ]);
};
const $d5ea6d1627235160$export$ead1fecec2ecf57c = {
    padding: (0, $aFUXX.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $aFUXX.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $aFUXX.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $aFUXX.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $aFUXX.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $4BBKV.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $bWRlG.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (breakoutConsts)=>(layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    const wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
    calcBreakoutWithCustomWidth: (breakoutConsts)=>(mode, width, editorContainerWidth)=>{
            if (width !== null && width > 0) {
                const effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return `${Math.min(width, effectiveFullWidth)}px`;
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        },
    calcLineLength: (breakoutConsts)=>()=>breakoutConsts.defaultLayoutWidth,
    calcWideWidth: (breakoutConsts)=>(containerWidth = breakoutConsts.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            const layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
};
const $d5ea6d1627235160$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcBreakoutWidth($d5ea6d1627235160$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $aFUXX.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $aFUXX.akEditorWideLayoutWidth;
        default:
            return $d5ea6d1627235160$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($d5ea6d1627235160$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $d5ea6d1627235160$export$86325001fe8f3adc = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcWideWidth($d5ea6d1627235160$export$ead1fecec2ecf57c);
const $d5ea6d1627235160$export$5f4502874a28dfce = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcBreakoutWidth($d5ea6d1627235160$export$ead1fecec2ecf57c);
const $d5ea6d1627235160$export$ccc0a02edddeed39 = $d5ea6d1627235160$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($d5ea6d1627235160$export$ead1fecec2ecf57c);
function $d5ea6d1627235160$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $d5ea6d1627235160$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $4vlwG.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $aFUXX.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $aFUXX.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $d5ea6d1627235160$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $4vlwG.parsePx)($d5ea6d1627235160$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $d5ea6d1627235160$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $d5ea6d1627235160$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $61p3e.default).layoutFixedWidth;
        case 'wide':
            return (0, $61p3e.default).layoutFullWidth;
        default:
            return (0, $61p3e.default).layoutWide;
    }
};
module.exports["breakoutResizableNodes"] = $d5ea6d1627235160$export$2626b4a7243208a1;
module.exports["getBreakoutResizableNodeTypes"] = $d5ea6d1627235160$export$c2c078d93ed82790;
module.exports["breakoutConsts"] = $d5ea6d1627235160$export$ead1fecec2ecf57c;
module.exports["absoluteBreakoutWidth"] = $d5ea6d1627235160$export$b34ea040d1533a3;
module.exports["calcWideWidth"] = $d5ea6d1627235160$export$86325001fe8f3adc;
module.exports["calcBreakoutWidth"] = $d5ea6d1627235160$export$5f4502874a28dfce;
module.exports["calculateBreakoutStyles"] = $d5ea6d1627235160$export$c377853ecdd53e5b;
module.exports["getNextBreakoutMode"] = $d5ea6d1627235160$export$7eb758567e6644fd;
module.exports["getTitle"] = $d5ea6d1627235160$export$70d1bf7729efff40;

});

parcelRegister("61p3e", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $h82at = parcelRequire("h82at");


var $hkTaH = parcelRequire("hkTaH");


var $ahUGI = parcelRequire("ahUGI");


var $5duTD = parcelRequire("5duTD");


var $eKkkY = parcelRequire("eKkkY");


var $2UWDO = parcelRequire("2UWDO");


var $7Rcde = parcelRequire("7Rcde");



var $fpEzC = parcelRequire("fpEzC");


var $ckqYV = parcelRequire("ckqYV");



var $9c6e5 = parcelRequire("9c6e5");


var $f8J4a = parcelRequire("f8J4a");


var $4HWgE = parcelRequire("4HWgE");


var $gVDfZ = parcelRequire("gVDfZ");


var $3RxtY = parcelRequire("3RxtY");


var $8aWkM = parcelRequire("8aWkM");


var $2zaaI = parcelRequire("2zaaI");


var $2CQVV = parcelRequire("2CQVV");


var $5Ilz2 = parcelRequire("5Ilz2");


var $ocPnd = parcelRequire("ocPnd");


var $agX1m = parcelRequire("agX1m");


var $1moKB = parcelRequire("1moKB");


var $l51YQ = parcelRequire("l51YQ");


var $2REsZ = parcelRequire("2REsZ");


var $c5kBY = parcelRequire("c5kBY");


var $6YSsz = parcelRequire("6YSsz");


var $lzn6v = parcelRequire("lzn6v");



var $jOP6v = parcelRequire("jOP6v");


var $2iuib = parcelRequire("2iuib");


var $hdkJi = parcelRequire("hdkJi");


var $fHFVT = parcelRequire("fHFVT");


var $02xUP = parcelRequire("02xUP");


var $ePpFN = parcelRequire("ePpFN");


var $iesbi = parcelRequire("iesbi");


var $e0nFU = parcelRequire("e0nFU");


var $dwl7L = parcelRequire("dwl7L");


var $b0RMS = parcelRequire("b0RMS");


var $3NvMe = parcelRequire("3NvMe");


var $1o1Zn = parcelRequire("1o1Zn");


var $5dODy = parcelRequire("5dODy");


var $kofef = parcelRequire("kofef");


var $808tb = parcelRequire("808tb");


var $gA3OZ = parcelRequire("gA3OZ");


var $fzXn1 = parcelRequire("fzXn1");



var $9dV3t = parcelRequire("9dV3t");


var $7Irim = parcelRequire("7Irim");

const $deed4682d9d46c57$var$_default_1 = (0, $h82at.defineMessages)({
    layoutFixedWidth: {
        id: "fabric.editor.layoutFixedWidth",
        defaultMessage: "Back to center"
    },
    layoutStateFixedWidth: {
        id: "fabric.editor.layoutStateFixedWidth",
        defaultMessage: "Centered"
    },
    layoutWide: {
        id: "fabric.editor.layoutWide",
        defaultMessage: "Go wide"
    },
    layoutStateWide: {
        id: "fabric.editor.layoutStateWide",
        defaultMessage: "Wide"
    },
    layoutFullWidth: {
        id: "fabric.editor.layoutFullWidth",
        defaultMessage: "Go full width"
    },
    layoutStateFullWidth: {
        id: "fabric.editor.layoutStateFullWidth",
        defaultMessage: "Full width"
    },
    alignImageRight: {
        id: "fabric.editor.alignImageRight",
        defaultMessage: "Align right"
    },
    alignImageCenter: {
        id: "fabric.editor.alignImageCenter",
        defaultMessage: "Align center"
    },
    alignImageLeft: {
        id: "fabric.editor.alignImageLeft",
        defaultMessage: "Align left"
    },
    delete: {
        id: "fabric.editor.delete",
        defaultMessage: "Delete"
    },
    remove: {
        id: "fabric.editor.remove",
        defaultMessage: "Remove"
    },
    removeEmoji: {
        id: "fabric.editor.removeEmoji",
        defaultMessage: "Remove emoji"
    },
    visit: {
        id: "fabric.editor.visit",
        defaultMessage: "Open link in a new window"
    },
    inviteToEditButtonTitle: {
        id: "fabric.editor.editMode.inviteToEditButton.title",
        defaultMessage: "Invite to edit"
    },
    saveButton: {
        id: "fabric.editor.saveButton",
        defaultMessage: "Save"
    },
    cancelButton: {
        id: "fabric.editor.cancelButton",
        defaultMessage: "Cancel"
    },
    taskList: {
        id: "fabric.editor.tooltip.taskList",
        defaultMessage: "an action item"
    },
    bulletList: {
        id: "fabric.editor.tooltip.bulletList",
        defaultMessage: "a list"
    },
    nestedExpand: {
        id: "fabric.editor.tooltip.nestedExpand",
        defaultMessage: "a nested expand"
    },
    decisionList: {
        id: "fabric.editor.tooltip.decisionList",
        defaultMessage: "a decision list"
    },
    defaultBlockNode: {
        id: "fabric.editor.tooltip.defaultBlockNode",
        defaultMessage: "a block node"
    },
    panel: {
        id: "fabric.editor.tooltip.blockPanel",
        defaultMessage: "a panel"
    },
    blockquote: {
        id: "fabric.editor.blockquote",
        defaultMessage: "a quote"
    },
    timeUpdated: {
        id: "fabric.editor.time.updated",
        defaultMessage: "Updated"
    },
    timeViewed: {
        id: "fabric.editor.time.viewed",
        defaultMessage: "Viewed"
    },
    timeAgo: {
        id: "fabric.editor.time.ago",
        defaultMessage: "ago"
    },
    copyToClipboard: {
        id: "fabric.editor.copyToClipboard",
        defaultMessage: "Copy"
    },
    copiedToClipboard: {
        id: "fabric.editor.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    viewMore: {
        id: "fabric.editor.overflowMenuViewMore",
        defaultMessage: "View more"
    },
    imageEdit: {
        id: "fabric.editor.imageEdit",
        defaultMessage: "Edit image"
    },
    error: {
        id: "fabric.editor.error.message.label",
        defaultMessage: "Error"
    },
    success: {
        id: "fabric.editor.success.message.label",
        defaultMessage: "Success"
    }
});
var $deed4682d9d46c57$export$2e2bcd8739ae039 = $deed4682d9d46c57$var$_default_1;
module.exports["default"] = $deed4682d9d46c57$export$2e2bcd8739ae039;

});

parcelRegister("hkTaH", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $e57f64ef4f7fa472$export$5229ffea355cfdf6 = (0, $h82at.defineMessages)({
    alignment: {
        id: "fabric.editor.alignment",
        defaultMessage: "Text alignment"
    },
    alignLeft: {
        id: "fabric.editor.alignLeft",
        defaultMessage: "Align left"
    },
    alignCenter: {
        id: "fabric.editor.alignCenter",
        defaultMessage: "Align center"
    },
    alignRight: {
        id: "fabric.editor.alignRight",
        defaultMessage: "Align right"
    }
});
module.exports["alignmentMessages"] = $e57f64ef4f7fa472$export$5229ffea355cfdf6;

});

parcelRegister("ahUGI", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $48c5e4b8bf27ceee$export$ff612ca71703201d = (0, $h82at.defineMessages)({
    createComment: {
        id: "fabric.editor.createComment",
        defaultMessage: "Comment"
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: "fabric.editor.createCommentInvalid",
        defaultMessage: "You can only comment on text and headings"
    },
    createCommentDisabled: {
        id: "fabric.editor.createCommentDisabled",
        defaultMessage: "You can only comment on text, headings, emojis, dates, mentions, links, and statuses."
    },
    // Duplicated by Confluence's
    // highlight-actions.inline-comments.comment.no.permission
    noPermissionToAddComment: {
        id: "fabric.editor.noPermissionToAddComment",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}"
    },
    toolbar: {
        id: "fabric.editor.annotationToolbar",
        defaultMessage: "Annotation toolbar"
    }
});
module.exports["annotationMessages"] = $48c5e4b8bf27ceee$export$ff612ca71703201d;

});

parcelRegister("5duTD", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $d91c973aee84789e$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    maxWidthLabel: {
        id: "fabric.editor.breakoutMaxWidthLabel",
        defaultMessage: "Max-width"
    },
    fullWidthLabel: {
        id: "fabric.editor.breakoutFullWidthLabel",
        defaultMessage: "Full-width"
    },
    wideWidthLabel: {
        id: "fabric.editor.breakoutWideWidthLabel",
        defaultMessage: "Wide"
    },
    resizeHandle: {
        id: "fabric.editor.resizeHandle",
        defaultMessage: "Resize handle"
    },
    resizeExpand: {
        id: "fabric.editor.breakout.resizeExpand",
        defaultMessage: "Resize expand"
    },
    resizeCodeBlock: {
        id: "fabric.editor.breakout.resizeCodeBlock",
        defaultMessage: "Resize code snippet"
    },
    resizeLayout: {
        id: "fabric.editor.breakout.resizeLayout",
        defaultMessage: "Resize layout"
    },
    resizeElement: {
        id: "fabric.editor.breakout.resizeElement",
        defaultMessage: "Resize element"
    }
});
module.exports["messages"] = $d91c973aee84789e$export$defe85febe8b728c;

});

parcelRegister("eKkkY", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $1029fcd095daaf54$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    copyBlock: {
        id: "fabric.editor.block.menu.copy.block",
        defaultMessage: "Copy block"
    },
    moveUpBlock: {
        id: "fabric.editor.block.menu.move.up",
        defaultMessage: "Move up"
    },
    moveDownBlock: {
        id: "fabric.editor.block.menu.move.down",
        defaultMessage: "Move down"
    },
    copyLink: {
        id: "fabric.editor.block.menu.copy.link",
        defaultMessage: "Copy link"
    },
    copyLinkToBlock: {
        id: "fabric.editor.block.menu.copy.link.to.block",
        defaultMessage: "Copy link to block"
    },
    // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
    // New message with updated wording. To clean up: remove old message and feature flag check when flag is removed.
    copyLinkToSelection: {
        id: "fabric.editor.block.menu.copy.link.to.selection",
        defaultMessage: "Copy link to selection"
    },
    linkCopiedToClipboard: {
        id: "fabric.editor.block.menu.link.copied.to.clipboard",
        defaultMessage: "Link copied to clipboard"
    },
    paragraph: {
        id: "fabric.editor.block.menu.paragraph",
        defaultMessage: "Paragraph"
    },
    codeBlock: {
        id: "fabric.editor.block.menu.codeblock",
        defaultMessage: "Code block"
    },
    layout: {
        id: "fabric.editor.block.menu.layout",
        defaultMessage: "Layout"
    },
    deleteBlock: {
        id: "fabric.editor.block.menu.delete.block",
        defaultMessage: "Delete"
    },
    turnInto: {
        id: "fabric.editor.block.menu.turn.into",
        defaultMessage: "Turn into"
    },
    createSyncedBlock: {
        id: "fabric.editor.block.menu.create.synced.block",
        defaultMessage: "Create synced block"
    },
    // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
    // New message with updated wording. To clean up: remove old message and feature flag check when flag is removed.
    syncBlock: {
        id: "fabric.editor.block.menu.sync.block",
        defaultMessage: "Sync block"
    },
    copySyncedBlock: {
        id: "fabric.editor.block.menu.copy.synced.block",
        defaultMessage: "Copy synced block"
    },
    newLozenge: {
        id: "fabric.editor.block.menu.new.lozenge",
        defaultMessage: "New"
    },
    decisionList: {
        id: "fabric.editor.block.menu.decision",
        defaultMessage: "Decision"
    },
    wrapIcon: {
        id: "fabric.editor.block.menu.wrap.icon",
        defaultMessage: "Wrap"
    },
    create: {
        id: "fabric.editor.block.menu.create",
        defaultMessage: "Create"
    },
    headings: {
        id: "fabric.editor.block.menu.headings",
        defaultMessage: "Headings"
    },
    suggested: {
        id: "fabric.editor.block.menu.suggested",
        defaultMessage: "Suggested"
    },
    structure: {
        id: "fabric.editor.block.menu.structure",
        defaultMessage: "Structure"
    },
    fallbackNestedMenu: {
        id: "fabric.editor.block.menu.fallback.nested.menu",
        defaultMessage: "Nested Menu"
    },
    fallbackMenuItem: {
        id: "fabric.editor.block.menu.fallback.menu.item",
        defaultMessage: "Block Menu Item"
    }
});
module.exports["messages"] = $1029fcd095daaf54$export$defe85febe8b728c;

});

parcelRegister("2UWDO", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $1be454cb3ba0e245$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    normal: {
        id: "fabric.editor.normal",
        defaultMessage: "Normal text"
    },
    smallText: {
        id: "fabric.editor.smallText",
        defaultMessage: "Small text"
    },
    heading1: {
        id: "fabric.editor.heading1",
        defaultMessage: "Heading 1"
    },
    heading1Description: {
        id: "fabric.editor.heading1Description",
        defaultMessage: "Use this for a top level heading"
    },
    heading2: {
        id: "fabric.editor.heading2",
        defaultMessage: "Heading 2"
    },
    heading2Description: {
        id: "fabric.editor.heading2Description",
        defaultMessage: "Use this for key sections"
    },
    heading3: {
        id: "fabric.editor.heading3",
        defaultMessage: "Heading 3"
    },
    heading3Description: {
        id: "fabric.editor.heading3Description",
        defaultMessage: "Use this for sub sections and group headings"
    },
    heading4: {
        id: "fabric.editor.heading4",
        defaultMessage: "Heading 4"
    },
    heading4Description: {
        id: "fabric.editor.heading4Description",
        defaultMessage: "Use this for deep headings"
    },
    heading5: {
        id: "fabric.editor.heading5",
        defaultMessage: "Heading 5"
    },
    heading5Description: {
        id: "fabric.editor.heading5Description",
        defaultMessage: "Use this for grouping list items"
    },
    heading6: {
        id: "fabric.editor.heading6",
        defaultMessage: "Heading 6"
    },
    heading6Description: {
        id: "fabric.editor.heading6Description",
        defaultMessage: "Use this for low level headings"
    },
    blockquote: {
        id: "fabric.editor.blockquote2",
        defaultMessage: "Quote"
    },
    blockquoteDescription: {
        id: "fabric.editor.blockquote.description",
        defaultMessage: "Insert a quote or citation"
    },
    codeblock: {
        id: "fabric.editor.codeblock",
        defaultMessage: "Code snippet"
    },
    codeblockDescription: {
        id: "fabric.editor.codeblock.description",
        defaultMessage: "Display code with syntax highlighting"
    },
    infoPanel: {
        id: "fabric.editor.infoPanel",
        defaultMessage: "Info panel"
    },
    infoPanelDescription: {
        id: "fabric.editor.infoPanel.description",
        defaultMessage: "Highlight information in a colored panel"
    },
    notePanel: {
        id: "fabric.editor.notePanel",
        defaultMessage: "Note panel"
    },
    notePanelDescription: {
        id: "fabric.editor.notePanel.description",
        defaultMessage: "Add a note in a colored panel"
    },
    successPanel: {
        id: "fabric.editor.successPanel",
        defaultMessage: "Success panel"
    },
    successPanelDescription: {
        id: "fabric.editor.successPanel.description",
        defaultMessage: "Add tips in a colored panel"
    },
    warningPanel: {
        id: "fabric.editor.warningPanel",
        defaultMessage: "Warning panel"
    },
    warningPanelDescription: {
        id: "fabric.editor.warningPanel.description",
        defaultMessage: "Add a note of caution in a colored panel"
    },
    errorPanel: {
        id: "fabric.editor.errorPanel",
        defaultMessage: "Error panel"
    },
    errorPanelDescription: {
        id: "fabric.editor.errorPanel.description",
        defaultMessage: "Call out errors in a colored panel"
    },
    customPanel: {
        id: "fabric.editor.customPanel",
        defaultMessage: "Custom panel"
    },
    customPanelDescription: {
        id: "fabric.editor.customPanel.description",
        defaultMessage: "Add a note with an emoji and colored background"
    },
    syncedBlock: {
        id: "fabric.editor.syncedBlock",
        defaultMessage: "Create synced block"
    },
    // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
    // New message with updated wording. To clean up: remove old message and feature flag check when flag is removed.
    syncBlock: {
        id: "fabric.editor.syncBlock",
        defaultMessage: "Sync block"
    },
    syncedBlockDescription: {
        id: "fabric.editor.syncedBlock.description",
        defaultMessage: "Sync content across multiple locations"
    },
    newLozenge: {
        id: "fabric.editor.quickinsert.new.lozenge",
        defaultMessage: "New"
    },
    panel: {
        id: "fabric.editor.panel",
        defaultMessage: "Panel"
    },
    textBoxAriaLabel: {
        id: "fabric.editor.aria.textbox",
        defaultMessage: "textbox"
    },
    other: {
        id: "fabric.editor.other",
        defaultMessage: "Others..."
    }
});
module.exports["messages"] = $1be454cb3ba0e245$export$defe85febe8b728c;

});

parcelRegister("7Rcde", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $71e03d612e0cb7ab$export$42bb270d1224182 = (0, $h82at.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: "fabric.editor.codeBidiWarningLabel",
        defaultMessage: "Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code."
    }
});
module.exports["codeBidiWarningMessages"] = $71e03d612e0cb7ab$export$42bb270d1224182;

});

parcelRegister("fpEzC", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $8b2a73d924c824ef$export$4ce3884394d6d9 = (0, $h82at.defineMessages)({
    openLink: {
        id: "fabric.editor.openLink",
        defaultMessage: "Open link in a new tab"
    },
    openPreviewPanel: {
        id: "fabric.editor.openPreviewPanel",
        defaultMessage: "Open preview panel"
    }
});
module.exports["linkMessages"] = $8b2a73d924c824ef$export$4ce3884394d6d9;

});

parcelRegister("ckqYV", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $f9584a45f41233ef$export$2d7676d841c8ae9 = (0, $h82at.defineMessages)({
    addLink: {
        id: "fabric.editor.mediaAddLink",
        defaultMessage: "Add link"
    },
    unableToOpenLink: {
        id: "fabric.editor.unableToOpenLink",
        defaultMessage: "Unable to open this link"
    },
    unlink: {
        id: "fabric.editor.unlink",
        defaultMessage: "Unlink"
    },
    editDatasourceStandalone: {
        id: "fabric.editor.editDatasourceStandalone",
        defaultMessage: "Edit"
    },
    editDatasourceStandaloneTooltip: {
        id: "fabric.editor.editDatasourceStandaloneTooltip",
        defaultMessage: "Edit search query"
    },
    editLink: {
        id: "fabric.editor.editLink",
        defaultMessage: "Edit link"
    },
    placeholder: {
        id: "fabric.editor.hyperlinkToolbarPlaceholder",
        defaultMessage: "Paste or search for link"
    },
    linkPlaceholder: {
        id: "fabric.editor.linkPlaceholder",
        defaultMessage: "Paste link"
    },
    linkAddress: {
        id: "fabric.editor.linkAddress",
        defaultMessage: "Link address"
    },
    invalidLink: {
        id: "fabric.editor.invalidLink",
        defaultMessage: "Please enter a valid link."
    },
    emptyLink: {
        id: "fabric.editor.emptyLink",
        defaultMessage: "Please enter a link."
    },
    settingsLink: {
        id: "fabric.editor.settingsLinks",
        defaultMessage: "Go to Link Preferences"
    },
    preferencesLink: {
        id: "fabric.editor.preferencesLink",
        defaultMessage: "Link preferences"
    },
    editDatasource: {
        id: "fabric.editor.edit.datasource",
        defaultMessage: "Edit search query"
    },
    searchInput: {
        id: "fabric.editor.edit.searchInput",
        defaultMessage: "Add a link"
    }
});
module.exports["linkToolbarMessages"] = $f9584a45f41233ef$export$2d7676d841c8ae9;

});

parcelRegister("9c6e5", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $0195961b2f3a7fe2$export$8bd807073e2c6716 = (0, $h82at.defineMessages)({
    codeblockLanguageAriaDescription: {
        id: "fabric.editor.codeBlock.languageAriaDescription",
        defaultMessage: "Code snippet language: {language}."
    },
    codeBlockLanguageNotSet: {
        id: "fabric.editor.codeBlock.languageNotSet",
        defaultMessage: "Code language not set."
    }
});
module.exports["codeBlockMessages"] = $0195961b2f3a7fe2$export$8bd807073e2c6716;

});

parcelRegister("f8J4a", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $a33388bf0f1afdd4$export$74e304339778e94d = (0, $h82at.defineMessages)({
    copyCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copyToClipboard",
        defaultMessage: "Copy as text"
    },
    copiedCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    wrapCode: {
        id: "fabric.editor.codeBlockWrapButton.wrapCodeBlock",
        defaultMessage: "Turn on wrap"
    },
    unwrapCode: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCodeBlock",
        defaultMessage: "Turn off wrap"
    },
    selectLanguage: {
        id: "fabric.editor.selectLanguage",
        defaultMessage: "Select language"
    }
});
module.exports["codeBlockButtonMessages"] = $a33388bf0f1afdd4$export$74e304339778e94d;

});

parcelRegister("4HWgE", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $8db99cec71546e3d$export$70c8a7203d95247 = (0, $h82at.defineMessages)({
    action: {
        id: "fabric.editor.action",
        defaultMessage: "Action item"
    },
    actionDescription: {
        id: "fabric.editor.action.description",
        defaultMessage: "Create and assign action items"
    },
    closeInsertRightRail: {
        id: "fabric.editor.insertRightRail.close",
        defaultMessage: "Close"
    },
    link: {
        id: "fabric.editor.link",
        defaultMessage: "Link"
    },
    linkDescription: {
        id: "fabric.editor.link.description",
        defaultMessage: "Insert a link"
    },
    mediaFiles: {
        id: "fabric.editor.mediaFiles",
        defaultMessage: "Image, video, or file"
    },
    addMediaFiles: {
        id: "fabric.editor.addMediaFiles",
        defaultMessage: "Add image, video, or file"
    },
    insertRightRailTitle: {
        id: "fabric.editor.insertRightRail.title",
        defaultMessage: "Insert"
    },
    mediaFilesDescription: {
        id: "fabric.editor.mediaFiles.description",
        defaultMessage: "Add images and other files to your page"
    },
    image: {
        id: "fabric.editor.image",
        defaultMessage: "Image"
    },
    mention: {
        id: "fabric.editor.mention",
        defaultMessage: "Mention"
    },
    mentionDescription: {
        id: "fabric.editor.mention.description",
        defaultMessage: "Mention someone to send them a notification"
    },
    emoji: {
        id: "fabric.editor.emoji",
        defaultMessage: "Emoji"
    },
    emojiDescription: {
        id: "fabric.editor.emoji.description",
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04"
    },
    table: {
        id: "fabric.editor.table",
        defaultMessage: "Table"
    },
    tableDescription: {
        id: "fabric.editor.table.description",
        defaultMessage: "Insert a table"
    },
    tableSelector: {
        id: "fabric.editor.tableSelector",
        defaultMessage: "Table size"
    },
    tableSelectorDescription: {
        id: "fabric.editor.tableSelector.description",
        defaultMessage: "Add a table using popup to select a custom size"
    },
    tableSizeSelectorButton: {
        id: "fabric.editor.tableSizeSelectorButton",
        defaultMessage: "{numberOfColumns} by {numberOfRows}"
    },
    tableSizeSelectorPopup: {
        id: "fabric.editor.tableSizeSelectorPopup",
        defaultMessage: "Table size selector"
    },
    expand: {
        id: "fabric.editor.expand",
        defaultMessage: "Expand"
    },
    expandDescription: {
        id: "fabric.editor.expand.description",
        defaultMessage: "Insert an expand"
    },
    decision: {
        id: "fabric.editor.decision",
        defaultMessage: "Decision"
    },
    decisionDescription: {
        id: "fabric.editor.decision.description",
        defaultMessage: "Capture decisions so they're easy to track"
    },
    feedbackDialog: {
        id: "fabric.editor.feedbackDialog",
        defaultMessage: "Give feedback"
    },
    feedbackDialogDescription: {
        id: "fabric.editor.feedbackDialog.description",
        defaultMessage: "Tell us about your experience using the cloud editor"
    },
    horizontalRule: {
        id: "fabric.editor.horizontalRule",
        defaultMessage: "Divider"
    },
    horizontalRuleDescription: {
        id: "fabric.editor.horizontalRule.description",
        defaultMessage: "Separate content with a horizontal line"
    },
    date: {
        id: "fabric.editor.date",
        defaultMessage: "Date"
    },
    dateDescription: {
        id: "fabric.editor.date.description",
        defaultMessage: "Add a date using a calendar"
    },
    placeholderText: {
        id: "fabric.editor.placeholderText",
        defaultMessage: "Placeholder text"
    },
    placeholderTextDescription: {
        id: "fabric.editor.placeholderText.description",
        defaultMessage: "Insert a text placeholder into the page"
    },
    columns: {
        id: "fabric.editor.columns",
        defaultMessage: "Layouts"
    },
    columnsDescription: {
        id: "fabric.editor.columns.description",
        defaultMessage: "Structure your page using sections"
    },
    columnsDescriptionAdvancedLayout: {
        id: "fabric.editor.columns.advanced.layout.description",
        defaultMessage: "Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}"
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: "fabric.editor.columns.advanced.layout.single.description",
        defaultMessage: "Insert a single column layout"
    },
    status: {
        id: "fabric.editor.status",
        defaultMessage: "Status"
    },
    statusDescription: {
        id: "fabric.editor.status.description",
        defaultMessage: "Add a custom status label"
    },
    viewMore: {
        id: "fabric.editor.viewMore",
        defaultMessage: "View more"
    },
    viewMoreAriaLabel: {
        id: "fabric.editor.viewMoreAriaLabel",
        defaultMessage: "View all elements"
    },
    insertMenu: {
        id: "fabric.editor.insertMenu",
        defaultMessage: "Insert elements"
    },
    help: {
        id: "fabric.editor.help",
        defaultMessage: "Help"
    },
    helpDescription: {
        id: "fabric.editor.help.description",
        defaultMessage: "Browse all the keyboard shortcuts and markdown options"
    },
    recordVideo: {
        id: "fabric.editor.recordVideo",
        defaultMessage: "Record a Loom video"
    },
    addLoomVideo: {
        id: "fabric.editor.addLoomVideo",
        defaultMessage: "Record a Loom video"
    },
    addLoomVideoComment: {
        id: "fabric.editor.addLoomVideoComment",
        defaultMessage: "Record a Loom video comment"
    },
    recordVideoDescription: {
        id: "fabric.editor.recordVideo.description",
        defaultMessage: "Record and share your screen and thoughts"
    },
    recordLoomShortTitle: {
        id: "fabric.editor.recordLoomShortTitle",
        defaultMessage: "Record"
    },
    turnInto: {
        id: "fabric.editor.turnInto",
        defaultMessage: "Turn into"
    }
});
module.exports["toolbarInsertBlockMessages"] = $8db99cec71546e3d$export$70c8a7203d95247;

});

parcelRegister("gVDfZ", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $0889ec8859f0b4df$export$81b075fd34c2f0bb = (0, $h82at.defineMessages)({
    wrapLeft: {
        id: "fabric.editor.wrapLeft",
        defaultMessage: "Wrap left"
    },
    wrapRight: {
        id: "fabric.editor.wrapRight",
        defaultMessage: "Wrap right"
    },
    changeToMediaSingle: {
        id: "fabric.editor.media_change_mediasingle",
        defaultMessage: "Original size"
    },
    changeToMediaInlineImage: {
        id: "fabric.editor.media_change_mediainline_default",
        defaultMessage: "Inline"
    },
    changeToMediaInlineImageCaptionWarning: {
        id: "fabric.editor.media_change_mediainline_caption_warn",
        defaultMessage: "Inline (caption will be removed)"
    }
});
module.exports["toolbarMessages"] = $0889ec8859f0b4df$export$81b075fd34c2f0bb;

});

parcelRegister("3RxtY", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $75232df246e43c97$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    url: {
        id: "fabric.editor.url",
        defaultMessage: "Display URL"
    },
    block: {
        id: "fabric.editor.displayBlock",
        defaultMessage: "Display card"
    },
    inline: {
        id: "fabric.editor.displayInline",
        defaultMessage: "Display inline"
    },
    embed: {
        id: "fabric.editor.displayEmbed",
        defaultMessage: "Display embed"
    },
    link: {
        id: "fabric.editor.displayLink",
        defaultMessage: "Display as text"
    },
    card: {
        id: "fabric.editor.cardFloatingControls",
        defaultMessage: "Card options"
    },
    blockCardUnavailable: {
        id: "fabric.editor.blockCardUnavailable",
        defaultMessage: "The inline link is inside {node} and cannot have its view changed"
    },
    displayOptionUnavailableInParentNode: {
        id: "fabric.editor.displayOptionUnavailableInParentNode",
        defaultMessage: "This display option isn't available inside {node}"
    },
    urlTitle: {
        id: "fabric.editor.urlTitle",
        defaultMessage: "URL"
    },
    blockTitle: {
        id: "fabric.editor.blockTitle",
        defaultMessage: "Card"
    },
    inlineTitle: {
        id: "fabric.editor.inlineTitle",
        defaultMessage: "Inline"
    },
    openButtonTitle: {
        id: "fabric.editor.openButtonTitle",
        defaultMessage: "Open"
    },
    panelButtonTitle: {
        id: "fabric.editor.panelButtonTitle",
        defaultMessage: "Panel"
    },
    previewButtonTitle: {
        id: "fabric.editor.previewButtonTitle",
        defaultMessage: "Preview"
    },
    embedTitle: {
        id: "fabric.editor.embedTitle",
        defaultMessage: "Embed"
    },
    urlDescription: {
        id: "fabric.editor.urlDescription",
        defaultMessage: "Display link as URL"
    },
    blockDescription: {
        id: "fabric.editor.blockDescription",
        defaultMessage: "Display more information about a link, including a summary and actions"
    },
    inlineDescription: {
        id: "fabric.editor.inlineDescription",
        defaultMessage: "Display link as inline text"
    },
    embedDescription: {
        id: "fabric.editor.ecombedDescription",
        defaultMessage: "Display an interactive preview of a link"
    },
    embedToBlockCardWarning: {
        id: "fabric.editor.embedToBlockCardWarning",
        defaultMessage: "Displays as a card on small screens"
    },
    editDropdownExpandIconLabel: {
        id: "fabric.editor.editDropdownExpandIconLabel",
        defaultMessage: "Expand dropdown menu"
    },
    editDropdownTriggerTitle: {
        id: "fabric.editor.editDropdownTriggerTitle",
        defaultMessage: "Edit"
    },
    editDropdownEditLinkTitle: {
        id: "fabric.editor.editDropdownEditLinkTitle",
        defaultMessage: "Edit link"
    },
    editDropdownEditDatasourceTitle: {
        id: "fabric.editor.editDropdownEditDatasourceTitle",
        defaultMessage: "Edit search query"
    },
    datasourceTitle: {
        id: "fabric.editor.datasourceTitle",
        defaultMessage: "Edit search query"
    },
    datasourceAppearanceTitle: {
        id: "fabric.editor.datasourceAppearanceTitle",
        defaultMessage: "List"
    },
    datasourceJiraIssue: {
        id: "fabric.editor.datasource.jiraIssue",
        defaultMessage: "Jira Issues"
    },
    datasourceJiraIssueDescription: {
        id: "fabric.editor.datasource.jiraIssue.description",
        defaultMessage: "Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration."
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: "fabric.editor.datasource.assetsObjectsGeneralAvailability",
        defaultMessage: "Assets"
    },
    datasourceAssetsObjectsDescription: {
        id: "fabric.editor.datasource.assetsObjects.description",
        defaultMessage: "Insert objects from Assets in Jira Service Management with search and filtering"
    },
    inlineOverlay: {
        id: "fabric.editor.inlineOverlay",
        defaultMessage: "Configure"
    },
    inlineConfigureLink: {
        id: "fabric.editor.inlineConfigureLink",
        defaultMessage: "Configure link"
    },
    inlineGoToLink: {
        id: "fabric.editor.inlineGoToLink",
        defaultMessage: "Go to link"
    },
    datasourceConfluenceSearch: {
        id: "fabric.editor.datasource.confluenceSearch",
        defaultMessage: "Insert Confluence list"
    },
    datasourceConfluenceSearchDescription: {
        id: "fabric.editor.datasource.confluenceSearch.description",
        defaultMessage: "Insert list of search results from Confluence with enhanced search, filtering, and configuration."
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: "fabric.editor.datasource.jiraIssue.issue-term-refresh",
        defaultMessage: "Jira Work Items"
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: "fabric.editor.datasource.jiraIssue.description.issue-term-refresh",
        defaultMessage: "Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration."
    }
});
module.exports["messages"] = $75232df246e43c97$export$defe85febe8b728c;

});

parcelRegister("8aWkM", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $a1c0ccc91a87c11c$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    toolbarLabel: {
        id: "fabric.editor.toolbarLabel",
        defaultMessage: "Editor"
    },
    pageActionsLabel: {
        id: "fabric.editor.pageActionsLabel",
        defaultMessage: "Page actions"
    },
    editableContentLabel: {
        id: "fabric.editor.editableContentLabel",
        defaultMessage: "Editable content"
    }
});
module.exports["messages"] = $a1c0ccc91a87c11c$export$defe85febe8b728c;

});

parcelRegister("2zaaI", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $09bc4db4179d16d9$export$81b075fd34c2f0bb = (0, $h82at.defineMessages)({
    underline: {
        id: "fabric.editor.underline",
        defaultMessage: "Underline"
    },
    strike: {
        id: "fabric.editor.strike",
        defaultMessage: "Strikethrough"
    },
    code: {
        id: "fabric.editor.code",
        defaultMessage: "Code"
    },
    codeOn: {
        id: "fabric.editor.code.on",
        defaultMessage: "{textFormattingOff}, Code On"
    },
    subscript: {
        id: "fabric.editor.subscript",
        defaultMessage: "Subscript"
    },
    subscriptOffSuperscriptOn: {
        id: "fabric.editor.subscript.off.superscript.on",
        defaultMessage: "Subscript Off, Superscript On"
    },
    superscript: {
        id: "fabric.editor.superscript",
        defaultMessage: "Superscript"
    },
    superscriptOffSubscriptOn: {
        id: "fabric.editor.superscript.off.subscript.on",
        defaultMessage: "Superscript Off, Subscript On"
    },
    clearFormatting: {
        id: "fabric.editor.clearFormatting",
        defaultMessage: "Clear formatting"
    },
    moreFormatting: {
        id: "fabric.editor.moreFormatting",
        defaultMessage: "More formatting"
    },
    textFormatting: {
        id: "fabric.editor.textFormatting",
        defaultMessage: "Text formatting"
    },
    textFormat: {
        id: "fabric.editor.textFormat",
        defaultMessage: "Format text"
    },
    bold: {
        id: "fabric.editor.bold",
        defaultMessage: "Bold"
    },
    italic: {
        id: "fabric.editor.italic",
        defaultMessage: "Italic"
    },
    on: {
        id: "fabric.editor.on",
        defaultMessage: "{formattingType} On"
    },
    off: {
        id: "fabric.editor.off",
        defaultMessage: "{formattingType} Off"
    },
    textStyles: {
        id: "fabric.editor.textStyles",
        defaultMessage: "{blockTypeName} Text styles"
    },
    textStylesTooltip: {
        id: "fabric.editor.textStylesTooltip",
        defaultMessage: "Text styles"
    },
    textFormattingOff: {
        id: "fabric.editor.text.formatting.off",
        defaultMessage: "Text formatting Off"
    },
    navigateToEditorToolbar: {
        id: "fabric.editor.navigate.toolbar.editor",
        defaultMessage: "Navigate to editor toolbar"
    },
    navigateToFloatingToolbar: {
        id: "fabric.editor.navigate.toolbar.floating",
        defaultMessage: "Navigate to floating toolbar"
    },
    askAI: {
        id: "fabric.editor.navigate.toolbar.askAI",
        defaultMessage: "Ask AI"
    },
    selectionToolbarOverflowMenuTooltip: {
        id: "fabric.editor.selectionToolbarOverflowMenuTooltip",
        defaultMessage: "More options"
    }
});
module.exports["toolbarMessages"] = $09bc4db4179d16d9$export$81b075fd34c2f0bb;

});

parcelRegister("2CQVV", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $3d7dc9b28782bfb3$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    tableScrollRegion: {
        id: "fabric.editor.tableScrollRegion",
        defaultMessage: "Table scroll region"
    },
    tableOptions: {
        id: "fabric.editor.tableOptions",
        defaultMessage: "Table options"
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeIncreaseScreenReaderInformation",
        defaultMessage: "Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeDecreaseScreenReaderInformation",
        defaultMessage: "Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    headerRow: {
        id: "fabric.editor.headerRow",
        defaultMessage: "Header row"
    },
    headerColumn: {
        id: "fabric.editor.headerColumn",
        defaultMessage: "Header column"
    },
    numberedColumn: {
        id: "fabric.editor.numberedColumn",
        defaultMessage: "Numbered column"
    },
    collapseTable: {
        id: "fabric.editor.collapseTable",
        defaultMessage: "Collapse table"
    },
    resizeTable: {
        id: "fabric.editor.tables.resizeTable",
        defaultMessage: "Resize table"
    },
    insertColumn: {
        id: "fabric.editor.insertColumn",
        defaultMessage: "Insert column right"
    },
    addColumnLeft: {
        id: "fabric.editor.addColumnLeft",
        defaultMessage: "Add column left"
    },
    addColumnRight: {
        id: "fabric.editor.addColumnRight",
        defaultMessage: "Add column right"
    },
    insertColumnDrag: {
        id: "fabric.editor.insertColumnDrag",
        defaultMessage: "Insert column"
    },
    removeColumns: {
        id: "fabric.editor.removeColumns",
        defaultMessage: "Delete {0, plural, one {column} other {columns}}"
    },
    insertRow: {
        id: "fabric.editor.insertRow",
        defaultMessage: "Insert row below"
    },
    addRowAbove: {
        id: "fabric.editor.addRowAbove",
        defaultMessage: "Add row above"
    },
    addRowBelow: {
        id: "fabric.editor.addRowBelow",
        defaultMessage: "Add row below"
    },
    moveColumnLeft: {
        id: "fabric.editor.moveColumnLeft",
        defaultMessage: "Move {0, plural, one {column} other {columns}} left"
    },
    moveColumnLeftHelpDialogLabel: {
        id: "fabric.editor.moveColumnLeftHelpDialogLabel",
        defaultMessage: "Move column left"
    },
    moveColumnRight: {
        id: "fabric.editor.moveColumnRight",
        defaultMessage: "Move {0, plural, one {column} other {columns}} right"
    },
    moveColumnRightHelpDialogLabel: {
        id: "fabric.editor.moveColumnRightHelpDialogLabel",
        defaultMessage: "Move column right"
    },
    moveRowUp: {
        id: "fabric.editor.moveRowUp",
        defaultMessage: "Move {0, plural, one {row} other {rows}} up"
    },
    moveRowUpHelpDialogLabel: {
        id: "fabric.editor.moveRowUpHelpDialogLabel",
        defaultMessage: "Move row up"
    },
    moveRowDown: {
        id: "fabric.editor.moveDownDown",
        defaultMessage: "Move {0, plural, one {row} other {rows}} down"
    },
    moveRowDownHelpDialogLabel: {
        id: "fabric.editor.moveRowDownHelpDialogLabel",
        defaultMessage: "Move row down"
    },
    insertRowDrag: {
        id: "fabric.editor.insertRowDrag",
        defaultMessage: "Insert row"
    },
    removeRows: {
        id: "fabric.editor.removeRows",
        defaultMessage: "Delete {0, plural, one {row} other {rows}}"
    },
    rowNumbers: {
        id: "fabrid.editor.rowNumbers",
        defaultMessage: "Row numbers"
    },
    numberedRows: {
        id: "fabrid.editor.numberedRows",
        defaultMessage: "Numbered rows"
    },
    rowsAreInserted: {
        id: "fabric.editor.rowsAreInserted",
        defaultMessage: "{count, plural, one {A row has been} other {{count} rows have been}} inserted"
    },
    rowsAreRemoved: {
        id: "fabric.editor.rowsAreRemoved",
        defaultMessage: "{count, plural, one {The row has been} other {{count} rows have been}} removed"
    },
    rowSelected: {
        id: "fabric.editor.rowSelected",
        defaultMessage: "Row {index} of {total} selected"
    },
    rowMovedUp: {
        id: "fabric.editor.rowMovedUp",
        defaultMessage: "Row moved up to {index} of {total}"
    },
    rowMovedDown: {
        id: "fabric.editor.rowMovedDown",
        defaultMessage: "Row moved down to {index} of {total}"
    },
    columnsAreInserted: {
        id: "fabric.editor.columnsAreInserted",
        defaultMessage: "{count, plural, one {A column has been} other {{count} columns have been}} inserted"
    },
    columnsAreRemoved: {
        id: "fabric.editor.columnsAreRemoved",
        defaultMessage: "{count, plural, one {The column has been} other {{count} columns have been}} removed"
    },
    columnSelected: {
        id: "fabric.editor.columnSelected",
        defaultMessage: "Column {index} of {total} selected"
    },
    columnMovedLeft: {
        id: "fabric.editor.columnMovedLeft",
        defaultMessage: "Column moved left to {index} of {total}"
    },
    columnMovedRight: {
        id: "fabric.editor.columnMovedRight",
        defaultMessage: "Column moved right to {index} of {total}"
    },
    cellOptions: {
        id: "fabric.editor.cellOptions",
        defaultMessage: "Cell options"
    },
    confirmDeleteLinkedModalOKButton: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalOKButton",
        defaultMessage: "Delete"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix",
        defaultMessage: "Deleting"
    },
    confirmModalCheckboxLabel: {
        id: "fabric.editor.floatingToolbar.confirmModalCheckboxLabel",
        defaultMessage: "Also delete connected elements"
    },
    deleteElementTitle: {
        id: "fabric.editor.extension.deleteElementTitle",
        defaultMessage: "Delete element"
    },
    unnamedSource: {
        id: "fabric.editor.extension.sourceNoTitledName",
        defaultMessage: "this element"
    },
    adjustColumns: {
        id: "fabric.editor.tables.adjustColumn",
        defaultMessage: "Adjust column"
    },
    cornerControl: {
        id: "fabric.editor.cornerControl",
        defaultMessage: "Highlight table"
    },
    cellBackground: {
        id: "fabric.editor.cellBackground",
        defaultMessage: "Cell background"
    },
    backgroundColor: {
        id: "fabric.editor.backgroundColor",
        defaultMessage: "Background color"
    },
    mergeCells: {
        id: "fabric.editor.mergeCells",
        defaultMessage: "Merge cells"
    },
    splitCell: {
        id: "fabric.editor.splitCell",
        defaultMessage: "Split cell"
    },
    clearCells: {
        id: "fabric.editor.clearCells",
        defaultMessage: "Clear {0, plural, one {cell} other {cells}}"
    },
    sortColumnASC: {
        id: "fabric.editor.sortColumnASC",
        defaultMessage: "Sort column A \u2192 Z"
    },
    sortColumnDESC: {
        id: "fabric.editor.sortColumnDESC",
        defaultMessage: "Sort column Z \u2192 A"
    },
    sortColumnIncreasing: {
        id: "fabric.editor.sortColumnIncreasing",
        defaultMessage: "Sort increasing"
    },
    sortColumnDecreasing: {
        id: "fabric.editor.sortColumnDecreasing",
        defaultMessage: "Sort decreasing"
    },
    canNotSortTable: {
        id: "fabric.editor.canNotSortTable",
        defaultMessage: "\u26A0\uFE0F You can't sort a table with merged cells"
    },
    distributeColumns: {
        id: "fabric.editor.distributeColumns",
        defaultMessage: "Distribute columns"
    },
    lockColumnWidths: {
        id: "fabric.editor.lockColumns",
        defaultMessage: "Fixed column widths"
    },
    rowControl: {
        id: "fabric.editor.rowControl",
        defaultMessage: "Highlight row"
    },
    rowDragHandle: {
        id: "fabric.editor.rowDragHandle",
        defaultMessage: "Row options"
    },
    dragHandleZone: {
        id: "fabric.editor.dragHandleZone",
        defaultMessage: "Activate drag handle zone"
    },
    columnDragHandle: {
        id: "fabric.editor.columnDragHandle",
        defaultMessage: "Column options"
    },
    fullWidthLabel: {
        id: "fabric.editor.tableFullWidthLabel",
        defaultMessage: "Full-width"
    },
    startedColumnResize: {
        id: "fabric.editor.tables.startedColumnResize",
        defaultMessage: "Started column resize"
    },
    focusedOtherResize: {
        id: "fabric.editor.tables.otherResize",
        defaultMessage: "{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}"
    },
    changedColumnWidth: {
        id: "fabric.editor.tables.columnWidth",
        defaultMessage: "{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}"
    },
    columnResizeStop: {
        id: "fabric.editor.tables.resizeStop",
        defaultMessage: "Stopped resize"
    },
    columnResizeOverflow: {
        id: "fabric.editor.tables.columnResizeOverflow",
        defaultMessage: "You can only resize this column while the table has a scroll bar."
    },
    columnResizeLast: {
        id: "fabric.editor.tables.columnResizeLast",
        defaultMessage: "You can only resize this column to the left."
    },
    tableAlignmentOptions: {
        id: "fabric.editor.tableAlignmentOptions",
        defaultMessage: "Alignment options"
    },
    alignTableCenter: {
        id: "fabric.editor.alignTableCenter",
        defaultMessage: "Align center"
    },
    alignTableLeft: {
        id: "fabric.editor.alignTableLeft",
        defaultMessage: "Align left"
    }
});
module.exports["messages"] = $3d7dc9b28782bfb3$export$defe85febe8b728c;

});

parcelRegister("5Ilz2", function(module, exports) {
// Common Translations will live here

var $h82at = parcelRequire("h82at");

const $068e62ba641eb2d0$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    unorderedList: {
        id: "fabric.editor.unorderedList",
        defaultMessage: "Bullet list"
    },
    unorderedListDescription: {
        id: "fabric.editor.unorderedList.description",
        defaultMessage: "Create an unordered list"
    },
    bulletedList: {
        id: "fabric.editor.bulletedList",
        defaultMessage: "Bulleted list"
    },
    orderedList: {
        id: "fabric.editor.orderedList",
        defaultMessage: "Numbered list"
    },
    orderedListDescription: {
        id: "fabric.editor.orderedList.description",
        defaultMessage: "Create an ordered list"
    },
    lists: {
        id: "fabric.editor.lists",
        defaultMessage: "Lists"
    },
    listsFormat: {
        id: "fabric.editor.listsFormat",
        defaultMessage: "List formatting"
    }
});
module.exports["messages"] = $068e62ba641eb2d0$export$defe85febe8b728c;

});

parcelRegister("ocPnd", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $fdd67bada3df875e$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    undo: {
        id: "fabric.editor.undo",
        defaultMessage: "Undo"
    },
    redo: {
        id: "fabric.editor.redo",
        defaultMessage: "Redo"
    }
});
module.exports["messages"] = $fdd67bada3df875e$export$defe85febe8b728c;

});

parcelRegister("agX1m", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $999917ff18060c14$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    statusEditorLabel: {
        id: "fabric.editor.statusEditorLabel",
        defaultMessage: "Status editor"
    },
    placeholder: {
        id: "fabric.editor.statusPlaceholder",
        defaultMessage: "Set a status"
    },
    editText: {
        id: "fabric.editor.editStatusText",
        defaultMessage: "Edit Status"
    },
    editColor: {
        id: "fabric.editor.editStatusColor",
        defaultMessage: "Edit Status Color"
    },
    statusPickerOpenedAlert: {
        id: "fabric.editor.statusPickerOpenedAlert",
        defaultMessage: "Status editor popup opened, press Tab to access popup"
    }
});
module.exports["messages"] = $999917ff18060c14$export$defe85febe8b728c;

});

parcelRegister("1moKB", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $1cc68e0c29594f76$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    editText: {
        id: "fabric.editor.editDateText",
        defaultMessage: "Edit Date"
    },
    invalidDateError: {
        id: "fabric.editor.invalidDateError",
        defaultMessage: "Enter a valid date"
    },
    onKeyUpDownText: {
        id: "fabric.editor.upDown",
        defaultMessage: "On the use of up and down arrow keys into the following input field, the date will update below"
    },
    datePickerOpenedAlert: {
        id: "fabric.editor.datePickerOpenedAlert",
        defaultMessage: "Date editor popup opened, press Tab to access popup"
    }
});
module.exports["messages"] = $1cc68e0c29594f76$export$defe85febe8b728c;

});

parcelRegister("l51YQ", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $d073017558d077cd$export$81b075fd34c2f0bb = (0, $h82at.defineMessages)({
    singleColumn: {
        id: "fabric.editor.single",
        defaultMessage: "Single column layout"
    },
    twoColumns: {
        id: "fabric.editor.twoColumns",
        defaultMessage: "Two columns layout"
    },
    singleColumnAdvancedLayout: {
        id: "fabric.editor.singleColumns",
        defaultMessage: "1 Column layout"
    },
    twoColumnsAdvancedLayout: {
        id: "fabric.editor.twoColumns",
        defaultMessage: "2 Column layout"
    },
    threeColumns: {
        id: "fabric.editor.threeColumns",
        defaultMessage: "Three columns layout"
    },
    threeColumnsAdvancedLayout: {
        id: "fabric.editor.threeColumns",
        defaultMessage: "3 Column layout"
    },
    fourColumns: {
        id: "fabric.editor.fourColumns",
        defaultMessage: "4 Column layout"
    },
    fiveColumns: {
        id: "fabric.editor.fiveColumns",
        defaultMessage: "5 Column layout"
    },
    rightSidebar: {
        id: "fabric.editor.rightSidebar",
        defaultMessage: "Right sidebar layout"
    },
    leftSidebar: {
        id: "fabric.editor.leftSidebar",
        defaultMessage: "Left sidebar layout"
    },
    threeColumnsWithSidebars: {
        id: "fabric.editor.threeColumnsWithSidebars",
        defaultMessage: "Three columns with sidebars layout"
    },
    threeColumnsWithLeftSidebars: {
        id: "fabric.editor.threeColumnsWithLeftSidebars",
        defaultMessage: "Three columns with left sidebar layout"
    },
    threeColumnsWithRightSidebars: {
        id: "fabric.editor.threeColumnsWithRightSidebars",
        defaultMessage: "Three columns with right sidebar layout"
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: "fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel",
        defaultMessage: "Layout options"
    },
    layoutPlaceholder: {
        id: "fabric.editor.layout.placeholder",
        defaultMessage: "Add content"
    },
    controlslayoutPlaceholder: {
        id: "fabric.editor.layout.controls.placeholder",
        defaultMessage: "/ to insert"
    },
    columnOption: {
        id: "fabric.editor.layout.columnOption",
        defaultMessage: "{count, plural, one {{count} Column} other {{count} Columns}}"
    },
    resizeLayout: {
        id: "fabric.editor.layout.resizeLayout",
        defaultMessage: "Resize layout"
    }
});
module.exports["toolbarMessages"] = $d073017558d077cd$export$81b075fd34c2f0bb;

});

parcelRegister("2REsZ", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $def49925be501c72$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    indent: {
        id: "fabric.editor.indent",
        defaultMessage: "Indent"
    },
    outdent: {
        id: "fabric.editor.outdent",
        defaultMessage: "Outdent"
    }
});
module.exports["messages"] = $def49925be501c72$export$defe85febe8b728c;

});

parcelRegister("c5kBY", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $42b8e02e0568f6fb$export$8a0e7c3f8f5b8868 = (0, $h82at.defineMessages)({
    editors: {
        id: "fabric.editor.editors",
        defaultMessage: "Editors"
    },
    anonymousCollaborator: {
        id: "fabric.editor.anonymous-collaborator",
        defaultMessage: "Anonymous collaborator"
    }
});
module.exports["avatarGroupMessages"] = $42b8e02e0568f6fb$export$8a0e7c3f8f5b8868;

});

parcelRegister("lzn6v", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $754e59d9d4a5571d$export$b46a930e1a386b2e = (0, $h82at.defineMessages)({
    find: {
        id: "fabric.editor.find",
        defaultMessage: "Find"
    },
    matchCase: {
        id: "fabric.editor.matchCase",
        defaultMessage: "Match case"
    },
    findNext: {
        id: "fabric.editor.findNext",
        defaultMessage: "Find next"
    },
    findPrevious: {
        id: "fabric.editor.findPrevious",
        defaultMessage: "Find previous"
    },
    findReplaceDialogAriaLabel: {
        id: "fabric.editor.findReplaceDialogAriaLabel",
        defaultMessage: "Find and Replace"
    },
    closeFindReplaceDialog: {
        id: "fabric.editor.closeFindReplaceDialog",
        defaultMessage: "Close"
    },
    noResultsFound: {
        id: "fabric.editor.noResultsFound",
        defaultMessage: "No results"
    },
    resultsCount: {
        id: "fabric.editor.resultsCount",
        defaultMessage: "{selectedMatchPosition} of {totalResultsCount}"
    },
    findReplaceToolbarButton: {
        id: "fabric.editor.findReplaceToolbarButton",
        defaultMessage: "Find and replace"
    },
    replaceWith: {
        id: "fabric.editor.replaceWith",
        defaultMessage: "Replace with"
    },
    replace: {
        id: "fabric.editor.replace",
        defaultMessage: "Replace"
    },
    replaceAll: {
        id: "fabric.editor.replaceAll",
        defaultMessage: "Replace all"
    },
    replaceSuccess: {
        id: "fabric.editor.replaceSuccess",
        defaultMessage: "{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}"
    }
});
module.exports["findReplaceMessages"] = $754e59d9d4a5571d$export$b46a930e1a386b2e;

});

parcelRegister("jOP6v", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $360b616eee27c764$export$effb4ee8b6f74abe = (0, $h82at.defineMessages)({
    textColor: {
        id: "fabric.editor.textColor",
        defaultMessage: "{selectedColorName} Text color"
    },
    textColorTooltip: {
        id: "fabric.editor.textColorTooltip",
        defaultMessage: "Text color"
    },
    textColorHighlightTooltip: {
        id: "fabric.editor.textColorHighlightTooltip",
        defaultMessage: "Text and highlight color"
    }
});
module.exports["textColorMessages"] = $360b616eee27c764$export$effb4ee8b6f74abe;

});

parcelRegister("2iuib", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $924758c132d4c526$export$273d864e9e6d0b1f = (0, $h82at.defineMessages)({
    taskPlaceholder: {
        id: "fabric.editor.taskPlaceholder",
        defaultMessage: "Type your action, use '@' to assign to someone."
    },
    decisionPlaceholder: {
        id: "fabric.editor.decisionPlaceholder",
        defaultMessage: "Add a decision\u2026"
    },
    editAccessTitle: {
        id: "fabric.editor.editAccessTitle",
        defaultMessage: "You need edit access"
    },
    requestToEditDescription: {
        id: "fabric.editor.requestToEditDescription",
        defaultMessage: "When you request access, the page owner will receive a notification."
    },
    requestToEdit: {
        id: "fabric.editor.requestToEdit",
        defaultMessage: "Request to edit"
    },
    dismiss: {
        id: "fabric.editor.requestToEditDismiss",
        defaultMessage: "Dismiss"
    },
    markTaskAsCompleted: {
        id: "fabric.editor.taskDecision.markTaskAsCompleted",
        defaultMessage: "Mark task as completed"
    },
    markTaskAsNotCompleted: {
        id: "fabric.editor.taskDecision.markTaskAsNotCompleted",
        defaultMessage: "Mark task as not completed"
    },
    taskList: {
        id: "fabric.editor.taskList",
        defaultMessage: "Task list"
    },
    decisionAriaLabel: {
        id: "fabric.editor.decisionAriaLabel",
        defaultMessage: "Decision"
    },
    undefinedDecisionAriaLabel: {
        id: "fabric.editor.undefinedDecisionAriaLabel",
        defaultMessage: "Undefined decision"
    }
});
module.exports["tasksAndDecisionsMessages"] = $924758c132d4c526$export$273d864e9e6d0b1f;

});

parcelRegister("hdkJi", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $18e8afe4cc6854a5$export$ee8ab8a034b5a8bd = (0, $h82at.defineMessages)({
    placeholderTextPlaceholder: {
        id: "fabric.editor.placeholderTextPlaceholder",
        defaultMessage: "Add placeholder text"
    },
    shortEmptyNodePlaceholderText: {
        id: "fabric.editor.shortEmptyNodePlaceholderText",
        defaultMessage: "/ to insert"
    },
    shortEmptyNodePlaceholderADFSlashShortcut: {
        id: "fabric.editor.shortEmptyNodePlaceholderSlash",
        defaultMessage: "/"
    },
    shortEmptyNodePlaceholderADFSuffix: {
        id: "fabric.editor.shortEmptyNodePlaceholderSuffix",
        defaultMessage: " to insert"
    },
    longEmptyNodePlaceholderText: {
        id: "fabric.editor.longEmptyNodePlaceholderText",
        defaultMessage: "Type / to insert elements"
    },
    longEmptyNodePlaceholderADFPrefix: {
        id: "fabric.editor.longEmptyNodePlaceholderPrefix",
        defaultMessage: "Type "
    },
    longEmptyNodePlaceholderADFSlashShortcut: {
        id: "fabric.editor.longEmptyNodePlaceholderSlash",
        defaultMessage: "/"
    },
    longEmptyNodePlaceholderADFSuffix: {
        id: "fabric.editor.longEmptyNodePlaceholderSuffix",
        defaultMessage: " to insert elements"
    },
    sourceSyncBlockPlaceholderText: {
        id: "fabric.editor.sourceSyncBlockPlaceholderText",
        defaultMessage: "Add content you want to reuse. Copy and paste this block to sync in other locations."
    }
});
module.exports["placeholderTextMessages"] = $18e8afe4cc6854a5$export$ee8ab8a034b5a8bd;

});

parcelRegister("fHFVT", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $be64ff90a26bb531$export$703e803e9cb0cea4 = (0, $h82at.defineMessages)({
    pasteOptions: {
        id: "fabric.editor.pasteOptions",
        defaultMessage: "Paste options"
    },
    plainText: {
        id: "fabric.editor.plainText",
        defaultMessage: "Use plain text"
    },
    markdown: {
        id: "fabric.editor.useMarkdown",
        defaultMessage: "Use Markdown"
    },
    richText: {
        id: "fabric.editor.richText",
        defaultMessage: "Use rich text"
    },
    plainTextAction: {
        id: "fabric.editor.plainTextAction",
        defaultMessage: "Plain text"
    },
    markdownAction: {
        id: "fabric.editor.useMarkdownAction",
        defaultMessage: "Markdown"
    },
    richTextAction: {
        id: "fabric.editor.richTextAction",
        defaultMessage: "Rich text"
    },
    pasteMenuActionsTitle: {
        id: "fabric.editor.pasteMenuActionsTitle",
        defaultMessage: "Paste actions"
    }
});
module.exports["pasteOptionsToolbarMessages"] = $be64ff90a26bb531$export$703e803e9cb0cea4;

});

parcelRegister("02xUP", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $32a348785e1147ed$export$7bb18eb6f9170174 = (0, $h82at.defineMessages)({
    info: {
        id: "fabric.editor.info",
        defaultMessage: "Info"
    },
    note: {
        id: "fabric.editor.note",
        defaultMessage: "Note"
    },
    success: {
        id: "fabric.editor.success",
        defaultMessage: "Success"
    },
    warning: {
        id: "fabric.editor.warning",
        defaultMessage: "Warning"
    },
    error: {
        id: "fabric.editor.error",
        defaultMessage: "Error"
    },
    emoji: {
        id: "fabric.editor.panel.emoji",
        defaultMessage: "Add emoji"
    },
    custom: {
        id: "fabric.editor.panel.custom",
        defaultMessage: "Custom"
    },
    backgroundColor: {
        id: "fabric.editor.panel.backgroundColor",
        defaultMessage: "Background color"
    },
    panelsGroup: {
        id: "fabric.editor.panel.panelsGroup",
        defaultMessage: "Panel Types"
    }
});
module.exports["panelMessages"] = $32a348785e1147ed$export$7bb18eb6f9170174;

});

parcelRegister("ePpFN", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $13a2e5f08644d69c$export$33aafd5ccbbbd00a = (0, $h82at.defineMessages)({
    inviteItemTitle: {
        id: "fabric.editor.inviteItem.title",
        defaultMessage: "{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}"
    },
    mentionsAddLabel: {
        id: "fabric.editor.mentionsAddLabel",
        defaultMessage: "add-icon"
    },
    mentionsIconLabel: {
        id: "fabric.editor.mentionsIconLabel",
        defaultMessage: "Mention"
    },
    mentionsNodeLabel: {
        id: "fabric.editor.mentionNode.label",
        defaultMessage: "Tagged user"
    },
    unknownLabel: {
        id: "fabric.editor.unknown.label",
        defaultMessage: "Unknown"
    },
    inviteTeammateInvalidEmail: {
        id: "fabric.editor.inviteItem.invalidEmail",
        defaultMessage: "Enter a valid email address"
    },
    sendInvite: {
        id: "fabric.editor.inviteItem.sendInvite",
        defaultMessage: "Send request to invite teammate"
    }
});
module.exports["mentionMessages"] = $13a2e5f08644d69c$export$33aafd5ccbbbd00a;

});

parcelRegister("iesbi", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $b210df4a90d17f4b$export$83c85447c71428ba = (0, $h82at.defineMessages)({
    editorHelp: {
        id: "fabric.editor.editorHelp",
        defaultMessage: "Editor help"
    },
    helpDialogTips: {
        id: "fabric.editor.helpDialogTips",
        defaultMessage: "Press {keyMap} to quickly open this dialog at any time"
    },
    keyboardShortcuts: {
        id: "fabric.editor.keyboardShortcuts",
        defaultMessage: "Keyboard shortcuts"
    },
    markdown: {
        id: "fabric.editor.markdown",
        defaultMessage: "Markdown"
    },
    pastePlainText: {
        id: "fabric.editor.pastePlainText",
        defaultMessage: "Paste plain text"
    },
    CheckUncheckActionItem: {
        id: "fabric.editor.checkUncheckActionItem",
        defaultMessage: "Toggle action item"
    },
    InsertTableColumn: {
        id: "fabric.editor.insertTableColumn",
        defaultMessage: "Insert table column"
    },
    InsertTableRow: {
        id: "fabric.editor.insertTableRow",
        defaultMessage: "Insert table row"
    },
    altText: {
        id: "fabric.editor.altText",
        defaultMessage: "Alt text"
    },
    selectTableRow: {
        id: "fabric.editor.selectTableRow",
        defaultMessage: "Select table row"
    },
    selectTableColumn: {
        id: "fabric.editor.selectTableColumn",
        defaultMessage: "Select table column"
    },
    selectColumnResize: {
        id: "fabric.editor.selectColumnResize",
        defaultMessage: "Select column resize"
    },
    increaseSize: {
        id: "fabric.editor.increaseSize",
        defaultMessage: "Increase table or media size"
    },
    increaseElementSize: {
        id: "fabric.editor.increaseElementSize",
        defaultMessage: "Increase element size"
    },
    decreaseSize: {
        id: "fabric.editor.decreaseSize",
        defaultMessage: "Decrease table or media size"
    },
    decreaseElementSize: {
        id: "fabric.editor.decreaseElementSize",
        defaultMessage: "Decrease element size"
    },
    openCellOptions: {
        id: "fabric.editor.openCellOptions",
        defaultMessage: "Open cell options"
    },
    focusTableResizeHandle: {
        id: "fabric.editor.focusTableResizeHandle",
        defaultMessage: "Focus table resize handle"
    },
    closeHelpDialog: {
        id: "fabric.editor.closeHelpDialog",
        defaultMessage: "Close help dialog"
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: "fabric.editor.quickInsert",
        defaultMessage: "Quick insert"
    },
    highlightColor: {
        id: "fabric.editor.highlightColor",
        defaultMessage: "Toggle highlight color palette"
    }
});
module.exports["helpDialogMessages"] = $b210df4a90d17f4b$export$83c85447c71428ba;

});

parcelRegister("e0nFU", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $55d7177264572689$export$456100c8374b6011 = (0, $h82at.defineMessages)({
    highlight: {
        id: "fabric.editor.highlight",
        defaultMessage: "Highlight color"
    },
    highlightFloatingToolbar: {
        id: "fabric.editor.highlightFloatingToolbar",
        defaultMessage: "Highlight"
    },
    removeColor: {
        id: "fabric.editor.highlight.removeColor",
        defaultMessage: "Remove color"
    },
    removeHighlight: {
        id: "fabric.editor.highlight.removeHighlight",
        defaultMessage: "Remove highlight"
    }
});
module.exports["highlightMessages"] = $55d7177264572689$export$456100c8374b6011;

});

parcelRegister("dwl7L", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $57e7b00f8aef02d8$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    dragToMove: {
        id: "fabric.editor.blockControlDragHandleMove",
        defaultMessage: "Drag to move"
    },
    dragToMoveClickToOpen: {
        id: "fabric.editor.blockControlDragHandleMoveOrOpen",
        defaultMessage: "Drag to move {br} Click to open menu"
    },
    dragToRearrange: {
        id: "fabric.editor.blockControlDragHandleRearrange",
        defaultMessage: "Drag to rearrange"
    },
    insert: {
        id: "fabric.editor.blockControlInsert",
        defaultMessage: "Insert"
    },
    moveUp: {
        id: "fabric.editor.blockControlMoveUp",
        defaultMessage: "Move up"
    },
    moveDown: {
        id: "fabric.editor.blockControlMoveDown",
        defaultMessage: "Move down"
    },
    movedup: {
        id: "fabric.editor.blockControlMovedUp",
        defaultMessage: "Content has been moved up"
    },
    movedDown: {
        id: "fabric.editor.blockControlMovedDown",
        defaultMessage: "Content has been moved down"
    },
    moveLeft: {
        id: "fabric.editor.blockControlMoveLeft",
        defaultMessage: "Move left"
    },
    moveRight: {
        id: "fabric.editor.blockControlMoveRight",
        defaultMessage: "Move right"
    },
    delete: {
        id: "fabric.editor.blockControlDelete",
        defaultMessage: "Delete"
    }
});
module.exports["messages"] = $57e7b00f8aef02d8$export$defe85febe8b728c;

});

parcelRegister("b0RMS", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $385543ae0341715d$export$7eb9dc59242bbc45 = (0, $h82at.defineMessages)({
    loadPreview: {
        id: "fabric.editor.media.insert.loadPreview",
        defaultMessage: "Load preview"
    },
    insert: {
        id: "fabric.editor.media.insert.insert",
        defaultMessage: "Insert"
    },
    pasteLinkToUpload: {
        id: "fabric.editor.media.insert.pasteLinkToUpload",
        defaultMessage: "Paste link to upload"
    },
    cancel: {
        id: "fabric.editor.media.insert.cancel",
        defaultMessage: "Cancel"
    },
    fromUrlErrorMessage: {
        id: "fabric.editor.media.insert.fromUrlErrorMessage",
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page."
    },
    fromUrlWarning: {
        id: "fabric.editor.media.insert.fromUrlWarning",
        defaultMessage: "This image might not be visible to others due to source restrictions. Consider uploading the file instead."
    },
    localFileNetworkErrorMessage: {
        id: "fabric.editor.media.insert.localFileNetworkErrorMessage",
        defaultMessage: "File upload error. Check file path or network."
    },
    localFileErrorMessage: {
        id: "fabric.editor.media.insert.localFileErrorMessage",
        defaultMessage: "This file couldn\u2019t be uploaded."
    },
    mediaAlt: {
        id: "fabric.editor.media.insert.mediaAlt",
        defaultMessage: "Preview for uploaded image or video file"
    },
    upload: {
        id: "fabric.editor.media.insert.upload",
        defaultMessage: "Upload"
    },
    linkTabTitle: {
        id: "fabric.editor.media.insert.linkTabTitle",
        defaultMessage: "Link"
    },
    fileTabTitle: {
        id: "fabric.editor.media.insert.fileTabTitle",
        defaultMessage: "File"
    },
    mediaPickerPopupAriaLabel: {
        id: "fabric.editor.media.insert.mediaPickerPopupAriaLabel",
        defaultMessage: "Media picker"
    },
    invalidUrlErrorMessage: {
        id: "fabric.editor.media.insert.invalidUrlErrorMessage",
        defaultMessage: "Invalid link"
    }
});
module.exports["mediaInsertMessages"] = $385543ae0341715d$export$7eb9dc59242bbc45;

});

parcelRegister("3NvMe", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $b80caa4a3ffee1b9$export$423a6caa00ac48ec = (0, $h82at.defineMessages)({
    aspectRatioSelectionOriginal: {
        id: "editor.imageEditor.aspectRatio.original",
        defaultMessage: "Original"
    },
    aspectRatioSelectionCustom: {
        id: "editor.imageEditor.aspectRatio.custom",
        defaultMessage: "Custom"
    },
    aspectRatioSelectionSquare: {
        id: "editor.imageEditor.aspectRatio.square",
        defaultMessage: "Square"
    },
    aspectRatioSelectionCircle: {
        id: "editor.imageEditor.aspectRatio.circle",
        defaultMessage: "Circle"
    },
    aspectRatioSelectionLandscape: {
        id: "editor.imageEditor.aspectRatio.landscape",
        defaultMessage: "Landscape"
    },
    aspectRatioSelectionPortrait: {
        id: "editor.imageEditor.aspectRatio.portrait",
        defaultMessage: "Portrait"
    },
    aspectRatioSelectionWide: {
        id: "editor.imageEditor.aspectRatio.wide",
        defaultMessage: "Wide"
    },
    squareButton: {
        id: "editor.imageEditor.aspectRatio.squareButton",
        defaultMessage: "Square 1:1"
    },
    circleButton: {
        id: "editor.imageEditor.aspectRatio.circleButton",
        defaultMessage: "Circle 1:1"
    },
    landscapeButton: {
        id: "editor.imageEditor.aspectRatio.landscapeButton",
        defaultMessage: "Landscape 4:3"
    },
    portraitButton: {
        id: "editor.imageEditor.aspectRatio.portraitButton",
        defaultMessage: "Portrait 3:4"
    },
    wideButton: {
        id: "editor.imageEditor.aspectRatio.wideButton",
        defaultMessage: "Wide 16:9"
    },
    cancelButton: {
        id: "editor.imageEditor.cancel",
        defaultMessage: "Cancel"
    },
    doneButton: {
        id: "editor.imageEditor.done",
        defaultMessage: "Done"
    },
    savingButton: {
        id: "editor.imageEditor.saving",
        defaultMessage: "Saving..."
    }
});
module.exports["mediaEditingMessages"] = $b80caa4a3ffee1b9$export$423a6caa00ac48ec;

});

parcelRegister("1o1Zn", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $faa277178071abe8$export$6bc8062c04c761fa = (0, $h82at.defineMessages)({
    selectionExtensionDropdownButtonLabel: {
        id: "fabric.editor.selectionExtensionDropdownButtonLabel",
        defaultMessage: "Select app"
    },
    externalExtensionsHeading: {
        id: "fabric.editor.externalExtensionsHeading",
        defaultMessage: "Apps"
    }
});
module.exports["selectionExtensionMessages"] = $faa277178071abe8$export$6bc8062c04c761fa;

});

parcelRegister("5dODy", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $bb7725b6f12abdeb$export$b0226831bf5c0d3e = (0, $h82at.defineMessages)({
    toolbarAppears: {
        id: "fabric.editor.toolbarAppears",
        defaultMessage: "Toolbar appears"
    },
    toolbarPositionInline: {
        id: "fabric.editor.toolbarPositionInline",
        defaultMessage: "In-line with text"
    },
    toolbarPositionFixedAtTop: {
        id: "fabric.editor.toolbarPositionFixedAtTop",
        defaultMessage: "Fixed at top"
    },
    toolbarPositionUnpined: {
        id: "fabric.editor.toolbarPositionUnpined",
        defaultMessage: "Pin the toolbar at the top"
    },
    toolbarPositionPinedAtTop: {
        id: "fabric.editor.toolbarPositionPinedAtTop",
        defaultMessage: "Unpin the toolbar"
    },
    toolbarPositionUnpinnedConcise: {
        id: "fabric.editor.toolbarPositionUnpinnedConcise",
        defaultMessage: "Pin toolbar to top"
    }
});
module.exports["selectionToolbarMessages"] = $bb7725b6f12abdeb$export$b0226831bf5c0d3e;

});

parcelRegister("kofef", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $81a4f62f6d4935be$export$8ea7f7e979b71fa5 = (0, $h82at.defineMessages)({
    panelLabel: {
        id: "fabric.editor.contextPanel.panelLabel",
        defaultMessage: "Context panel"
    },
    panelContentLabel: {
        id: "fabric.editor.contextPanel.panelContentLabel",
        defaultMessage: "Scrollable context panel content"
    }
});
module.exports["contextPanelMessages"] = $81a4f62f6d4935be$export$8ea7f7e979b71fa5;

});

parcelRegister("808tb", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $bda778c801e17725$export$8448461a71ae48a1 = (0, $h82at.defineMessages)({
    toolbarIconLabel: {
        id: "editor.trackChanges.toolbarIconLabel",
        defaultMessage: "View changes"
    },
    removed: {
        id: "editor.trackChanges.removed",
        defaultMessage: "Removed"
    },
    added: {
        id: "editor.trackChanges.added",
        defaultMessage: "Added"
    }
});
module.exports["trackChangesMessages"] = $bda778c801e17725$export$8448461a71ae48a1;

});

parcelRegister("gA3OZ", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $46cd2a98f2b1b2d8$export$29c5997a25e4779b = (0, $h82at.defineMessages)({
    codeSnippetTextBox: {
        id: "fabric.editor.ariaRoleDescription.codeSnippetTextBox",
        defaultMessage: "codesnippet textbox"
    }
});
module.exports["roleDescriptionMessages"] = $46cd2a98f2b1b2d8$export$29c5997a25e4779b;

});

parcelRegister("fzXn1", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $f6c896072a7b1f2a$export$254768729b492c8b = (0, $h82at.defineMessages)({
    copySyncBlockLabel: {
        id: "fabric.editor.copySyncBlock",
        defaultMessage: "Copy"
    },
    copySyncedBlockTooltip: {
        id: "fabric.editor.copySyncedBlockTooltip",
        defaultMessage: "Copy synced block"
    },
    editSourceLabel: {
        id: "fabric.editor.editSourceLabel",
        defaultMessage: "Edit source"
    },
    editSourceTooltip: {
        id: "fabric.editor.editSourceTooltipEnabled",
        defaultMessage: "Edit synced content at source location"
    },
    editSourceTooltipDisabled: {
        id: "fabric.editor.editSourceTooltipDisabled",
        defaultMessage: "Source link is not currently available"
    },
    syncBlockGroup: {
        id: "fabric.editor.syncBlockGroup",
        defaultMessage: "Sync Block Types"
    },
    syncedBlockLabel: {
        id: "fabric.editor.syncedBlock.label.text",
        defaultMessage: "Synced block"
    },
    unsyncedBlockLabel: {
        id: "fabric.editor.unsyncedBlock.label.text",
        defaultMessage: "Unsynced block"
    },
    permissionDeniedHeading: {
        id: "fabric.editor.syncedBlockPermissionDeniedHeading",
        defaultMessage: "Request access to view synced block"
    },
    permissionDeniedDescription: {
        id: "fabric.editor.syncedBlockPermissionDeniedDescription",
        defaultMessage: "You don't have access to view the source content of this synced block."
    },
    permissionDeniedAltText: {
        id: "fabric.editor.syncedBlockPermissionDeniedIconAltText",
        defaultMessage: "Permission denied."
    },
    requestAccessButton: {
        id: "fabric.editor.requestAccessToSyncedBlock",
        defaultMessage: "Request access"
    },
    accessRequested: {
        id: "fabric.editor.accessToSyncedBlockRequested",
        defaultMessage: "Access requested"
    },
    requestAccessError: {
        id: "fabric.editor.requestAccessToSyncedBlockError",
        defaultMessage: "Something went wrong. Click to try again"
    },
    sourceSyncBlockTooltip: {
        id: "fabric.editor.sourceSyncBlockTooltip",
        defaultMessage: "When you edit this source block it will update across synced locations."
    },
    defaultSyncBlockTooltip: {
        id: "fabric.editor.sourceSyncBlockTooltip",
        defaultMessage: "Synced block"
    },
    referenceSyncBlockTooltip: {
        id: "fabric.editor.referenceSyncBlockTooltip",
        defaultMessage: "Synced from: {title}"
    },
    referenceSyncBlockLastEdited: {
        id: "fabric.editor.referenceSyncBlockLastEdited",
        defaultMessage: "Last edited: "
    },
    taskInDestinationSyncedBlockTooltip: {
        id: "fabric.editor.taskInDestinationSyncedBlockTooltip",
        defaultMessage: "This content is synced. Edit it at the source."
    },
    deletionConfirmationModalTitleSingle: {
        id: "fabric.editor.deletionConfirmationModalTitleSingle",
        defaultMessage: "Delete synced content?"
    },
    deleteConfirmationModalTitleMultiple: {
        id: "fabric.editor.deleteConfirmationModalTitleMultiple",
        defaultMessage: "Delete content in {count, plural, one {1 location} other {# locations}}?"
    },
    deleteConfirmationModalCancelButton: {
        id: "fabric.editor.deleteConfirmationModalCancelButton",
        defaultMessage: "Cancel"
    },
    deleteConfirmationModalDeleteButton: {
        id: "fabric.editor.deleteConfirmationModalDeleteButton",
        defaultMessage: "Delete"
    },
    deleteRetryButton: {
        id: "fabric.editor.deleteConfirmationModalRetryButton",
        defaultMessage: "Try again"
    },
    deletionConfirmationModalDescription: {
        id: "fabric.editor.deletionConfirmationModalDescription",
        defaultMessage: "If you delete this synced block, it will become an \u201CUnsynced block\u201D in other locations. This action is permanent and cannot be undone."
    },
    deletionConfirmationModalDescriptionNoRef: {
        id: "fabric.editor.deletionConfirmationModalDescriptionNoRef",
        defaultMessage: "Your content will no longer appear, and the synced block will be deleted. This action is permanent and cannot be undone."
    },
    createSyncBlockLabel: {
        id: "fabric.editor.createSyncBlockLabel",
        defaultMessage: "Create synced block"
    },
    // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
    // New message with updated wording. To clean up: remove old message and feature flag check when flag is removed.
    syncBlockLabel: {
        id: "fabric.editor.syncBlockLabel",
        defaultMessage: "Sync block"
    },
    newLozenge: {
        id: "fabric.editor.syncBlock.toolbar.newLozenge",
        defaultMessage: "New"
    },
    failToDeleteTitle: {
        id: "fabric.editor.error.title.failToDelete",
        defaultMessage: "Failed to delete"
    },
    failToDeleteWhenOfflineDescription: {
        id: "fabric.editor.error.description.failToDeleteWhenOffline",
        defaultMessage: "You appear to be offline. Please connect to the internet to delete synced content."
    },
    cannotDeleteTitle: {
        id: "fabric.editor.error.flag.title.cannotDelete",
        defaultMessage: "Failed to delete synced block"
    },
    cannotDeleteDescription: {
        id: "fabric.editor.error.description.cannotDelete",
        defaultMessage: "An error occurred while trying to delete this synced block. "
    },
    failToEditTitle: {
        id: "fabric.editor.error.title.failToEdit",
        defaultMessage: "Cannot edit synced content offline"
    },
    failToEditWhenOfflineDescription: {
        id: "fabric.editor.error.description.failToEditWhenOffline",
        defaultMessage: "You appear to be offline. Please connect to the internet to edit synced content."
    },
    failToCreateTitle: {
        id: "fabric.editor.error.title.failToCreate",
        defaultMessage: "Cannot create synced content offline"
    },
    failToCreateWhenOfflineDescription: {
        id: "fabric.editor.error.description.failToCreateWhenOffline",
        defaultMessage: "You appear to be offline. Please connect to the internet to create synced content."
    },
    loadingSyncedContent: {
        id: "fabric.editor.syncedBlockLoadingSyncedContent",
        defaultMessage: "Loading synced content"
    },
    generalErrorDescription: {
        id: "fabric.editor.syncedBlockGeneralErrorDescription",
        defaultMessage: "We're unable to display this content at the moment."
    },
    notFoundAltText: {
        id: "fabric.editor.syncedBlockNotFoundIconAltText",
        defaultMessage: "Synced block not found."
    },
    notFoundDescription: {
        id: "fabric.editor.syncedBlockNotFoundDescription.non-final",
        defaultMessage: "We're unable to display this content as its source has been deleted or archived."
    },
    sourceUnsyncedDescription: {
        id: "fabric.editor.syncedBlockSourceUnsyncedDescription",
        defaultMessage: "We're unable to display this content as it's been unsynced from <a>{title}</a>."
    },
    sourceDeletedDescription: {
        id: "fabric.editor.syncedBlockSourceDeletedDescription",
        defaultMessage: "We're unable to display this content as it's been deleted from <a>{title}</a>."
    },
    genericNotFoundDescription: {
        id: "fabric.editor.syncedBlockGenericNotFoundDescription",
        defaultMessage: "We're unable to display this synced content as it's been deleted or unsynced."
    },
    retryButton: {
        id: "fabric.editor.retrySyncedBlock",
        defaultMessage: "Try again"
    },
    offlineError: {
        id: "fabric.editor.error.description.reference.offline",
        defaultMessage: "We're unable to display synced blocks when you're offline"
    },
    unpublishedError: {
        id: "fabric.editor.error.description.reference.unpublished",
        defaultMessage: "Synced content will display <link>when the page is published</link>"
    },
    syncBlockCopiedTitle: {
        id: "fabric.editor.syncBlockCopiedTitle",
        defaultMessage: "Synced block copied to clipboard"
    },
    syncBlockCopiedDescription: {
        id: "fabric.editor.syncBlockCopiedDescription",
        defaultMessage: "Paste your synced block to keep content auto-updated. Permissions are the same."
    },
    syncBlockCopiedAction: {
        id: "fabric.editor.syncBlockCopiedAction",
        defaultMessage: "Learn more"
    },
    syncedLocationDropdownTitle: {
        id: "fabric.editor.syncedLocationDropdownTitle",
        defaultMessage: "Synced locations"
    },
    syncedLocationDropdownHeading: {
        id: "fabric.editor.syncedLocationDropdownHeading",
        defaultMessage: "{count} locations:"
    },
    syncedLocationDropdownError: {
        id: "fabric.editor.syncedLocationDropdownError",
        defaultMessage: "We can't load locations right now. Please wait a few minutes and refresh your browser."
    },
    syncedLocationDropdownNoResults: {
        id: "fabric.editor.syncedLocationDropdownNoResults",
        defaultMessage: "Copy and paste synced blocks to reuse in other locations."
    },
    syncedLocationDropdownLearnMoreLink: {
        id: "fabric.editor.syncedLocationDropdownLearnMoreLink",
        defaultMessage: "Learn more about synced blocks"
    },
    syncedLocationDropdownSamePage: {
        id: "fabric.editor.syncedLocationDropdownSamePage",
        defaultMessage: "This page"
    },
    syncedLocationDropdownTitleBlockIndex: {
        id: "fabric.editor.syncedLocationDropdownTitleNote",
        defaultMessage: "block {index}"
    },
    syncedLocationDropdownTitleNoteForConfluencePage: {
        id: "fabric.editor.syncedLocationDropdownTitleNoteForConfluencePage",
        defaultMessage: "This page"
    },
    syncedLocationDropdownTitleNoteForJiraWorkItem: {
        id: "fabric.editor.syncedLocationDropdownTitleNoteForJiraWorkItem",
        defaultMessage: "This work item"
    },
    syncedLocationDropdownSourceLozenge: {
        id: "fabric.editor.syncedLocationDropdownSourceLozenge",
        defaultMessage: "Source"
    },
    syncedLocationDropdownRequestAccess: {
        id: "fabric.editor.syncedLocationDropdownRequestAccess",
        defaultMessage: "Request access"
    },
    unpublishedSyncBlockPastedTitle: {
        id: "fabric.editor.unpublishedSyncBlockPastedTitle",
        defaultMessage: "Pasted from unpublished page"
    },
    unpublishedSyncBlockPastedDescription: {
        id: "fabric.editor.unpublishedSyncBlockPastedDescription",
        defaultMessage: "When the page is published, the content will be displayed."
    },
    unsyncButton: {
        id: "fabric.editor.syncedBlock.unsync",
        defaultMessage: "Unsync"
    },
    deleteConfirmationModalUnsyncButton: {
        id: "fabric.editor.deleteConfirmationModalUnsyncButton",
        defaultMessage: "Unsync"
    },
    unsyncConfirmationModalTitle: {
        id: "fabric.editor.unsyncConfirmationModalTitle",
        defaultMessage: "Unsync this content?"
    },
    unsyncConfirmModalDescriptionSingle: {
        id: "fabric.editor.unsyncConfirmModalDescriptionSingle",
        defaultMessage: "Your content will stay here. It will no longer be a synced block. This action is permanent and cannot be undone."
    },
    unsyncConfirmModalDescriptionMultiple: {
        id: "fabric.editor.unsyncConfirmModalDescriptionMultiple",
        defaultMessage: "Your content will stay here. In {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}} it will appear as an \u201CUnsynced block\u201D. This action is permanent and cannot be undone."
    },
    cannotPasteSyncedBlockTitle: {
        id: "fabric.editor.cannotPasteSyncedBlockTitle",
        defaultMessage: "Unable to paste"
    },
    cannotPasteSyncedBlockDescription: {
        id: "fabric.editor.cannotPasteSyncedBlockDescription",
        defaultMessage: "We\u2019re still building this feature. Currently, you can only paste synced content once your work item has been created. "
    },
    cannotPasteSyncedBlockAction: {
        id: "fabric.editor.cannotPasteSyncedBlockAction",
        defaultMessage: "Learn more"
    },
    cannotCreateSyncBlockTitle: {
        id: "fabric.editor.cannotCreateSyncBlockTitle",
        defaultMessage: "Unable to create synced block"
    },
    CannotCreateSyncBlockDescription: {
        id: "fabric.editor.cannotCreateSyncBlockDescription",
        defaultMessage: "An error occurred while trying to create this synced block. "
    },
    inlineExtensionInSyncBlockTitle: {
        id: "fabric.editor.inlineExtensionInSyncBlockTitle",
        defaultMessage: "Some macros may not work when adding synced blocks to new locations"
    },
    inlineExtensionInSyncBlockDescription: {
        id: "fabric.editor.inlineExtensionInSyncBlockDescription",
        defaultMessage: "This may happen if your synced block is used in places that don't support certain macros."
    },
    extensionInSyncBlockTitle: {
        id: "fabric.editor.extensionInSyncBlockTitle",
        defaultMessage: "Some macros may not work when adding synced blocks to new locations"
    },
    extensionInSyncBlockDescription: {
        id: "fabric.editor.extensionInSyncBlockDescription",
        defaultMessage: "This may happen if your synced block is used in places that don't support certain macros."
    }
});
module.exports["syncBlockMessages"] = $f6c896072a7b1f2a$export$254768729b492c8b;

});

parcelRegister("9dV3t", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $0cd509c669fd054b$export$8becdf1c29fc36cd = (0, $h82at.defineMessages)({
    colorPickerTitle: {
        id: "company-hub-text-color.color-picker-dropdown.picker-title",
        defaultMessage: "Text Color"
    }
});
module.exports["companyHubTextColorMessages"] = $0cd509c669fd054b$export$8becdf1c29fc36cd;

});

parcelRegister("7Irim", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $f5d214400ea0a33b$export$cdc1205423c9f2de = (0, $h82at.defineMessages)({
    alwaysShowTitle: {
        id: "fabric.editor.alwaysShowTitle.non-final",
        defaultMessage: "Always show title"
    },
    refresh: {
        id: "fabric.editor.refresh.non-final",
        defaultMessage: "Refresh"
    },
    setEmbedType: {
        id: "fabric.editor.setEmbedType.non-final",
        defaultMessage: "Set embed type"
    }
});
module.exports["nativeEmbedToolbarMessages"] = $f5d214400ea0a33b$export$cdc1205423c9f2de;

});

parcelRegister("4vlwG", function(module, exports) {
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $56f33ebd9f14b1a0$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $56f33ebd9f14b1a0$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $56f33ebd9f14b1a0$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $56f33ebd9f14b1a0$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $56f33ebd9f14b1a0$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $56f33ebd9f14b1a0$export$d508bcfb7f019487(node, s) {
    return $56f33ebd9f14b1a0$export$ff7f7c97cdce86e(node, s);
}
function $56f33ebd9f14b1a0$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $56f33ebd9f14b1a0$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $56f33ebd9f14b1a0$export$5b6ab01a6efa50e2(elem, callback) {
    return $56f33ebd9f14b1a0$export$b2d5d4f1aeebddf1(elem, callback);
}
module.exports["walkUpTreeUntil"] = $56f33ebd9f14b1a0$export$df14aaf7a527ab0c;
module.exports["unwrap"] = $56f33ebd9f14b1a0$export$debb760848ca95a;
module.exports["removeNestedEmptyEls"] = $56f33ebd9f14b1a0$export$5b66dc78851adb5e;
module.exports["containsClassName"] = $56f33ebd9f14b1a0$export$c8913a477cc44663;
module.exports["closest"] = $56f33ebd9f14b1a0$export$ff7f7c97cdce86e;
module.exports["closestElement"] = $56f33ebd9f14b1a0$export$d508bcfb7f019487;
module.exports["parsePx"] = $56f33ebd9f14b1a0$export$b0eef8cd00b29d5c;
module.exports["maphElem"] = $56f33ebd9f14b1a0$export$5b6ab01a6efa50e2;

});

parcelRegister("jVL42", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $ade5271c9bbd1338$var$clPrefix = 'ak-renderer-';
const $ade5271c9bbd1338$export$91f3bbbf974496e2 = {
    FLEX_CENTER_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}flex-center-wrapper`,
    DOCUMENT: `${$ade5271c9bbd1338$var$clPrefix}document`,
    EXTENSION: `${$ade5271c9bbd1338$var$clPrefix}extension`,
    EXTENSION_AS_INLINE: `${$ade5271c9bbd1338$var$clPrefix}extension-as-inline`,
    EXTENSION_CENTER_ALIGN: `${$ade5271c9bbd1338$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$ade5271c9bbd1338$var$clPrefix}extension-overflow-container`,
    EXTENSION_INNER_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}extension-inner-wrapper`,
    /** Wrapper for center-aligned extensions/MBE; margin here so it participates in collapse */ STICKY_SAFE_CENTER_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}sticky-safe-center-wrapper`,
    /** Wrapper for center-aligned embed card (wide/full-width); margin here so it participates in collapse */ EMBED_CARD_CENTER_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}embed-card-center-wrapper`,
    /** Wrapper for center-aligned block card datasource (wide/full-width); margin here so it participates in collapse */ BLOCK_CARD_DATASOURCE_CENTER_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}block-card-datasource-center-wrapper`,
    /** Outer flex wrapper for sticky-safe breakout (has vertical margin); zero margin when first in doc */ STICKY_SAFE_BREAKOUT_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}sticky-safe-breakout-wrapper`,
    /** Flex item in sticky-safe breakout; zero first/last child margin so flex container height matches legacy */ STICKY_SAFE_BREAKOUT_INNER: `${$ade5271c9bbd1338$var$clPrefix}sticky-safe-breakout-inner`,
    NUMBER_COLUMN: `${$ade5271c9bbd1338$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$ade5271c9bbd1338$var$clPrefix}tableHeader-sorting-icon__no-order`
};
module.exports["RendererCssClassName"] = $ade5271c9bbd1338$export$91f3bbbf974496e2;

});

parcelRegister("fZRom", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $k7eoe = parcelRequire("k7eoe");


var $hWRJP = parcelRequire("hWRJP");


var $59U23 = parcelRequire("59U23");


var $1oCLl = parcelRequire("1oCLl");


var $dQl1W = parcelRequire("dQl1W");

class $e10374371e1c8ea4$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $k7eoe.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState((prevState)=>({
                    domError: true,
                    domErrorCount: prevState.domErrorCount + 1
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) {
            const key = (0, $1oCLl.expValEquals)('platform_editor_renderer_error_boundary_stable_key', 'isEnabled', true) ? this.state.domErrorCount : // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                children: this.props.children
            }, key);
        }
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false,
            domError: false,
            domErrorCount: 0
        };
    }
}
module.exports["ErrorBoundary"] = $e10374371e1c8ea4$export$e926676385687eaf;

});

parcelRegister("hWRJP", function(module, exports) {

var $7hGsm = parcelRequire("7hGsm");


var $dh538 = parcelRequire("dh538");

const $6df845e06168a227$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $6df845e06168a227$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $6df845e06168a227$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}


const $5b6a7d5ed82a6889$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $5b6a7d5ed82a6889$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$5b6a7d5ed82a6889$export$b5bdb04ea16a02e3
];
const $5b6a7d5ed82a6889$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$5b6a7d5ed82a6889$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gmu');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $5b6a7d5ed82a6889$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($5b6a7d5ed82a6889$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $5b6a7d5ed82a6889$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category?.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $5b6a7d5ed82a6889$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};


const $bbb29939e3426646$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $bbb29939e3426646$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $bbb29939e3426646$var$packageVersion = "0.0.0-use.local";
const $bbb29939e3426646$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $bbb29939e3426646$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await Promise.resolve((parcelRequire("7hGsm")));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("a8PPW"));
        const breadcrumbsIntegration = (0, $dh538.fg)('platform_editor_sentry_breadcrumbs') ? new (0, $7hGsm.Integrations).Breadcrumbs({
            // only enable breadcrumbs for dom (UI clicks and inputs)
            // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
            dom: {
                serializeAttribute: (0, $5b6a7d5ed82a6889$export$b5bdb04ea16a02e3)
            },
            fetch: false,
            xhr: false,
            console: false,
            history: false,
            sentry: false
        }) : undefined;
        const sentryOptions = {
            dsn: (0, $6df845e06168a227$export$64d6499adf9b2e51)() ? undefined : $bbb29939e3426646$var$SENTRY_DSN,
            release: `${$bbb29939e3426646$var$packageName}@${$bbb29939e3426646$var$packageVersion}`,
            environment: "production" ?? 'unknown',
            beforeBreadcrumb: (0, $dh538.fg)('platform_editor_sentry_breadcrumbs') ? (0, $5b6a7d5ed82a6889$export$6f14342128c6eaa4) : undefined,
            ignoreErrors: [
                // Network issues
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network error/i,
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    ...breadcrumbsIntegration ? [
                        breadcrumbsIntegration
                    ] : [],
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $bbb29939e3426646$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        // @ts-ignore - TypeScript 5.9.2 upgrade
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        // @ts-ignore - TypeScript 5.9.2 upgrade
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};
module.exports["logException"] = $bbb29939e3426646$export$f86b2a1a2ce291b3;

});

parcelRegister("a8PPW", function(module, exports) {

let $7622dc75c88171a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7622dc75c88171a9$var$load("6nDfv"),
    $7622dc75c88171a9$var$load("1FTmX")
]).then(()=>parcelRequire('aGHdx'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("59U23", function(module, exports) {
var $7452dae99863188e$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $7452dae99863188e$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $7452dae99863188e$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($7452dae99863188e$var$RESOLVE_METHOD || {});
module.exports["PLATFORM"] = $7452dae99863188e$export$88c4881e092abcaf;
module.exports["MODE"] = $7452dae99863188e$export$e48589d9e4824227;

});

parcelRegister("gi5bC", function(module, exports) {
var $b7a27a5000feb1b6$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $b7a27a5000feb1b6$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $b7a27a5000feb1b6$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $b7a27a5000feb1b6$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});
module.exports["EVENT_TYPE"] = $b7a27a5000feb1b6$export$76a2e4c433c23bb9;
module.exports["ACTION"] = $b7a27a5000feb1b6$export$9523889e0a5da4ba;
module.exports["ACTION_SUBJECT"] = $b7a27a5000feb1b6$export$7525482b5931e326;
module.exports["ACTION_SUBJECT_ID"] = $b7a27a5000feb1b6$export$9957974f8b4d8f74;

});

parcelRegister("d7o2V", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cUycv = parcelRequire("cUycv");








var $IcpgS = parcelRequire("IcpgS");


var $1lzbj = parcelRequire("1lzbj");


var $lspPP = parcelRequire("lspPP");

const $a9788d28138ffd57$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const actionContext = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $1lzbj.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $42omo.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $42omo.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $l998X.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};



























var $jZG1P = parcelRequire("jZG1P");


var $k7eoe = parcelRequire("k7eoe");


var $d925B = parcelRequire("d925B");





var $3h7Ko = parcelRequire("3h7Ko");

const $e42187240da9c39a$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const onCreateCallback = (0, $42omo.useCallback)((annotationId)=>{
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        }).fire((0, $k7eoe.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $42omo.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $42omo.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $d925B.ACTION).OPENED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $k7eoe.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $jZG1P.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $42omo.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $42omo.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $k7eoe.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});









var $hFjCV = parcelRequire("hFjCV");

const $a2ccd099cd67e7f8$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $3h7Ko.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $hFjCV.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e42187240da9c39a$export$2109cd350bcf6eda), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$a2ccd099cd67e7f8$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';














/** Exists in its own module to allow mocking in unit tests */ const $3fda5c6b1c3401ed$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};



var $jSHzw = parcelRequire("jSHzw");

const $9c05d72e21b72e90$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $42omo.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $3h7Ko.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $42omo.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $42omo.useCallback)((_event)=>{
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        selectionTimeoutRef.current = setTimeout(()=>{
            const sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            let _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $3fda5c6b1c3401ed$export$90ee8f2d9317f430)(rendererDOM, _range)) {
                const { startContainer: startContainer, endContainer: endContainer } = _range;
                const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    let p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        const range = document.createRange();
                        range.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(range);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, 100);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};









var $cUcZ5 = parcelRequire("cUcZ5");





var $dh538 = parcelRequire("dh538");











var $djzd2 = parcelRequire("djzd2");










const $b40078015275204e$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $3h7Ko.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $jSHzw.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $42omo.useMemo)(()=>{
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $djzd2.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $42omo.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        // !!! at this point, the documentPosition can be the wrong position if the user select something else
        const positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        }).fire((0, $k7eoe.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $42omo.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $42omo.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $d925B.ACTION).OPENED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $k7eoe.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $jZG1P.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // at this point, the documentPosition is the position that the user has selected,
        // not the selectionDraftDocumentPosition
        // because the documentPosition is not promoted to selectionDraftDocumentPosition yet
        // use platform_editor_comments_api_manager here so we can clear the code path when the flag is removed
        const positionToAnnotate = (0, $dh538.fg)('platform_editor_comments_api_manager') ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }).fire((0, $k7eoe.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $42omo.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $42omo.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $k7eoe.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $42omo.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $cUycv.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $42omo.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});





const $b486b70e1a3998ec$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $9c05d72e21b72e90$export$47201332e612f5a4)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $b40078015275204e$export$ca7741472ed8ba00), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$b486b70e1a3998ec$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';


const $93be4f7567f6fd00$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            children,
            !!hoverComponent && /*#__PURE__*/ (0, $l998X.jsx)((0, $a2ccd099cd67e7f8$export$6d8376a902cb8aa7), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                component: hoverComponent
            }),
            !!selectionComponent && /*#__PURE__*/ (0, $l998X.jsx)((0, $b486b70e1a3998ec$export$74435b85e23b84d9), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectionComponent: selectionComponent
            })
        ]
    });
};









var $21K7m = parcelRequire("21K7m");










const $d2f9ac245b0d60aa$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $42omo.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};






var $inPa6 = parcelRequire("inPa6");










const $848af0e2e5a97564$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $d2f9ac245b0d60aa$export$39f7c1a861a0d41c)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $848af0e2e5a97564$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    startPos: 1
});
const $848af0e2e5a97564$export$7121915072388536 = (props)=>{
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $1lzbj.useAnnotationStateByTypeEvent)({
        type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $IcpgS.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3h7Ko.AnnotationRangeProvider), {
            allowCommentsOnMedia: providers?.inlineComment?.allowCommentsOnMedia ?? false,
            isNestedRender: isNestedRender,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hFjCV.AnnotationHoverContext), {
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $93be4f7567f6fd00$export$787af8a111ff3c03), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    isNestedRender: isNestedRender,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($848af0e2e5a97564$var$LoadAnnotations, {
                            adfDocument: adfDocument,
                            isNestedRender: isNestedRender,
                            onLoadComplete: onLoadComplete
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $a9788d28138ffd57$export$41cd4a02859c2806), {
                            isNestedRender: isNestedRender,
                            createAnalyticsEvent: createAnalyticsEvent
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const $848af0e2e5a97564$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider?.annotationManager) // We need to ensure there is a single instance of the annotation manager for the whole document
    // and that it is the same instance for all annotations.
    // This is because the annotation manager is responsible for managing the state of ALL annotations.
    // This includes annotations inside extensions.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $IcpgS.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jSHzw.AnnotationManagerProvider), {
            annotationManager: annotationProvider.annotationManager,
            updateSubscriber: annotationProvider?.inlineComment?.updateSubscriber ?? undefined,
            children: /*#__PURE__*/ (0, $l998X.jsx)($848af0e2e5a97564$export$7121915072388536, {
                rendererRef: rendererRef,
                adfDocument: adfDocument,
                isNestedRender: isNestedRender,
                onLoadComplete: onLoadComplete,
                children: children
            })
        })
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $IcpgS.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $l998X.jsx)($848af0e2e5a97564$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete,
            children: children
        })
    });
};
module.exports["AnnotationsPositionContext"] = $848af0e2e5a97564$export$8c8c3e12db6c0591;
module.exports["AnnotationsWrapper"] = $848af0e2e5a97564$export$cef0157dd42cbb3f;

});

parcelRegister("lspPP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $inPa6 = parcelRequire("inPa6");


var $3pfAb = parcelRequire("3pfAb");


var $d925B = parcelRequire("d925B");


var $cUycv = parcelRequire("cUycv");


var $bYZ53 = parcelRequire("bYZ53");


var $h9yJL = parcelRequire("h9yJL");


var $ks2lK = parcelRequire("ks2lK");





var $aXG5V = parcelRequire("aXG5V");










function $d5988c5b4b1df67c$export$aabc9b13a308cc43(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $d5988c5b4b1df67c$var$getNodeType = (element)=>element.dataset.nodeType;
function $d5988c5b4b1df67c$var$isPositionPointer(element) {
    return $d5988c5b4b1df67c$export$aabc9b13a308cc43(element) > -1;
}
function $d5988c5b4b1df67c$export$25245567f53f158f(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $d5988c5b4b1df67c$export$9d1d5d87ae7da22f(parentElement)) return null;
    if ($d5988c5b4b1df67c$var$isPositionPointer(parentElement)) return parentElement;
    return $d5988c5b4b1df67c$export$25245567f53f158f(parentElement);
}
function $d5988c5b4b1df67c$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $d5988c5b4b1df67c$export$9d1d5d87ae7da22f(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $d5988c5b4b1df67c$var$findMediaParent(parentElement);
}
function $d5988c5b4b1df67c$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($d5988c5b4b1df67c$export$9d1d5d87ae7da22f(parentElement) || !parentElement) return null;
    if ($d5988c5b4b1df67c$var$isPositionPointer(parentElement)) return element;
    return $d5988c5b4b1df67c$var$findParentBeforePointer(parentElement);
}
function $d5988c5b4b1df67c$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $d5988c5b4b1df67c$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $d5988c5b4b1df67c$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $d5988c5b4b1df67c$var$isNodeInlineMark(node) {
    return $d5988c5b4b1df67c$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $d5988c5b4b1df67c$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $d5988c5b4b1df67c$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $d5988c5b4b1df67c$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
   * This checks if the element has any descendents with the data-inline-card
   * attribute set to 'true'. If it does, we should not consider it as an
   * inline text mark.
   **/ if ($d5988c5b4b1df67c$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $d5988c5b4b1df67c$var$hasInlineNodeDescendant(node) {
    if ($d5988c5b4b1df67c$var$isElementNode(node)) {
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($d5988c5b4b1df67c$var$hasInlineNodeDescendant);
    }
    return false;
}
function $d5988c5b4b1df67c$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($d5988c5b4b1df67c$var$isTextNode(prev) || $d5988c5b4b1df67c$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($d5988c5b4b1df67c$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($d5988c5b4b1df67c$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $d5988c5b4b1df67c$export$9d1d5d87ae7da22f(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $d5988c5b4b1df67c$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
   * If anchor node is an element (e.g. after a triple click) the anchorOffset
   * is the number of child nodes preceding the anchor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
   *
   * For end pos we calculate the number of characters by stepping through
   * each of the node's children.
   */ if (node instanceof HTMLElement && $d5988c5b4b1df67c$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $d5988c5b4b1df67c$export$aabc9b13a308cc43(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $d5988c5b4b1df67c$export$aabc9b13a308cc43(node) + offset;
    }
    const parent = $d5988c5b4b1df67c$export$25245567f53f158f(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $d5988c5b4b1df67c$export$aabc9b13a308cc43(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $d5988c5b4b1df67c$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($d5988c5b4b1df67c$var$isNodeInlineTextMark(preParentPointer) || $d5988c5b4b1df67c$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($d5988c5b4b1df67c$var$isElementInlineMark(preParentPointer) || $d5988c5b4b1df67c$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $d5988c5b4b1df67c$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $d5988c5b4b1df67c$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $d5988c5b4b1df67c$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $d5988c5b4b1df67c$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $d5988c5b4b1df67c$export$25245567f53f158f(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($d5988c5b4b1df67c$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $d5988c5b4b1df67c$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $d5988c5b4b1df67c$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $d5988c5b4b1df67c$export$aabc9b13a308cc43(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $d5988c5b4b1df67c$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $d5988c5b4b1df67c$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $d5988c5b4b1df67c$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $aXG5V.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}



var $djzd2 = parcelRequire("djzd2");

function $dfb07954adffbc39$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $dfb07954adffbc39$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $dfb07954adffbc39$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $dfb07954adffbc39$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}






var $8qoeq = parcelRequire("8qoeq");


const $be7bedbe4c954a25$export$3726c4866ce829b5 = ({ doc: doc, schema: schema })=>{
    if (!doc || !schema) return null;
    const selection = document.getSelection();
    if (!selection || selection.type !== 'Range' || selection.rangeCount !== 1) return null;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return null;
    const startNode = (0, $d5988c5b4b1df67c$export$25245567f53f158f)(range.startContainer);
    const endNode = (0, $d5988c5b4b1df67c$export$25245567f53f158f)(range.endContainer);
    if (!startNode || !endNode) return null;
    const startPos = (0, $d5988c5b4b1df67c$export$aabc9b13a308cc43)(startNode);
    const endPos = (0, $d5988c5b4b1df67c$export$aabc9b13a308cc43)(endNode);
    if (startPos === null || endPos === null) return null;
    const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
    if (!pos) return null;
    const from = Math.min(pos.from, pos.to);
    const to = Math.max(pos.from, pos.to);
    if (from === to) return null;
    let pmSelection;
    try {
        pmSelection = (0, $ks2lK.TextSelection).create(doc, from, to);
    } catch  {
        return null;
    }
    const startIndex = from - startPos;
    const endIndex = to - endPos;
    if (startIndex < 0 || endIndex < 0) return null;
    const selectionFragment = (0, $8qoeq.getFragmentsFromSelection)(pmSelection);
    const localIds = (0, $8qoeq.getLocalIdsFromSelection)(pmSelection);
    return {
        localIds: localIds,
        selectionFragment: selectionFragment,
        selectionMarkdown: null,
        startIndex: startIndex,
        endIndex: endIndex
    };
};


class $99cc0efe08aadb17$export$2e2bcd8739ae039 {
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
   * Validate whether we can create an annotation between two positions
   */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const currentSelection = (0, $ks2lK.TextSelection).create(this.doc, from, to);
        if ((0, $bYZ53.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
        const result = (0, $bYZ53.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $aXG5V.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $aXG5V.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $d925B.ACTION).DELETED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $aXG5V.RemoveMarkStep) ? (0, $djzd2.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, _annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * This is replaced by `isRangeAnnotatable`.
   *
   * @deprecated
   **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
   * Note: False indicates that the selection not able to be calculated.
   */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
    }
    getSelectionContext() {
        return (0, $be7bedbe4c954a25$export$3726c4866ce829b5)({
            doc: this.doc,
            schema: this.schema
        });
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $d5988c5b4b1df67c$export$243cdddc5b21d8c1)(range);
        if (!pos || !this.doc) return [];
        return (0, $bYZ53.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $aXG5V.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $d5988c5b4b1df67c$export$74899f7e5acb5cd3)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $dfb07954adffbc39$export$fb7dab895a0d310e)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $djzd2.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            ancestorNodeTypes: (0, $djzd2.getRendererRangeAncestorNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $dfb07954adffbc39$export$fb7dab895a0d310e)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $bYZ53.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.transformer = void 0;
        this.doc = void 0;
        this.schema = void 0;
        // Any kind of refence is allowed
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.ref = void 0;
        this.onAnalyticsEvent = void 0;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $h9yJL.JSONTransformer)();
    }
}


const $0a20e195094e2f97$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(new (0, $99cc0efe08aadb17$export$2e2bcd8739ae039)());
function $0a20e195094e2f97$export$66feffbad722f9d4({ children: children, context: context }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const actions = (0, $42omo.useMemo)(()=>new (0, $99cc0efe08aadb17$export$2e2bcd8739ae039)(true), []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) > 1 && (0, $dh538.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $3pfAb.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($0a20e195094e2f97$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions,
        children: (0, $dh538.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(children) : children
    });
}
const $0a20e195094e2f97$export$d5fcf151601331bc = $0a20e195094e2f97$export$1e9ea4edb6d1bfe6.Consumer;
module.exports["RendererContext"] = $0a20e195094e2f97$export$1e9ea4edb6d1bfe6;
module.exports["RendererActionsContext"] = $0a20e195094e2f97$export$66feffbad722f9d4;
module.exports["RendererActionsContextConsumer"] = $0a20e195094e2f97$export$d5fcf151601331bc;

});

parcelRegister("bYZ53", function(module, exports) {

var $cUycv = parcelRequire("cUycv");


var $dh538 = parcelRequire("dh538");

const $7620bc72075c20fa$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $7620bc72075c20fa$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $7620bc72075c20fa$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $7620bc72075c20fa$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $7620bc72075c20fa$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($7620bc72075c20fa$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $7620bc72075c20fa$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $7620bc72075c20fa$export$2a160f09551a3adc({ doc: doc, pos: pos }) {
    if (!(0, $dh538.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        // For a range, we can get ancestors at both from and to positions
        // or just use the from position if you want ancestors at the start
        const resolvedFromPos = doc.resolve(pos.from);
        const resolvedToPos = doc.resolve(pos.to);
        // Collect ancestors at the 'from' position
        for(let depth = resolvedFromPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedFromPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        // Use nodesBetween to collect parent types without additional resolve() calls
        // This isn't as precise as calling resolve() on each parent, but it's a lot faster
        // and should hopefully provide a good approximation of the ancestor nodes
        const seenParents = new Set();
        doc.nodesBetween(pos.from, pos.to, (_node, _nodePos, parent)=>{
            // Collect parent chain using the parent parameter
            const currentParent = parent;
            if (!!currentParent && !seenParents.has(currentParent)) {
                seenParents.add(currentParent);
                nodeNames.add(currentParent.type.name);
            // Note: We can't easily get the parent's parent from this context
            // without additional resolve calls, so this approach has limitations
            }
            return true;
        });
        // Optionally collect ancestors at the 'to' position if different
        // This ensures we capture all ancestor contexts across the range
        if (pos.from !== pos.to) for(let depth = resolvedToPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedToPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        return [
            ...nodeNames
        ];
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $7620bc72075c20fa$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, _pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $7620bc72075c20fa$export$bb1945a828f2864b(pos) {
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $7620bc72075c20fa$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $7620bc72075c20fa$export$a35880e7ecdcf47b(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}
module.exports["canApplyAnnotationOnRange"] = $7620bc72075c20fa$export$77ddf8216f9eb904;
module.exports["getAnnotationIdsFromRange"] = $7620bc72075c20fa$export$badbcc229c848aec;
module.exports["hasAnnotationMark"] = $7620bc72075c20fa$export$5fe1412b20386053;
module.exports["containsAnyAnnotations"] = $7620bc72075c20fa$export$1976770b876b2728;
module.exports["getRangeInlineNodeNames"] = $7620bc72075c20fa$export$35054451202ed5d9;
module.exports["getRangeAncestorNodeNames"] = $7620bc72075c20fa$export$2a160f09551a3adc;
module.exports["getAnnotationInlineNodeTypes"] = $7620bc72075c20fa$export$8261bc1f662f3f6e;
module.exports["getAnnotationMarksForPos"] = $7620bc72075c20fa$export$bb1945a828f2864b;
module.exports["isEmptyTextSelection"] = $7620bc72075c20fa$export$2efbc6d84ea0fbec;
module.exports["isEmptyTextSelectionRenderer"] = $7620bc72075c20fa$export$a35880e7ecdcf47b;

});

parcelRegister("8qoeq", function(module, exports) {

var $h9yJL = parcelRequire("h9yJL");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");

const $66716f5bfeb7aaba$var$listDepth = 3;
const $66716f5bfeb7aaba$export$8701765a689d47ab = ($from, $to)=>{
    // Block level lists
    const listParents = [
        'bulletList',
        'orderedList'
    ];
    if ($from.depth >= $66716f5bfeb7aaba$var$listDepth && $to.depth >= $66716f5bfeb7aaba$var$listDepth && $from.depth === $to.depth) {
        // Get grandparents (from)
        const grandparentFrom = $from.node($from.depth - 1);
        const greatGrandparentFrom = $from.node($from.depth - 2);
        // Get grandparents (to)
        const grandparentTo = $to.node($from.depth - 1);
        const greatGrandparentTo = $to.node($from.depth - 2);
        if (greatGrandparentTo.eq(greatGrandparentFrom) && listParents.includes(greatGrandparentFrom.type.name) && // Selection covers entire list
        greatGrandparentFrom.firstChild?.eq(grandparentFrom) && greatGrandparentFrom.lastChild?.eq(grandparentTo)) return true;
    }
    return false;
};
const $66716f5bfeb7aaba$export$4fd509032ef7561b = (selection)=>{
    const { from: from, to: to } = selection;
    if (from === to) return (0, $5SAOw.Fragment).empty;
    let frag = (0, $5SAOw.Fragment).empty;
    const sortedRanges = [
        ...selection.ranges.slice()
    ].sort((a, b)=>a.$from.pos - b.$from.pos);
    for (const range of sortedRanges){
        const { $from: $from, $to: $to } = range;
        const to = $to.pos;
        const depth = // If we're in a text selection, and share the parent node across the anchor->head
        // make the depth the parent node
        selection instanceof (0, $ks2lK.TextSelection) && $from.parent.eq($to.parent) ? Math.max(0, $from.sharedDepth(to) - 1) : $from.sharedDepth(to);
        let finalDepth = depth;
        // For block-level lists (non-nested) specifically use the selection
        if ($66716f5bfeb7aaba$export$8701765a689d47ab($from, $to)) finalDepth = $from.depth - $66716f5bfeb7aaba$var$listDepth;
        const start = $from.start(finalDepth);
        const node = $from.node(finalDepth);
        const content = node.content.cut($from.pos - start, $to.pos - start);
        frag = frag.append(content);
    }
    return frag;
};
const $66716f5bfeb7aaba$export$dae3dcae007fe30 = (selection)=>{
    if (!selection || selection.empty) return null;
    const slice = $66716f5bfeb7aaba$export$4fd509032ef7561b(selection);
    const content = slice.content;
    const fragment = [];
    content.forEach((node)=>{
        fragment.push((0, $h9yJL.nodeToJSON)(node));
    });
    return fragment;
};
const $66716f5bfeb7aaba$export$9ce8378d786d4035 = (selection)=>{
    if (!selection) return null;
    if (selection instanceof (0, $ks2lK.NodeSelection)) return [
        selection.node.attrs.localId
    ];
    else if (selection.empty) return [
        selection.$from.parent.attrs.localId
    ];
    const slice = $66716f5bfeb7aaba$export$4fd509032ef7561b(selection);
    const content = slice.content;
    const ids = [];
    content.forEach((node)=>{
        const localId = node.attrs?.localId;
        if (localId) ids.push(localId);
    });
    return ids;
};
module.exports["getFragmentsFromSelection"] = $66716f5bfeb7aaba$export$dae3dcae007fe30;
module.exports["getLocalIdsFromSelection"] = $66716f5bfeb7aaba$export$9ce8378d786d4035;

});

parcelRegister("3h7Ko", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $ddde644a24a9c36e$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $ddde644a24a9c36e$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $ddde644a24a9c36e$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $42omo.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $ddde644a24a9c36e$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $42omo.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $ddde644a24a9c36e$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $42omo.useReducer)($ddde644a24a9c36e$var$reducer, $ddde644a24a9c36e$var$initialState);
    const clearSelectionRange = (0, $42omo.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $42omo.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $42omo.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setHoverTarget = (0, $42omo.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $42omo.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $42omo.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $42omo.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $42omo.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $42omo.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $42omo.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($ddde644a24a9c36e$export$145b9bb655c3d220.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $l998X.jsx)($ddde644a24a9c36e$export$efb0d1c8cbaac647.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $ddde644a24a9c36e$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    /*
   * If this is a nested render, we do not provide the context
   * because it has already been provided higher up the component tree
   * and we need the original context to create annotations on extensions.
   */ return isNestedRender ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)($ddde644a24a9c36e$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        children: children
    });
};
const $ddde644a24a9c36e$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $42omo.useContext)($ddde644a24a9c36e$export$145b9bb655c3d220);
};
const $ddde644a24a9c36e$export$708fc397e2b6f08d = ()=>{
    return (0, $42omo.useContext)($ddde644a24a9c36e$export$efb0d1c8cbaac647);
};
module.exports["AnnotationRangeProvider"] = $ddde644a24a9c36e$export$30384a6aedd19fee;
module.exports["useAnnotationRangeState"] = $ddde644a24a9c36e$export$e07ee6d6cc95d9a0;
module.exports["useAnnotationRangeDispatch"] = $ddde644a24a9c36e$export$708fc397e2b6f08d;

});

parcelRegister("hFjCV", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $adc627cbe56a02e2$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isWithinRange: false
});
const $adc627cbe56a02e2$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $adc627cbe56a02e2$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $42omo.useState)(false);
    const timeoutHandler = (0, $42omo.useRef)();
    const cancelTimeout = (0, $42omo.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $42omo.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $42omo.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $42omo.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($adc627cbe56a02e2$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $l998X.jsx)($adc627cbe56a02e2$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $adc627cbe56a02e2$export$a02bfcbbbf920306 = ()=>{
    return (0, $42omo.useContext)($adc627cbe56a02e2$var$AnnotationHoverStateContext);
};
const $adc627cbe56a02e2$export$c288883964405c82 = ()=>{
    return (0, $42omo.useContext)($adc627cbe56a02e2$var$AnnotationHoverDispatchContext);
};
module.exports["AnnotationHoverContext"] = $adc627cbe56a02e2$export$b3db0feb20552fc3;
module.exports["useAnnotationHoverContext"] = $adc627cbe56a02e2$export$a02bfcbbbf920306;
module.exports["useAnnotationHoverDispatch"] = $adc627cbe56a02e2$export$c288883964405c82;

});

parcelRegister("iZq0X", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1d0afbb8858f32d4$export$d452675449e81987 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $1d0afbb8858f32d4$export$5b655fe45447a548 = $1d0afbb8858f32d4$export$d452675449e81987.Provider;
module.exports["ValidationContext"] = $1d0afbb8858f32d4$export$d452675449e81987;
module.exports["ValidationContextProvider"] = $1d0afbb8858f32d4$export$5b655fe45447a548;

});

parcelRegister("6uN0A", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1aa8eab29b174a45$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $1aa8eab29b174a45$export$2e2bcd8739ae039 = $1aa8eab29b174a45$var$AnalyticsContext;
module.exports["default"] = $1aa8eab29b174a45$export$2e2bcd8739ae039;

});

parcelRegister("kIphX", function(module, exports) {
const $d510f2e588a31a71$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });
module.exports["copyTextToClipboard"] = $d510f2e588a31a71$export$f980440e1ab4537d;

});

parcelRegister("48Use", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $cs1vW = parcelRequire("cs1vW");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $h82at = parcelRequire("h82at");

const $e087e0e2784d599e$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    placeholder: {
        id: "fabric.editor.captionPlaceholder",
        defaultMessage: "Add a caption"
    }
});


function $c7d42479d13572a9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c7d42479d13572a9$var$captionWrapperStyle = {
    name: "4iruax",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #505258)"
};
const $c7d42479d13572a9$var$placeholderStyle = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $c7d42479d13572a9$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $c7d42479d13572a9$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            xcss: $c7d42479d13572a9$var$placeholderStyle
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5dK2X.default), null, formatMessage((0, $e087e0e2784d599e$export$defe85febe8b728c).placeholder))) : null, children);
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $c7d42479d13572a9$var$_default_1 = (0, $cs1vW.default)($c7d42479d13572a9$export$f7feb87190a94c76);
var $c7d42479d13572a9$export$2e2bcd8739ae039 = $c7d42479d13572a9$var$_default_1;
module.exports["default"] = $c7d42479d13572a9$export$2e2bcd8739ae039;

});

parcelRegister("4mSjx", function(module, exports) {
const $34379dd11d589f9f$export$bafd6beec0797f87 = 24;
var $34379dd11d589f9f$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($34379dd11d589f9f$var$CSS_VAR_NAMES || {});
const $34379dd11d589f9f$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $34379dd11d589f9f$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $34379dd11d589f9f$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $34379dd11d589f9f$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $34379dd11d589f9f$var$stringifyStyle(style);
    return style;
}
module.exports["listItemCounterPadding"] = $34379dd11d589f9f$export$bafd6beec0797f87;
module.exports["getOrderedListInlineStyles"] = $34379dd11d589f9f$export$6d31fdb1d74cee3e;

});

parcelRegister("irKZA", function(module, exports) {
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $775de8d03f6b80cd$export$8ef94ae42a3729bd = 1;
const $775de8d03f6b80cd$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $775de8d03f6b80cd$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $775de8d03f6b80cd$export$d445360e2a3c026b(order) ?? $775de8d03f6b80cd$export$8ef94ae42a3729bd;
};
const $775de8d03f6b80cd$export$320582fc14ba1e0f = (options)=>{
    const order = $775de8d03f6b80cd$export$d445360e2a3c026b(options.order) ?? $775de8d03f6b80cd$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $775de8d03f6b80cd$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $775de8d03f6b80cd$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $775de8d03f6b80cd$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $775de8d03f6b80cd$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}
module.exports["resolveOrder"] = $775de8d03f6b80cd$export$d445360e2a3c026b;
module.exports["getOrderFromOrderedListNode"] = $775de8d03f6b80cd$export$cbefb5b89ef0719f;
module.exports["getItemCounterDigitsSize"] = $775de8d03f6b80cd$export$320582fc14ba1e0f;
module.exports["isListNode"] = $775de8d03f6b80cd$export$a7d7d2b9ba4d4dbb;
module.exports["isParagraphNode"] = $775de8d03f6b80cd$export$35f600abfe6f0127;
module.exports["isListItemNode"] = $775de8d03f6b80cd$export$2ddb0a75547407f6;
module.exports["isBulletList"] = $775de8d03f6b80cd$export$35b2f400604e700;

});

parcelRegister("1zav4", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $63Ztt = parcelRequire("63Ztt");


var $aFUXX = parcelRequire("aFUXX");

var $kPuBV = parcelRequire("kPuBV");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $d7ZU3 = parcelRequire("d7ZU3");


var $5MaNT = parcelRequire("5MaNT");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







var $6icEc = parcelRequire("6icEc");

// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $9afc1a6cc885e6cd$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $63Ztt.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $6icEc.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $9afc1a6cc885e6cd$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $9K4OG.css)($9afc1a6cc885e6cd$var$mapBackgroundColors());


function $2799e2cdfcd8e59e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2799e2cdfcd8e59e$export$808015ab1dd6897a = 24;
const $2799e2cdfcd8e59e$export$afe1899c3eea9823 = 16;
const $2799e2cdfcd8e59e$export$910bf0d22c3d10f2 = 14;
const $2799e2cdfcd8e59e$export$a43e30915fab3ccf = 8;
const $2799e2cdfcd8e59e$export$531f77930bf508de = 48;
const $2799e2cdfcd8e59e$export$c60fae4049791eae = 140;
const $2799e2cdfcd8e59e$export$72aad729077aa0fb = 1;
const $2799e2cdfcd8e59e$export$e56b8ca552b280f6 = 8;
const $2799e2cdfcd8e59e$export$bba39e724bc39451 = 6;
const $2799e2cdfcd8e59e$export$e5ff276883773ffd = 8;
const $2799e2cdfcd8e59e$export$880976487022eb5 = $2799e2cdfcd8e59e$export$808015ab1dd6897a + $2799e2cdfcd8e59e$export$e5ff276883773ffd - $2799e2cdfcd8e59e$export$72aad729077aa0fb;
const $2799e2cdfcd8e59e$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $63Ztt.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-wrapper`,
    TABLE_NODE_WRAPPER_NO_OVERFLOW: `${(0, $63Ztt.tablePrefixSelector)}-wrapper-no-overflow`,
    TABLE_SCROLL_INLINE_SHADOW: `${(0, $63Ztt.tablePrefixSelector)}-scroll-inline-shadow`,
    TABLE_RIGHT_BORDER: `${(0, $63Ztt.tablePrefixSelector)}-right-border`,
    TABLE_LEFT_BORDER: `${(0, $63Ztt.tablePrefixSelector)}-left-border`,
    TABLE_LEFT_SHADOW: `${(0, $63Ztt.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $63Ztt.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $63Ztt.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $63Ztt.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $63Ztt.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $63Ztt.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $63Ztt.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $63Ztt.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $63Ztt.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $63Ztt.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $63Ztt.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $63Ztt.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $63Ztt.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $63Ztt.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $63Ztt.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $2799e2cdfcd8e59e$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $2799e2cdfcd8e59e$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $2799e2cdfcd8e59e$var$firstNodeWithNotMarginTop = ()=>(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $2799e2cdfcd8e59e$var$_ref2 : $2799e2cdfcd8e59e$var$_ref;
const $2799e2cdfcd8e59e$export$c2bf8eea75aa9302 = ()=>{
    const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return /*#__PURE__*/ (0, $9K4OG.css)((0, $9afc1a6cc885e6cd$export$677e93f0f5f9623a)(), " .", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_RIGHT_BORDER, ",.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_LEFT_BORDER, "{display:block;width:1px;height:calc(100% - var(--ds-space-300, 24px));background:var(--ds-background-accent-gray-subtler, #DDDEE1);position:absolute;top:var(--ds-space-300, 24px);}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_RIGHT_BORDER, "{right:0;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_LEFT_BORDER, "{left:0;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_LEFT_BORDER, "[data-with-numbered-table='true']{left:", (0, $aFUXX.akEditorTableNumberColumnWidth) - 1, "px;}}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $aFUXX.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $dh538.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${$2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"};
		}` : '', ".", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $2799e2cdfcd8e59e$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $2799e2cdfcd8e59e$export$72aad729077aa0fb, "px solid var(--ds-background-accent-gray-subtler, #DDDEE1);border-left-color:transparent;border-right-color:transparent;table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, #00000000);}>tbody>tr>th,>tbody>tr>td{min-width:", $2799e2cdfcd8e59e$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid var(--ds-background-accent-gray-subtler, #DDDEE1);border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', " ", $2799e2cdfcd8e59e$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}th{background-color:var(--ds-background-accent-gray-subtlest, #F0F1F2);text-align:left;", (0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', "{.", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, #FFFFFF);:not(.", (0, $aFUXX.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, #0B120E24);}.", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $kPuBV.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, #0515240F);}.", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #0515240F);}>[data-ds--code--code-block]{background-image:", (0, $kPuBV.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, #0515240F)!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, #0515240F);}}}}}}");
};
const $2799e2cdfcd8e59e$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $aFUXX.akEditorBreakoutPadding) : 0), (0, $aFUXX.akEditorFullWidthLayoutWidth)) : (0, $aFUXX.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $aFUXX.akEditorBreakoutPadding) : 0), (0, $aFUXX.akEditorWideLayoutWidth));
            return 0, $aFUXX.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};
module.exports["tableMarginTop"] = $2799e2cdfcd8e59e$export$808015ab1dd6897a;
module.exports["tableMarginTopWithControl"] = $2799e2cdfcd8e59e$export$910bf0d22c3d10f2;
module.exports["tableCellMinWidth"] = $2799e2cdfcd8e59e$export$531f77930bf508de;
module.exports["tableNewColumnMinWidth"] = $2799e2cdfcd8e59e$export$c60fae4049791eae;
module.exports["tableCellBorderWidth"] = $2799e2cdfcd8e59e$export$72aad729077aa0fb;
module.exports["tableCellPadding"] = $2799e2cdfcd8e59e$export$e56b8ca552b280f6;
module.exports["tableControlsSpacing"] = $2799e2cdfcd8e59e$export$880976487022eb5;
module.exports["TableSharedCssClassName"] = $2799e2cdfcd8e59e$export$c096bca5477eb7ad;
module.exports["tableSharedStyle"] = $2799e2cdfcd8e59e$export$c2bf8eea75aa9302;
module.exports["calcTableWidth"] = $2799e2cdfcd8e59e$export$d7ece4d8beb06815;

});

parcelRegister("5MaNT", function(module, exports) {
const $f61fb812fe2d68f7$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
module.exports["CodeBlockSharedCssClassName"] = $f61fb812fe2d68f7$export$42659c26f026f6ea;

});

parcelRegister("6icEc", function(module, exports) {
// This import will be stripped on build

var $1To4a = parcelRequire("1To4a");

function $76f1a9db98b6b1bf$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $76f1a9db98b6b1bf$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $76f1a9db98b6b1bf$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $76f1a9db98b6b1bf$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $76f1a9db98b6b1bf$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #669DF1)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E7F9FF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #C6EDFB)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #6CC3E0)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #DCFFF1)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #BAF3DB)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #4BCE97)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #F5E989)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FCA700)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFECEB)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFD5D2)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #F87168)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #F8EEFE)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #EED7FC)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #C97CF4)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $1To4a.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F0F1F2)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $1To4a.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #8C8F97)" // source for hex code was legacy token N60,
    }
};
module.exports["hexToEditorBackgroundPaletteColor"] = $76f1a9db98b6b1bf$export$5f6a44a42a4b38c2;
module.exports["hexToEditorBackgroundPaletteRawValue"] = $76f1a9db98b6b1bf$export$a270511a0e7fd61a;

});

parcelRegister("cN8vw", function(module, exports) {
/** Helper type for single arg function */ function $521e53eeebc4ccf3$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
module.exports["compose"] = $521e53eeebc4ccf3$export$f672e0b6f7222cd7;

});

parcelRegister("caYZ2", function(module, exports) {
function $56d4043887516d4a$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $56d4043887516d4a$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}
function $56d4043887516d4a$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $56d4043887516d4a$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $56d4043887516d4a$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}
module.exports["getColumnWidths"] = $56d4043887516d4a$export$e54c9225ca52acc;
module.exports["calcTableColumnWidths"] = $56d4043887516d4a$export$98951d3cdcfd364b;
module.exports["hasMergedCell"] = $56d4043887516d4a$export$f9d610bfbb78949b;
module.exports["convertProsemirrorTableNodeToArrayOfRows"] = $56d4043887516d4a$export$69fbfaf01f2fd534;
module.exports["isPositionNearTableRow"] = $56d4043887516d4a$export$889a8e446452be16;

});

parcelRegister("d4WtM", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $2QYOD = parcelRequire("2QYOD");

var $eff95bd9cb48403a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $eff95bd9cb48403a$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $eff95bd9cb48403a$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $eff95bd9cb48403a$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(RegExp("\\p{Number}", "gu"), '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(RegExp("\\p{Number}", "gu"), '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $eff95bd9cb48403a$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $eff95bd9cb48403a$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $eff95bd9cb48403a$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $eff95bd9cb48403a$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $eff95bd9cb48403a$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $eff95bd9cb48403a$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $eff95bd9cb48403a$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $eff95bd9cb48403a$export$49215374a8bec29c = (options, order = (0, $2QYOD.SortOrder).ASC)=>{
    const normalizeTextParser = $eff95bd9cb48403a$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $eff95bd9cb48403a$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $eff95bd9cb48403a$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $eff95bd9cb48403a$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $2QYOD.SortOrder).DESC ? -1 : 1) * $eff95bd9cb48403a$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $eff95bd9cb48403a$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if ((0, $dh538.fg)('platform_editor_fix_mixed_types_column_sort')) {
        if (metaNodeA.type === 5 && metaNodeB.type === 0 || metaNodeA.type === 0 && metaNodeB.type === 5) return $eff95bd9cb48403a$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    }
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $eff95bd9cb48403a$var$compareValue(metaNodeA.value, metaNodeB.value);
}
module.exports["createCompareNodes"] = $eff95bd9cb48403a$export$49215374a8bec29c;

});

parcelRegister("2QYOD", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $21K7m = parcelRequire("21K7m");


var $zMjD6 = parcelRequire("zMjD6");


var $ah4M9 = parcelRequire("ah4M9");

var $0829eaae2cd5a49f$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});
module.exports["SortOrder"] = $0829eaae2cd5a49f$export$7ae723045d45777a;

});

parcelRegister("zMjD6", function(module, exports) {
var $5e0903e4ee7a468f$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $5e0903e4ee7a468f$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $5e0903e4ee7a468f$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $5e0903e4ee7a468f$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $5e0903e4ee7a468f$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});
module.exports["ToolbarSize"] = $5e0903e4ee7a468f$export$ed55211407a9423;
module.exports["ToolbarWidths"] = $5e0903e4ee7a468f$export$423b5e8c92d477b9;
module.exports["ToolbarWidthsNext"] = $5e0903e4ee7a468f$export$3f050002d3df641b;
module.exports["ToolbarWidthsFullPage"] = $5e0903e4ee7a468f$export$63ca43752be70b90;
module.exports["ToolbarWidthsFullPageNext"] = $5e0903e4ee7a468f$export$501a79d885598191;

});

parcelRegister("ah4M9", function(module, exports) {
var $0340026301a73b77$export$9106728c49045482 = /*#__PURE__*/ function(DIRECTION) {
    DIRECTION["UP"] = "up";
    DIRECTION["DOWN"] = "down";
    DIRECTION["LEFT"] = "left";
    DIRECTION["RIGHT"] = "right";
    return DIRECTION;
}({});
module.exports["DIRECTION"] = $0340026301a73b77$export$9106728c49045482;

});

parcelRegister("6fQl1", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $5Ev1b = parcelRequire("5Ev1b");


var $boKri = parcelRequire("boKri");


var $1zav4 = parcelRequire("1zav4");


var $fJNzZ = parcelRequire("fJNzZ");

const $2eab9b0df279d802$var$GRID_SIZE = 8;
const $2eab9b0df279d802$var$NESTED_DND_GUTTER_OFFSET = 8;
const $2eab9b0df279d802$var$NESTED_DND_MARGIN_OFFSET = 12;
const $2eab9b0df279d802$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $aFUXX.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $aFUXX.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $aFUXX.akEditorFullWidthLayoutWidth)
};
const $2eab9b0df279d802$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $2eab9b0df279d802$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    const breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    let parentWidth = $2eab9b0df279d802$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $aFUXX.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                // margin between sections
                parentWidth -= (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $boKri.LAYOUT_SECTION_MARGIN) + $2eab9b0df279d802$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1) : ((0, $boKri.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $boKri.LAYOUT_COLUMN_PADDING) + $2eab9b0df279d802$var$NESTED_DND_GUTTER_OFFSET) * 2 : (0, $boKri.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $5Ev1b.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $5Ev1b.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $2eab9b0df279d802$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $2eab9b0df279d802$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $2eab9b0df279d802$var$GRID_SIZE;
            // padding left
            parentWidth -= $2eab9b0df279d802$var$GRID_SIZE * 4 - $2eab9b0df279d802$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $1zav4.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $2eab9b0df279d802$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader
    ]);
    return parent ? parent.node : null;
};
const $2eab9b0df279d802$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled, breakoutWidth)=>{
    if (breakoutWidth) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $aFUXX.akEditorGutterPaddingDynamic)() * 2 + (0, $aFUXX.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $aFUXX.akEditorFullWidthLayoutWidth)) : (0, $fJNzZ.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $2eab9b0df279d802$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $2eab9b0df279d802$export$9b77d38feba5446[node?.attrs.layout] || (0, $aFUXX.akEditorDefaultLayoutWidth);
};
const $2eab9b0df279d802$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $2eab9b0df279d802$export$3930799be057b305(node) - offset;
    return $2eab9b0df279d802$export$3930799be057b305(node);
};
module.exports["layoutToWidth"] = $2eab9b0df279d802$export$9b77d38feba5446;
module.exports["getParentNodeWidth"] = $2eab9b0df279d802$export$d76cc081ce1449a8;
module.exports["getTableContainerWidth"] = $2eab9b0df279d802$export$3930799be057b305;

});

parcelRegister("5Ev1b", function(module, exports) {
const $12a95dac6e3e610f$export$f5ecdce4c60ff98b = 8;
const $12a95dac6e3e610f$export$5ac5087fe1217160 = $12a95dac6e3e610f$export$f5ecdce4c60ff98b * 2;
const $12a95dac6e3e610f$export$91624ec52c59c24c = 12;
module.exports["BODIED_EXT_PADDING"] = $12a95dac6e3e610f$export$5ac5087fe1217160;
module.exports["BODIED_EXT_MBE_MARGIN_TOP"] = $12a95dac6e3e610f$export$91624ec52c59c24c;

});

parcelRegister("boKri", function(module, exports) {
const $59f993087aaa984c$export$cd04f19842abff0 = 8;
const $59f993087aaa984c$export$a1bb91aa2d5fcce8 = $59f993087aaa984c$export$cd04f19842abff0 * 1.5;
const $59f993087aaa984c$export$e5ee675b2c7e739b = 50;
module.exports["LAYOUT_SECTION_MARGIN"] = $59f993087aaa984c$export$cd04f19842abff0;
module.exports["LAYOUT_COLUMN_PADDING"] = $59f993087aaa984c$export$a1bb91aa2d5fcce8;

});

parcelRegister("1zvWv", function(module, exports) {
const $fd0f66b4af830316$export$12fd658e5eef0d79 = 32;
const $fd0f66b4af830316$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
module.exports["FullPagePadding"] = $fd0f66b4af830316$export$12fd658e5eef0d79;
module.exports["TELEPOINTER_ID"] = $fd0f66b4af830316$export$74b525449cc7cbd1;

});

parcelRegister("7f6CO", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $cs1vW = parcelRequire("cs1vW");


var $3gadb = parcelRequire("3gadb");


var $2QYOD = parcelRequire("2QYOD");


var $1j8OE = parcelRequire("1j8OE");


var $h82at = parcelRequire("h82at");

const $39171b9c8b93a075$export$458c50917513cd1a = (0, $h82at.defineMessages)({
    noOrderLabel: {
        id: "fabric.editor.headingLink.noOrderLabel",
        defaultMessage: "Sort column A to Z"
    },
    ascOrderLabel: {
        id: "fabric.editor.headingLink.ascOrderLabel",
        defaultMessage: "Sort column Z to A"
    },
    descOrderLabel: {
        id: "fabric.editor.headingLink.descOrderLabel",
        defaultMessage: "Clear sorting"
    },
    invalidLabel: {
        id: "fabric.editor.headingLink.invalidLabel",
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: "\u26A0\uFE0F  You can't sort a table with merged cells"
    }
});
const $39171b9c8b93a075$export$f142573f51a67577 = (0, $h82at.defineMessages)({
    noOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.no",
        defaultMessage: "No sort applied to the column"
    },
    ascOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.asc",
        defaultMessage: "Ascending sort applied"
    },
    descOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.desc",
        defaultMessage: "Descending sort applied"
    },
    invalidLabel: {
        id: "fabric.editor.tableHeader.sorting.invalid",
        defaultMessage: "You can't sort a table with merged cells"
    },
    defaultLabel: {
        id: "fabric.editor.tableHeader.sorting.default",
        defaultMessage: "Sort the column"
    }
});


function $cd5bbe471a3a63ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $cd5bbe471a3a63ba$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $cd5bbe471a3a63ba$var$buttonStyles = /*#__PURE__*/ (0, $9K4OG.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:var(--ds-border-width-selected, 2px) solid var(--ds-border, #0B120E24);border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F0F1F2);}&:active{background-color:var(--ds-surface-overlay-pressed, #DDDEE1);}&.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $cd5bbe471a3a63ba$var$iconWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $cd5bbe471a3a63ba$var$iconStyles = {
    name: "3kmdk1",
    styles: "height:100%;width:2px;border-radius:var(--ds-radius-full, 9999px);background:var(--ds-icon, #292A2E);user-select:none;&::before, &::after{background:var(--ds-icon, #292A2E);content:'';height:2px;width:6px;position:absolute;border-radius:var(--ds-radius-full, 9999px);}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $cd5bbe471a3a63ba$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $2QYOD.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $2QYOD.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $2QYOD.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $cd5bbe471a3a63ba$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $39171b9c8b93a075$export$458c50917513cd1a);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $2QYOD.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $2QYOD.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $cd5bbe471a3a63ba$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $39171b9c8b93a075$export$f142573f51a67577);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $2QYOD.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $2QYOD.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $cd5bbe471a3a63ba$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME)} ${sortOrdered !== (0, $2QYOD.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME}__not-allowed `}`;
    const content = $cd5bbe471a3a63ba$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $cd5bbe471a3a63ba$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $cd5bbe471a3a63ba$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $cd5bbe471a3a63ba$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $cd5bbe471a3a63ba$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $cd5bbe471a3a63ba$var$iconStyles
        ]
    }))));
};
const $cd5bbe471a3a63ba$var$_default_1 = (0, $cs1vW.default)($cd5bbe471a3a63ba$var$SortingIcon);
var $cd5bbe471a3a63ba$export$2e2bcd8739ae039 = $cd5bbe471a3a63ba$var$_default_1;
module.exports["default"] = $cd5bbe471a3a63ba$export$2e2bcd8739ae039;

});

parcelRegister("1j8OE", function(module, exports) {
const $9f6a2cabc4658788$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;
module.exports["SORTABLE_COLUMN_ICON_CLASSNAME"] = $9f6a2cabc4658788$export$bd4f24d8b1e86b23;

});

parcelRegister("bZfVt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $9a2cd2417c72e065$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(new Map());
const $9a2cd2417c72e065$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)($9a2cd2417c72e065$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $9a2cd2417c72e065$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        render() {
            return /*#__PURE__*/ (0, $l998X.jsx)($9a2cd2417c72e065$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};
module.exports["Provider"] = $9a2cd2417c72e065$export$2881499e37b75b9a;
module.exports["withSmartCardStorage"] = $9a2cd2417c72e065$export$65e2d5a272a382b0;

});

parcelRegister("bBvs5", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $42omo = parcelRequire("42omo");

const $e8c8dd4eecc10576$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
const $e8c8dd4eecc10576$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($e8c8dd4eecc10576$var$RendererContext);
const $e8c8dd4eecc10576$export$ca5df47902194781 = $e8c8dd4eecc10576$var$RendererContext.Provider;
module.exports["useRendererContext"] = $e8c8dd4eecc10576$export$a906432540ed7ed8;
module.exports["RendererContextProvider"] = $e8c8dd4eecc10576$export$ca5df47902194781;

});

parcelRegister("96XCF", function(module, exports) {

let $6a22ec6ce265855d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a22ec6ce265855d$var$load("6wr18"),
    $6a22ec6ce265855d$var$load("ffEVr"),
    $6a22ec6ce265855d$var$load("2Yc7I")
]).then(()=>parcelRequire('4elbo'));

});

parcelRegister("d5ZV5", function(module, exports) {

let $988bc5f8f610a58e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $988bc5f8f610a58e$var$load("klApM"),
    $988bc5f8f610a58e$var$load("eQgf0"),
    $988bc5f8f610a58e$var$load("6wr18"),
    $988bc5f8f610a58e$var$load("37ldp"),
    $988bc5f8f610a58e$var$load("ffEVr"),
    $988bc5f8f610a58e$var$load("9vWDd")
]).then(()=>parcelRequire('sc949'));

});

parcelRegister("jblE9", function(module, exports) {

let $df6fd5f5484060f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df6fd5f5484060f1$var$load("hri9L").then(()=>parcelRequire('b89xc'));

});

parcelRegister("2ve85", function(module, exports) {

let $1d296fdb291d1444$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d296fdb291d1444$var$load("6wr18"),
    $1d296fdb291d1444$var$load("ffEVr"),
    $1d296fdb291d1444$var$load("hjv2W")
]).then(()=>parcelRequire('8aT3t'));

});

parcelRegister("8DVsQ", function(module, exports) {

let $64ae8a77c8da5e33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64ae8a77c8da5e33$var$load("h3GJZ").then(()=>parcelRequire('jouXW'));

});

parcelRegister("gbCDG", function(module, exports) {

let $bc8ba55b6259265c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc8ba55b6259265c$var$load("6wr18"),
    $bc8ba55b6259265c$var$load("ffEVr"),
    $bc8ba55b6259265c$var$load("hAerp")
]).then(()=>parcelRequire('kGWTg'));

});

parcelRegister("ezNcf", function(module, exports) {

let $a9ca7ef500c4f100$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a9ca7ef500c4f100$var$load("klApM"),
    $a9ca7ef500c4f100$var$load("eQgf0"),
    $a9ca7ef500c4f100$var$load("cBo2a")
]).then(()=>parcelRequire('7xxJX'));

});

parcelRegister("kQgmx", function(module, exports) {

let $f2c55b40464c4069$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2c55b40464c4069$var$load("hhss7"),
    $f2c55b40464c4069$var$load("Wowvf"),
    $f2c55b40464c4069$var$load("8m00X")
]).then(()=>parcelRequire('5xRci'));

});

parcelRegister("fqjOA", function(module, exports) {

let $b3a8a78910ca931f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b3a8a78910ca931f$var$load("klApM"),
    $b3a8a78910ca931f$var$load("eQgf0"),
    $b3a8a78910ca931f$var$load("7cABH"),
    $b3a8a78910ca931f$var$load("f9WnJ")
]).then(()=>parcelRequire('gVFlX'));

});

parcelRegister("jSXwK", function(module, exports) {

let $e7a13c4d1efe43af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e7a13c4d1efe43af$var$load("6wr18"),
    $e7a13c4d1efe43af$var$load("jjLHK"),
    $e7a13c4d1efe43af$var$load("cxoS1"),
    $e7a13c4d1efe43af$var$load("ffEVr"),
    $e7a13c4d1efe43af$var$load("klApM"),
    $e7a13c4d1efe43af$var$load("eQgf0"),
    $e7a13c4d1efe43af$var$load("7cABH"),
    $e7a13c4d1efe43af$var$load("f9WnJ"),
    $e7a13c4d1efe43af$var$load("l50fY")
]).then(()=>parcelRequire('3ARr2'));

});

parcelRegister("68cQw", function(module, exports) {

let $476d74620bb99bf4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $476d74620bb99bf4$var$load("klApM"),
    $476d74620bb99bf4$var$load("eQgf0"),
    $476d74620bb99bf4$var$load("5CdWD"),
    $476d74620bb99bf4$var$load("jjLHK"),
    $476d74620bb99bf4$var$load("cxoS1"),
    $476d74620bb99bf4$var$load("aiWbc"),
    $476d74620bb99bf4$var$load("7oiUM"),
    $476d74620bb99bf4$var$load("8t3po"),
    $476d74620bb99bf4$var$load("855o0"),
    $476d74620bb99bf4$var$load("8MfZE"),
    $476d74620bb99bf4$var$load("hv4mn"),
    $476d74620bb99bf4$var$load("dek7I"),
    $476d74620bb99bf4$var$load("9aQIt"),
    $476d74620bb99bf4$var$load("XZauT"),
    $476d74620bb99bf4$var$load("4S1SF"),
    $476d74620bb99bf4$var$load("jiFtb"),
    $476d74620bb99bf4$var$load("lm9Lt"),
    $476d74620bb99bf4$var$load("9wPDc"),
    $476d74620bb99bf4$var$load("1MWOL"),
    $476d74620bb99bf4$var$load("6fQco"),
    $476d74620bb99bf4$var$load("aOY32"),
    $476d74620bb99bf4$var$load("7jSfd"),
    $476d74620bb99bf4$var$load("4HZlX"),
    $476d74620bb99bf4$var$load("kDqHr"),
    $476d74620bb99bf4$var$load("dYtBN"),
    $476d74620bb99bf4$var$load("kNV5Y"),
    $476d74620bb99bf4$var$load("6wr18"),
    $476d74620bb99bf4$var$load("kjZZD"),
    $476d74620bb99bf4$var$load("2zxmz"),
    $476d74620bb99bf4$var$load("7269o"),
    $476d74620bb99bf4$var$load("dRpV3"),
    $476d74620bb99bf4$var$load("ffEVr"),
    $476d74620bb99bf4$var$load("7EorR"),
    $476d74620bb99bf4$var$load("dTsOE"),
    $476d74620bb99bf4$var$load("hogcU"),
    $476d74620bb99bf4$var$load("axFxW"),
    $476d74620bb99bf4$var$load("2jp1v"),
    $476d74620bb99bf4$var$load("hhss7"),
    $476d74620bb99bf4$var$load("Wowvf"),
    $476d74620bb99bf4$var$load("2zeg1")
]).then(()=>parcelRequire('f7Vk9'));

});

parcelRegister("dVRt3", function(module, exports) {

let $a24a12cac360bf72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a24a12cac360bf72$var$load("jjLHK"),
    $a24a12cac360bf72$var$load("cxoS1"),
    $a24a12cac360bf72$var$load("aiWbc"),
    $a24a12cac360bf72$var$load("7oiUM"),
    $a24a12cac360bf72$var$load("8t3po"),
    $a24a12cac360bf72$var$load("855o0"),
    $a24a12cac360bf72$var$load("8MfZE"),
    $a24a12cac360bf72$var$load("hv4mn"),
    $a24a12cac360bf72$var$load("dek7I"),
    $a24a12cac360bf72$var$load("9aQIt"),
    $a24a12cac360bf72$var$load("XZauT"),
    $a24a12cac360bf72$var$load("4S1SF"),
    $a24a12cac360bf72$var$load("jiFtb"),
    $a24a12cac360bf72$var$load("lm9Lt"),
    $a24a12cac360bf72$var$load("9wPDc"),
    $a24a12cac360bf72$var$load("1MWOL"),
    $a24a12cac360bf72$var$load("6fQco"),
    $a24a12cac360bf72$var$load("aOY32"),
    $a24a12cac360bf72$var$load("7jSfd"),
    $a24a12cac360bf72$var$load("4HZlX"),
    $a24a12cac360bf72$var$load("kDqHr"),
    $a24a12cac360bf72$var$load("dYtBN"),
    $a24a12cac360bf72$var$load("kNV5Y"),
    $a24a12cac360bf72$var$load("6wr18"),
    $a24a12cac360bf72$var$load("kjZZD"),
    $a24a12cac360bf72$var$load("2zxmz"),
    $a24a12cac360bf72$var$load("7269o"),
    $a24a12cac360bf72$var$load("dRpV3"),
    $a24a12cac360bf72$var$load("ffEVr"),
    $a24a12cac360bf72$var$load("7EorR"),
    $a24a12cac360bf72$var$load("dTsOE"),
    $a24a12cac360bf72$var$load("hogcU"),
    $a24a12cac360bf72$var$load("hhss7"),
    $a24a12cac360bf72$var$load("Wowvf"),
    $a24a12cac360bf72$var$load("axFxW")
]).then(()=>parcelRequire('5Iqpa'));

});

parcelRegister("bUOE6", function(module, exports) {

let $8acc35db5ad85339$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8acc35db5ad85339$var$load("jjLHK"),
    $8acc35db5ad85339$var$load("cxoS1"),
    $8acc35db5ad85339$var$load("aiWbc"),
    $8acc35db5ad85339$var$load("7oiUM"),
    $8acc35db5ad85339$var$load("8t3po"),
    $8acc35db5ad85339$var$load("855o0"),
    $8acc35db5ad85339$var$load("8MfZE"),
    $8acc35db5ad85339$var$load("hv4mn"),
    $8acc35db5ad85339$var$load("dek7I"),
    $8acc35db5ad85339$var$load("9aQIt"),
    $8acc35db5ad85339$var$load("XZauT"),
    $8acc35db5ad85339$var$load("4S1SF"),
    $8acc35db5ad85339$var$load("jiFtb"),
    $8acc35db5ad85339$var$load("lm9Lt"),
    $8acc35db5ad85339$var$load("9wPDc"),
    $8acc35db5ad85339$var$load("1MWOL"),
    $8acc35db5ad85339$var$load("6fQco"),
    $8acc35db5ad85339$var$load("aOY32"),
    $8acc35db5ad85339$var$load("7jSfd"),
    $8acc35db5ad85339$var$load("4HZlX"),
    $8acc35db5ad85339$var$load("kDqHr"),
    $8acc35db5ad85339$var$load("dYtBN"),
    $8acc35db5ad85339$var$load("kNV5Y"),
    $8acc35db5ad85339$var$load("6wr18"),
    $8acc35db5ad85339$var$load("kjZZD"),
    $8acc35db5ad85339$var$load("2zxmz"),
    $8acc35db5ad85339$var$load("7269o"),
    $8acc35db5ad85339$var$load("dRpV3"),
    $8acc35db5ad85339$var$load("ffEVr"),
    $8acc35db5ad85339$var$load("7EorR"),
    $8acc35db5ad85339$var$load("dTsOE"),
    $8acc35db5ad85339$var$load("hogcU"),
    $8acc35db5ad85339$var$load("axFxW"),
    $8acc35db5ad85339$var$load("hhss7"),
    $8acc35db5ad85339$var$load("Wowvf"),
    $8acc35db5ad85339$var$load("2jp1v")
]).then(()=>parcelRequire('eQ05w'));

});

parcelRegister("3yJXT", function(module, exports) {

let $297833ca68a987bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $297833ca68a987bc$var$load("5CdWD"),
    $297833ca68a987bc$var$load("jjLHK"),
    $297833ca68a987bc$var$load("cxoS1"),
    $297833ca68a987bc$var$load("klllM"),
    $297833ca68a987bc$var$load("klApM"),
    $297833ca68a987bc$var$load("eQgf0"),
    $297833ca68a987bc$var$load("74vOE"),
    $297833ca68a987bc$var$load("f35QR"),
    $297833ca68a987bc$var$load("eVYW1"),
    $297833ca68a987bc$var$load("ls0Um"),
    $297833ca68a987bc$var$load("020xd"),
    $297833ca68a987bc$var$load("eTBsW"),
    $297833ca68a987bc$var$load("bYxCZ"),
    $297833ca68a987bc$var$load("6HBYC"),
    $297833ca68a987bc$var$load("eDqo1"),
    $297833ca68a987bc$var$load("lxiFd"),
    $297833ca68a987bc$var$load("1oiJ6"),
    $297833ca68a987bc$var$load("huUvS"),
    $297833ca68a987bc$var$load("6wr18"),
    $297833ca68a987bc$var$load("fisfU"),
    $297833ca68a987bc$var$load("fsikk"),
    $297833ca68a987bc$var$load("gOOwE"),
    $297833ca68a987bc$var$load("8j9XC"),
    $297833ca68a987bc$var$load("6vhrJ"),
    $297833ca68a987bc$var$load("fxC6e"),
    $297833ca68a987bc$var$load("kknf5"),
    $297833ca68a987bc$var$load("ajMch"),
    $297833ca68a987bc$var$load("hPalR"),
    $297833ca68a987bc$var$load("jDjSj"),
    $297833ca68a987bc$var$load("8059b"),
    $297833ca68a987bc$var$load("3QZdB"),
    $297833ca68a987bc$var$load("3M4Om"),
    $297833ca68a987bc$var$load("4jPsO"),
    $297833ca68a987bc$var$load("72780"),
    $297833ca68a987bc$var$load("hszIA"),
    $297833ca68a987bc$var$load("fwuXj"),
    $297833ca68a987bc$var$load("2fk6g"),
    $297833ca68a987bc$var$load("ffEVr"),
    $297833ca68a987bc$var$load("dRpV3"),
    $297833ca68a987bc$var$load("hhss7"),
    $297833ca68a987bc$var$load("7EorR"),
    $297833ca68a987bc$var$load("5jCVU")
]).then(()=>parcelRequire('4ebXC'));

});

parcelRegister("gtfGk", function(module, exports) {

let $bfdb84dacad222c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bfdb84dacad222c1$var$load("6wr18"),
    $bfdb84dacad222c1$var$load("ffEVr"),
    $bfdb84dacad222c1$var$load("gOOwE"),
    $bfdb84dacad222c1$var$load("4Kqu1")
]).then(()=>parcelRequire('i6jK3'));

});

parcelRegister("9wbn0", function(module, exports) {

let $6edfec0e3feb58fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6edfec0e3feb58fa$var$load("jjLHK"),
    $6edfec0e3feb58fa$var$load("cxoS1"),
    $6edfec0e3feb58fa$var$load("9oODd"),
    $6edfec0e3feb58fa$var$load("klllM"),
    $6edfec0e3feb58fa$var$load("klApM"),
    $6edfec0e3feb58fa$var$load("eQgf0"),
    $6edfec0e3feb58fa$var$load("74vOE"),
    $6edfec0e3feb58fa$var$load("f35QR"),
    $6edfec0e3feb58fa$var$load("eVYW1"),
    $6edfec0e3feb58fa$var$load("ls0Um"),
    $6edfec0e3feb58fa$var$load("020xd"),
    $6edfec0e3feb58fa$var$load("eTBsW"),
    $6edfec0e3feb58fa$var$load("bYxCZ"),
    $6edfec0e3feb58fa$var$load("6HBYC"),
    $6edfec0e3feb58fa$var$load("eDqo1"),
    $6edfec0e3feb58fa$var$load("lxiFd"),
    $6edfec0e3feb58fa$var$load("1oiJ6"),
    $6edfec0e3feb58fa$var$load("huUvS"),
    $6edfec0e3feb58fa$var$load("6wr18"),
    $6edfec0e3feb58fa$var$load("fisfU"),
    $6edfec0e3feb58fa$var$load("fsikk"),
    $6edfec0e3feb58fa$var$load("gOOwE"),
    $6edfec0e3feb58fa$var$load("8j9XC"),
    $6edfec0e3feb58fa$var$load("fwuXj"),
    $6edfec0e3feb58fa$var$load("6vhrJ"),
    $6edfec0e3feb58fa$var$load("fxC6e"),
    $6edfec0e3feb58fa$var$load("kknf5"),
    $6edfec0e3feb58fa$var$load("ajMch"),
    $6edfec0e3feb58fa$var$load("hPalR"),
    $6edfec0e3feb58fa$var$load("jDjSj"),
    $6edfec0e3feb58fa$var$load("8059b"),
    $6edfec0e3feb58fa$var$load("3QZdB"),
    $6edfec0e3feb58fa$var$load("3M4Om"),
    $6edfec0e3feb58fa$var$load("4jPsO"),
    $6edfec0e3feb58fa$var$load("72780"),
    $6edfec0e3feb58fa$var$load("hszIA"),
    $6edfec0e3feb58fa$var$load("2fk6g"),
    $6edfec0e3feb58fa$var$load("ffEVr"),
    $6edfec0e3feb58fa$var$load("dRpV3"),
    $6edfec0e3feb58fa$var$load("7EorR"),
    $6edfec0e3feb58fa$var$load("9YdHi")
]).then(()=>parcelRequire('9d6BC'));

});

parcelRegister("dm5Dj", function(module, exports) {

let $9b91b308b72d3597$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b91b308b72d3597$var$load("klApM"),
    $9b91b308b72d3597$var$load("eQgf0"),
    $9b91b308b72d3597$var$load("5CdWD"),
    $9b91b308b72d3597$var$load("75rSO")
]).then(()=>parcelRequire('1HlBH'));

});

parcelRegister("a8O6D", function(module, exports) {

let $762184b994623f6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $762184b994623f6e$var$load("7cABH"),
    $762184b994623f6e$var$load("6wr18"),
    $762184b994623f6e$var$load("ffEVr"),
    $762184b994623f6e$var$load("3WB19"),
    $762184b994623f6e$var$load("1MlIV"),
    $762184b994623f6e$var$load("g9CVe"),
    $762184b994623f6e$var$load("diCLj")
]).then(()=>parcelRequire('7peIa'));

});

parcelRegister("4Y3We", function(module, exports) {

let $39dfd212b2ad980e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $39dfd212b2ad980e$var$load("6wr18"),
    $39dfd212b2ad980e$var$load("ffEVr"),
    $39dfd212b2ad980e$var$load("5xpVW")
]).then(()=>parcelRequire('babkf'));

});

parcelRegister("64LyH", function(module, exports) {

let $46c801f63bb419d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46c801f63bb419d2$var$load("8gytj").then(()=>parcelRequire('3UlV5'));

});

parcelRegister("dvtp1", function(module, exports) {

let $9d54fa5d7c6dc3c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9d54fa5d7c6dc3c0$var$load("2ksh5").then(()=>parcelRequire('3BDe4'));

});

parcelRegister("b7FrM", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iyDxB = parcelRequire("iyDxB");


var $h9yJL = parcelRequire("h9yJL");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e3bf22e8c40775ba$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $e3bf22e8c40775ba$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.encode = void 0;
        const transformer = createTransformerWithSchema((0, $iyDxB.defaultSchema));
        this.encode = $e3bf22e8c40775ba$var$createEncoder(transformer, new (0, $h9yJL.JSONTransformer)());
    }
}
const $e3bf22e8c40775ba$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $e3bf22e8c40775ba$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $e3bf22e8c40775ba$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $e3bf22e8c40775ba$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}
module.exports["ADFEncoder"] = $e3bf22e8c40775ba$export$bcf771b83128eae7;
module.exports["getText"] = $e3bf22e8c40775ba$export$c72d34660a162238;
module.exports["getEventHandler"] = $e3bf22e8c40775ba$export$eee20638634729b3;
module.exports["findInTree"] = $e3bf22e8c40775ba$export$38b61ebf4950cd39;

});

parcelRegister("7nUdN", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cUycv = parcelRequire("cUycv");





var $42omo = parcelRequire("42omo");





var $21K7m = parcelRequire("21K7m");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");





var $dh538 = parcelRequire("dh538");


var $1cfRh = parcelRequire("1cfRh");


var $3kBFe = parcelRequire("3kBFe");


var $jSHzw = parcelRequire("jSHzw");

const $7fcae4a13326e885$var$markStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cUycv.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
            cursor: 'pointer'
        }
    }
});
const $7fcae4a13326e885$var$markStylesLayeringFix = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cUycv.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cUycv.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cUycv.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $cUycv.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7fcae4a13326e885$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $7fcae4a13326e885$var$accessibilityStylesOld = /*#__PURE__*/ (0, $9K4OG.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-startmarker)] '`
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-endmarker)] '`
    }
});
const $7fcae4a13326e885$var$accessibilityStylesNew = /*#__PURE__*/ (0, $9K4OG.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-startmarker)'
        ]
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-endmarker)'
        ]
    }
});
const $7fcae4a13326e885$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $1cfRh.default)();
    const annotationIds = (0, $42omo.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $jSHzw.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $42omo.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $42omo.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $cUycv.AnnotationMarkStates).ACTIVE) return;
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $7fcae4a13326e885$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $cUycv.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $9K4OG.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $7fcae4a13326e885$var$markStyles,
                $7fcae4a13326e885$var$markStylesLayeringFix,
                (0, $dh538.fg)('editor_inline_comments_on_inline_nodes') && $7fcae4a13326e885$var$markStylesWithInlineComments,
                $7fcae4a13326e885$var$markStylesWithCommentsPanel,
                !$7fcae4a13326e885$var$isMobile() && ((0, $dh538.fg)('platform_renderer_a11y_inline_comment_fix') ? $7fcae4a13326e885$var$accessibilityStylesNew : $7fcae4a13326e885$var$accessibilityStylesOld),
                $7fcae4a13326e885$var$markStylesWithUpdatedShadow
            ],
            style: (0, $dh538.fg)('platform_renderer_a11y_inline_comment_fix') ? {
                '--ak-renderer-annotation-startmarker': `"${intl.formatMessage((0, $3kBFe.inlineCommentMessages).contentRendererInlineCommentMarkerStart)}"`,
                '--ak-renderer-annotation-endmarker': `"${intl.formatMessage((0, $3kBFe.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)}"`
            } : {
                '--ak-renderer-annotation-startmarker': intl.formatMessage((0, $3kBFe.inlineCommentMessages).contentRendererInlineCommentMarkerStart),
                '--ak-renderer-annotation-endmarker': intl.formatMessage((0, $3kBFe.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)
            }
        }
    }, children);
};



var $ancN7 = parcelRequire("ancN7");


var $hXhSb = parcelRequire("hXhSb");


var $1lzbj = parcelRequire("1lzbj");


var $IcpgS = parcelRequire("IcpgS");




const $8711d9493341addc$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $hXhSb.useInlineCommentSubscriberContext)();
    const states = (0, $42omo.useContext)((0, $IcpgS.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $1lzbj.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $42omo.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const onClick = (0, $42omo.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager?.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((_error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $ancN7.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $cUycv.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7fcae4a13326e885$export$4f5a51511304fdd0), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        children: children
    });
};


const $02b331d070d05b79$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $02b331d070d05b79$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $cUycv.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $l998X.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8711d9493341addc$export$f3069f755c1eba0b), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $l998X.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $02b331d070d05b79$export$2e2bcd8739ae039 = $02b331d070d05b79$var$AnnotationComponent;
module.exports["isAnnotationMark"] = $02b331d070d05b79$export$855795c145f03402;
module.exports["default"] = $02b331d070d05b79$export$2e2bcd8739ae039;

});

parcelRegister("ancN7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $IcpgS = parcelRequire("IcpgS");

const $5c4a32a3b8bea484$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $42omo.useContext)((0, $IcpgS.InlineCommentsStateContext));
    return (0, $42omo.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};
module.exports["useInlineCommentsFilter"] = $5c4a32a3b8bea484$export$8e7d47f9e38ad4f1;

});

parcelRegister("hXhSb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $IcpgS = parcelRequire("IcpgS");

const $667d06be2b39b9f1$export$b46737175cffd396 = ()=>{
    const providers = (0, $42omo.useContext)((0, $IcpgS.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};
module.exports["useInlineCommentSubscriberContext"] = $667d06be2b39b9f1$export$b46737175cffd396;

});

parcelRegister("lwZHY", function(module, exports) {
/* code.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $g7Pc3 = parcelRequire("g7Pc3");


var $03WRT = parcelRequire("03WRT");

const $6cbd39251ee9e7e1$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
}; /**
    * __Code__
    *
    * Code highlights short strings of code snippets inline with body text.
    *
    * - [Examples](https://atlassian.design/components/code/examples)
    * - [Code](https://atlassian.design/components/code/code)
    * - [Usage](https://atlassian.design/components/code/usage)
    */ 
const $6cbd39251ee9e7e1$var$Code = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props; // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, $l998X.jsx)($6cbd39251ee9e7e1$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $l998X.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $gMc0m.default)([
            $6cbd39251ee9e7e1$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $6cbd39251ee9e7e1$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $03WRT.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g7Pc3.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($6cbd39251ee9e7e1$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $l998X.jsx)($6cbd39251ee9e7e1$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: replacedChildren
    });
}
function $6cbd39251ee9e7e1$var$isReactElement(child) {
    return !!child.type;
}
$6cbd39251ee9e7e1$var$Code.displayName = 'Code';
var $6cbd39251ee9e7e1$export$2e2bcd8739ae039 = $6cbd39251ee9e7e1$var$Code;
module.exports["default"] = $6cbd39251ee9e7e1$export$2e2bcd8739ae039;

});

parcelRegister("iS6Uy", function(module, exports) {
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $874fb90bacae98d1$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $874fb90bacae98d1$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $874fb90bacae98d1$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #357DE8)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #1558BC)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #2898BD)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #206A83)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #22A06B)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #216E4E)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FCA700)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #E06C00)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #C9372C)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #AE2E24)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #AF59E1)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #803FA5)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #7D818A)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #292A2E)" // source for hex code was legacy token N800
};
module.exports["hexToEditorTextPaletteColor"] = $874fb90bacae98d1$export$9c2f408d391feb93;

});

parcelRegister("bWiTS", function(module, exports) {
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $9d897280e134968c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ ['#F8E6A0']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #EED7FC)"
};
function $9d897280e134968c$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $9d897280e134968c$export$12a518ff137dd389[hexColor.toUpperCase()];
}
module.exports["hexToEditorTextBackgroundPaletteColor"] = $9d897280e134968c$export$8b58ff1b36bb75e0;

});

parcelRegister("lf9Ji", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iyDxB = parcelRequire("iyDxB");


var $6jPem = parcelRequire("6jPem");


var $jqXx5 = parcelRequire("jqXx5");

const $a3f798d5a25f20e6$var$NATIVE_EMBED_EXTENSION_KEY = 'native-embed';
const $a3f798d5a25f20e6$export$fdee1e5f1664414c = (adf)=>{
    let didTransform = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        extension: (node)=>{
            if (node.attrs?.['extensionKey'].split(':')[0] !== $a3f798d5a25f20e6$var$NATIVE_EMBED_EXTENSION_KEY) return node;
            const url = node.attrs?.['parameters']?.macroParams?.url?.value;
            if (!url) {
                didTransform = true;
                return false;
            }
            didTransform = true;
            return {
                type: 'paragraph',
                content: [
                    {
                        type: 'inlineCard',
                        attrs: {
                            url: url
                        }
                    }
                ]
            };
        }
    });
    if (didTransform && transformedAdf) try {
        const validate = (0, $jqXx5.validator)();
        const { valid: valid } = validate(transformedAdf);
        if (!valid) // Transformed ADF is invalid – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    } catch  {
        // Validation threw – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    }
    return {
        transformedAdf: transformedAdf,
        hasValidTransform: didTransform
    };
};


var $1LHXq = parcelRequire("1LHXq");

var $dDZcC = parcelRequire("dDZcC");


var $d925B = parcelRequire("d925B");


var $juTiU = parcelRequire("juTiU");

var $6aq5c = parcelRequire("6aq5c");


var $bSXAs = parcelRequire("bSXAs");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $2XqLN = parcelRequire("2XqLN");


var $59U23 = parcelRequire("59U23");


var $lWghV = parcelRequire("lWghV");

var $kOYZR = parcelRequire("kOYZR");







const $ac4164d5be644112$var$rendersMap = {};
const $ac4164d5be644112$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $kOYZR.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $lWghV.getAnalyticsAppearance)(item.appearance),
                platform: (0, $59U23.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $ac4164d5be644112$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $ac4164d5be644112$var$DEFAULT_SAMPLING_RATE = 100;
const $ac4164d5be644112$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$ac4164d5be644112$var$rendersMap[appearance]) $ac4164d5be644112$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $ac4164d5be644112$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $ac4164d5be644112$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $ac4164d5be644112$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($ac4164d5be644112$var$rendersMap[appearance].size === 1) $ac4164d5be644112$var$schedule(()=>$ac4164d5be644112$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($ac4164d5be644112$var$rendersMap[appearance].size % sampleRate === 0) $ac4164d5be644112$var$rendersMap[appearance] = new Set();
};



var $1Qaul = parcelRequire("1Qaul");

const $bb293804104002a3$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $bb293804104002a3$var$withStopwatch = (cb)=>{
    const startTime = $bb293804104002a3$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $bb293804104002a3$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $bb293804104002a3$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1LHXq.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $6aq5c.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $bSXAs.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $dDZcC.transformNestedTablesIncomingDocument)(result);
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $d925B.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    if (result && !(0, $1oCLl.expValEquals)('cc-maui-experiment', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_native_embeds_fallback_transform')) {
        const { transformedAdf: transformedAdf, hasValidTransform: hasValidTransform } = (0, $a3f798d5a25f20e6$export$fdee1e5f1664414c)(result);
        if (hasValidTransform && transformedAdf) {
            dispatchAnalyticsEvent?.({
                action: (0, $d925B.ACTION).NATIVE_EMBEDS_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    }
    return result;
};
const $bb293804104002a3$var$memoValidation = (0, $2XqLN.default)($bb293804104002a3$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ newSkipValidation, newValidationOverrides] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ oldSkipValidation, oldValidationOverrides] = lastArgs;
    return $bb293804104002a3$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb293804104002a3$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $bb293804104002a3$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $bb293804104002a3$var$memoSerializeFragment = (0, $2XqLN.default)($bb293804104002a3$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $bb293804104002a3$var$areDocsEqual(newDoc, oldDoc);
});
const $bb293804104002a3$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $59U23.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $bb293804104002a3$var$memoCreateNodeAndCheck = (0, $2XqLN.default)($bb293804104002a3$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $bb293804104002a3$var$areDocsEqual(newDoc, oldDoc);
});
const $bb293804104002a3$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $iyDxB.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    if ((0, $dh538.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $bb293804104002a3$var$withStopwatch(()=>{
        return $bb293804104002a3$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $bb293804104002a3$var$withStopwatch(()=>{
        return $bb293804104002a3$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $bb293804104002a3$var$withStopwatch(()=>{
        return $bb293804104002a3$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $juTiU.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $ac4164d5be644112$export$a43de96edd8d0a0)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $1Qaul.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};
module.exports["renderDocument"] = $bb293804104002a3$export$59a54f98b9753d5c;

});

parcelRegister("1LHXq", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

const $509946b00b1dc655$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
module.exports["transformMediaLinkMarks"] = $509946b00b1dc655$export$6528700f3fa2fe2a;

});

parcelRegister("kOYZR", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

var $c9985f9e1fc7d853$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $c9985f9e1fc7d853$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $c9985f9e1fc7d853$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $c9985f9e1fc7d853$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $c9985f9e1fc7d853$export$f9f8a29778652c3e.BLOCKING
    };
};
const $c9985f9e1fc7d853$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $6jPem.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $6jPem.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $c9985f9e1fc7d853$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $c9985f9e1fc7d853$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $c9985f9e1fc7d853$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $c9985f9e1fc7d853$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $c9985f9e1fc7d853$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};
module.exports["getUnsupportedContentLevelData"] = $c9985f9e1fc7d853$export$484b83e0462998d;

});

parcelRegister("9KIOh", function(module, exports) {
$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $b77f3940744feba2$export$20439b49fdd0d26c);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const { Provider: $b77f3940744feba2$export$20439b49fdd0d26c, Consumer: $b77f3940744feba2$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $b77f3940744feba2$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $42omo.useState)();
    return /*#__PURE__*/ (0, $l998X.jsx)($b77f3940744feba2$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};
module.exports["ActiveHeaderIdConsumer"] = $b77f3940744feba2$export$cddc3c6ebe2d2cec;

});

parcelRegister("fhm10", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $5gVJx = parcelRequire("5gVJx");

const $d6d0bc28331ae132$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $d6d0bc28331ae132$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $d6d0bc28331ae132$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $d6d0bc28331ae132$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $d6d0bc28331ae132$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $9K4OG.css)(">.mediaInlineView-content-wrap>.", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, ",>.", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $d6d0bc28331ae132$export$dee15762144889b7 = /*#__PURE__*/ (0, $9K4OG.css)(".", $d6d0bc28331ae132$export$dd2e16f83ae6aa78, "{height:", (0, $5gVJx.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h1'], -3), ";}h2{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h2'], -3), ";}h3{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h3'], -2), ";}h4{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h4'], -2), ";}h5{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h5'], -2), ";}h6{", $d6d0bc28331ae132$var$inlineImageHeight((0, $5gVJx.referenceHeights)['h6'], -2), ";}");
const $d6d0bc28331ae132$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$d6d0bc28331ae132$export$7ab34e219ce6eef}, ${(0, $5gVJx.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $d6d0bc28331ae132$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $9K4OG.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    outline: 'none'
});
const $d6d0bc28331ae132$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $9K4OG.css)({
    borderColor: `var(${$d6d0bc28331ae132$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$d6d0bc28331ae132$export$263a8a844c370a89}, ${(0, $5gVJx.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$d6d0bc28331ae132$export$263a8a844c370a89}, ${(0, $5gVJx.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});
module.exports["INLINE_IMAGE_WRAPPER_CLASS_NAME"] = $d6d0bc28331ae132$export$dd2e16f83ae6aa78;
module.exports["INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY"] = $d6d0bc28331ae132$export$7ab34e219ce6eef;
module.exports["INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY"] = $d6d0bc28331ae132$export$263a8a844c370a89;
module.exports["INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY"] = $d6d0bc28331ae132$export$b0d1f1e1fb3c4b46;
module.exports["wrapperStyle"] = $d6d0bc28331ae132$export$c4d4f06a25de97f;
module.exports["selectedStyle"] = $d6d0bc28331ae132$export$a7abb1b3dc25813f;
module.exports["borderStyle"] = $d6d0bc28331ae132$export$4d0a7f76ad443516;

});

parcelRegister("5gVJx", function(module, exports) {
const $34d61841b825d2c8$export$d722b7527b1834a8 = 250;
const $34d61841b825d2c8$export$da894f7669b4e67c = 200;
const $34d61841b825d2c8$export$286cf28b87ad4b4f = $34d61841b825d2c8$export$d722b7527b1834a8 / $34d61841b825d2c8$export$da894f7669b4e67c;
const $34d61841b825d2c8$export$64fe09732fb8680 = 0;
const $34d61841b825d2c8$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
module.exports["DEFAULT_IMAGE_WIDTH"] = $34d61841b825d2c8$export$d722b7527b1834a8;
module.exports["DEFAULT_IMAGE_HEIGHT"] = $34d61841b825d2c8$export$da894f7669b4e67c;
module.exports["DEFAULT_INLINE_IMAGE_ASPECT_RATIO"] = $34d61841b825d2c8$export$286cf28b87ad4b4f;
module.exports["DEFAULT_INLINE_IMAGE_BORDER_SIZE"] = $34d61841b825d2c8$export$64fe09732fb8680;
module.exports["referenceHeights"] = $34d61841b825d2c8$export$c1317a9224e4d798;

});

parcelRegister("7bDsi", function(module, exports) {
const $2d87519b5d393b3d$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
module.exports["DateSharedCssClassName"] = $2d87519b5d393b3d$export$99cdf122d0bb9f95;

});

parcelRegister("gnMzP", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");

const $1a978e7ea9233092$export$cfe6da7d522d87bb = 'rich-media-item';
const $1a978e7ea9233092$var$wrappedMediaBreakoutPoint = 410;
const $1a978e7ea9233092$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$1a978e7ea9233092$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $1a978e7ea9233092$export$b51dea84d928a378 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $aFUXX.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$1a978e7ea9233092$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-left, .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right + .${$1a978e7ea9233092$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$1a978e7ea9233092$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
module.exports["richMediaClassName"] = $1a978e7ea9233092$export$cfe6da7d522d87bb;

});

parcelRegister("cV5SN", function(module, exports) {
const $2775743fdfdf82a1$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
module.exports["SmartCardSharedCssClassName"] = $2775743fdfdf82a1$export$4ccd31bf665a88f6;

});

parcelRegister("7iisy", function(module, exports) {
const $d23ce9b4e7735d18$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
module.exports["TaskDecisionSharedCssClassName"] = $d23ce9b4e7735d18$export$a7172b75d403a0e4;

});

parcelRegister("j2w4t", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");

var $kPuBV = parcelRequire("kPuBV");


var $5MaNT = parcelRequire("5MaNT");


var $1tRSs = parcelRequire("1tRSs");


var $jVL42 = parcelRequire("jVL42");

const $223f15bdc9399d28$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $aFUXX.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            display: 'flex',
            borderRadius: "var(--ds-radius-small, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #292A2E)",
                borderRadius: "var(--ds-radius-small, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #6B6E76)",
            boxSizing: 'content-box'
        }
    }
});
const $223f15bdc9399d28$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    [`.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $223f15bdc9399d28$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $223f15bdc9399d28$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $jVL42.RendererCssClassName).DOCUMENT, ">.", $223f15bdc9399d28$export$afbde0e7339bed51.CONTAINER, " .", (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $aFUXX.blockNodesVerticalMargin), ";}");
};
const $223f15bdc9399d28$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $42omo.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $42omo.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $1tRSs.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $223f15bdc9399d28$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $kPuBV.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $223f15bdc9399d28$var$codeBlockSharedStyles,
            $223f15bdc9399d28$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        className: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("code", null, renderBidiWarnings(text))))));
});
var $223f15bdc9399d28$export$2e2bcd8739ae039 = $223f15bdc9399d28$var$LightWeightCodeBlock;
module.exports["LightWeightCodeBlockCssClassName"] = $223f15bdc9399d28$export$afbde0e7339bed51;
module.exports["default"] = $223f15bdc9399d28$export$2e2bcd8739ae039;

});

parcelRegister("1tRSs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $g7Pc3 = parcelRequire("g7Pc3");


var $7Rcde = parcelRequire("7Rcde");


var $03WRT = parcelRequire("03WRT");


var $1oCLl = parcelRequire("1oCLl");

const $1ac1bf4a86d18ce4$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $1cfRh.default)();
    const warningLabel = intl.formatMessage((0, $7Rcde.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return text;
        return (0, $03WRT.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g7Pc3.default), {
                bidiCharacter: bidiCharacter,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }, index));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};
module.exports["useBidiWarnings"] = $1ac1bf4a86d18ce4$export$9fb9fe546a188c7b;

});

parcelRegister("ilPbq", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $9202133f4d3acb51$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $9202133f4d3acb51$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $9202133f4d3acb51$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body.small': 'normal 400 0.875em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};


function $cf904c6b16edcd21$var$editorUGCToken(path) {
    let tokens;
    if ((0, $dh538.fg)('platform_editor_typography_ugc')) tokens = (0, $9202133f4d3acb51$export$63adc0ebe3278d31);
    else tokens = (0, $9202133f4d3acb51$export$4a3637dc6e2ae29e);
    return tokens[path];
}
var $cf904c6b16edcd21$export$2e2bcd8739ae039 = $cf904c6b16edcd21$var$editorUGCToken;
module.exports["default"] = $cf904c6b16edcd21$export$2e2bcd8739ae039;

});

parcelRegister("98HrB", function(module, exports) {

var $8hpYf = parcelRequire("8hpYf");

const $200d6bd4f803d466$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $8hpYf.emojiNodeStyles),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $8hpYf.emojiSprite),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $8hpYf.emojiImage),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $8hpYf.placeholder)
};
module.exports["EmojiSharedCssClassName"] = $200d6bd4f803d466$export$ee47248f9a998789;

});

parcelRegister("e6n00", function(module, exports) {
const $e31affe2f363c0cc$var$prefix = 'ak-editor-sync-block';
const $e31affe2f363c0cc$export$84840734cffb342f = {
    prefix: $e31affe2f363c0cc$var$prefix,
    renderer: `${$e31affe2f363c0cc$var$prefix}__renderer`,
    error: `${$e31affe2f363c0cc$var$prefix}__error_state`,
    loading: `${$e31affe2f363c0cc$var$prefix}__loading_state`
};
const $e31affe2f363c0cc$export$8c57d8325d08218b = 'data-sync-block-renderer';
const $e31affe2f363c0cc$var$bodiedPrefix = 'ak-editor-bodied-sync-block';
const $e31affe2f363c0cc$export$628f41eb22ec9a2 = {
    prefix: $e31affe2f363c0cc$var$bodiedPrefix,
    renderer: `${$e31affe2f363c0cc$var$bodiedPrefix}__renderer`,
    content: `${$e31affe2f363c0cc$var$bodiedPrefix}__content`,
    selectionInside: `${$e31affe2f363c0cc$var$bodiedPrefix}__selection_inside`
};
const $e31affe2f363c0cc$var$labelClassName = 'ak-editor-sync-block__label';
const $e31affe2f363c0cc$export$f75b6075afbd73af = {
    labelClassName: $e31affe2f363c0cc$var$labelClassName
};
const $e31affe2f363c0cc$export$7e44804769d54f36 = 'disabled';
const $e31affe2f363c0cc$export$da351099a95c41a2 = 'view-mode';
const $e31affe2f363c0cc$export$ddb90512ea536019 = 'creation-loading';
const $e31affe2f363c0cc$export$52ab9fe57e8e4c2e = 'user-is-dragging';
const $e31affe2f363c0cc$export$9b10dd4c500e3ce8 = {
    disabledClassName: $e31affe2f363c0cc$export$7e44804769d54f36,
    viewModeClassName: $e31affe2f363c0cc$export$da351099a95c41a2,
    creationLoadingClassName: $e31affe2f363c0cc$export$ddb90512ea536019,
    draggingClassName: $e31affe2f363c0cc$export$52ab9fe57e8e4c2e
};
module.exports["SyncBlockSharedCssClassName"] = $e31affe2f363c0cc$export$84840734cffb342f;
module.exports["SyncBlockRendererDataAttributeName"] = $e31affe2f363c0cc$export$8c57d8325d08218b;
module.exports["BodiedSyncBlockSharedCssClassName"] = $e31affe2f363c0cc$export$628f41eb22ec9a2;
module.exports["SyncBlockLabelSharedCssClassName"] = $e31affe2f363c0cc$export$f75b6075afbd73af;
module.exports["SyncBlockStateCssClassName"] = $e31affe2f363c0cc$export$9b10dd4c500e3ce8;

});

parcelRegister("eauJy", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5e9b251857e7eb9b$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
function $5e9b251857e7eb9b$export$b1072f43c67b540c(props) {
    const portalFromContext = (0, $42omo.useContext)($5e9b251857e7eb9b$export$60d741e20e0aa309);
    return props?.portal || portalFromContext;
}
module.exports["PortalContext"] = $5e9b251857e7eb9b$export$60d741e20e0aa309;
module.exports["usePortal"] = $5e9b251857e7eb9b$export$b1072f43c67b540c;

});

parcelRegister("e2wMq", function(module, exports) {
var $c8d6368806133d17$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $c8d6368806133d17$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $c8d6368806133d17$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $c8d6368806133d17$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});
module.exports["PLATFORMS"] = $c8d6368806133d17$export$a8d23193462f2b63;
module.exports["MODE"] = $c8d6368806133d17$export$e48589d9e4824227;
module.exports["FULL_WIDTH_MODE"] = $c8d6368806133d17$export$57453495b81e2dde;
module.exports["BROWSER_FREEZE_INTERACTION_TYPE"] = $c8d6368806133d17$export$60a219cfaef9722;

});

parcelRegister("3824I", function(module, exports) {
var $fa05b1e32f887e46$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    TABLE_ACTION["DRAG_MENU_OPENED"] = "dragMenuOpened";
    /**
	 * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
	 * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
	 */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    TABLE_ACTION["TABLE_EDITOR_HEIGHT_INFO"] = "tableEditorHeightInformation";
    TABLE_ACTION["TABLE_RENDERER_HEIGHT_INFO"] = "tableRendererHeightInformation";
    TABLE_ACTION["STICKY_HEADER_METHOD_TOGGLED"] = "stickyHeaderMethodToggled";
    return TABLE_ACTION;
}({});
var $fa05b1e32f887e46$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $fa05b1e32f887e46$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $fa05b1e32f887e46$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $fa05b1e32f887e46$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $fa05b1e32f887e46$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});
module.exports["TABLE_ACTION"] = $fa05b1e32f887e46$export$1627223e090990cf;
module.exports["TABLE_OVERFLOW_CHANGE_TRIGGER"] = $fa05b1e32f887e46$export$e0b2ad636c1c8ab4;
module.exports["TABLE_STATUS"] = $fa05b1e32f887e46$export$90dde066fa32cf2f;
module.exports["TABLE_DISPLAY_MODE"] = $fa05b1e32f887e46$export$a62a68f32aa71693;
module.exports["CHANGE_ALIGNMENT_REASON"] = $fa05b1e32f887e46$export$ba2dfc055a59d951;

});

parcelRegister("2jkq1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $1zav4 = parcelRequire("1zav4");


var $2CQVV = parcelRequire("2CQVV");


var $frt7o = parcelRequire("frt7o");

var $bWRlG = parcelRequire("bWRlG");


var $dh538 = parcelRequire("dh538");


var $cN8vw = parcelRequire("cN8vw");

var $caYZ2 = parcelRequire("caYZ2");

var $d4WtM = parcelRequire("d4WtM");


var $2QYOD = parcelRequire("2QYOD");


var $aFUXX = parcelRequire("aFUXX");


var $6fQl1 = parcelRequire("6fQl1");


var $iu6m9 = parcelRequire("iu6m9");


var $1zvWv = parcelRequire("1zvWv");


var $iKFPk = parcelRequire("iKFPk");


var $bZfVt = parcelRequire("bZfVt");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");
















parcelRequire("42omo");













/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $bBvs5 = parcelRequire("bBvs5");

const $a5ed469e3634fc57$export$90335b3ff08f335 = ()=>(0, $bBvs5.useRendererContext)()?.featureFlags;









var $1oCLl = parcelRequire("1oCLl");

// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $90b28d79aa634748$var$MAX_SCALING_PERCENT = 0.3;
const $90b28d79aa634748$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $90b28d79aa634748$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $90b28d79aa634748$var$fixColumnWidth = ({ columnWidth: columnWidth, zeroWidthColumnsCount: zeroWidthColumnsCount, scaleDownPercent: scaleDownPercent })=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $1zav4.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $1zav4.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $aFUXX.akEditorTableLegacyCellMinWidth) : (0, $1zav4.tableCellMinWidth));
};
const $90b28d79aa634748$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $aFUXX.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $aFUXX.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $90b28d79aa634748$export$2d9bdaa5b8cd99f0 = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $90b28d79aa634748$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    if (!columnWidths || columnWidths.every((width)=>width === 0) && (0, $dh538.fg)('platform_editor_numbered_column_in_include')) return [];
    const tableColumnResized = $90b28d79aa634748$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested && (!(0, $dh538.fg)('platform_fix_nested_num_column_scaling') || !isNumberColumnEnabled) ? renderWidth : (0, $6fQl1.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $90b28d79aa634748$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        const scalePercentage = +((calculatedTableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        const targetMaxWidth = calculatedTableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $1zav4.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $1zav4.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $aFUXX.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $aFUXX.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $90b28d79aa634748$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $90b28d79aa634748$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $aFUXX.akEditorTableLegacyCellMinWidth) ? (0, $aFUXX.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $90b28d79aa634748$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: (0, $dh538.fg)('platform-ssr-table-resize') ? maxScalingPercent : shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0)) {
        const fixedColWidths = targetWidths.map((width)=>$90b28d79aa634748$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent
            }) || cellMinWidth);
        const sumFixedColumnWidths = $90b28d79aa634748$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map((colWidth)=>{
            const width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $aFUXX.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: `${width / sumFixedColumnWidths * 100}%`
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                const style = width ? {
                    width: `${width}px`
                } : {};
                return style;
            }
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $90b28d79aa634748$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent
        }) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $90b28d79aa634748$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $bBvs5.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $a5ed469e3634fc57$export$90335b3ff08f335)();
    if (!columnWidths) return null;
    const isTableFixedColumnWidthsOptionEnabled = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? props.allowFixedColumnWidthOption : flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) ?? false;
    const colStyles = $90b28d79aa634748$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) || props.rendererAppearance === 'comment' && (0, $iu6m9.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $iu6m9.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)))
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $l998X.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $aFUXX.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};











const $f71f60011122dddb$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption = false })=>{
    let tableWidth = tableNode ? (0, $6fQl1.getTableContainerWidth)(tableNode) : (0, $aFUXX.akEditorDefaultLayoutWidth);
    let tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $dh538.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') {
        if ((0, $dh538.fg)('platform-ssr-table-resize')) tableColumnWidths = columnWidths && (0, $90b28d79aa634748$export$2d9bdaa5b8cd99f0)(columnWidths) ? columnWidths : undefined;
    }
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, $l998X.jsxs)("table", {
        ...(0, $dh538.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        },
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $90b28d79aa634748$export$89efc2d0ceeaa030), {
                columnWidths: tableColumnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing,
                allowFixedColumnWidthOption: allowFixedColumnWidthOption
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("tbody", {
                children: children
            })
        ]
    });
});





function $5b4b0ffc2cc8f5f6$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            children: $5b4b0ffc2cc8f5f6$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, propsToInject);
    });
}


function $a9ad1d399ee36b19$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a9ad1d399ee36b19$export$3de6413b528017ca = 8;
const $a9ad1d399ee36b19$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $a9ad1d399ee36b19$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, #FFFFFF)"
        }
    },
    borderTop: `${$a9ad1d399ee36b19$export$3de6413b528017ca}px solid ${"var(--ds-surface, #FFFFFF)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    boxShadow: `0 6px 4px -4px ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $a9ad1d399ee36b19$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $aFUXX.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $a9ad1d399ee36b19$var$fixedTableDivStaticStyles,
            $a9ad1d399ee36b19$var$modeSpecficStyles?.[mode]
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: typeof top === 'number' ? `${top}px` : undefined
        }
    }, props.children);
};
const $a9ad1d399ee36b19$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($a9ad1d399ee36b19$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f71f60011122dddb$export$54ec01a60f47d33d), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $5b4b0ffc2cc8f5f6$export$40e12ce8e0a76b0c)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $a9ad1d399ee36b19$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $a9ad1d399ee36b19$export$e97bc6692974bd0b {
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $a9ad1d399ee36b19$export$e97bc6692974bd0b($a9ad1d399ee36b19$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    addEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    removeEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
}



const $32a0d933940b97cc$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $32a0d933940b97cc$export$ab050440a1241762 = (appearance)=>appearance === 'max';
const $32a0d933940b97cc$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $32a0d933940b97cc$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $32a0d933940b97cc$export$33331a99fac775a1 = (appearance)=>$32a0d933940b97cc$export$a64737a81cde10b4(appearance) || $32a0d933940b97cc$export$c0112b8340d4924b(appearance) || $32a0d933940b97cc$export$ab050440a1241762(appearance);








class $f6f7c885cc4b0838$export$8c072780619cfc83 {
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        const scrollbarContainers = this.wrapper.parentElement?.querySelectorAll(`.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @atlaskit/platform/valid-gate-name
        this.stickyScrollbarContainerElement = (0, $dh538.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers?.item(scrollbarContainers.length - 1) : this.wrapper.parentElement?.querySelector(`.${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/platform/valid-gate-name
        this.sentinels.bottom = (0, $dh538.fg)('platform_editor_querySelector_fix_table_renderer') ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        bottomSentinels?.item(bottomSentinels.length - 1) : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.wrapper?.parentElement?.getElementsByClassName((0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
    constructor(wrapper){
        this.wrapper = void 0;
        this.rendererScrollableElement = void 0;
        this.intersectionObserver = void 0;
        this.stickyScrollbarContainerElement = void 0;
        this.sentinels = {};
        this.topSentinelState = void 0;
        this.bottomSentinelState = void 0;
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
}


/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 











































const $24d26e13c81033f3$var$stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
const $24d26e13c81033f3$var$stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $24d26e13c81033f3$export$eec82c0a93aa66d9 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) || (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(appearance) && (0, $iu6m9.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $24d26e13c81033f3$export$bdb2dadcb04aad50 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) && (0, $iu6m9.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $24d26e13c81033f3$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $2QYOD.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $d4WtM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $caYZ2.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $24d26e13c81033f3$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $24d26e13c81033f3$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $24d26e13c81033f3$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $24d26e13c81033f3$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $24d26e13c81033f3$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $24d26e13c81033f3$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $iKFPk.TableHeader);
    return children.every((node)=>node.type === (0, $iKFPk.TableHeader));
};
const $24d26e13c81033f3$export$940095e914312886 = (node, children)=>{
    return $24d26e13c81033f3$export$28daf78feed5098c(children) && node && node.firstChild && !$24d26e13c81033f3$export$42f5658c8e0092da(node.firstChild);
};
class $24d26e13c81033f3$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $f6f7c885cc4b0838$export$8c072780619cfc83)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $1zav4.tableMarginTop) - (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $aFUXX.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const fullPageRendererWidthCSS = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $1zvWv.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'max' && !tableNode?.attrs.width && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) return `min(${0, $aFUXX.akEditorMaxWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return `min(${0, $aFUXX.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLengthCSS = `min(${(0, $aFUXX.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $32a0d933940b97cc$export$ab050440a1241762)(rendererAppearance) && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $6fQl1.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) || (0, $32a0d933940b97cc$export$ab050440a1241762)(rendererAppearance) && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max' && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $aFUXX.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                "data-testid": "table-container",
                ref: this.props.handleRef,
                style: style,
                children: [
                    $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && tableNode && $24d26e13c81033f3$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $l998X.jsx)((0, $a9ad1d399ee36b19$export$fd9654fc359d55a3), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: "inherit",
                        renderWidth: 0,
                        layout: layout,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        fixTableSSRResizing: true,
                        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        "data-number-column": tableNode?.attrs.isNumberColumnEnabled,
                        "data-layout": tableNode?.attrs.layout,
                        "data-autosize": tableNode?.attrs.__autoSize,
                        "data-table-local-id": tableNode?.attrs.localId,
                        "data-table-width": tableNode?.attrs.width,
                        "data-vc": "table-node-wrapper",
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f71f60011122dddb$export$54ec01a60f47d33d), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            renderWidth: 0,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}${(0, $dh538.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''}`,
                        ref: this.stickyScrollbarRef,
                        "data-vc": "table-sticky-scrollbar-container",
                        style: (0, $dh538.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? {
                            ...$24d26e13c81033f3$var$stickyContainerBaseStyles,
                            ...$24d26e13c81033f3$var$stickyContainerAdditionalStyles
                        } : $24d26e13c81033f3$var$stickyContainerBaseStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            style: {
                                width: (0, $dh538.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $24d26e13c81033f3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        };
        this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbar = void 0;
        this.nextFrame = void 0;
        this.overflowParent = null;
        this.updatedLayout = 'custom';
        this.resizeObserver = null;
        this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        };
        this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        };
        this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        };
        this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
            const tableTop = $24d26e13c81033f3$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $24d26e13c81033f3$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $24d26e13c81033f3$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        };
        this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        };
        this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        };
        this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $24d26e13c81033f3$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children);
        const orderedChildren = (0, $cN8vw.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $l998X.jsx)($24d26e13c81033f3$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            tableOrderStatus: undefined
        };
        // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $24d26e13c81033f3$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $caYZ2.hasMergedCell)(tableNode)) return $24d26e13c81033f3$export$100baa0f10804e6e($24d26e13c81033f3$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        };
        this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $24d26e13c81033f3$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}





const $8cb6dda2f8b04521$export$eec82c0a93aa66d9 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) || (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(appearance) && (0, $iu6m9.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $8cb6dda2f8b04521$export$bdb2dadcb04aad50 = (appearance)=>(0, $32a0d933940b97cc$export$33331a99fac775a1)(appearance) && (0, $iu6m9.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $8cb6dda2f8b04521$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $2QYOD.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $d4WtM.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $caYZ2.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $8cb6dda2f8b04521$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $8cb6dda2f8b04521$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $8cb6dda2f8b04521$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $8cb6dda2f8b04521$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $8cb6dda2f8b04521$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $8cb6dda2f8b04521$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $iKFPk.TableHeader);
    return children.every((node)=>node.type === (0, $iKFPk.TableHeader));
};
/**
 * This TableWrapper component was created to make sure that the aria-label can be
 * internationalized without needing to add `intl` to the TableContainer.
 *
 * <TableWrapper wrapperRef={ref} onScroll={handleScroll} stickyHeaders={config}>
 *   <Table>...</Table>
 * </TableWrapper>
 */ const $8cb6dda2f8b04521$var$TableWrapper = ({ children: children, wrapperRef: wrapperRef, onScroll: onScroll, stickyHeaders: stickyHeaders, tabIndex: tabIndex })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const isScrollableRegion = tabIndex !== undefined && (0, $1oCLl.expValEquals)('platform_editor_a11y_table_wrapper_fix', 'isEnabled', true);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER,
        ref: wrapperRef,
        onScroll: stickyHeaders ? onScroll : undefined,
        // Adding tabIndex here because this is a scrollable container and it needs to be focusable so keyboard users can scroll it.
        // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
        tabIndex: tabIndex,
        role: isScrollableRegion ? 'region' : undefined,
        "aria-label": isScrollableRegion ? formatMessage((0, $2CQVV.messages).tableScrollRegion) : undefined,
        children: children
    });
};
const $8cb6dda2f8b04521$export$940095e914312886 = (node, children)=>{
    return $8cb6dda2f8b04521$export$28daf78feed5098c(children) && node && node.firstChild && !$8cb6dda2f8b04521$export$42f5658c8e0092da(node.firstChild);
};
class $8cb6dda2f8b04521$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $f6f7c885cc4b0838$export$8c072780619cfc83)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $a9ad1d399ee36b19$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $1zav4.tableMarginTop) - (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $aFUXX.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const fullPageRendererWidthCSS = (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $1zvWv.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $aFUXX.akEditorFullWidthLayoutWidth), renderWidth) : (0, $aFUXX.akEditorFullWidthLayoutWidth),
                `min(${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'max' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $aFUXX.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $aFUXX.akEditorMaxWidthLayoutWidth),
                `min(${(0, $aFUXX.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $aFUXX.akEditorFullWidthLayoutWidth), renderWidth) : (0, $aFUXX.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $aFUXX.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLength = isRenderWidthValid ? Math.min((0, $aFUXX.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $aFUXX.akEditorMaxWidthLayoutWidth);
        const maxWidthLineLengthCSS = `min(${(0, $aFUXX.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $32a0d933940b97cc$export$f77d2ff45b2c53ed)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLength : (0, $32a0d933940b97cc$export$ab050440a1241762)(rendererAppearance) && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $32a0d933940b97cc$export$ab050440a1241762)(rendererAppearance) && ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $6fQl1.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $32a0d933940b97cc$export$c0112b8340d4924b)(rendererAppearance) || ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && (0, $32a0d933940b97cc$export$ab050440a1241762)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $32a0d933940b97cc$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $aFUXX.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        let style;
        if (fixTableSSRResizing) style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $1zav4.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                children: [
                    $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && $8cb6dda2f8b04521$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $l998X.jsx)((0, $a9ad1d399ee36b19$export$fd9654fc359d55a3), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: tableWidth,
                        layout: layout,
                        renderWidth: renderWidth,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($8cb6dda2f8b04521$var$TableWrapper, {
                        wrapperRef: this.wrapperRef,
                        onScroll: this.props.stickyHeaders ? this.onWrapperScrolled : undefined,
                        stickyHeaders: stickyHeaders,
                        tabIndex: this.props.tabIndex,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f71f60011122dddb$export$54ec01a60f47d33d), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                        ref: this.stickyScrollbarRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: "var(--ds-space-250, 20px)",
                            // MAX_BROWSER_SCROLLBAR_HEIGHT
                            // Follow editor to hide by default so it does not show empty gap in SSR
                            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            display: fixTableSSRResizing ? 'none' : 'block',
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            style: {
                                width: this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $8cb6dda2f8b04521$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $1zav4.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        };
        this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.stickyScrollbar = void 0;
        this.nextFrame = void 0;
        this.overflowParent = null;
        this.resizeObserver = null;
        this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        };
        this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        };
        this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        };
        this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $a9ad1d399ee36b19$export$3de6413b528017ca);
            const tableTop = $8cb6dda2f8b04521$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $8cb6dda2f8b04521$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $8cb6dda2f8b04521$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        };
        this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        };
        this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        };
        this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $8cb6dda2f8b04521$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children);
        const orderedChildren = (0, $cN8vw.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $l998X.jsx)($8cb6dda2f8b04521$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            tableOrderStatus: undefined
        };
        // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $8cb6dda2f8b04521$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $caYZ2.hasMergedCell)(tableNode)) return $8cb6dda2f8b04521$export$100baa0f10804e6e($8cb6dda2f8b04521$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        };
        this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $8cb6dda2f8b04521$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cb6dda2f8b04521$var$TableWithShadowsAndContainerStyles = (0, $frt7o.default)((0, $24d26e13c81033f3$export$827f89182557f335), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8cb6dda2f8b04521$var$TableWithShadows = (0, $frt7o.default)($8cb6dda2f8b04521$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $1zav4.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $8cb6dda2f8b04521$var$TableWithWidth = (props)=>{
    if ((0, $dh538.fg)('platform-ssr-table-resize')) {
        const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $l998X.jsx)($8cb6dda2f8b04521$var$TableWithShadowsAndContainerStyles, {
            ...props
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $24d26e13c81033f3$export$827f89182557f335), {
            ...props
        });
    } else return /*#__PURE__*/ (0, $l998X.jsx)((0, $bWRlG.WidthConsumer), {
        children: ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $1zvWv.FullPagePadding) * 2 : width;
            const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
            props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $l998X.jsx)($8cb6dda2f8b04521$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
            return /*#__PURE__*/ (0, $l998X.jsx)($8cb6dda2f8b04521$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        }
    });
};
const $8cb6dda2f8b04521$var$_default_1 = (0, $bZfVt.withSmartCardStorage)($8cb6dda2f8b04521$var$TableWithWidth);
var $8cb6dda2f8b04521$export$2e2bcd8739ae039 = $8cb6dda2f8b04521$var$_default_1;
module.exports["isTableResizingEnabled"] = $8cb6dda2f8b04521$export$eec82c0a93aa66d9;
module.exports["isStickyScrollbarEnabled"] = $8cb6dda2f8b04521$export$bdb2dadcb04aad50;
module.exports["default"] = $8cb6dda2f8b04521$export$2e2bcd8739ae039;

});

parcelRegister("iNqGB", function(module, exports) {
function $44e243c4cf2c5688$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $44e243c4cf2c5688$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$44e243c4cf2c5688$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}
module.exports["isNestedHeaderLinksEnabled"] = $44e243c4cf2c5688$export$7aa7587d1ce9583c;
module.exports["getActiveHeadingId"] = $44e243c4cf2c5688$export$acb253d79d72af92;

});

parcelRegister("GH4gU", function(module, exports) {
$parcel$export(module.exports, "default", () => $37d44366a8af079c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cs1vW = parcelRequire("cs1vW");


var $lwZHY = parcelRequire("lwZHY");


var $7Rcde = parcelRequire("7Rcde");

const $37d44366a8af079c$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $37d44366a8af079c$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $7Rcde.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lwZHY.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
var $37d44366a8af079c$export$2e2bcd8739ae039 = (0, $cs1vW.default)($37d44366a8af079c$export$7cea6ffa7022e85f);
module.exports["isCodeMark"] = $37d44366a8af079c$export$86390c02c110ec2f;

});

parcelRegister("hMQQ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $eaea92635c0e0d50$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $eaea92635c0e0d50$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $l998X.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("g5cj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a08d476a56fd0b1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $dh538 = parcelRequire("dh538");


var $b7FrM = parcelRequire("b7FrM");


var $59U23 = parcelRequire("59U23");


var $d925B = parcelRequire("d925B");


var $hn4RR = parcelRequire("hn4RR");


var $bYRk6 = parcelRequire("bYRk6");

function $0a08d476a56fd0b1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0a08d476a56fd0b1$var$anchorStyles = {
    name: "sa5fy1",
    styles: "color:var(--ds-link, #1868DB);&:hover{color:var(--ds-link, #1868DB);text-decoration:underline;}&:active{color:var(--ds-link-pressed, #1558BC);}"
};
function $0a08d476a56fd0b1$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, onSetLinkTarget: onSetLinkTarget, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    let actualTarget = target;
    if (onSetLinkTarget && href && (0, $dh538.fg)('rovo_chat_deep_linking_enabled')) try {
        actualTarget = onSetLinkTarget(href) ?? actualTarget;
    } catch (error) {
    // eslint-disable-line no-unused-vars
    // If URL parsing fails, use the original target
    }
    const anchorProps = {
        href: href,
        target: actualTarget,
        title: href
    };
    if (actualTarget === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $b7FrM.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bYRk6.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hn4RR.default), {
        css: $0a08d476a56fd0b1$var$anchorStyles,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $d925B.ACTION).VISITED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).LINK,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    mode: (0, $59U23.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        isLinkComponent: true,
        enableResolve: true
    }, props.children));
}

});

parcelRegister("jyYl7", function(module, exports) {
$parcel$export(module.exports, "default", () => $91cd5902b10cc40d$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $91cd5902b10cc40d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("cHFH7", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfc5c059d1a31794$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $dfc5c059d1a31794$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $l998X.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("2KFEz", function(module, exports) {
$parcel$export(module.exports, "default", () => $5be0c346e0e6a7c7$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $5be0c346e0e6a7c7$var$isSub = (type)=>{
    return type === 'sub';
};
function $5be0c346e0e6a7c7$export$2e2bcd8739ae039(props) {
    if ($5be0c346e0e6a7c7$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("6wVZ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $e65feb0aaa1b4075$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aDU6C = parcelRequire("aDU6C");


var $iS6Uy = parcelRequire("iS6Uy");


var $cOrQJ = parcelRequire("cOrQJ");

function $e65feb0aaa1b4075$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $iS6Uy.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $iS6Uy.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $aDU6C.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $42omo.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});

parcelRegister("4XjCW", function(module, exports) {
$parcel$export(module.exports, "default", () => $477b09df0a03f691$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aDU6C = parcelRequire("aDU6C");


var $bWiTS = parcelRequire("bWiTS");


var $cOrQJ = parcelRequire("cOrQJ");

function $477b09df0a03f691$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $aDU6C.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $42omo.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    if (props.isStandalone) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "background-color-padding-left background-color-padding-right",
            children: props.children
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});

parcelRegister("6ObvC", function(module, exports) {
$parcel$export(module.exports, "default", () => $94828f1f255f279b$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $94828f1f255f279b$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("hJ84o", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3ec42e144727e1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $iu6m9 = parcelRequire("iu6m9");


var $1oCLl = parcelRequire("1oCLl");


var $jVL42 = parcelRequire("jVL42");

function $c3ec42e144727e1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Legacy centering (breaks position: sticky in nested content).
const $c3ec42e144727e1e$var$legacyWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
const $c3ec42e144727e1e$var$flexWrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0`
});
// Flex item: no vertical margin so flex container height = content height (matches legacy single-wrapper height).
// flexShrink: 0 so the inner div keeps its width (matches legacy behaviour; flex items default to flex-shrink: 1).
const $c3ec42e144727e1e$var$innerWrapperStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $c3ec42e144727e1e$var$getWidth = (width, mode)=>{
    if ((0, $iu6m9.editorExperiment)('advanced_layouts', true) && width) return `min(${width}px, var(--ak-editor--breakout-container-without-gutter-width))`;
    else {
        if ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) {
            if (mode === 'max' || typeof width === 'number' && width >= (0, $aFUXX.akEditorFullWidthLayoutWidth)) return `min(${0, $aFUXX.akEditorMaxLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        }
        if (mode === 'full-width') return `min(${0, $aFUXX.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        if (mode === 'wide') return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))`;
    }
};
function $c3ec42e144727e1e$export$2e2bcd8739ae039(props) {
    const width = $c3ec42e144727e1e$var$getWidth('width' in props ? props.width : null, props.mode);
    const useStickySafeCentering = (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
    if (useStickySafeCentering) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER,
        css: $c3ec42e144727e1e$var$flexWrapperStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $c3ec42e144727e1e$var$innerWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $jVL42.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} fabric-editor-breakout-mark fabric-editor-block-mark`,
        "data-mode": props.mode,
        ...(0, $iu6m9.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: width
        }
    }, props.children));
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $c3ec42e144727e1e$var$legacyWrapperStyles,
        "data-mode": props.mode,
        ...(0, $iu6m9.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: $c3ec42e144727e1e$var$getWidth('width' in props ? props.width : null, props.mode)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-breakout-mark fabric-editor-block-mark"
    }, props.children);
}

});

parcelRegister("9DaqG", function(module, exports) {
$parcel$export(module.exports, "default", () => $624960bf79edb235$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $624960bf79edb235$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("gwCgB", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb8a383b3d03d76f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $fb8a383b3d03d76f$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("118BP", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bcfe8463d12ab19$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $0bcfe8463d12ab19$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $l998X.jsx)(WrapperElement, {
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("a6ktG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cff835241e99f05$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $0cff835241e99f05$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $l998X.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("5UG0R", function(module, exports) {
$parcel$export(module.exports, "default", () => $3be8fe9cdede03f9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $3be8fe9cdede03f9$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("kzW3z", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bc77e7590ca73fa$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $0bc77e7590ca73fa$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-font-size",
        "data-font-size": props.fontSize,
        children: props.children
    });
}

});

parcelRegister("8FDtv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce0be8c2097fd490$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $ce0be8c2097fd490$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("blockquote", {
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("bHs3B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $k8515 = parcelRequire("k8515");


var $fZRom = parcelRequire("fZRom");


var $5VmpF = parcelRequire("5VmpF");


var $gi5bC = parcelRequire("gi5bC");


var $d925B = parcelRequire("d925B");


var $d7o2V = parcelRequire("d7o2V");


var $iZq0X = parcelRequire("iZq0X");

const $10ef4e12f0998137$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes, localId: localId, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const validationContextValue = (0, $42omo.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fZRom.ErrorBoundary), {
        component: (0, $gi5bC.ACTION_SUBJECT).RENDERER,
        componentId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d7o2V.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iZq0X.ValidationContextProvider), {
                value: validationContextValue,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5VmpF.default), {
                    ...props,
                    type: "bodiedExtension",
                    children: ({ node: node, result: result })=>{
                        try {
                            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                            return (0, $k8515.renderExtension)(result, layout, {
                                isTopLevel: path.length < 1,
                                rendererAppearance: props.rendererAppearance
                            }, removeOverflow, parameters?.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
                        } catch  {
                        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                        // Always return default content if anything goes wrong
                        return (0, $k8515.renderExtension)(children, layout, {
                            isTopLevel: path.length < 1,
                            rendererAppearance: props.rendererAppearance
                        }, removeOverflow, parameters?.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
                    }
                })
            })
        })
    });
};
var $10ef4e12f0998137$export$2e2bcd8739ae039 = $10ef4e12f0998137$var$BodiedExtension;
module.exports["default"] = $10ef4e12f0998137$export$2e2bcd8739ae039;

});

parcelRegister("1acNj", function(module, exports) {
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $bWRlG = parcelRequire("bWRlG");


var $jVL42 = parcelRequire("jVL42");


var $fJNzZ = parcelRequire("fJNzZ");




const $412f9b1c55f8103a$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            removeChild (_index) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};






var $2XqLN = parcelRequire("2XqLN");


var $heH5c = parcelRequire("heH5c");


var $6mbqi = parcelRequire("6mbqi");

const $f289f2207b4baf8b$export$e55394818db35473 = ({ extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $2XqLN.default)((0, $heH5c.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const providerPromise = (0, $6mbqi.useProvider)('extensionProvider');
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $heH5c.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const NodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!provider || !NodeRenderer || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: NodeRenderer,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        provider,
        NodeRenderer,
        privateProps
    ]);
};



var $1oCLl = parcelRequire("1oCLl");


var $2W3B8 = parcelRequire("2W3B8");

function $001e619277309332$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $001e619277309332$var$containerStyles = {
    name: "hwppun",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}&:first-child > .ak-renderer-sticky-safe-center-wrapper{margin-top:0;}"
};
const $001e619277309332$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $001e619277309332$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $001e619277309332$var$MultiBodiedExtensionWrapperLegacy = ({ width: width, path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $fJNzZ.calcBreakoutWidth)(layout, width) : (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $001e619277309332$var$MultiBodiedExtensionWrapperNext = ({ path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2W3B8.calcBreakoutWidthCss)(layout) : (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $001e619277309332$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, content: content, marks: marks, localId: localId, rendererAppearance: rendererAppearance } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $42omo.useState)(0);
    const { loading: loading, extensionContext: extensionContext } = (0, $f289f2207b4baf8b$export$e55394818db35473)({
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $412f9b1c55f8103a$export$3c7139d93ecb4f1f)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext?.privateProps?.__allowBodiedOverride
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $9K4OG.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $9K4OG.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    if ((0, $1oCLl.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        const isTopLevel = path.length < 1;
        const useCenterWrapper = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) && (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const wrapper = /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionWrapperNext, {
            layout: layout,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return /*#__PURE__*/ (0, $9K4OG.jsx)("section", {
            css: [
                $001e619277309332$var$containerStyles,
                containerActiveFrameStyles
            ],
            "data-testid": "multiBodiedExtension--container",
            "data-multiBodiedExtension-container": true,
            "data-active-child-index": activeChildIndex,
            "data-layout": layout,
            "data-local-id": localId,
            "data-node-type": "multiBodiedExtension"
        }, useCenterWrapper ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper);
    }
    const isTopLevel = path.length < 1;
    const useCenterWrapper = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("section", {
        css: [
            $001e619277309332$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>{
        const wrapper = /*#__PURE__*/ (0, $9K4OG.jsx)($001e619277309332$var$MultiBodiedExtensionWrapperLegacy, {
            layout: layout,
            width: width,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return useCenterWrapper ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper;
    }));
};
var $001e619277309332$export$2e2bcd8739ae039 = $001e619277309332$var$MultiBodiedExtension;
module.exports["default"] = $001e619277309332$export$2e2bcd8739ae039;

});

parcelRegister("l5RsK", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

const $ef229c57415fc2fe$var$containerCSS = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $ef229c57415fc2fe$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $ef229c57415fc2fe$var$containerCSS
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $ef229c57415fc2fe$export$2e2bcd8739ae039 = $ef229c57415fc2fe$var$ExtensionFrame;
module.exports["default"] = $ef229c57415fc2fe$export$2e2bcd8739ae039;

});

parcelRegister("4aPtv", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a60824ddd9f14a5$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ghpxT = parcelRequire("ghpxT");


var $drJ23 = parcelRequire("drJ23");

function $6a60824ddd9f14a5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ghpxT.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $drJ23.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});

parcelRegister("8jc2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $61eb98cf96d6d9e9$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jVL42 = parcelRequire("jVL42");


var $d925B = parcelRequire("d925B");


var $42omo = parcelRequire("42omo");


var $6uN0A = parcelRequire("6uN0A");

class $6ae1df30d2a89e31$export$6e6724d89f27411 {
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $6ae1df30d2a89e31$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $6ae1df30d2a89e31$export$6e6724d89f27411(win.getSelection());
    }
    constructor(selection){
        this.type = void 0;
        this.range = void 0;
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
}


const $24fdc3f18020be27$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $6uN0A.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $6ae1df30d2a89e31$export$6e6724d89f27411).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                action: (0, $d925B.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                action: (0, $d925B.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};


function $61eb98cf96d6d9e9$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $jVL42.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $61eb98cf96d6d9e9$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: (0, $24fdc3f18020be27$export$98871b245ee25215)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jVL42.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
module.exports["DocWithSelectAllTrap"] = $61eb98cf96d6d9e9$export$41121a410ca2f650;

});

parcelRegister("k8515", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $5VmpF = parcelRequire("5VmpF");


var $frt7o = parcelRequire("frt7o");

var $bWRlG = parcelRequire("bWRlG");


var $fJNzZ = parcelRequire("fJNzZ");


var $jVL42 = parcelRequire("jVL42");


var $1oCLl = parcelRequire("1oCLl");


var $2W3B8 = parcelRequire("2W3B8");


var $dh538 = parcelRequire("dh538");

function $eb61561689376623$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $eb61561689376623$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $eb61561689376623$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $eb61561689376623$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $eb61561689376623$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $eb61561689376623$var$macroHeights[viewportSize];
    }
};
const $eb61561689376623$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
const $eb61561689376623$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes, nodeHeight, localId, shouldDisplayExtensionAsInline, node, isInsideOfInlineExtension)=>{
    const overflowContainerClass = !removeOverflow ? (0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true, rendererAppearance: rendererAppearance } = options || {};
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $jVL42.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
   * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
   * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
   * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
   * as the extension handler in CFE for legacy macros and Connect.
   */ const viewportSize = $eb61561689376623$var$getViewportSize(extensionId, extensionViewportSizes);
    const extensionHeight = nodeHeight || viewportSize;
    const isInline = shouldDisplayExtensionAsInline?.(node) && (0, $1oCLl.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true);
    const inlineClassName = isInline ? (0, $jVL42.RendererCssClassName).EXTENSION_AS_INLINE : '';
    if ((0, $1oCLl.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        const extensionDiv = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                width: isInline ? undefined : ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $2W3B8.calcBreakoutWidthCss)(layout) : (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : extensionHeight && `${extensionHeight}px`
            },
            "data-layout": layout,
            "data-local-id": localId,
            "data-testid": "extension--wrapper",
            "data-node-type": "extension"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            tabIndex: options.tabIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: `${(0, $jVL42.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
            css: [
                !isInsideOfInlineExtension && (0, $dh538.fg)('platform_fix_macro_renders_in_layouts') && $eb61561689376623$var$containerStyle
            ]
        }, content));
        return centerAlignClass && (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    }
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>{
        const extensionDiv = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jVL42.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isInline ? undefined : ((0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $fJNzZ.calcBreakoutWidth)(layout, width) : (0, $1oCLl.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : `${extensionHeight}px`
            },
            "data-layout": layout,
            "data-local-id": localId
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            tabIndex: options.tabIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: `${(0, $jVL42.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
            css: [
                !isInsideOfInlineExtension && (0, $dh538.fg)('platform_fix_macro_renders_in_layouts') && $eb61561689376623$var$containerStyle
            ]
        }, content));
        return centerAlignClass && (0, $1oCLl.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jVL42.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jVL42.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    });
};
const $eb61561689376623$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters, nodeHeight: nodeHeight, localId: localId, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5VmpF.default), {
        ...props,
        type: "extension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(result)) return $eb61561689376623$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames,
                tabIndex: props.tabIndex,
                rendererAppearance: props.rendererAppearance
            }, undefined, parameters?.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return $eb61561689376623$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames,
            tabIndex: props.tabIndex,
            rendererAppearance: props.rendererAppearance
        }, undefined, parameters?.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
    });
};
const $eb61561689376623$var$_default_1 = (0, $frt7o.default)($eb61561689376623$var$Extension, {
    overflowSelector: `.${(0, $jVL42.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});
var $eb61561689376623$export$2e2bcd8739ae039 = $eb61561689376623$var$_default_1;
module.exports["renderExtension"] = $eb61561689376623$export$b7482bdc8aff85e4;
module.exports["default"] = $eb61561689376623$export$2e2bcd8739ae039;

});

parcelRegister("8dFG8", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $502b94a4b5302811$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("br", {}),
            /*#__PURE__*/ (0, $l998X.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("br", {});
};
var $502b94a4b5302811$export$2e2bcd8739ae039 = $502b94a4b5302811$var$HardBreak;
module.exports["default"] = $502b94a4b5302811$export$2e2bcd8739ae039;

});

parcelRegister("9IIii", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $d925B = parcelRequire("d925B");


var $6F6hl = parcelRequire("6F6hl");


var $1oCLl = parcelRequire("1oCLl");


var $6uN0A = parcelRequire("6uN0A");


var $kIphX = parcelRequire("kIphX");


var $3HdsG = parcelRequire("3HdsG");


var $9K4OG = parcelRequire("9K4OG");

function $af6844859e3a51a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af6844859e3a51a3$var$RENDERER_HEADING_WRAPPER = 'renderer-heading-wrapper';
const $af6844859e3a51a3$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $af6844859e3a51a3$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
const $af6844859e3a51a3$var$wrapperStyles = {
    name: "4zleql",
    styles: "display:block"
};
function $af6844859e3a51a3$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6uN0A.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $3HdsG.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onCopyText: ()=>{
                fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).CLICKED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $d925B.EVENT_TYPE).UI
                });
                return (0, $kIphX.copyTextToClipboard)($af6844859e3a51a3$var$getCurrentUrlWithHash(headingId));
            },
            hideFromScreenReader: hideFromScreenReader,
            headingId: headingId
        }));
}
/**
 * Old heading structure (before a11y fix):
 * - headning anchor is rendered INSIDE the heading element
 * - A duplicate anchor is rendered in VisuallyHidden for screen readers
 * - The visible button has hideFromScreenReader={true}
 *
 */ function $af6844859e3a51a3$var$HeadingWithDuplicateAnchor(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $af6844859e3a51a3$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $4u5NT.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: mouseEnterHandler,
        tabIndex: (0, $1oCLl.expValEquals)('confluence_toc_nav_a11y', 'isEnabled', true) ? -1 : undefined
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: true
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: true
    }))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6F6hl.default), {
        testId: "visually-hidden-heading-anchor"
    }, showAnchorLink && headingId && /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId
    })));
}
/**
 * New heading structure (a11y fix):
 * - Heading anchor is rendered OUTSIDE the heading element in a .renderer-heading-wrapper div
 * - Uses data-level attribute for CSS styling
 * - Better accessibility: heading contains only text, button is a sibling
 */ function $af6844859e3a51a3$var$HeadingWithWrapper(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $af6844859e3a51a3$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $4u5NT.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: $af6844859e3a51a3$var$RENDERER_HEADING_WRAPPER,
        "data-testid": $af6844859e3a51a3$var$RENDERER_HEADING_WRAPPER,
        "data-level": props.level,
        css: $af6844859e3a51a3$var$wrapperStyles
    }, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: false
    }), /*#__PURE__*/ (0, $9K4OG.jsx)(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: mouseEnterHandler,
        tabIndex: (0, $1oCLl.expValEquals)('confluence_toc_nav_a11y', 'isEnabled', true) ? -1 : undefined
    }, props.children), showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId,
        hideFromScreenReader: false
    }));
}
/**
 * Gated Heading component:
 * - When platform_editor_copy_link_a11y_inconsistency_fix experiment is enabled,
 *   returns HeadingWithWrapper (new a11y-improved structure)
 * - Otherwise returns HeadingWithDuplicateAnchor (old structure)
 */ function $af6844859e3a51a3$var$Heading({ allowHeadingAnchorLinks: allowHeadingAnchorLinks, children: children, dataAttributes: dataAttributes, headingId: headingId, invisible: invisible, level: level, localId: localId, marks: marks, nodeType: nodeType, showAnchorLink: showAnchorLink, serializer: serializer, asInline: asInline }) {
    if ((0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$HeadingWithWrapper, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline
    }, children);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($af6844859e3a51a3$var$HeadingWithDuplicateAnchor, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline
    }, children);
}
var $af6844859e3a51a3$export$2e2bcd8739ae039 = $af6844859e3a51a3$var$Heading;
module.exports["default"] = $af6844859e3a51a3$export$2e2bcd8739ae039;

});

parcelRegister("AXP6M", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5VmpF = parcelRequire("5VmpF");

const $7ae9d43d02a0afce$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $l998X.jsx)((0, $5VmpF.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(result)) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $7ae9d43d02a0afce$export$2e2bcd8739ae039 = $7ae9d43d02a0afce$var$InlineExtension;
module.exports["default"] = $7ae9d43d02a0afce$export$2e2bcd8739ae039;

});

parcelRegister("iPgHB", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e32ab0c2bcbe4a4$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iu6m9 = parcelRequire("iu6m9");

function $3e32ab0c2bcbe4a4$export$2e2bcd8739ae039(props) {
    return (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: "layout-section-container",
        "data-local-id": props.localId,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-layout-section": true,
        "data-local-id": props.localId,
        children: props.children
    });
}

});

parcelRegister("gaxtd", function(module, exports) {
$parcel$export(module.exports, "default", () => $7119b81e1329ee77$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $bWRlG = parcelRequire("bWRlG");


var $dh538 = parcelRequire("dh538");

function $7119b81e1329ee77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $7119b81e1329ee77$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $7119b81e1329ee77$var$multipleWrappedImagesStyle = {
    name: "y2yz5o",
    styles: "& [class*=\"image-wrap-\"] + [class*=\"image-wrap-\"], & [class*=\"image-wrap-\"]:has( + [class*=\"image-wrap-\"]){margin-top:0;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $7119b81e1329ee77$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
function $7119b81e1329ee77$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        },
        css: (0, $dh538.fg)('platform_editor_fix_media_in_renderer') && $7119b81e1329ee77$var$multipleWrappedImagesStyle
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthProvider), null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $7119b81e1329ee77$var$clearNextSiblingMarginTopStyle,
            $7119b81e1329ee77$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
}

});

parcelRegister("2y2LK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d550833e818bebdd$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $d550833e818bebdd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("e3xiQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $48Use = parcelRequire("48Use");

const $60e49dc64205ce7a$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $48Use.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $60e49dc64205ce7a$export$2e2bcd8739ae039 = $60e49dc64205ce7a$var$RenderCaption;
module.exports["default"] = $60e49dc64205ce7a$export$2e2bcd8739ae039;

});

parcelRegister("iKbB3", function(module, exports) {
$parcel$export(module.exports, "default", () => $380dd188db062d07$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fGuiW = parcelRequire("fGuiW");


var $4mSjx = parcelRequire("4mSjx");


var $irKZA = parcelRequire("irKZA");


var $drJ23 = parcelRequire("drJ23");

function $380dd188db062d07$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $irKZA.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $4mSjx.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $irKZA.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $l998X.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fGuiW.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $drJ23.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});

parcelRegister("4AYMa", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5d919d33f5d798a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $42omo = parcelRequire("42omo");

function $08993800855619e3$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: "\xa0"
    });
    return children;
}


function $c5d919d33f5d798a$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes, localId: localId, asInline: asInline }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $l998X.jsx)("p", {
        ...dataAttributes,
        "data-local-id": localId,
        "data-as-inline": asInline,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $08993800855619e3$export$2e2bcd8739ae039), {
            children: children
        })
    }));
}

});

parcelRegister("12YDi", function(module, exports) {
$parcel$export(module.exports, "default", () => $120764912de8ad63$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $120764912de8ad63$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {});
}

});

parcelRegister("40qpT", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ea7ab564e9f0cf2$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5ea7ab564e9f0cf2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("hr", {
        role: "presentation"
    });
}

});

parcelRegister("iKFPk", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aDU6C = parcelRequire("aDU6C");

var $63Ztt = parcelRequire("63Ztt");


var $cOrQJ = parcelRequire("cOrQJ");


var $2QYOD = parcelRequire("2QYOD");


var $6icEc = parcelRequire("6icEc");


var $7f6CO = parcelRequire("7f6CO");


var $59U23 = parcelRequire("59U23");


var $d925B = parcelRequire("d925B");


var $jVL42 = parcelRequire("jVL42");


var $1cfRh = parcelRequire("1cfRh");


var $3kBFe = parcelRequire("3kBFe");

const $22c24c997e66799c$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $22c24c997e66799c$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return (0, $2QYOD.SortOrder).ASC;
        case (0, $2QYOD.SortOrder).ASC:
            return (0, $2QYOD.SortOrder).DESC;
        case (0, $2QYOD.SortOrder).DESC:
            return (0, $2QYOD.SortOrder).NO_ORDER;
    }
    return (0, $2QYOD.SortOrder).NO_ORDER;
};
const $22c24c997e66799c$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $3kBFe.tableCellMessages);
    switch(currentSortOrder){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $2QYOD.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $2QYOD.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $22c24c997e66799c$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $22c24c997e66799c$var$cssVariablePattern = /^var\(--.*\)$/;
const $22c24c997e66799c$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $6icEc.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $22c24c997e66799c$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $aDU6C.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $22c24c997e66799c$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $cOrQJ.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $63Ztt.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, $l998X.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $22c24c997e66799c$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$22c24c997e66799c$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $22c24c997e66799c$var$TH = $22c24c997e66799c$var$getWithCellProps('th');
const $22c24c997e66799c$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $1cfRh.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $2QYOD.SortOrder).NO_ORDER ? (0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $l998X.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $l998X.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $22c24c997e66799c$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                className: (0, $jVL42.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $l998X.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $jVL42.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7f6CO.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$22c24c997e66799c$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $22c24c997e66799c$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).SORT_COLUMN,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $59U23.PLATFORM).WEB,
                        mode: (0, $59U23.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $d925B.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    mode: (0, $59U23.MODE).RENDERER
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            });
        }
    };
};
const $22c24c997e66799c$export$f850895b287ef28e = $22c24c997e66799c$export$cfca40ca5c56a38e($22c24c997e66799c$var$TH);
const $22c24c997e66799c$var$TD = $22c24c997e66799c$var$getWithCellProps('td');
const $22c24c997e66799c$export$1e4baea7053fc0e3 = $22c24c997e66799c$var$TD;
module.exports["TableHeader"] = $22c24c997e66799c$export$f850895b287ef28e;
module.exports["TableCell"] = $22c24c997e66799c$export$1e4baea7053fc0e3;

});

parcelRegister("a78Ri", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cN8vw = parcelRequire("cN8vw");


var $2QYOD = parcelRequire("2QYOD");


var $jVL42 = parcelRequire("jVL42");

class $f7e5733ad19fb3c4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children);
        return /*#__PURE__*/ (0, $l998X.jsxs)("tr", {
            ref: innerRef,
            children: [
                this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)("td", {
                    className: (0, $jVL42.RendererCssClassName).NUMBER_COLUMN,
                    children: this.props.index
                }),
                (0, $cN8vw.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray)
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            colGroupWidths: []
        };
        this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && isHeaderRow) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $2QYOD.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $2QYOD.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        };
        this.addColGroupWidth = (childrenArray)=>{
            if (this.state.colGroupWidths?.length) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}
module.exports["default"] = $f7e5733ad19fb3c4$export$2e2bcd8739ae039;

});

parcelRegister("cCNNZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8295e31785de4f76$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $8295e31785de4f76$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("iCOwP", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $c789bfafac09dd18$export$32ec96484dd3ba39 = (0, $h82at.defineMessages)({
    unsupportedInlineContent: {
        id: "fabric.editor.unsupportedInlineContent",
        defaultMessage: "Unsupported content"
    },
    unsupportedBlockContent: {
        id: "fabric.editor.unsupportedBlockContent",
        defaultMessage: "This editor does not support displaying this content"
    },
    unsupportedContentTooltip: {
        id: "fabric.editor.unsupportedContentTooltip",
        defaultMessage: "Content is not available in this editor, this will be preserved when you edit and save"
    }
});
module.exports["unsupportedContentMessages"] = $c789bfafac09dd18$export$32ec96484dd3ba39;

});

parcelRegister("1QdLR", function(module, exports) {
function $0688bb6895de1706$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}
module.exports["getUnsupportedContent"] = $0688bb6895de1706$export$d4ded51d0f0bd2df;

});

parcelRegister("fp8V7", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");

var $6610dd290dab91d5$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $6610dd290dab91d5$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $6610dd290dab91d5$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $6610dd290dab91d5$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $6610dd290dab91d5$export$51a5b28e4fb2dba2 {
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $6610dd290dab91d5$var$cancelIdleCallback(this.requestCallbackId);
        }
        if ((0, $1oCLl.expValEquals)('platform_editor_renderer_shadow_observer_cleanup', 'isEnabled', true)) {
            this.sentinels.left?.remove();
            this.sentinels.right?.remove();
            this.sentinels = {};
        }
    }
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.intersectionObserver = void 0;
        this.scrollContainer = void 0;
        this.onUpdateShadows = void 0;
        this.sentinels = {};
        this.requestCallbackId = void 0;
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($6610dd290dab91d5$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($6610dd290dab91d5$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $6610dd290dab91d5$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($6610dd290dab91d5$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($6610dd290dab91d5$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
}
module.exports["shadowObserverClassNames"] = $6610dd290dab91d5$export$1cbe0bb16052178d;
module.exports["ShadowObserver"] = $6610dd290dab91d5$export$51a5b28e4fb2dba2;

});

parcelRegister("4BBKV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6dGgK = parcelRequire("6dGgK");


var $aFUXX = parcelRequire("aFUXX");


var $bWRlG = parcelRequire("bWRlG");

function $194645e6da8b5697$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $194645e6da8b5697$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $42omo.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $aFUXX.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6dGgK.a), {
        theme: memoizedTheme
    }, children);
}
function $194645e6da8b5697$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bWRlG.WidthConsumer), null, ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($194645e6da8b5697$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children)));
}
module.exports["mapBreakpointToLayoutMaxWidth"] = $194645e6da8b5697$export$b5ccf4d25d2c5af1;
module.exports["BaseTheme"] = $194645e6da8b5697$export$a1a213d350ca51ca;

});

parcelRegister("jSHzw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cUycv = parcelRequire("cUycv");


var $21K7m = parcelRequire("21K7m");


var $lspPP = parcelRequire("lspPP");

const $83d34ca77d432476$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $83d34ca77d432476$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $42omo.createContext)($83d34ca77d432476$var$initState);
const $83d34ca77d432476$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $83d34ca77d432476$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$83d34ca77d432476$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && state.annotations[id]?.markState === (0, $cUycv.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $cUycv.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!loadedAnnotation?.markState && state.annotations[id]?.markState !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current?.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $cUycv.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if (current?.markState !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $cUycv.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $cUycv.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $83d34ca77d432476$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $42omo.useReducer)($83d34ca77d432476$var$reducer, $83d34ca77d432476$var$initState);
    const actionContext = (0, $42omo.useContext)((0, $lspPP.RendererContext));
    (0, $42omo.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager?.hook('getDraft', getDraft);
        return ()=>{
            annotationManager?.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $42omo.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $42omo.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager?.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $42omo.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $42omo.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager?.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $42omo.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $cUycv.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager?.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager?.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
	 * This is a temporary solution to ensure that the annotation manager state is in sync with the
	 * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
	 * by the annotation manager itself.
	 */ (0, $42omo.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $cUycv.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: _eventTargetType, viewMethod: _viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber?.on((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber?.off((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $42omo.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($83d34ca77d432476$var$AnnotationManagerStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $l998X.jsx)($83d34ca77d432476$var$AnnotationManagerDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $83d34ca77d432476$export$654a1fb45487f838 = ()=>{
    return (0, $42omo.useContext)($83d34ca77d432476$var$AnnotationManagerStateContext);
};
const $83d34ca77d432476$export$12cbbb89fb7702d0 = ()=>{
    return (0, $42omo.useContext)($83d34ca77d432476$var$AnnotationManagerDispatchContext);
};
module.exports["AnnotationManagerProvider"] = $83d34ca77d432476$export$f21fb05766361bb3;
module.exports["useAnnotationManagerState"] = $83d34ca77d432476$export$654a1fb45487f838;
module.exports["useAnnotationManagerDispatch"] = $83d34ca77d432476$export$12cbbb89fb7702d0;

});

parcelRegister("jZG1P", function(module, exports) {
const $5f034ae8d7da98e3$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $5f034ae8d7da98e3$var$buildDataAttributesQuery = (pos)=>{
    const a = $5f034ae8d7da98e3$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $5f034ae8d7da98e3$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($5f034ae8d7da98e3$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};
module.exports["dataAttributes"] = $5f034ae8d7da98e3$export$15d6ddc168d35719;
module.exports["updateWindowSelectionAroundDraft"] = $5f034ae8d7da98e3$export$e14699d956e87e73;

});

parcelRegister("djzd2", function(module, exports) {

var $bYZ53 = parcelRequire("bYZ53");


var $dh538 = parcelRequire("dh538");

function $981298672e79c67e$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $bYZ53.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}
function $981298672e79c67e$export$1726c23d64498b6({ actions: actions, pos: pos }) {
    if (!(0, $dh538.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const ancestorNodeNames = (0, $bYZ53.getRangeAncestorNodeNames)({
        doc: doc,
        pos: pos
    });
    return ancestorNodeNames;
}
module.exports["getRendererRangeInlineNodeNames"] = $981298672e79c67e$export$b0ea72d31617ccea;
module.exports["getRendererRangeAncestorNodeNames"] = $981298672e79c67e$export$1726c23d64498b6;

});

parcelRegister("3kBFe", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $h82at = parcelRequire("h82at");

const $ff40fa5e20831b0c$export$74bada844422036d = (0, $h82at.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: "fabric.editor.headingLink.copyAnchorLink",
        defaultMessage: "Copy link to heading"
    },
    copyLinkToClipboard: {
        id: "fabric.editor.headingLink.copyAnchorLinkTo",
        defaultMessage: "Copy link to"
    },
    copyHeadingLinkLabelledBy: {
        id: "fabric.editor.headingLink.copyAnchorLinkLabelledBy",
        defaultMessage: "{copyLink} {heading}"
    },
    copiedHeadingLinkToClipboard: {
        id: "fabric.editor.headingLink.copied",
        defaultMessage: "Copied!"
    },
    failedToCopyHeadingLink: {
        id: "fabric.editor.headingLink.failedToCopy",
        defaultMessage: "Copy failed"
    },
    copyAriaLabel: {
        id: "fabric.editor.headingLink.copyAriaLabel",
        defaultMessage: "Copy"
    }
});
const $ff40fa5e20831b0c$export$c79ebc36348824d1 = (0, $h82at.defineMessages)({
    noneSortingLabel: {
        id: "fabric.editor.headingLink.noneSortingLabel",
        defaultMessage: "none"
    },
    ascSortingLabel: {
        id: "fabric.editor.headingLink.ascSortingLabel",
        defaultMessage: "ascending"
    },
    descSortingLabel: {
        id: "fabric.editor.headingLink.descSortingLabel",
        defaultMessage: "descending"
    }
});
const $ff40fa5e20831b0c$export$9f52c375a6ef34fc = (0, $h82at.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: "fabric.editor.inlineComment.marker.start",
        defaultMessage: "inline comment start"
    },
    contentRendererInlineCommentMarkerEnd: {
        id: "fabric.editor.inlineComment.marker.end",
        defaultMessage: "inline comment end"
    }
});
module.exports["headingAnchorLinkMessages"] = $ff40fa5e20831b0c$export$74bada844422036d;
module.exports["tableCellMessages"] = $ff40fa5e20831b0c$export$c79ebc36348824d1;
module.exports["inlineCommentMessages"] = $ff40fa5e20831b0c$export$9f52c375a6ef34fc;

});

parcelRegister("1lzbj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $21K7m = parcelRequire("21K7m");


var $cUycv = parcelRequire("cUycv");


var $d925B = parcelRequire("d925B");


var $k7eoe = parcelRequire("k7eoe");


var $jSHzw = parcelRequire("jSHzw");

const $bf54d68c492d222f$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $42omo.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $jSHzw.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $42omo.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $42omo.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $bf54d68c492d222f$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $42omo.useState)(false);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $jSHzw.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $42omo.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $bf54d68c492d222f$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $bf54d68c492d222f$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $42omo.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $jSHzw.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $jSHzw.useAnnotationManagerState)();
    const selectedAnnotation = (0, $42omo.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $bf54d68c492d222f$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $d925B.ACTION).VIEWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $k7eoe.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};
module.exports["useAnnotationStateByTypeEvent"] = $bf54d68c492d222f$export$95f9f9045e92d283;
module.exports["useHasFocusEvent"] = $bf54d68c492d222f$export$48f5d7f6702be07c;
module.exports["useAnnotationClickEvent"] = $bf54d68c492d222f$export$26cf539704e444c1;

});

parcelRegister("IcpgS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $fcecf936ee660f14$export$6a26b015ac619737 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $fcecf936ee660f14$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["ProvidersContext"] = $fcecf936ee660f14$export$6a26b015ac619737;
module.exports["InlineCommentsStateContext"] = $fcecf936ee660f14$export$aafe46a36ef535ba;

});

parcelRegister("1Qaul", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

function $c1722af477a6914e$export$1daf15cbaf649dad(adfDocument) {
    return (0, $1A9t2.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}
module.exports["countNodes"] = $c1722af477a6914e$export$1daf15cbaf649dad;

});

parcelRegister("kPuBV", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

const $b1b93f863d38edeb$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)();
};
module.exports["overflowShadow"] = $b1b93f863d38edeb$export$c5c1e4f4640336fb;

});

parcelRegister("2W3B8", function(module, exports) {
const $b62d428850ff7f45$export$87eeb477611c8fe = (layout)=>{
    if (layout === 'full-width') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--full-width-layout-width))';
    if (layout === 'wide') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--breakout-wide-layout-width))';
    return '100%';
};
module.exports["calcBreakoutWidthCss"] = $b62d428850ff7f45$export$87eeb477611c8fe;

});

parcelRegister("3HdsG", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba5ac32bd70f8fda$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $cs1vW = parcelRequire("cs1vW");


var $1bY7o = parcelRequire("1bY7o");


var $1oCLl = parcelRequire("1oCLl");


var $3gadb = parcelRequire("3gadb");


var $3kBFe = parcelRequire("3kBFe");

function $ba5ac32bd70f8fda$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ba5ac32bd70f8fda$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $ba5ac32bd70f8fda$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $ba5ac32bd70f8fda$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $ba5ac32bd70f8fda$var$copyAnchorButtonStyles = {
    name: "x4slh0",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #292A2E);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ba5ac32bd70f8fda$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $ba5ac32bd70f8fda$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage,
            isScreenReaderAnnouncementDisabled: (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(props){
        super(props);
        this.state = {
            tooltipMessage: '',
            isClicked: false
        };
        this.copyLinkId = void 0;
        this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        };
        this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $3kBFe.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        };
        this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $3kBFe.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch  {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        };
        this.resetMessage = ()=>{
            const tooltip = (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? (0, $3kBFe.headingAnchorLinkMessages).copyLinkToClipboard : (0, $3kBFe.headingAnchorLinkMessages).copyHeadingLinkToClipboard;
            this.setTooltipState(tooltip);
        };
        this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            const labelledBy = (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? this.props.intl.formatMessage((0, $3kBFe.headingAnchorLinkMessages).copyHeadingLinkLabelledBy, {
                copyLink: this.copyLinkId,
                heading: headingId
            }) : headingId;
            const tabIndex = (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? 0 : hideFromScreenReader ? undefined : -1;
            return /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
                "data-testid": "anchor-button",
                id: this.copyLinkId,
                css: $ba5ac32bd70f8fda$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onBlur: (0, $1oCLl.expValEquals)('platform_editor_a11y_eslint_fix', 'isEnabled', true) ? this.resetMessage : undefined,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: this.getCopyAriaLabel(),
                color: this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        };
        this.copyLinkId = (0, $1oCLl.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? crypto.randomUUID() : undefined;
    }
}
var $ba5ac32bd70f8fda$export$2e2bcd8739ae039 = (0, $cs1vW.default)($ba5ac32bd70f8fda$var$HeadingAnchor);
module.exports["HeadingAnchorWrapperClassName"] = $ba5ac32bd70f8fda$export$3c9cedc52604835d;

});

parcelRegister("drJ23", function(module, exports) {
function $67762bf75d20c8f0$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}
module.exports["getListIndentLevel"] = $67762bf75d20c8f0$export$75aa84e85754623e;

});


$parcel$global.rlb("aYdgM")
//# sourceMappingURL=FullPageEditorComponent.f25a5458.js.map
